export interface CitySearch {
    CityCode?: string;
    CityDsc?: string;
    responsibleUser?: string;
    pageSize?: number;
    pageIndex?: number;
}

export interface city {
    id: number;
    updatedBy: string;
    updatedAt: Date;
    closingTimeMDFe: string;
    vehiclePlateNumber: string;
    typeOwner: string;
    uFOwner: string;
    iEOwner: string;
    corporateNameOwner: string;
    rntCOwner: string;
    cpF_CNPJ_Owner: string;
    flagOwnCity: boolean;
    tareCity: number;
    ufRegistration: string;
    flagEmitsMDFe: boolean;
    flagEuroClassification: string;
    loadCapacity: number;
    length: number;
    height: number;
    width: number;
    yearCityForce: number;
    cartPlateNumber: string;
    vehicleManufacturer: string;
    vehicleType: string;
    companyId: number;
    renavam: string;
    supplieCode: number;
    descricaoFlagEmiteMDFe: string;
    createdBy : string;
}

export interface CityPost {
    id: number;
    updatedBy: string;
    updatedAt: Date;
    closingTimeMDFe: string;
    vehiclePlateNumber: string;
    typeOwner: string;
    uFOwner: string;
    iEOwner: string;
    corporateNameOwner: string;
    rntCOwner: string;
    cpF_CNPJ_Owner: string;
    flagOwnCity: boolean;
    tareCity: number;
    ufRegistration: string;
    flagEmitsMDFe: boolean;
    flagEuroClassification: string;
    loadCapacity: number;
    length: number;
    height: number;
    width: number;
    yearCityForce: number;
    cartPlateNumber: string;
    vehicleManufacturer: string;
    vehicleType: string;
    companyId: number;
    renavam: string;
    supplieCode: number;
    descricaoFlagEmiteMDFe: string;
    createdBy : string;
}

export const UF = [
	{
		"COD_UF": "11",
		"SIGLA_UF": "RO"
	},
	{
		"COD_UF": "12",
		"SIGLA_UF": "AC"
	},
	{
		"COD_UF": "13",
		"SIGLA_UF": "AM"
	},
	{
		"COD_UF": "14",
		"SIGLA_UF": "RR"
	},
	{
		"COD_UF": "15",
		"SIGLA_UF": "PA"
	},
	{
		"COD_UF": "16",
		"SIGLA_UF": "AP"
	},
	{
		"COD_UF": "17",
		"SIGLA_UF": "TO"
	},
	{
		"COD_UF": "21",
		"SIGLA_UF": "MA"
	},
	{
		"COD_UF": "22",
		"SIGLA_UF": "PI"
	},
	{
		"COD_UF": "23",
		"SIGLA_UF": "CE"
	},
	{
		"COD_UF": "24",
		"SIGLA_UF": "RN"
	},
	{
		"COD_UF": "25",
		"SIGLA_UF": "PB"
	},
	{
		"COD_UF": "26",
		"SIGLA_UF": "PE"
	},
	{
		"COD_UF": "27",
		"SIGLA_UF": "AL"
	},
	{
		"COD_UF": "28",
		"SIGLA_UF": "SE"
	},
	{
		"COD_UF": "29",
		"SIGLA_UF": "BA"
	},
	{
		"COD_UF": "31",
		"SIGLA_UF": "MG"
	},
	{
		"COD_UF": "32",
		"SIGLA_UF": "ES"
	},
	{
		"COD_UF": "33",
		"SIGLA_UF": "RJ"
	},
	{
		"COD_UF": "35",
		"SIGLA_UF": "SP"
	},
	{
		"COD_UF": "41",
		"SIGLA_UF": "PR"
	},
	{
		"COD_UF": "42",
		"SIGLA_UF": "SC"
	},
	{
		"COD_UF": "43",
		"SIGLA_UF": "RS"
	},
	{
		"COD_UF": "50",
		"SIGLA_UF": "MS"
	},
	{
		"COD_UF": "51",
		"SIGLA_UF": "MT"
	},
	{
		"COD_UF": "52",
		"SIGLA_UF": "GO"
	},
	{
		"COD_UF": "53",
		"SIGLA_UF": "DF"
	}
]
export const Company = [
    {
        "companyID": 154,
        "companyCode": 1,
        "warehouseID": 1,
        "companyName": "Fiat Automoveis S.A.",
        "companyBOMCode": 161,
        "modifiedBy": "furlong_alessandro.sardela",
        "modifiedOn": "2021-11-23T16:06:49.957",
        "numberCnpj": "16701716000156",
        "name": "FIAT AUTOMOVEIS SA",
        "address": "AV CONTORNO.3455PAULO CAMILO",
        "postalCode": "32669900",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": null,
        "stateRegistration": "0671233540032",
        "anagraficCode": 1080,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 161,
        "pdpCode": 33,
        "regionID": 4,
        "companyType": "V",
        "starsCompanyCode": "161",
        "plantID": 1,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "161",
		"publicPlace": "AV CONTORNO",
		"issuerNumber": "3455",
		"issuerNeighborhood": "PAULO CAMILO",
		"issuerCityCode": "3106705",
		"issuerUFCode": "31"

    },
    {
        "companyID": 162,
        "companyCode": 162,
        "warehouseID": 3,
        "companyName": "Fiat Cordoba - 162 - Almacén 03",
        "companyBOMCode": 162,
        "modifiedBy": "fiatauto\\F05698B",
        "modifiedOn": "2015-04-27T17:09:27.097",
        "numberCnpj": "30682450963",
        "name": "FIAT AUTO ARGENTINA S.A.",
        "address": "Ruta 9 KM 695 – Ferreyra",
        "postalCode": "5000",
        "locality": "CORDOBA",
        "region": "03",
        "countryCode": 639,
        "country": "ARGENTINA",
        "cnpj": null,
        "stateRegistration": "ISENTO",
        "anagraficCode": 1394,
        "grossTicketNumber": 9011707350,
        "acitivityStart": "1997-06-05T00:00:00",
        "supplierCompanyCode": 53,
        "pdpCode": 34,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": "162",
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 165,
        "companyCode": 165,
        "warehouseID": 3,
        "companyName": "Fiat Cordoba - 165 - Almacén 03",
        "companyBOMCode": 165,
        "modifiedBy": "fiatauto\\F05698B",
        "modifiedOn": "2015-04-27T17:09:27.097",
        "numberCnpj": "30682450963",
        "name": "FIAT AUTO ARGENTINA S.A.",
        "address": "Ruta 9 KM 695 – Ferreyra",
        "postalCode": "5000",
        "locality": "CORDOBA",
        "region": "03",
        "countryCode": 639,
        "country": "ARGENTINA",
        "cnpj": null,
        "stateRegistration": "ISENTO",
        "anagraficCode": 1394,
        "grossTicketNumber": 9011707350,
        "acitivityStart": "1997-06-05T00:00:00",
        "supplierCompanyCode": 53,
        "pdpCode": 34,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 166,
        "companyCode": 999,
        "warehouseID": 99,
        "companyName": "999",
        "companyBOMCode": 999,
        "modifiedBy": "fiasa\\weltonf",
        "modifiedOn": "2014-02-16T19:29:17.16",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": 999,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 999,
        "pdpCode": null,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 167,
        "companyCode": 191,
        "warehouseID": 1,
        "companyName": "JEEP Pernambuco",
        "companyBOMCode": 191,
        "modifiedBy": "fiasa\\fredf",
        "modifiedOn": "2014-12-26T14:02:06.667",
        "numberCnpj": "16701716003686",
        "name": "FIAT AUTOMOVEIS LTDA         *",
        "address": "RODOVIA BR 101 - NORTE S/N KM13 AO 15S/NNOVA GOIANA",
        "postalCode": "55900000",
        "locality": "GOIANA",
        "region": "PE",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": null,
        "stateRegistration": "053213106",
        "anagraficCode": 29991,
        "grossTicketNumber": null,
        "acitivityStart": "2014-06-04T00:00:00",
        "supplierCompanyCode": 191,
        "pdpCode": 28,
        "regionID": 4,
        "companyType": "V",
        "starsCompanyCode": "191",
        "plantID": 3,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "G654"
    },
    {
        "companyID": 168,
        "companyCode": 10,
        "warehouseID": 10,
        "companyName": "FPT Fire - 010",
        "companyBOMCode": 196,
        "modifiedBy": "ECN1455_A02",
        "modifiedOn": "2018-12-12T16:37:30.113",
        "numberCnpj": "16701716003171",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS *",
        "address": "AV DO CONTORNO DA FIAT3451BR 381JARDIM TERESOPOLIS",
        "postalCode": "32600065",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": "16701716003171",
        "stateRegistration": null,
        "anagraficCode": 1036,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 196,
        "pdpCode": 0,
        "regionID": 8,
        "companyType": "M",
        "starsCompanyCode": "010",
        "plantID": 1,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "G325"
    },
    {
        "companyID": 169,
        "companyCode": 12,
        "warehouseID": 1,
        "companyName": "FPT Mecânica - 012",
        "companyBOMCode": 196,
        "modifiedBy": "fiasa\\ccrispim",
        "modifiedOn": "2015-02-27T09:29:53.223",
        "numberCnpj": "16701716003333",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS *",
        "address": "AV DO CONTORNO DA FIAT3455PAULO CAMILO PENA",
        "postalCode": "32530490",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": null,
        "stateRegistration": "0671233541020",
        "anagraficCode": 1046,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 196,
        "pdpCode": 0,
        "regionID": 8,
        "companyType": "M",
        "starsCompanyCode": "196",
        "plantID": 1,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "G324"
    },
    {
        "companyID": 170,
        "companyCode": 595,
        "warehouseID": 1,
        "companyName": "FPT Campo Largo - 595",
        "companyBOMCode": 595,
        "modifiedBy": "fiasa\\weltonf",
        "modifiedOn": "2014-10-18T13:56:28.497",
        "numberCnpj": "01655350000159",
        "name": "FPT POWERTRAIN TECH DO BRASIL",
        "address": "RUA EMA TANNER DE ANDRADE1892VILA FERRARI",
        "postalCode": "83606360",
        "locality": "CAMPO LARGO",
        "region": "PR",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": null,
        "stateRegistration": "9015696734",
        "anagraficCode": 16273,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 595,
        "pdpCode": 0,
        "regionID": 8,
        "companyType": "M",
        "starsCompanyCode": "595",
        "plantID": 2,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "G355"
    },
    {
        "companyID": 178,
        "companyCode": 1,
        "warehouseID": 29,
        "companyName": "Fiat Filial CKD - 29",
        "companyBOMCode": 161,
        "modifiedBy": "furlong_alessandro.sardela",
        "modifiedOn": "2021-11-23T16:06:31.357",
        "numberCnpj": "16701716001713",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS *",
        "address": "RODOVIA BR 381 KM 484SNDISTRITO INDUSTRIAL  JARDIM PIEMONT N",
        "postalCode": "32689898",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": "16701716001713",
        "stateRegistration": "0671233541446",
        "anagraficCode": 1111,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 161,
        "pdpCode": 0,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": "716",
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 179,
        "companyCode": 25,
        "warehouseID": 33,
        "companyName": "Fiat Filial CKD - 33",
        "companyBOMCode": 161,
        "modifiedBy": "fiasa\\fredf",
        "modifiedOn": "2015-12-09T19:04:20.8",
        "numberCnpj": "16701716001713",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS *",
        "address": "RODOVIA BR 381 KM 484SNDISTRITO INDUSTRIAL  JARDIM PIEMONT N",
        "postalCode": "32689898",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": "16701716001713",
        "stateRegistration": "0671233541446",
        "anagraficCode": 1111,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 161,
        "pdpCode": 0,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": "G164"
    },
    {
        "companyID": 180,
        "companyCode": 162,
        "warehouseID": 18,
        "companyName": "Fiat Cordoba - 162 - Almacén 18",
        "companyBOMCode": 162,
        "modifiedBy": "fiatauto\\F57509A",
        "modifiedOn": "2017-03-09T14:01:55.66",
        "numberCnpj": "30682450963",
        "name": "FIAT AUTO ARGENTINA S.A.",
        "address": "Ruta 9 KM 695 – Ferreyra",
        "postalCode": "5000",
        "locality": "CORDOBA",
        "region": "03",
        "countryCode": 639,
        "country": "ARGENTINA",
        "cnpj": null,
        "stateRegistration": "ISENTO",
        "anagraficCode": 1394,
        "grossTicketNumber": 9011707350,
        "acitivityStart": "1997-06-05T00:00:00",
        "supplierCompanyCode": 53,
        "pdpCode": 34,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": "162",
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 181,
        "companyCode": 165,
        "warehouseID": 18,
        "companyName": "Fiat Cordoba - 165 - Almacén 18",
        "companyBOMCode": 165,
        "modifiedBy": "fiatauto\\F57509A",
        "modifiedOn": "2017-03-09T14:01:55.66",
        "numberCnpj": "30682450963",
        "name": "FIAT AUTO ARGENTINA S.A.",
        "address": "Ruta 9 KM 695 – Ferreyra",
        "postalCode": "5000",
        "locality": "CORDOBA",
        "region": "03",
        "countryCode": 639,
        "country": "ARGENTINA",
        "cnpj": null,
        "stateRegistration": "ISENTO",
        "anagraficCode": 1394,
        "grossTicketNumber": 9011707350,
        "acitivityStart": "1997-06-05T00:00:00",
        "supplierCompanyCode": 53,
        "pdpCode": 34,
        "regionID": 4,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 182,
        "companyCode": 1,
        "warehouseID": 31,
        "companyName": "Fiat Matriz CKD - 31",
        "companyBOMCode": 161,
        "modifiedBy": "system",
        "modifiedOn": "2017-07-26T10:10:27.617",
        "numberCnpj": "16701716000157",
        "name": "FIAT AUTOMOVEIS SA",
        "address": "AV CONTORNO.3455PAULO CAMILO",
        "postalCode": "32669900",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": null,
        "stateRegistration": "0671233540032",
        "anagraficCode": 1080,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 161,
        "pdpCode": 33,
        "regionID": 4,
        "companyType": "V",
        "starsCompanyCode": "161",
        "plantID": 4,
        "irfBranchID": 179,
        "warehouse": null,
        "companyCodeSAP": "G164"
    },
    {
        "companyID": 183,
        "companyCode": 153,
        "warehouseID": 1,
        "companyName": "S.A.T.A. Melfi - 153",
        "companyBOMCode": 153,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2017-09-14T17:33:39.527",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 184,
        "companyCode": 724,
        "warehouseID": 1,
        "companyName": "Guanzhou - 724",
        "companyBOMCode": 724,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2017-09-14T17:33:39.54",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 1,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 186,
        "companyCode": 123,
        "warehouseID": 55,
        "companyName": "Fiat Mopar",
        "companyBOMCode": 123,
        "modifiedBy": "fiatauto\\f15542c",
        "modifiedOn": "2017-10-25T00:00:00",
        "numberCnpj": "16701716003848",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS LTDA",
        "address": "RUA WAGNER LUIZ BEVILAQUA 525, GALPAO 1. PARTE “E” GUEMBE.",
        "postalCode": "13290000",
        "locality": "LOUVEIRA",
        "region": "SP",
        "countryCode": 55,
        "country": "BRASIL",
        "cnpj": "16701716003848",
        "stateRegistration": "421025441119",
        "anagraficCode": 35048,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 123,
        "pdpCode": 0,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": "123",
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 187,
        "companyCode": 9999,
        "warehouseID": 1,
        "companyName": "Dummy Plant - 9999",
        "companyBOMCode": 9999,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-01-26T16:38:58.6",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": null,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 188,
        "companyCode": 183,
        "warehouseID": 1,
        "companyName": "Ranjangaon - 183",
        "companyBOMCode": 183,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-01-26T16:38:58.637",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": null,
        "regionID": 2,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 189,
        "companyCode": 144,
        "warehouseID": 1,
        "companyName": "Pomigliano - 144",
        "companyBOMCode": 144,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-05-25T16:02:04.123",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 190,
        "companyCode": 149,
        "warehouseID": 1,
        "companyName": "Sevel - 149",
        "companyBOMCode": 149,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-05-25T16:02:04.157",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 191,
        "companyCode": 158,
        "warehouseID": 1,
        "companyName": "Tychy - 158",
        "companyBOMCode": 158,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-05-25T16:02:04.193",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 192,
        "companyCode": 148,
        "warehouseID": 1,
        "companyName": "Kragujevac - 148",
        "companyBOMCode": 148,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-05-25T16:02:04.22",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 193,
        "companyCode": 129,
        "warehouseID": 1,
        "companyName": "TOFAS Bursa - 129",
        "companyBOMCode": 129,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-06-08T14:37:15.213",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 6,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 194,
        "companyCode": 141,
        "warehouseID": 1,
        "companyName": "Mirafiori - 141",
        "companyBOMCode": 141,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-06-08T14:37:15.3",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 195,
        "companyCode": 145,
        "warehouseID": 1,
        "companyName": "Cassino - 145",
        "companyBOMCode": 145,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-06-08T14:37:15.32",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 196,
        "companyCode": 197,
        "warehouseID": 1,
        "companyName": "AGAP Grugliasco - 197",
        "companyBOMCode": 197,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-06-08T14:37:15.34",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 197,
        "companyCode": 8481,
        "warehouseID": 1,
        "companyName": "Toluca - 8481",
        "companyBOMCode": 8481,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-11T15:03:31.473",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 198,
        "companyCode": 2452,
        "warehouseID": 1,
        "companyName": "Dodge City - 2452",
        "companyBOMCode": 2452,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.69",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 199,
        "companyCode": 2459,
        "warehouseID": 1,
        "companyName": "Toledo South - 2459",
        "companyBOMCode": 2459,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.733",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 200,
        "companyCode": 2462,
        "warehouseID": 1,
        "companyName": "Toledo North - 2462",
        "companyBOMCode": 2462,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.75",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 201,
        "companyCode": 4012,
        "warehouseID": 1,
        "companyName": "Jefferson North - 4012",
        "companyBOMCode": 4012,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.77",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 202,
        "companyCode": 4015,
        "warehouseID": 1,
        "companyName": "Belvidere - 4015",
        "companyBOMCode": 4015,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.787",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 203,
        "companyCode": 4025,
        "warehouseID": 1,
        "companyName": "Sterling Heights - 4025",
        "companyBOMCode": 4025,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.813",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 204,
        "companyCode": 4199,
        "warehouseID": 1,
        "companyName": "CTC - 4199",
        "companyBOMCode": 4199,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.83",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 205,
        "companyCode": 6231,
        "warehouseID": 1,
        "companyName": "Conner - 6231",
        "companyBOMCode": 6231,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.853",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 206,
        "companyCode": 8068,
        "warehouseID": 1,
        "companyName": "Venezuela - 8068",
        "companyBOMCode": 8068,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.87",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 207,
        "companyCode": 8475,
        "warehouseID": 1,
        "companyName": "Saltillo Truck - 8475",
        "companyBOMCode": 8475,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:34.887",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 208,
        "companyCode": 8483,
        "warehouseID": 1,
        "companyName": "Saltillo Van - 8483",
        "companyBOMCode": 848,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:35.097",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 209,
        "companyCode": 9103,
        "warehouseID": 1,
        "companyName": "Windsor - 9103",
        "companyBOMCode": 9103,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:35.113",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 210,
        "companyCode": 9126,
        "warehouseID": 1,
        "companyName": "Brampton - 9126",
        "companyBOMCode": 9126,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-10-31T15:08:35.14",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 5,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 224,
        "companyCode": 721,
        "warehouseID": 1,
        "companyName": "Changsha - 721",
        "companyBOMCode": 721,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2018-11-26T19:56:36.85",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 1,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 225,
        "companyCode": 184,
        "warehouseID": 1,
        "companyName": "Ranjangaon PWT - 184",
        "companyBOMCode": 184,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2019-03-11T11:57:58.317",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 226,
        "companyCode": 500,
        "warehouseID": 1,
        "companyName": "Maserati Modena - 500",
        "companyBOMCode": 500,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2019-11-08T13:29:57.223",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 3,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 227,
        "companyCode": 121,
        "warehouseID": 1,
        "companyName": "121 - PWT Mirafori",
        "companyBOMCode": 121,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:15:42.163",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 228,
        "companyCode": 123,
        "warehouseID": 1,
        "companyName": "123 - PWT Termoli",
        "companyBOMCode": 123,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:15:50.03",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 229,
        "companyCode": 124,
        "warehouseID": 1,
        "companyName": "124 - PWT Verrone",
        "companyBOMCode": 124,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:16:00.29",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 230,
        "companyCode": 139,
        "warehouseID": 1,
        "companyName": "139 - PWT Pratola Serra",
        "companyBOMCode": 139,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:16:23.313",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 231,
        "companyCode": 171,
        "warehouseID": 1,
        "companyName": "171 - PWT Bielsko Biala Twin Air",
        "companyBOMCode": 171,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:16:39.797",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 232,
        "companyCode": 172,
        "warehouseID": 1,
        "companyName": "172 - PWT Cento",
        "companyBOMCode": 172,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:16:47.627",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 233,
        "companyCode": 192,
        "warehouseID": 1,
        "companyName": "192 - PWT Bielsko Biala GSE",
        "companyBOMCode": 192,
        "modifiedBy": "fiatauto\\f05572b",
        "modifiedOn": "2020-09-03T18:16:57.8",
        "numberCnpj": null,
        "name": null,
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": 0,
        "regionID": 7,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 241,
        "companyCode": 3,
        "warehouseID": 32,
        "companyName": "Mopar - P&A",
        "companyBOMCode": 0,
        "modifiedBy": "fiatauto\\F69155B",
        "modifiedOn": "2021-03-04T00:00:00",
        "numberCnpj": "16701716002957",
        "name": "FCA FIAT CHRYSLER AUTOMOVEIS *",
        "address": "AV MIRAFIORI233IMBIRUCUDISTRITO INDUSTRIAL PAULO CAMILO SUL",
        "postalCode": "32530970",
        "locality": "BETIM",
        "region": "MG",
        "countryCode": 1058,
        "country": "BRASIL",
        "cnpj": "16701716002957",
        "stateRegistration": "0671233540784",
        "anagraficCode": 1088,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": 3,
        "pdpCode": null,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": 4,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 242,
        "companyCode": 629,
        "warehouseID": 0,
        "companyName": "Palomar",
        "companyBOMCode": 629,
        "modifiedBy": "fiatauto\\SC18523",
        "modifiedOn": "2022-10-20T16:15:19.68",
        "numberCnpj": null,
        "name": "Palomar",
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": 1394,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": null,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 243,
        "companyCode": 630,
        "warehouseID": 0,
        "companyName": "Porto Real",
        "companyBOMCode": 630,
        "modifiedBy": "fiatauto\\SC18523",
        "modifiedOn": "2022-10-20T16:15:19.727",
        "numberCnpj": null,
        "name": "Porto Real",
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": null,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": null,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": 6,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    },
    {
        "companyID": 244,
        "companyCode": 164,
        "warehouseID": 1,
        "companyName": "Fiat Filial Ferrolene",
        "companyBOMCode": 161,
        "modifiedBy": "fiatauto\\SC18523",
        "modifiedOn": "2022-12-22T11:58:57.283",
        "numberCnpj": "16701716000903",
        "name": "Fiat Filial Ferrolene",
        "address": null,
        "postalCode": null,
        "locality": null,
        "region": null,
        "countryCode": null,
        "country": null,
        "cnpj": null,
        "stateRegistration": null,
        "anagraficCode": 1080,
        "grossTicketNumber": null,
        "acitivityStart": null,
        "supplierCompanyCode": null,
        "pdpCode": null,
        "regionID": null,
        "companyType": null,
        "starsCompanyCode": null,
        "plantID": null,
        "irfBranchID": null,
        "warehouse": null,
        "companyCodeSAP": null
    }
]

export const city = [
	{
		"COD_MUNICIPIO": "1100015",
		"NOME_MUNICIPIO": "ALTA FLORESTA DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100023",
		"NOME_MUNICIPIO": "ARIQUEMES",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100031",
		"NOME_MUNICIPIO": "CABIXI",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100049",
		"NOME_MUNICIPIO": "CACOAL",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100056",
		"NOME_MUNICIPIO": "CEREJEIRAS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100064",
		"NOME_MUNICIPIO": "COLORADO DO OESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100072",
		"NOME_MUNICIPIO": "CORUMBIARA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100080",
		"NOME_MUNICIPIO": "COSTA MARQUES",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100098",
		"NOME_MUNICIPIO": "ESPIGAO DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100106",
		"NOME_MUNICIPIO": "GUAJARA-MIRIM",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100114",
		"NOME_MUNICIPIO": "JARU",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100122",
		"NOME_MUNICIPIO": "JI-PARANA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100130",
		"NOME_MUNICIPIO": "MACHADINHO DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100148",
		"NOME_MUNICIPIO": "NOVA BRASILANDIA DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100155",
		"NOME_MUNICIPIO": "OURO PRETO DO OESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100189",
		"NOME_MUNICIPIO": "PIMENTA BUENO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100205",
		"NOME_MUNICIPIO": "PORTO VELHO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100254",
		"NOME_MUNICIPIO": "PRESIDENTE MEDICI",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100262",
		"NOME_MUNICIPIO": "RIO CRESPO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100288",
		"NOME_MUNICIPIO": "ROLIM DE MOURA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100296",
		"NOME_MUNICIPIO": "SANTA LUZIA DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100304",
		"NOME_MUNICIPIO": "VILHENA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100320",
		"NOME_MUNICIPIO": "SAO MIGUEL DO GUAPORE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100338",
		"NOME_MUNICIPIO": "NOVA MAMORE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100346",
		"NOME_MUNICIPIO": "ALVORADA DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100379",
		"NOME_MUNICIPIO": "ALTO ALEGRE DOS PARECIS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100403",
		"NOME_MUNICIPIO": "ALTO PARAISO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100452",
		"NOME_MUNICIPIO": "BURITIS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100502",
		"NOME_MUNICIPIO": "NOVO HORIZONTE DO OESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100601",
		"NOME_MUNICIPIO": "CACAULANDIA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100700",
		"NOME_MUNICIPIO": "CAMPO NOVO DE RONDÔNIA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100809",
		"NOME_MUNICIPIO": "CANDEIAS DO JAMARI",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100908",
		"NOME_MUNICIPIO": "CASTANHEIRAS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100924",
		"NOME_MUNICIPIO": "CHUPINGUAIA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1100940",
		"NOME_MUNICIPIO": "CUJUBIM",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101005",
		"NOME_MUNICIPIO": "GOVERNADOR JORGE TEIXEIRA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101104",
		"NOME_MUNICIPIO": "ITAPUA DO OESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101203",
		"NOME_MUNICIPIO": "MINISTRO ANDREAZZA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101302",
		"NOME_MUNICIPIO": "MIRANTE DA SERRA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101401",
		"NOME_MUNICIPIO": "MONTE NEGRO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101435",
		"NOME_MUNICIPIO": "NOVA UNIAO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101450",
		"NOME_MUNICIPIO": "PARECIS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101468",
		"NOME_MUNICIPIO": "PIMENTEIRAS DO OESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101476",
		"NOME_MUNICIPIO": "PRIMAVERA DE RONDÔNIA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101484",
		"NOME_MUNICIPIO": "SAO FELIPE DOESTE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101492",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO GUAPORE",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101500",
		"NOME_MUNICIPIO": "SERINGUEIRAS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101559",
		"NOME_MUNICIPIO": "TEIXEIROPOLIS",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101609",
		"NOME_MUNICIPIO": "THEOBROMA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101708",
		"NOME_MUNICIPIO": "URUPA",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101757",
		"NOME_MUNICIPIO": "VALE DO ANARI",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1101807",
		"NOME_MUNICIPIO": "VALE DO PARAISO",
		"COD_UF": "11"
	},
	{
		"COD_MUNICIPIO": "1200013",
		"NOME_MUNICIPIO": "ACRELANDIA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200054",
		"NOME_MUNICIPIO": "ASSIS BRASIL",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200104",
		"NOME_MUNICIPIO": "BRASILEIA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200138",
		"NOME_MUNICIPIO": "BUJARI",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200179",
		"NOME_MUNICIPIO": "CAPIXABA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200203",
		"NOME_MUNICIPIO": "CRUZEIRO DO SUL",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200252",
		"NOME_MUNICIPIO": "EPITACIOLANDIA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200302",
		"NOME_MUNICIPIO": "FEIJO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200328",
		"NOME_MUNICIPIO": "JORDAO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200336",
		"NOME_MUNICIPIO": "MANCIO LIMA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200344",
		"NOME_MUNICIPIO": "MANOEL URBANO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200351",
		"NOME_MUNICIPIO": "MARECHAL THAUMATURGO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200385",
		"NOME_MUNICIPIO": "PLACIDO DE CASTRO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200393",
		"NOME_MUNICIPIO": "PORTO WALTER",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200401",
		"NOME_MUNICIPIO": "RIO BRANCO",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200427",
		"NOME_MUNICIPIO": "RODRIGUES ALVES",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200435",
		"NOME_MUNICIPIO": "SANTA ROSA DO PURUS",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200450",
		"NOME_MUNICIPIO": "SENADOR GUIOMARD",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200500",
		"NOME_MUNICIPIO": "SENA MADUREIRA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200609",
		"NOME_MUNICIPIO": "TARAUACA",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200708",
		"NOME_MUNICIPIO": "XAPURI",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1200807",
		"NOME_MUNICIPIO": "PORTO ACRE",
		"COD_UF": "12"
	},
	{
		"COD_MUNICIPIO": "1300029",
		"NOME_MUNICIPIO": "ALVARAES",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300060",
		"NOME_MUNICIPIO": "AMATURA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300086",
		"NOME_MUNICIPIO": "ANAMA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300102",
		"NOME_MUNICIPIO": "ANORI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300144",
		"NOME_MUNICIPIO": "APUI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300201",
		"NOME_MUNICIPIO": "ATALAIA DO NORTE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300300",
		"NOME_MUNICIPIO": "AUTAZES",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300409",
		"NOME_MUNICIPIO": "BARCELOS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300508",
		"NOME_MUNICIPIO": "BARREIRINHA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300607",
		"NOME_MUNICIPIO": "BENJAMIN CONSTANT",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300631",
		"NOME_MUNICIPIO": "BERURI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300680",
		"NOME_MUNICIPIO": "BOA VISTA DO RAMOS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300706",
		"NOME_MUNICIPIO": "BOCA DO ACRE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300805",
		"NOME_MUNICIPIO": "BORBA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300839",
		"NOME_MUNICIPIO": "CAAPIRANGA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1300904",
		"NOME_MUNICIPIO": "CANUTAMA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301001",
		"NOME_MUNICIPIO": "CARAUARI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301100",
		"NOME_MUNICIPIO": "CAREIRO",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301159",
		"NOME_MUNICIPIO": "CAREIRO DA VARZEA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301209",
		"NOME_MUNICIPIO": "COARI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301308",
		"NOME_MUNICIPIO": "CODAJAS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301407",
		"NOME_MUNICIPIO": "EIRUNEPE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301506",
		"NOME_MUNICIPIO": "ENVIRA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301605",
		"NOME_MUNICIPIO": "FONTE BOA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301654",
		"NOME_MUNICIPIO": "GUAJARA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301704",
		"NOME_MUNICIPIO": "HUMAITA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301803",
		"NOME_MUNICIPIO": "IPIXUNA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301852",
		"NOME_MUNICIPIO": "IRANDUBA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301902",
		"NOME_MUNICIPIO": "ITACOATIARA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1301951",
		"NOME_MUNICIPIO": "ITAMARATI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302009",
		"NOME_MUNICIPIO": "ITAPIRANGA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302108",
		"NOME_MUNICIPIO": "JAPURA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302207",
		"NOME_MUNICIPIO": "JURUA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302306",
		"NOME_MUNICIPIO": "JUTAI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302405",
		"NOME_MUNICIPIO": "LABREA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302504",
		"NOME_MUNICIPIO": "MANACAPURU",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302553",
		"NOME_MUNICIPIO": "MANAQUIRI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302603",
		"NOME_MUNICIPIO": "MANAUS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302702",
		"NOME_MUNICIPIO": "MANICORE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302801",
		"NOME_MUNICIPIO": "MARAA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1302900",
		"NOME_MUNICIPIO": "MAUES",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303007",
		"NOME_MUNICIPIO": "NHAMUNDA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303106",
		"NOME_MUNICIPIO": "NOVA OLINDA DO NORTE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303205",
		"NOME_MUNICIPIO": "NOVO AIRAO",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303304",
		"NOME_MUNICIPIO": "NOVO ARIPUANA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303403",
		"NOME_MUNICIPIO": "PARINTINS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303502",
		"NOME_MUNICIPIO": "PAUINI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303536",
		"NOME_MUNICIPIO": "PRESIDENTE FIGUEIREDO",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303569",
		"NOME_MUNICIPIO": "RIO PRETO DA EVA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303601",
		"NOME_MUNICIPIO": "SANTA ISABEL DO RIO NEGRO",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303700",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO IÇA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303809",
		"NOME_MUNICIPIO": "SAO GABRIEL DA CACHOEIRA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303908",
		"NOME_MUNICIPIO": "SAO PAULO DE OLIVENÇA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1303957",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO UATUMA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304005",
		"NOME_MUNICIPIO": "SILVES",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304062",
		"NOME_MUNICIPIO": "TABATINGA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304104",
		"NOME_MUNICIPIO": "TAPAUA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304203",
		"NOME_MUNICIPIO": "TEFE",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304237",
		"NOME_MUNICIPIO": "TONANTINS",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304260",
		"NOME_MUNICIPIO": "UARINI",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304302",
		"NOME_MUNICIPIO": "URUCARA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1304401",
		"NOME_MUNICIPIO": "URUCURITUBA",
		"COD_UF": "13"
	},
	{
		"COD_MUNICIPIO": "1400027",
		"NOME_MUNICIPIO": "AMAJARI",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400050",
		"NOME_MUNICIPIO": "ALTO ALEGRE",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400100",
		"NOME_MUNICIPIO": "BOA VISTA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400159",
		"NOME_MUNICIPIO": "BONFIM",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400175",
		"NOME_MUNICIPIO": "CANTA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400209",
		"NOME_MUNICIPIO": "CARACARAI",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400233",
		"NOME_MUNICIPIO": "CAROEBE",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400282",
		"NOME_MUNICIPIO": "IRACEMA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400308",
		"NOME_MUNICIPIO": "MUCAJAI",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400407",
		"NOME_MUNICIPIO": "NORMANDIA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400456",
		"NOME_MUNICIPIO": "PACARAIMA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400472",
		"NOME_MUNICIPIO": "RORAINOPOLIS",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400506",
		"NOME_MUNICIPIO": "SAO JOAO DA BALIZA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400605",
		"NOME_MUNICIPIO": "SAO LUIZ",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1400704",
		"NOME_MUNICIPIO": "UIRAMUTA",
		"COD_UF": "14"
	},
	{
		"COD_MUNICIPIO": "1500107",
		"NOME_MUNICIPIO": "ABAETETUBA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500131",
		"NOME_MUNICIPIO": "ABEL FIGUEIREDO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500206",
		"NOME_MUNICIPIO": "ACARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500305",
		"NOME_MUNICIPIO": "AFUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500347",
		"NOME_MUNICIPIO": "AGUA AZUL DO NORTE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500404",
		"NOME_MUNICIPIO": "ALENQUER",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500503",
		"NOME_MUNICIPIO": "ALMEIRIM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500602",
		"NOME_MUNICIPIO": "ALTAMIRA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500701",
		"NOME_MUNICIPIO": "ANAJAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500800",
		"NOME_MUNICIPIO": "ANANINDEUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500859",
		"NOME_MUNICIPIO": "ANAPU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500909",
		"NOME_MUNICIPIO": "AUGUSTO CORRÊA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1500958",
		"NOME_MUNICIPIO": "AURORA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501006",
		"NOME_MUNICIPIO": "AVEIRO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501105",
		"NOME_MUNICIPIO": "BAGRE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501204",
		"NOME_MUNICIPIO": "BAIAO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501253",
		"NOME_MUNICIPIO": "BANNACH",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501303",
		"NOME_MUNICIPIO": "BARCARENA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501402",
		"NOME_MUNICIPIO": "BELEM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501451",
		"NOME_MUNICIPIO": "BELTERRA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501501",
		"NOME_MUNICIPIO": "BENEVIDES",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501576",
		"NOME_MUNICIPIO": "BOM JESUS DO TOCANTINS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501600",
		"NOME_MUNICIPIO": "BONITO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501709",
		"NOME_MUNICIPIO": "BRAGANÇA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501725",
		"NOME_MUNICIPIO": "BRASIL NOVO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501758",
		"NOME_MUNICIPIO": "BREJO GRANDE DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501782",
		"NOME_MUNICIPIO": "BREU BRANCO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501808",
		"NOME_MUNICIPIO": "BREVES",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501907",
		"NOME_MUNICIPIO": "BUJARU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1501956",
		"NOME_MUNICIPIO": "CACHOEIRA DO PIRIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502004",
		"NOME_MUNICIPIO": "CACHOEIRA DO ARARI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502103",
		"NOME_MUNICIPIO": "CAMETA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502152",
		"NOME_MUNICIPIO": "CANAA DOS CARAJAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502202",
		"NOME_MUNICIPIO": "CAPANEMA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502301",
		"NOME_MUNICIPIO": "CAPITAO POÇO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502400",
		"NOME_MUNICIPIO": "CASTANHAL",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502509",
		"NOME_MUNICIPIO": "CHAVES",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502608",
		"NOME_MUNICIPIO": "COLARES",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502707",
		"NOME_MUNICIPIO": "CONCEIÇAO DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502756",
		"NOME_MUNICIPIO": "CONCORDIA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502764",
		"NOME_MUNICIPIO": "CUMARU DO NORTE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502772",
		"NOME_MUNICIPIO": "CURIONOPOLIS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502806",
		"NOME_MUNICIPIO": "CURRALINHO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502855",
		"NOME_MUNICIPIO": "CURUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502905",
		"NOME_MUNICIPIO": "CURUÇA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502939",
		"NOME_MUNICIPIO": "DOM ELISEU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1502954",
		"NOME_MUNICIPIO": "ELDORADO DO CARAJAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503002",
		"NOME_MUNICIPIO": "FARO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503044",
		"NOME_MUNICIPIO": "FLORESTA DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503077",
		"NOME_MUNICIPIO": "GARRAFAO DO NORTE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503093",
		"NOME_MUNICIPIO": "GOIANESIA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503101",
		"NOME_MUNICIPIO": "GURUPA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503200",
		"NOME_MUNICIPIO": "IGARAPE-AÇU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503309",
		"NOME_MUNICIPIO": "IGARAPE-MIRI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503408",
		"NOME_MUNICIPIO": "INHANGAPI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503457",
		"NOME_MUNICIPIO": "IPIXUNA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503507",
		"NOME_MUNICIPIO": "IRITUIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503606",
		"NOME_MUNICIPIO": "ITAITUBA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503705",
		"NOME_MUNICIPIO": "ITUPIRANGA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503754",
		"NOME_MUNICIPIO": "JACAREACANGA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503804",
		"NOME_MUNICIPIO": "JACUNDA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1503903",
		"NOME_MUNICIPIO": "JURUTI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504000",
		"NOME_MUNICIPIO": "LIMOEIRO DO AJURU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504059",
		"NOME_MUNICIPIO": "MAE DO RIO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504109",
		"NOME_MUNICIPIO": "MAGALHAES BARATA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504208",
		"NOME_MUNICIPIO": "MARABA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504307",
		"NOME_MUNICIPIO": "MARACANA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504406",
		"NOME_MUNICIPIO": "MARAPANIM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504422",
		"NOME_MUNICIPIO": "MARITUBA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504455",
		"NOME_MUNICIPIO": "MEDICILANDIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504505",
		"NOME_MUNICIPIO": "MELGAÇO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504604",
		"NOME_MUNICIPIO": "MOCAJUBA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504703",
		"NOME_MUNICIPIO": "MOJU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504752",
		"NOME_MUNICIPIO": "MOJUI DOS CAMPOS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504802",
		"NOME_MUNICIPIO": "MONTE ALEGRE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504901",
		"NOME_MUNICIPIO": "MUANA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504950",
		"NOME_MUNICIPIO": "NOVA ESPERANÇA DO PIRIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1504976",
		"NOME_MUNICIPIO": "NOVA IPIXUNA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505007",
		"NOME_MUNICIPIO": "NOVA TIMBOTEUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505031",
		"NOME_MUNICIPIO": "NOVO PROGRESSO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505064",
		"NOME_MUNICIPIO": "NOVO REPARTIMENTO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505106",
		"NOME_MUNICIPIO": "OBIDOS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505205",
		"NOME_MUNICIPIO": "OEIRAS DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505304",
		"NOME_MUNICIPIO": "ORIXIMINA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505403",
		"NOME_MUNICIPIO": "OUREM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505437",
		"NOME_MUNICIPIO": "OURILANDIA DO NORTE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505486",
		"NOME_MUNICIPIO": "PACAJA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505494",
		"NOME_MUNICIPIO": "PALESTINA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505502",
		"NOME_MUNICIPIO": "PARAGOMINAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505536",
		"NOME_MUNICIPIO": "PARAUAPEBAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505551",
		"NOME_MUNICIPIO": "PAU DARCO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505601",
		"NOME_MUNICIPIO": "PEIXE-BOI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505635",
		"NOME_MUNICIPIO": "PIÇARRA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505650",
		"NOME_MUNICIPIO": "PLACAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505700",
		"NOME_MUNICIPIO": "PONTA DE PEDRAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505809",
		"NOME_MUNICIPIO": "PORTEL",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1505908",
		"NOME_MUNICIPIO": "PORTO DE MOZ",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506005",
		"NOME_MUNICIPIO": "PRAINHA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506104",
		"NOME_MUNICIPIO": "PRIMAVERA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506112",
		"NOME_MUNICIPIO": "QUATIPURU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506138",
		"NOME_MUNICIPIO": "REDENÇAO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506161",
		"NOME_MUNICIPIO": "RIO MARIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506187",
		"NOME_MUNICIPIO": "RONDON DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506195",
		"NOME_MUNICIPIO": "RUROPOLIS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506203",
		"NOME_MUNICIPIO": "SALINOPOLIS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506302",
		"NOME_MUNICIPIO": "SALVATERRA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506351",
		"NOME_MUNICIPIO": "SANTA BARBARA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506401",
		"NOME_MUNICIPIO": "SANTA CRUZ DO ARARI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506500",
		"NOME_MUNICIPIO": "SANTA IZABEL DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506559",
		"NOME_MUNICIPIO": "SANTA LUZIA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506583",
		"NOME_MUNICIPIO": "SANTA MARIA DAS BARREIRAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506609",
		"NOME_MUNICIPIO": "SANTA MARIA DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506708",
		"NOME_MUNICIPIO": "SANTANA DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506807",
		"NOME_MUNICIPIO": "SANTAREM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1506906",
		"NOME_MUNICIPIO": "SANTAREM NOVO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507003",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO TAUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507102",
		"NOME_MUNICIPIO": "SAO CAETANO DE ODIVELAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507151",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507201",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO CAPIM",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507300",
		"NOME_MUNICIPIO": "SAO FELIX DO XINGU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507409",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO PARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507458",
		"NOME_MUNICIPIO": "SAO GERALDO DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507466",
		"NOME_MUNICIPIO": "SAO JOAO DA PONTA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507474",
		"NOME_MUNICIPIO": "SAO JOAO DE PIRABAS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507508",
		"NOME_MUNICIPIO": "SAO JOAO DO ARAGUAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507607",
		"NOME_MUNICIPIO": "SAO MIGUEL DO GUAMA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507706",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DA BOA VISTA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507755",
		"NOME_MUNICIPIO": "SAPUCAIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507805",
		"NOME_MUNICIPIO": "SENADOR JOSE PORFIRIO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507904",
		"NOME_MUNICIPIO": "SOURE",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507953",
		"NOME_MUNICIPIO": "TAILANDIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507961",
		"NOME_MUNICIPIO": "TERRA ALTA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1507979",
		"NOME_MUNICIPIO": "TERRA SANTA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508001",
		"NOME_MUNICIPIO": "TOME-AÇU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508035",
		"NOME_MUNICIPIO": "TRACUATEUA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508050",
		"NOME_MUNICIPIO": "TRAIRAO",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508084",
		"NOME_MUNICIPIO": "TUCUMA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508100",
		"NOME_MUNICIPIO": "TUCURUI",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508126",
		"NOME_MUNICIPIO": "ULIANOPOLIS",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508159",
		"NOME_MUNICIPIO": "URUARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508209",
		"NOME_MUNICIPIO": "VIGIA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508308",
		"NOME_MUNICIPIO": "VISEU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508357",
		"NOME_MUNICIPIO": "VITORIA DO XINGU",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1508407",
		"NOME_MUNICIPIO": "XINGUARA",
		"COD_UF": "15"
	},
	{
		"COD_MUNICIPIO": "1600055",
		"NOME_MUNICIPIO": "SERRA DO NAVIO",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600105",
		"NOME_MUNICIPIO": "AMAPA",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600154",
		"NOME_MUNICIPIO": "PEDRA BRANCA DO AMAPARI",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600204",
		"NOME_MUNICIPIO": "CALÇOENE",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600212",
		"NOME_MUNICIPIO": "CUTIAS",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600238",
		"NOME_MUNICIPIO": "FERREIRA GOMES",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600253",
		"NOME_MUNICIPIO": "ITAUBAL",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600279",
		"NOME_MUNICIPIO": "LARANJAL DO JARI",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600303",
		"NOME_MUNICIPIO": "MACAPA",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600402",
		"NOME_MUNICIPIO": "MAZAGAO",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600501",
		"NOME_MUNICIPIO": "OIAPOQUE",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600535",
		"NOME_MUNICIPIO": "PORTO GRANDE",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600550",
		"NOME_MUNICIPIO": "PRACUUBA",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600600",
		"NOME_MUNICIPIO": "SANTANA",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600709",
		"NOME_MUNICIPIO": "TARTARUGALZINHO",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1600808",
		"NOME_MUNICIPIO": "VITORIA DO JARI",
		"COD_UF": "16"
	},
	{
		"COD_MUNICIPIO": "1700251",
		"NOME_MUNICIPIO": "ABREULANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1700301",
		"NOME_MUNICIPIO": "AGUIARNOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1700350",
		"NOME_MUNICIPIO": "ALIANÇA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1700400",
		"NOME_MUNICIPIO": "ALMAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1700707",
		"NOME_MUNICIPIO": "ALVORADA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1701002",
		"NOME_MUNICIPIO": "ANANAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1701051",
		"NOME_MUNICIPIO": "ANGICO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1701101",
		"NOME_MUNICIPIO": "APARECIDA DO RIO NEGRO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1701309",
		"NOME_MUNICIPIO": "ARAGOMINAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1701903",
		"NOME_MUNICIPIO": "ARAGUACEMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702000",
		"NOME_MUNICIPIO": "ARAGUAÇU",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702109",
		"NOME_MUNICIPIO": "ARAGUAINA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702158",
		"NOME_MUNICIPIO": "ARAGUANA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702208",
		"NOME_MUNICIPIO": "ARAGUATINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702307",
		"NOME_MUNICIPIO": "ARAPOEMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702406",
		"NOME_MUNICIPIO": "ARRAIAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702554",
		"NOME_MUNICIPIO": "AUGUSTINOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702703",
		"NOME_MUNICIPIO": "AURORA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1702901",
		"NOME_MUNICIPIO": "AXIXA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703008",
		"NOME_MUNICIPIO": "BABAÇULANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703057",
		"NOME_MUNICIPIO": "BANDEIRANTES DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703073",
		"NOME_MUNICIPIO": "BARRA DO OURO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703107",
		"NOME_MUNICIPIO": "BARROLANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703206",
		"NOME_MUNICIPIO": "BERNARDO SAYAO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703305",
		"NOME_MUNICIPIO": "BOM JESUS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703602",
		"NOME_MUNICIPIO": "BRASILANDIA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703701",
		"NOME_MUNICIPIO": "BREJINHO DE NAZARE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703800",
		"NOME_MUNICIPIO": "BURITI DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703826",
		"NOME_MUNICIPIO": "CACHOEIRINHA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703842",
		"NOME_MUNICIPIO": "CAMPOS LINDOS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703867",
		"NOME_MUNICIPIO": "CARIRI DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703883",
		"NOME_MUNICIPIO": "CARMOLANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703891",
		"NOME_MUNICIPIO": "CARRASCO BONITO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1703909",
		"NOME_MUNICIPIO": "CASEARA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1704105",
		"NOME_MUNICIPIO": "CENTENARIO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1704600",
		"NOME_MUNICIPIO": "CHAPADA DE AREIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1705102",
		"NOME_MUNICIPIO": "CHAPADA DA NATIVIDADE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1705508",
		"NOME_MUNICIPIO": "COLINAS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1705557",
		"NOME_MUNICIPIO": "COMBINADO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1705607",
		"NOME_MUNICIPIO": "CONCEIÇAO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1706001",
		"NOME_MUNICIPIO": "COUTO MAGALHAES",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1706100",
		"NOME_MUNICIPIO": "CRISTALANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1706258",
		"NOME_MUNICIPIO": "CRIXAS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1706506",
		"NOME_MUNICIPIO": "DARCINOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707009",
		"NOME_MUNICIPIO": "DIANOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707108",
		"NOME_MUNICIPIO": "DIVINOPOLIS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707207",
		"NOME_MUNICIPIO": "DOIS IRMAOS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707306",
		"NOME_MUNICIPIO": "DUERE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707405",
		"NOME_MUNICIPIO": "ESPERANTINA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707553",
		"NOME_MUNICIPIO": "FATIMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707652",
		"NOME_MUNICIPIO": "FIGUEIROPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1707702",
		"NOME_MUNICIPIO": "FILADELFIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1708205",
		"NOME_MUNICIPIO": "FORMOSO DO ARAGUAIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1708254",
		"NOME_MUNICIPIO": "FORTALEZA DO TABOCAO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1708304",
		"NOME_MUNICIPIO": "GOIANORTE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1709005",
		"NOME_MUNICIPIO": "GOIATINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1709302",
		"NOME_MUNICIPIO": "GUARAI",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1709500",
		"NOME_MUNICIPIO": "GURUPI",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1709807",
		"NOME_MUNICIPIO": "IPUEIRAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1710508",
		"NOME_MUNICIPIO": "ITACAJA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1710706",
		"NOME_MUNICIPIO": "ITAGUATINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1710904",
		"NOME_MUNICIPIO": "ITAPIRATINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1711100",
		"NOME_MUNICIPIO": "ITAPORA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1711506",
		"NOME_MUNICIPIO": "JAU DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1711803",
		"NOME_MUNICIPIO": "JUARINA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1711902",
		"NOME_MUNICIPIO": "LAGOA DA CONFUSAO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1711951",
		"NOME_MUNICIPIO": "LAGOA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712009",
		"NOME_MUNICIPIO": "LAJEADO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712157",
		"NOME_MUNICIPIO": "LAVANDEIRA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712405",
		"NOME_MUNICIPIO": "LIZARDA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712454",
		"NOME_MUNICIPIO": "LUZINOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712504",
		"NOME_MUNICIPIO": "MARIANOPOLIS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712702",
		"NOME_MUNICIPIO": "MATEIROS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1712801",
		"NOME_MUNICIPIO": "MAURILANDIA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713205",
		"NOME_MUNICIPIO": "MIRACEMA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713304",
		"NOME_MUNICIPIO": "MIRANORTE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713601",
		"NOME_MUNICIPIO": "MONTE DO CARMO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713700",
		"NOME_MUNICIPIO": "MONTE SANTO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713809",
		"NOME_MUNICIPIO": "PALMEIRAS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1713957",
		"NOME_MUNICIPIO": "MURICILANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1714203",
		"NOME_MUNICIPIO": "NATIVIDADE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1714302",
		"NOME_MUNICIPIO": "NAZARE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1714880",
		"NOME_MUNICIPIO": "NOVA OLINDA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715002",
		"NOME_MUNICIPIO": "NOVA ROSALANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715101",
		"NOME_MUNICIPIO": "NOVO ACORDO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715150",
		"NOME_MUNICIPIO": "NOVO ALEGRE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715259",
		"NOME_MUNICIPIO": "NOVO JARDIM",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715507",
		"NOME_MUNICIPIO": "OLIVEIRA DE FATIMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715705",
		"NOME_MUNICIPIO": "PALMEIRANTE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1715754",
		"NOME_MUNICIPIO": "PALMEIROPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716109",
		"NOME_MUNICIPIO": "PARAISO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716208",
		"NOME_MUNICIPIO": "PARANA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716307",
		"NOME_MUNICIPIO": "PAU DARCO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716505",
		"NOME_MUNICIPIO": "PEDRO AFONSO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716604",
		"NOME_MUNICIPIO": "PEIXE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716653",
		"NOME_MUNICIPIO": "PEQUIZEIRO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1716703",
		"NOME_MUNICIPIO": "COLMEIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1717008",
		"NOME_MUNICIPIO": "PINDORAMA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1717206",
		"NOME_MUNICIPIO": "PIRAQUÊ",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1717503",
		"NOME_MUNICIPIO": "PIUM",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1717800",
		"NOME_MUNICIPIO": "PONTE ALTA DO BOM JESUS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1717909",
		"NOME_MUNICIPIO": "PONTE ALTA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718006",
		"NOME_MUNICIPIO": "PORTO ALEGRE DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718204",
		"NOME_MUNICIPIO": "PORTO NACIONAL",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718303",
		"NOME_MUNICIPIO": "PRAIA NORTE",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718402",
		"NOME_MUNICIPIO": "PRESIDENTE KENNEDY",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718451",
		"NOME_MUNICIPIO": "PUGMIL",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718501",
		"NOME_MUNICIPIO": "RECURSOLANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718550",
		"NOME_MUNICIPIO": "RIACHINHO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718659",
		"NOME_MUNICIPIO": "RIO DA CONCEIÇAO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718709",
		"NOME_MUNICIPIO": "RIO DOS BOIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718758",
		"NOME_MUNICIPIO": "RIO SONO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718808",
		"NOME_MUNICIPIO": "SAMPAIO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718840",
		"NOME_MUNICIPIO": "SANDOLANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718865",
		"NOME_MUNICIPIO": "SANTA FE DO ARAGUAIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718881",
		"NOME_MUNICIPIO": "SANTA MARIA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718899",
		"NOME_MUNICIPIO": "SANTA RITA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1718907",
		"NOME_MUNICIPIO": "SANTA ROSA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1719004",
		"NOME_MUNICIPIO": "SANTA TEREZA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720002",
		"NOME_MUNICIPIO": "SANTA TEREZINHA DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720101",
		"NOME_MUNICIPIO": "SAO BENTO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720150",
		"NOME_MUNICIPIO": "SAO FELIX DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720200",
		"NOME_MUNICIPIO": "SAO MIGUEL DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720259",
		"NOME_MUNICIPIO": "SAO SALVADOR DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720309",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720499",
		"NOME_MUNICIPIO": "SAO VALERIO",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720655",
		"NOME_MUNICIPIO": "SILVANOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720804",
		"NOME_MUNICIPIO": "SITIO NOVO DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720853",
		"NOME_MUNICIPIO": "SUCUPIRA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720903",
		"NOME_MUNICIPIO": "TAGUATINGA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720937",
		"NOME_MUNICIPIO": "TAIPAS DO TOCANTINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1720978",
		"NOME_MUNICIPIO": "TALISMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1721000",
		"NOME_MUNICIPIO": "PALMAS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1721109",
		"NOME_MUNICIPIO": "TOCANTINIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1721208",
		"NOME_MUNICIPIO": "TOCANTINOPOLIS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1721257",
		"NOME_MUNICIPIO": "TUPIRAMA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1721307",
		"NOME_MUNICIPIO": "TUPIRATINS",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1722081",
		"NOME_MUNICIPIO": "WANDERLANDIA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "1722107",
		"NOME_MUNICIPIO": "XAMBIOA",
		"COD_UF": "17"
	},
	{
		"COD_MUNICIPIO": "2100055",
		"NOME_MUNICIPIO": "AÇAILANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100105",
		"NOME_MUNICIPIO": "AFONSO CUNHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100154",
		"NOME_MUNICIPIO": "AGUA DOCE DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100204",
		"NOME_MUNICIPIO": "ALCANTARA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100303",
		"NOME_MUNICIPIO": "ALDEIAS ALTAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100402",
		"NOME_MUNICIPIO": "ALTAMIRA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100436",
		"NOME_MUNICIPIO": "ALTO ALEGRE DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100477",
		"NOME_MUNICIPIO": "ALTO ALEGRE DO PINDARE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100501",
		"NOME_MUNICIPIO": "ALTO PARNAIBA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100550",
		"NOME_MUNICIPIO": "AMAPA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100600",
		"NOME_MUNICIPIO": "AMARANTE DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100709",
		"NOME_MUNICIPIO": "ANAJATUBA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100808",
		"NOME_MUNICIPIO": "ANAPURUS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100832",
		"NOME_MUNICIPIO": "APICUM-AÇU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100873",
		"NOME_MUNICIPIO": "ARAGUANA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100907",
		"NOME_MUNICIPIO": "ARAIOSES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2100956",
		"NOME_MUNICIPIO": "ARAME",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101004",
		"NOME_MUNICIPIO": "ARARI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101103",
		"NOME_MUNICIPIO": "AXIXA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101202",
		"NOME_MUNICIPIO": "BACABAL",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101251",
		"NOME_MUNICIPIO": "BACABEIRA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101301",
		"NOME_MUNICIPIO": "BACURI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101350",
		"NOME_MUNICIPIO": "BACURITUBA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101400",
		"NOME_MUNICIPIO": "BALSAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101509",
		"NOME_MUNICIPIO": "BARAO DE GRAJAU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101608",
		"NOME_MUNICIPIO": "BARRA DO CORDA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101707",
		"NOME_MUNICIPIO": "BARREIRINHAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101731",
		"NOME_MUNICIPIO": "BELAGUA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101772",
		"NOME_MUNICIPIO": "BELA VISTA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101806",
		"NOME_MUNICIPIO": "BENEDITO LEITE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101905",
		"NOME_MUNICIPIO": "BEQUIMAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101939",
		"NOME_MUNICIPIO": "BERNARDO DO MEARIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2101970",
		"NOME_MUNICIPIO": "BOA VISTA DO GURUPI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102002",
		"NOME_MUNICIPIO": "BOM JARDIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102036",
		"NOME_MUNICIPIO": "BOM JESUS DAS SELVAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102077",
		"NOME_MUNICIPIO": "BOM LUGAR",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102101",
		"NOME_MUNICIPIO": "BREJO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102150",
		"NOME_MUNICIPIO": "BREJO DE AREIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102200",
		"NOME_MUNICIPIO": "BURITI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102309",
		"NOME_MUNICIPIO": "BURITI BRAVO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102325",
		"NOME_MUNICIPIO": "BURITICUPU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102358",
		"NOME_MUNICIPIO": "BURITIRANA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102374",
		"NOME_MUNICIPIO": "CACHOEIRA GRANDE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102408",
		"NOME_MUNICIPIO": "CAJAPIO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102507",
		"NOME_MUNICIPIO": "CAJARI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102556",
		"NOME_MUNICIPIO": "CAMPESTRE DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102606",
		"NOME_MUNICIPIO": "CANDIDO MENDES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102705",
		"NOME_MUNICIPIO": "CANTANHEDE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102754",
		"NOME_MUNICIPIO": "CAPINZAL DO NORTE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102804",
		"NOME_MUNICIPIO": "CAROLINA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2102903",
		"NOME_MUNICIPIO": "CARUTAPERA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103000",
		"NOME_MUNICIPIO": "CAXIAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103109",
		"NOME_MUNICIPIO": "CEDRAL",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103125",
		"NOME_MUNICIPIO": "CENTRAL DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103158",
		"NOME_MUNICIPIO": "CENTRO DO GUILHERME",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103174",
		"NOME_MUNICIPIO": "CENTRO NOVO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103208",
		"NOME_MUNICIPIO": "CHAPADINHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103257",
		"NOME_MUNICIPIO": "CIDELANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103307",
		"NOME_MUNICIPIO": "CODO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103406",
		"NOME_MUNICIPIO": "COELHO NETO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103505",
		"NOME_MUNICIPIO": "COLINAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103554",
		"NOME_MUNICIPIO": "CONCEIÇAO DO LAGO-AÇU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103604",
		"NOME_MUNICIPIO": "COROATA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103703",
		"NOME_MUNICIPIO": "CURURUPU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103752",
		"NOME_MUNICIPIO": "DAVINOPOLIS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103802",
		"NOME_MUNICIPIO": "DOM PEDRO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2103901",
		"NOME_MUNICIPIO": "DUQUE BACELAR",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104008",
		"NOME_MUNICIPIO": "ESPERANTINOPOLIS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104057",
		"NOME_MUNICIPIO": "ESTREITO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104073",
		"NOME_MUNICIPIO": "FEIRA NOVA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104081",
		"NOME_MUNICIPIO": "FERNANDO FALCAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104099",
		"NOME_MUNICIPIO": "FORMOSA DA SERRA NEGRA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104107",
		"NOME_MUNICIPIO": "FORTALEZA DOS NOGUEIRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104206",
		"NOME_MUNICIPIO": "FORTUNA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104305",
		"NOME_MUNICIPIO": "GODOFREDO VIANA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104404",
		"NOME_MUNICIPIO": "GONÇALVES DIAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104503",
		"NOME_MUNICIPIO": "GOVERNADOR ARCHER",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104552",
		"NOME_MUNICIPIO": "GOVERNADOR EDISON LOBAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104602",
		"NOME_MUNICIPIO": "GOVERNADOR EUGÊNIO BARROS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104628",
		"NOME_MUNICIPIO": "GOVERNADOR LUIZ ROCHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104651",
		"NOME_MUNICIPIO": "GOVERNADOR NEWTON BELLO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104677",
		"NOME_MUNICIPIO": "GOVERNADOR NUNES FREIRE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104701",
		"NOME_MUNICIPIO": "GRAÇA ARANHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104800",
		"NOME_MUNICIPIO": "GRAJAU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2104909",
		"NOME_MUNICIPIO": "GUIMARAES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105005",
		"NOME_MUNICIPIO": "HUMBERTO DE CAMPOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105104",
		"NOME_MUNICIPIO": "ICATU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105153",
		"NOME_MUNICIPIO": "IGARAPE DO MEIO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105203",
		"NOME_MUNICIPIO": "IGARAPE GRANDE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105302",
		"NOME_MUNICIPIO": "IMPERATRIZ",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105351",
		"NOME_MUNICIPIO": "ITAIPAVA DO GRAJAU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105401",
		"NOME_MUNICIPIO": "ITAPECURU MIRIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105427",
		"NOME_MUNICIPIO": "ITINGA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105450",
		"NOME_MUNICIPIO": "JATOBA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105476",
		"NOME_MUNICIPIO": "JENIPAPO DOS VIEIRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105500",
		"NOME_MUNICIPIO": "JOAO LISBOA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105609",
		"NOME_MUNICIPIO": "JOSELANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105658",
		"NOME_MUNICIPIO": "JUNCO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105708",
		"NOME_MUNICIPIO": "LAGO DA PEDRA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105807",
		"NOME_MUNICIPIO": "LAGO DO JUNCO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105906",
		"NOME_MUNICIPIO": "LAGO VERDE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105922",
		"NOME_MUNICIPIO": "LAGOA DO MATO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105948",
		"NOME_MUNICIPIO": "LAGO DOS RODRIGUES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105963",
		"NOME_MUNICIPIO": "LAGOA GRANDE DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2105989",
		"NOME_MUNICIPIO": "LAJEADO NOVO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106003",
		"NOME_MUNICIPIO": "LIMA CAMPOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106102",
		"NOME_MUNICIPIO": "LORETO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106201",
		"NOME_MUNICIPIO": "LUIS DOMINGUES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106300",
		"NOME_MUNICIPIO": "MAGALHAES DE ALMEIDA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106326",
		"NOME_MUNICIPIO": "MARACAÇUME",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106359",
		"NOME_MUNICIPIO": "MARAJA DO SENA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106375",
		"NOME_MUNICIPIO": "MARANHAOZINHO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106409",
		"NOME_MUNICIPIO": "MATA ROMA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106508",
		"NOME_MUNICIPIO": "MATINHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106607",
		"NOME_MUNICIPIO": "MATÕES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106631",
		"NOME_MUNICIPIO": "MATÕES DO NORTE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106672",
		"NOME_MUNICIPIO": "MILAGRES DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106706",
		"NOME_MUNICIPIO": "MIRADOR",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106755",
		"NOME_MUNICIPIO": "MIRANDA DO NORTE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106805",
		"NOME_MUNICIPIO": "MIRINZAL",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2106904",
		"NOME_MUNICIPIO": "MONÇAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107001",
		"NOME_MUNICIPIO": "MONTES ALTOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107100",
		"NOME_MUNICIPIO": "MORROS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107209",
		"NOME_MUNICIPIO": "NINA RODRIGUES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107258",
		"NOME_MUNICIPIO": "NOVA COLINAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107308",
		"NOME_MUNICIPIO": "NOVA IORQUE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107357",
		"NOME_MUNICIPIO": "NOVA OLINDA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107407",
		"NOME_MUNICIPIO": "OLHO DAGUA DAS CUNHAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107456",
		"NOME_MUNICIPIO": "OLINDA NOVA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107506",
		"NOME_MUNICIPIO": "PAÇO DO LUMIAR",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107605",
		"NOME_MUNICIPIO": "PALMEIRANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107704",
		"NOME_MUNICIPIO": "PARAIBANO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107803",
		"NOME_MUNICIPIO": "PARNARAMA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2107902",
		"NOME_MUNICIPIO": "PASSAGEM FRANCA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108009",
		"NOME_MUNICIPIO": "PASTOS BONS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108058",
		"NOME_MUNICIPIO": "PAULINO NEVES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108108",
		"NOME_MUNICIPIO": "PAULO RAMOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108207",
		"NOME_MUNICIPIO": "PEDREIRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108256",
		"NOME_MUNICIPIO": "PEDRO DO ROSARIO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108306",
		"NOME_MUNICIPIO": "PENALVA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108405",
		"NOME_MUNICIPIO": "PERI MIRIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108454",
		"NOME_MUNICIPIO": "PERITORO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108504",
		"NOME_MUNICIPIO": "PINDARE-MIRIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108603",
		"NOME_MUNICIPIO": "PINHEIRO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108702",
		"NOME_MUNICIPIO": "PIO XII",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108801",
		"NOME_MUNICIPIO": "PIRAPEMAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2108900",
		"NOME_MUNICIPIO": "POÇAO DE PEDRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109007",
		"NOME_MUNICIPIO": "PORTO FRANCO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109056",
		"NOME_MUNICIPIO": "PORTO RICO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109106",
		"NOME_MUNICIPIO": "PRESIDENTE DUTRA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109205",
		"NOME_MUNICIPIO": "PRESIDENTE JUSCELINO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109239",
		"NOME_MUNICIPIO": "PRESIDENTE MEDICI",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109270",
		"NOME_MUNICIPIO": "PRESIDENTE SARNEY",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109304",
		"NOME_MUNICIPIO": "PRESIDENTE VARGAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109403",
		"NOME_MUNICIPIO": "PRIMEIRA CRUZ",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109452",
		"NOME_MUNICIPIO": "RAPOSA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109502",
		"NOME_MUNICIPIO": "RIACHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109551",
		"NOME_MUNICIPIO": "RIBAMAR FIQUENE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109601",
		"NOME_MUNICIPIO": "ROSARIO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109700",
		"NOME_MUNICIPIO": "SAMBAIBA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109759",
		"NOME_MUNICIPIO": "SANTA FILOMENA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109809",
		"NOME_MUNICIPIO": "SANTA HELENA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2109908",
		"NOME_MUNICIPIO": "SANTA INÊS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110005",
		"NOME_MUNICIPIO": "SANTA LUZIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110039",
		"NOME_MUNICIPIO": "SANTA LUZIA DO PARUA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110104",
		"NOME_MUNICIPIO": "SANTA QUITERIA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110203",
		"NOME_MUNICIPIO": "SANTA RITA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110237",
		"NOME_MUNICIPIO": "SANTANA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110278",
		"NOME_MUNICIPIO": "SANTO AMARO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110302",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DOS LOPES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110401",
		"NOME_MUNICIPIO": "SAO BENEDITO DO RIO PRETO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110500",
		"NOME_MUNICIPIO": "SAO BENTO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110609",
		"NOME_MUNICIPIO": "SAO BERNARDO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110658",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO AZEITAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110708",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110807",
		"NOME_MUNICIPIO": "SAO FELIX DE BALSAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110856",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO BREJAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2110906",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111003",
		"NOME_MUNICIPIO": "SAO JOAO BATISTA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111029",
		"NOME_MUNICIPIO": "SAO JOAO DO CARU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111052",
		"NOME_MUNICIPIO": "SAO JOAO DO PARAISO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111078",
		"NOME_MUNICIPIO": "SAO JOAO DO SOTER",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111102",
		"NOME_MUNICIPIO": "SAO JOAO DOS PATOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111201",
		"NOME_MUNICIPIO": "SAO JOSE DE RIBAMAR",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111250",
		"NOME_MUNICIPIO": "SAO JOSE DOS BASILIOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111300",
		"NOME_MUNICIPIO": "SAO LUIS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111409",
		"NOME_MUNICIPIO": "SAO LUIS GONZAGA DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111508",
		"NOME_MUNICIPIO": "SAO MATEUS DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111532",
		"NOME_MUNICIPIO": "SAO PEDRO DA AGUA BRANCA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111573",
		"NOME_MUNICIPIO": "SAO PEDRO DOS CRENTES",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111607",
		"NOME_MUNICIPIO": "SAO RAIMUNDO DAS MANGABEIRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111631",
		"NOME_MUNICIPIO": "SAO RAIMUNDO DO DOCA BEZERRA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111672",
		"NOME_MUNICIPIO": "SAO ROBERTO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111706",
		"NOME_MUNICIPIO": "SAO VICENTE FERRER",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111722",
		"NOME_MUNICIPIO": "SATUBINHA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111748",
		"NOME_MUNICIPIO": "SENADOR ALEXANDRE COSTA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111763",
		"NOME_MUNICIPIO": "SENADOR LA ROCQUE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111789",
		"NOME_MUNICIPIO": "SERRANO DO MARANHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111805",
		"NOME_MUNICIPIO": "SITIO NOVO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111904",
		"NOME_MUNICIPIO": "SUCUPIRA DO NORTE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2111953",
		"NOME_MUNICIPIO": "SUCUPIRA DO RIACHAO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112001",
		"NOME_MUNICIPIO": "TASSO FRAGOSO",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112100",
		"NOME_MUNICIPIO": "TIMBIRAS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112209",
		"NOME_MUNICIPIO": "TIMON",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112233",
		"NOME_MUNICIPIO": "TRIZIDELA DO VALE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112274",
		"NOME_MUNICIPIO": "TUFILANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112308",
		"NOME_MUNICIPIO": "TUNTUM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112407",
		"NOME_MUNICIPIO": "TURIAÇU",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112456",
		"NOME_MUNICIPIO": "TURILANDIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112506",
		"NOME_MUNICIPIO": "TUTOIA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112605",
		"NOME_MUNICIPIO": "URBANO SANTOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112704",
		"NOME_MUNICIPIO": "VARGEM GRANDE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112803",
		"NOME_MUNICIPIO": "VIANA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112852",
		"NOME_MUNICIPIO": "VILA NOVA DOS MARTIRIOS",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2112902",
		"NOME_MUNICIPIO": "VITORIA DO MEARIM",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2113009",
		"NOME_MUNICIPIO": "VITORINO FREIRE",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2114007",
		"NOME_MUNICIPIO": "ZE DOCA",
		"COD_UF": "21"
	},
	{
		"COD_MUNICIPIO": "2200053",
		"NOME_MUNICIPIO": "ACAUA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200103",
		"NOME_MUNICIPIO": "AGRICOLANDIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200202",
		"NOME_MUNICIPIO": "AGUA BRANCA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200251",
		"NOME_MUNICIPIO": "ALAGOINHA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200277",
		"NOME_MUNICIPIO": "ALEGRETE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200301",
		"NOME_MUNICIPIO": "ALTO LONGA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200400",
		"NOME_MUNICIPIO": "ALTOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200459",
		"NOME_MUNICIPIO": "ALVORADA DO GURGUEIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200509",
		"NOME_MUNICIPIO": "AMARANTE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200608",
		"NOME_MUNICIPIO": "ANGICAL DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200707",
		"NOME_MUNICIPIO": "ANISIO DE ABREU",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200806",
		"NOME_MUNICIPIO": "ANTÔNIO ALMEIDA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200905",
		"NOME_MUNICIPIO": "AROAZES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2200954",
		"NOME_MUNICIPIO": "AROEIRAS DO ITAIM",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201002",
		"NOME_MUNICIPIO": "ARRAIAL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201051",
		"NOME_MUNICIPIO": "ASSUNÇAO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201101",
		"NOME_MUNICIPIO": "AVELINO LOPES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201150",
		"NOME_MUNICIPIO": "BAIXA GRANDE DO RIBEIRO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201176",
		"NOME_MUNICIPIO": "BARRA DALCANTARA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201200",
		"NOME_MUNICIPIO": "BARRAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201309",
		"NOME_MUNICIPIO": "BARREIRAS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201408",
		"NOME_MUNICIPIO": "BARRO DURO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201507",
		"NOME_MUNICIPIO": "BATALHA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201556",
		"NOME_MUNICIPIO": "BELA VISTA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201572",
		"NOME_MUNICIPIO": "BELEM DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201606",
		"NOME_MUNICIPIO": "BENEDITINOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201705",
		"NOME_MUNICIPIO": "BERTOLINIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201739",
		"NOME_MUNICIPIO": "BETANIA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201770",
		"NOME_MUNICIPIO": "BOA HORA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201804",
		"NOME_MUNICIPIO": "BOCAINA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201903",
		"NOME_MUNICIPIO": "BOM JESUS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201919",
		"NOME_MUNICIPIO": "BOM PRINCIPIO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201929",
		"NOME_MUNICIPIO": "BONFIM DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201945",
		"NOME_MUNICIPIO": "BOQUEIRAO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201960",
		"NOME_MUNICIPIO": "BRASILEIRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2201988",
		"NOME_MUNICIPIO": "BREJO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202000",
		"NOME_MUNICIPIO": "BURITI DOS LOPES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202026",
		"NOME_MUNICIPIO": "BURITI DOS MONTES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202059",
		"NOME_MUNICIPIO": "CABECEIRAS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202075",
		"NOME_MUNICIPIO": "CAJAZEIRAS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202083",
		"NOME_MUNICIPIO": "CAJUEIRO DA PRAIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202091",
		"NOME_MUNICIPIO": "CALDEIRAO GRANDE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202109",
		"NOME_MUNICIPIO": "CAMPINAS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202117",
		"NOME_MUNICIPIO": "CAMPO ALEGRE DO FIDALGO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202133",
		"NOME_MUNICIPIO": "CAMPO GRANDE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202174",
		"NOME_MUNICIPIO": "CAMPO LARGO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202208",
		"NOME_MUNICIPIO": "CAMPO MAIOR",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202251",
		"NOME_MUNICIPIO": "CANAVIEIRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202307",
		"NOME_MUNICIPIO": "CANTO DO BURITI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202406",
		"NOME_MUNICIPIO": "CAPITAO DE CAMPOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202455",
		"NOME_MUNICIPIO": "CAPITAO GERVASIO OLIVEIRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202505",
		"NOME_MUNICIPIO": "CARACOL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202539",
		"NOME_MUNICIPIO": "CARAUBAS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202554",
		"NOME_MUNICIPIO": "CARIDADE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202604",
		"NOME_MUNICIPIO": "CASTELO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202653",
		"NOME_MUNICIPIO": "CAXINGO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202703",
		"NOME_MUNICIPIO": "COCAL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202711",
		"NOME_MUNICIPIO": "COCAL DE TELHA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202729",
		"NOME_MUNICIPIO": "COCAL DOS ALVES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202737",
		"NOME_MUNICIPIO": "COIVARAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202752",
		"NOME_MUNICIPIO": "COLÔNIA DO GURGUEIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202778",
		"NOME_MUNICIPIO": "COLÔNIA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202802",
		"NOME_MUNICIPIO": "CONCEIÇAO DO CANINDE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202851",
		"NOME_MUNICIPIO": "CORONEL JOSE DIAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2202901",
		"NOME_MUNICIPIO": "CORRENTE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203008",
		"NOME_MUNICIPIO": "CRISTALANDIA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203107",
		"NOME_MUNICIPIO": "CRISTINO CASTRO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203206",
		"NOME_MUNICIPIO": "CURIMATA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203230",
		"NOME_MUNICIPIO": "CURRAIS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203255",
		"NOME_MUNICIPIO": "CURRALINHOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203271",
		"NOME_MUNICIPIO": "CURRAL NOVO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203305",
		"NOME_MUNICIPIO": "DEMERVAL LOBAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203354",
		"NOME_MUNICIPIO": "DIRCEU ARCOVERDE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203404",
		"NOME_MUNICIPIO": "DOM EXPEDITO LOPES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203420",
		"NOME_MUNICIPIO": "DOMINGOS MOURAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203453",
		"NOME_MUNICIPIO": "DOM INOCÊNCIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203503",
		"NOME_MUNICIPIO": "ELESBAO VELOSO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203602",
		"NOME_MUNICIPIO": "ELISEU MARTINS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203701",
		"NOME_MUNICIPIO": "ESPERANTINA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203750",
		"NOME_MUNICIPIO": "FARTURA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203800",
		"NOME_MUNICIPIO": "FLORES DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203859",
		"NOME_MUNICIPIO": "FLORESTA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2203909",
		"NOME_MUNICIPIO": "FLORIANO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204006",
		"NOME_MUNICIPIO": "FRANCINOPOLIS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204105",
		"NOME_MUNICIPIO": "FRANCISCO AYRES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204154",
		"NOME_MUNICIPIO": "FRANCISCO MACEDO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204204",
		"NOME_MUNICIPIO": "FRANCISCO SANTOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204303",
		"NOME_MUNICIPIO": "FRONTEIRAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204352",
		"NOME_MUNICIPIO": "GEMINIANO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204402",
		"NOME_MUNICIPIO": "GILBUES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204501",
		"NOME_MUNICIPIO": "GUADALUPE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204550",
		"NOME_MUNICIPIO": "GUARIBAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204600",
		"NOME_MUNICIPIO": "HUGO NAPOLEAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204659",
		"NOME_MUNICIPIO": "ILHA GRANDE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204709",
		"NOME_MUNICIPIO": "INHUMA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204808",
		"NOME_MUNICIPIO": "IPIRANGA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2204907",
		"NOME_MUNICIPIO": "ISAIAS COELHO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205003",
		"NOME_MUNICIPIO": "ITAINOPOLIS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205102",
		"NOME_MUNICIPIO": "ITAUEIRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205151",
		"NOME_MUNICIPIO": "JACOBINA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205201",
		"NOME_MUNICIPIO": "JAICOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205250",
		"NOME_MUNICIPIO": "JARDIM DO MULATO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205276",
		"NOME_MUNICIPIO": "JATOBA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205300",
		"NOME_MUNICIPIO": "JERUMENHA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205359",
		"NOME_MUNICIPIO": "JOAO COSTA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205409",
		"NOME_MUNICIPIO": "JOAQUIM PIRES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205458",
		"NOME_MUNICIPIO": "JOCA MARQUES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205508",
		"NOME_MUNICIPIO": "JOSE DE FREITAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205516",
		"NOME_MUNICIPIO": "JUAZEIRO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205524",
		"NOME_MUNICIPIO": "JULIO BORGES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205532",
		"NOME_MUNICIPIO": "JUREMA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205540",
		"NOME_MUNICIPIO": "LAGOINHA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205557",
		"NOME_MUNICIPIO": "LAGOA ALEGRE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205565",
		"NOME_MUNICIPIO": "LAGOA DO BARRO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205573",
		"NOME_MUNICIPIO": "LAGOA DE SAO FRANCISCO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205581",
		"NOME_MUNICIPIO": "LAGOA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205599",
		"NOME_MUNICIPIO": "LAGOA DO SITIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205607",
		"NOME_MUNICIPIO": "LANDRI SALES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205706",
		"NOME_MUNICIPIO": "LUIS CORREIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205805",
		"NOME_MUNICIPIO": "LUZILANDIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205854",
		"NOME_MUNICIPIO": "MADEIRO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205904",
		"NOME_MUNICIPIO": "MANOEL EMIDIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2205953",
		"NOME_MUNICIPIO": "MARCOLANDIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206001",
		"NOME_MUNICIPIO": "MARCOS PARENTE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206050",
		"NOME_MUNICIPIO": "MASSAPÊ DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206100",
		"NOME_MUNICIPIO": "MATIAS OLIMPIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206209",
		"NOME_MUNICIPIO": "MIGUEL ALVES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206308",
		"NOME_MUNICIPIO": "MIGUEL LEAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206357",
		"NOME_MUNICIPIO": "MILTON BRANDAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206407",
		"NOME_MUNICIPIO": "MONSENHOR GIL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206506",
		"NOME_MUNICIPIO": "MONSENHOR HIPOLITO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206605",
		"NOME_MUNICIPIO": "MONTE ALEGRE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206654",
		"NOME_MUNICIPIO": "MORRO CABEÇA NO TEMPO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206670",
		"NOME_MUNICIPIO": "MORRO DO CHAPEU DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206696",
		"NOME_MUNICIPIO": "MURICI DOS PORTELAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206704",
		"NOME_MUNICIPIO": "NAZARE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206720",
		"NOME_MUNICIPIO": "NAZARIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206753",
		"NOME_MUNICIPIO": "NOSSA SENHORA DE NAZARE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206803",
		"NOME_MUNICIPIO": "NOSSA SENHORA DOS REMEDIOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206902",
		"NOME_MUNICIPIO": "NOVO ORIENTE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2206951",
		"NOME_MUNICIPIO": "NOVO SANTO ANTÔNIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207009",
		"NOME_MUNICIPIO": "OEIRAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207108",
		"NOME_MUNICIPIO": "OLHO DAGUA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207207",
		"NOME_MUNICIPIO": "PADRE MARCOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207306",
		"NOME_MUNICIPIO": "PAES LANDIM",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207355",
		"NOME_MUNICIPIO": "PAJEU DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207405",
		"NOME_MUNICIPIO": "PALMEIRA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207504",
		"NOME_MUNICIPIO": "PALMEIRAIS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207553",
		"NOME_MUNICIPIO": "PAQUETA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207603",
		"NOME_MUNICIPIO": "PARNAGUA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207702",
		"NOME_MUNICIPIO": "PARNAIBA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207751",
		"NOME_MUNICIPIO": "PASSAGEM FRANCA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207777",
		"NOME_MUNICIPIO": "PATOS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207793",
		"NOME_MUNICIPIO": "PAU DARCO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207801",
		"NOME_MUNICIPIO": "PAULISTANA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207850",
		"NOME_MUNICIPIO": "PAVUSSU",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207900",
		"NOME_MUNICIPIO": "PEDRO II",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207934",
		"NOME_MUNICIPIO": "PEDRO LAURENTINO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2207959",
		"NOME_MUNICIPIO": "NOVA SANTA RITA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208007",
		"NOME_MUNICIPIO": "PICOS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208106",
		"NOME_MUNICIPIO": "PIMENTEIRAS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208205",
		"NOME_MUNICIPIO": "PIO IX",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208304",
		"NOME_MUNICIPIO": "PIRACURUCA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208403",
		"NOME_MUNICIPIO": "PIRIPIRI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208502",
		"NOME_MUNICIPIO": "PORTO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208551",
		"NOME_MUNICIPIO": "PORTO ALEGRE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208601",
		"NOME_MUNICIPIO": "PRATA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208650",
		"NOME_MUNICIPIO": "QUEIMADA NOVA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208700",
		"NOME_MUNICIPIO": "REDENÇAO DO GURGUEIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208809",
		"NOME_MUNICIPIO": "REGENERAÇAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208858",
		"NOME_MUNICIPIO": "RIACHO FRIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208874",
		"NOME_MUNICIPIO": "RIBEIRA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2208908",
		"NOME_MUNICIPIO": "RIBEIRO GONÇALVES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209005",
		"NOME_MUNICIPIO": "RIO GRANDE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209104",
		"NOME_MUNICIPIO": "SANTA CRUZ DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209153",
		"NOME_MUNICIPIO": "SANTA CRUZ DOS MILAGRES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209203",
		"NOME_MUNICIPIO": "SANTA FILOMENA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209302",
		"NOME_MUNICIPIO": "SANTA LUZ",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209351",
		"NOME_MUNICIPIO": "SANTANA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209377",
		"NOME_MUNICIPIO": "SANTA ROSA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209401",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DE LISBOA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209450",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DOS MILAGRES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209500",
		"NOME_MUNICIPIO": "SANTO INACIO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209559",
		"NOME_MUNICIPIO": "SAO BRAZ DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209609",
		"NOME_MUNICIPIO": "SAO FELIX DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209658",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE ASSIS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209708",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209757",
		"NOME_MUNICIPIO": "SAO GONÇALO DO GURGUEIA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209807",
		"NOME_MUNICIPIO": "SAO GONÇALO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209856",
		"NOME_MUNICIPIO": "SAO JOAO DA CANABRAVA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209872",
		"NOME_MUNICIPIO": "SAO JOAO DA FRONTEIRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209906",
		"NOME_MUNICIPIO": "SAO JOAO DA SERRA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209955",
		"NOME_MUNICIPIO": "SAO JOAO DA VARJOTA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2209971",
		"NOME_MUNICIPIO": "SAO JOAO DO ARRAIAL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210003",
		"NOME_MUNICIPIO": "SAO JOAO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210052",
		"NOME_MUNICIPIO": "SAO JOSE DO DIVINO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210102",
		"NOME_MUNICIPIO": "SAO JOSE DO PEIXE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210201",
		"NOME_MUNICIPIO": "SAO JOSE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210300",
		"NOME_MUNICIPIO": "SAO JULIAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210359",
		"NOME_MUNICIPIO": "SAO LOURENÇO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210375",
		"NOME_MUNICIPIO": "SAO LUIS DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210383",
		"NOME_MUNICIPIO": "SAO MIGUEL DA BAIXA GRANDE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210391",
		"NOME_MUNICIPIO": "SAO MIGUEL DO FIDALGO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210409",
		"NOME_MUNICIPIO": "SAO MIGUEL DO TAPUIO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210508",
		"NOME_MUNICIPIO": "SAO PEDRO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210607",
		"NOME_MUNICIPIO": "SAO RAIMUNDO NONATO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210623",
		"NOME_MUNICIPIO": "SEBASTIAO BARROS",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210631",
		"NOME_MUNICIPIO": "SEBASTIAO LEAL",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210656",
		"NOME_MUNICIPIO": "SIGEFREDO PACHECO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210706",
		"NOME_MUNICIPIO": "SIMÕES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210805",
		"NOME_MUNICIPIO": "SIMPLICIO MENDES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210904",
		"NOME_MUNICIPIO": "SOCORRO DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210938",
		"NOME_MUNICIPIO": "SUSSUAPARA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210953",
		"NOME_MUNICIPIO": "TAMBORIL DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2210979",
		"NOME_MUNICIPIO": "TANQUE DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211001",
		"NOME_MUNICIPIO": "TERESINA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211100",
		"NOME_MUNICIPIO": "UNIAO",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211209",
		"NOME_MUNICIPIO": "URUÇUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211308",
		"NOME_MUNICIPIO": "VALENÇA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211357",
		"NOME_MUNICIPIO": "VARZEA BRANCA",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211407",
		"NOME_MUNICIPIO": "VARZEA GRANDE",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211506",
		"NOME_MUNICIPIO": "VERA MENDES",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211605",
		"NOME_MUNICIPIO": "VILA NOVA DO PIAUI",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2211704",
		"NOME_MUNICIPIO": "WALL FERRAZ",
		"COD_UF": "22"
	},
	{
		"COD_MUNICIPIO": "2300101",
		"NOME_MUNICIPIO": "ABAIARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300150",
		"NOME_MUNICIPIO": "ACARAPE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300200",
		"NOME_MUNICIPIO": "ACARAU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300309",
		"NOME_MUNICIPIO": "ACOPIARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300408",
		"NOME_MUNICIPIO": "AIUABA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300507",
		"NOME_MUNICIPIO": "ALCANTARAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300606",
		"NOME_MUNICIPIO": "ALTANEIRA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300705",
		"NOME_MUNICIPIO": "ALTO SANTO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300754",
		"NOME_MUNICIPIO": "AMONTADA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300804",
		"NOME_MUNICIPIO": "ANTONINA DO NORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2300903",
		"NOME_MUNICIPIO": "APUIARES",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301000",
		"NOME_MUNICIPIO": "AQUIRAZ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301109",
		"NOME_MUNICIPIO": "ARACATI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301208",
		"NOME_MUNICIPIO": "ARACOIABA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301257",
		"NOME_MUNICIPIO": "ARARENDA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301307",
		"NOME_MUNICIPIO": "ARARIPE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301406",
		"NOME_MUNICIPIO": "ARATUBA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301505",
		"NOME_MUNICIPIO": "ARNEIROZ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301604",
		"NOME_MUNICIPIO": "ASSARE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301703",
		"NOME_MUNICIPIO": "AURORA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301802",
		"NOME_MUNICIPIO": "BAIXIO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301851",
		"NOME_MUNICIPIO": "BANABUIU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301901",
		"NOME_MUNICIPIO": "BARBALHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2301950",
		"NOME_MUNICIPIO": "BARREIRA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302008",
		"NOME_MUNICIPIO": "BARRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302057",
		"NOME_MUNICIPIO": "BARROQUINHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302107",
		"NOME_MUNICIPIO": "BATURITE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302206",
		"NOME_MUNICIPIO": "BEBERIBE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302305",
		"NOME_MUNICIPIO": "BELA CRUZ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302404",
		"NOME_MUNICIPIO": "BOA VIAGEM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302503",
		"NOME_MUNICIPIO": "BREJO SANTO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302602",
		"NOME_MUNICIPIO": "CAMOCIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302701",
		"NOME_MUNICIPIO": "CAMPOS SALES",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302800",
		"NOME_MUNICIPIO": "CANINDE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2302909",
		"NOME_MUNICIPIO": "CAPISTRANO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303006",
		"NOME_MUNICIPIO": "CARIDADE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303105",
		"NOME_MUNICIPIO": "CARIRE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303204",
		"NOME_MUNICIPIO": "CARIRIAÇU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303303",
		"NOME_MUNICIPIO": "CARIUS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303402",
		"NOME_MUNICIPIO": "CARNAUBAL",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303501",
		"NOME_MUNICIPIO": "CASCAVEL",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303600",
		"NOME_MUNICIPIO": "CATARINA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303659",
		"NOME_MUNICIPIO": "CATUNDA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303709",
		"NOME_MUNICIPIO": "CAUCAIA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303808",
		"NOME_MUNICIPIO": "CEDRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303907",
		"NOME_MUNICIPIO": "CHAVAL",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303931",
		"NOME_MUNICIPIO": "CHORO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2303956",
		"NOME_MUNICIPIO": "CHOROZINHO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304004",
		"NOME_MUNICIPIO": "COREAU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304103",
		"NOME_MUNICIPIO": "CRATEUS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304202",
		"NOME_MUNICIPIO": "CRATO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304236",
		"NOME_MUNICIPIO": "CROATA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304251",
		"NOME_MUNICIPIO": "CRUZ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304269",
		"NOME_MUNICIPIO": "DEPUTADO IRAPUAN PINHEIRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304277",
		"NOME_MUNICIPIO": "ERERÊ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304285",
		"NOME_MUNICIPIO": "EUSEBIO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304301",
		"NOME_MUNICIPIO": "FARIAS BRITO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304350",
		"NOME_MUNICIPIO": "FORQUILHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304400",
		"NOME_MUNICIPIO": "FORTALEZA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304459",
		"NOME_MUNICIPIO": "FORTIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304509",
		"NOME_MUNICIPIO": "FRECHEIRINHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304608",
		"NOME_MUNICIPIO": "GENERAL SAMPAIO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304657",
		"NOME_MUNICIPIO": "GRAÇA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304707",
		"NOME_MUNICIPIO": "GRANJA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304806",
		"NOME_MUNICIPIO": "GRANJEIRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304905",
		"NOME_MUNICIPIO": "GROAIRAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2304954",
		"NOME_MUNICIPIO": "GUAIUBA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305001",
		"NOME_MUNICIPIO": "GUARACIABA DO NORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305100",
		"NOME_MUNICIPIO": "GUARAMIRANGA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305209",
		"NOME_MUNICIPIO": "HIDROLANDIA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305233",
		"NOME_MUNICIPIO": "HORIZONTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305266",
		"NOME_MUNICIPIO": "IBARETAMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305308",
		"NOME_MUNICIPIO": "IBIAPINA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305332",
		"NOME_MUNICIPIO": "IBICUITINGA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305357",
		"NOME_MUNICIPIO": "ICAPUI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305407",
		"NOME_MUNICIPIO": "ICO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305506",
		"NOME_MUNICIPIO": "IGUATU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305605",
		"NOME_MUNICIPIO": "INDEPENDÊNCIA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305654",
		"NOME_MUNICIPIO": "IPAPORANGA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305704",
		"NOME_MUNICIPIO": "IPAUMIRIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305803",
		"NOME_MUNICIPIO": "IPU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2305902",
		"NOME_MUNICIPIO": "IPUEIRAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306009",
		"NOME_MUNICIPIO": "IRACEMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306108",
		"NOME_MUNICIPIO": "IRAUÇUBA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306207",
		"NOME_MUNICIPIO": "ITAIÇABA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306256",
		"NOME_MUNICIPIO": "ITAITINGA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306306",
		"NOME_MUNICIPIO": "ITAPAJE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306405",
		"NOME_MUNICIPIO": "ITAPIPOCA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306504",
		"NOME_MUNICIPIO": "ITAPIUNA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306553",
		"NOME_MUNICIPIO": "ITAREMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306603",
		"NOME_MUNICIPIO": "ITATIRA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306702",
		"NOME_MUNICIPIO": "JAGUARETAMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306801",
		"NOME_MUNICIPIO": "JAGUARIBARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2306900",
		"NOME_MUNICIPIO": "JAGUARIBE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307007",
		"NOME_MUNICIPIO": "JAGUARUANA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307106",
		"NOME_MUNICIPIO": "JARDIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307205",
		"NOME_MUNICIPIO": "JATI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307254",
		"NOME_MUNICIPIO": "JIJOCA DE JERICOACOARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307304",
		"NOME_MUNICIPIO": "JUAZEIRO DO NORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307403",
		"NOME_MUNICIPIO": "JUCAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307502",
		"NOME_MUNICIPIO": "LAVRAS DA MANGABEIRA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307601",
		"NOME_MUNICIPIO": "LIMOEIRO DO NORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307635",
		"NOME_MUNICIPIO": "MADALENA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307650",
		"NOME_MUNICIPIO": "MARACANAU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307700",
		"NOME_MUNICIPIO": "MARANGUAPE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307809",
		"NOME_MUNICIPIO": "MARCO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2307908",
		"NOME_MUNICIPIO": "MARTINOPOLE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308005",
		"NOME_MUNICIPIO": "MASSAPÊ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308104",
		"NOME_MUNICIPIO": "MAURITI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308203",
		"NOME_MUNICIPIO": "MERUOCA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308302",
		"NOME_MUNICIPIO": "MILAGRES",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308351",
		"NOME_MUNICIPIO": "MILHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308377",
		"NOME_MUNICIPIO": "MIRAIMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308401",
		"NOME_MUNICIPIO": "MISSAO VELHA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308500",
		"NOME_MUNICIPIO": "MOMBAÇA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308609",
		"NOME_MUNICIPIO": "MONSENHOR TABOSA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308708",
		"NOME_MUNICIPIO": "MORADA NOVA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308807",
		"NOME_MUNICIPIO": "MORAUJO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2308906",
		"NOME_MUNICIPIO": "MORRINHOS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309003",
		"NOME_MUNICIPIO": "MUCAMBO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309102",
		"NOME_MUNICIPIO": "MULUNGU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309201",
		"NOME_MUNICIPIO": "NOVA OLINDA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309300",
		"NOME_MUNICIPIO": "NOVA RUSSAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309409",
		"NOME_MUNICIPIO": "NOVO ORIENTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309458",
		"NOME_MUNICIPIO": "OCARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309508",
		"NOME_MUNICIPIO": "OROS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309607",
		"NOME_MUNICIPIO": "PACAJUS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309706",
		"NOME_MUNICIPIO": "PACATUBA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309805",
		"NOME_MUNICIPIO": "PACOTI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2309904",
		"NOME_MUNICIPIO": "PACUJA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310001",
		"NOME_MUNICIPIO": "PALHANO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310100",
		"NOME_MUNICIPIO": "PALMACIA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310209",
		"NOME_MUNICIPIO": "PARACURU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310258",
		"NOME_MUNICIPIO": "PARAIPABA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310308",
		"NOME_MUNICIPIO": "PARAMBU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310407",
		"NOME_MUNICIPIO": "PARAMOTI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310506",
		"NOME_MUNICIPIO": "PEDRA BRANCA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310605",
		"NOME_MUNICIPIO": "PENAFORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310704",
		"NOME_MUNICIPIO": "PENTECOSTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310803",
		"NOME_MUNICIPIO": "PEREIRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310852",
		"NOME_MUNICIPIO": "PINDORETAMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310902",
		"NOME_MUNICIPIO": "PIQUET CARNEIRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2310951",
		"NOME_MUNICIPIO": "PIRES FERREIRA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311009",
		"NOME_MUNICIPIO": "PORANGA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311108",
		"NOME_MUNICIPIO": "PORTEIRAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311207",
		"NOME_MUNICIPIO": "POTENGI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311231",
		"NOME_MUNICIPIO": "POTIRETAMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311264",
		"NOME_MUNICIPIO": "QUITERIANOPOLIS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311306",
		"NOME_MUNICIPIO": "QUIXADA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311355",
		"NOME_MUNICIPIO": "QUIXELÔ",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311405",
		"NOME_MUNICIPIO": "QUIXERAMOBIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311504",
		"NOME_MUNICIPIO": "QUIXERE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311603",
		"NOME_MUNICIPIO": "REDENÇAO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311702",
		"NOME_MUNICIPIO": "RERIUTABA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311801",
		"NOME_MUNICIPIO": "RUSSAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311900",
		"NOME_MUNICIPIO": "SABOEIRO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2311959",
		"NOME_MUNICIPIO": "SALITRE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312007",
		"NOME_MUNICIPIO": "SANTANA DO ACARAU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312106",
		"NOME_MUNICIPIO": "SANTANA DO CARIRI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312205",
		"NOME_MUNICIPIO": "SANTA QUITERIA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312304",
		"NOME_MUNICIPIO": "SAO BENEDITO",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312403",
		"NOME_MUNICIPIO": "SAO GONÇALO DO AMARANTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312502",
		"NOME_MUNICIPIO": "SAO JOAO DO JAGUARIBE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312601",
		"NOME_MUNICIPIO": "SAO LUIS DO CURU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312700",
		"NOME_MUNICIPIO": "SENADOR POMPEU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312809",
		"NOME_MUNICIPIO": "SENADOR SA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2312908",
		"NOME_MUNICIPIO": "SOBRAL",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313005",
		"NOME_MUNICIPIO": "SOLONOPOLE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313104",
		"NOME_MUNICIPIO": "TABULEIRO DO NORTE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313203",
		"NOME_MUNICIPIO": "TAMBORIL",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313252",
		"NOME_MUNICIPIO": "TARRAFAS",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313302",
		"NOME_MUNICIPIO": "TAUA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313351",
		"NOME_MUNICIPIO": "TEJUÇUOCA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313401",
		"NOME_MUNICIPIO": "TIANGUA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313500",
		"NOME_MUNICIPIO": "TRAIRI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313559",
		"NOME_MUNICIPIO": "TURURU",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313609",
		"NOME_MUNICIPIO": "UBAJARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313708",
		"NOME_MUNICIPIO": "UMARI",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313757",
		"NOME_MUNICIPIO": "UMIRIM",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313807",
		"NOME_MUNICIPIO": "URUBURETAMA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313906",
		"NOME_MUNICIPIO": "URUOCA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2313955",
		"NOME_MUNICIPIO": "VARJOTA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2314003",
		"NOME_MUNICIPIO": "VARZEA ALEGRE",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2314102",
		"NOME_MUNICIPIO": "VIÇOSA DO CEARA",
		"COD_UF": "23"
	},
	{
		"COD_MUNICIPIO": "2400109",
		"NOME_MUNICIPIO": "ACARI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400208",
		"NOME_MUNICIPIO": "AÇU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400307",
		"NOME_MUNICIPIO": "AFONSO BEZERRA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400406",
		"NOME_MUNICIPIO": "AGUA NOVA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400505",
		"NOME_MUNICIPIO": "ALEXANDRIA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400604",
		"NOME_MUNICIPIO": "ALMINO AFONSO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400703",
		"NOME_MUNICIPIO": "ALTO DO RODRIGUES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400802",
		"NOME_MUNICIPIO": "ANGICOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2400901",
		"NOME_MUNICIPIO": "ANTÔNIO MARTINS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401008",
		"NOME_MUNICIPIO": "APODI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401107",
		"NOME_MUNICIPIO": "AREIA BRANCA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401206",
		"NOME_MUNICIPIO": "ARÊS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401305",
		"NOME_MUNICIPIO": "AUGUSTO SEVERO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401404",
		"NOME_MUNICIPIO": "BAIA FORMOSA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401453",
		"NOME_MUNICIPIO": "BARAUNA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401503",
		"NOME_MUNICIPIO": "BARCELONA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401602",
		"NOME_MUNICIPIO": "BENTO FERNANDES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401651",
		"NOME_MUNICIPIO": "BODO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401701",
		"NOME_MUNICIPIO": "BOM JESUS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401800",
		"NOME_MUNICIPIO": "BREJINHO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401859",
		"NOME_MUNICIPIO": "CAIÇARA DO NORTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2401909",
		"NOME_MUNICIPIO": "CAIÇARA DO RIO DO VENTO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402006",
		"NOME_MUNICIPIO": "CAICO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402105",
		"NOME_MUNICIPIO": "CAMPO REDONDO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402204",
		"NOME_MUNICIPIO": "CANGUARETAMA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402303",
		"NOME_MUNICIPIO": "CARAUBAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402402",
		"NOME_MUNICIPIO": "CARNAUBA DOS DANTAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402501",
		"NOME_MUNICIPIO": "CARNAUBAIS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402600",
		"NOME_MUNICIPIO": "CEARA-MIRIM",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402709",
		"NOME_MUNICIPIO": "CERRO CORA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402808",
		"NOME_MUNICIPIO": "CORONEL EZEQUIEL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2402907",
		"NOME_MUNICIPIO": "CORONEL JOAO PESSOA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403004",
		"NOME_MUNICIPIO": "CRUZETA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403103",
		"NOME_MUNICIPIO": "CURRAIS NOVOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403202",
		"NOME_MUNICIPIO": "DOUTOR SEVERIANO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403251",
		"NOME_MUNICIPIO": "PARNAMIRIM",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403301",
		"NOME_MUNICIPIO": "ENCANTO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403400",
		"NOME_MUNICIPIO": "EQUADOR",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403509",
		"NOME_MUNICIPIO": "ESPIRITO SANTO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403608",
		"NOME_MUNICIPIO": "EXTREMOZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403707",
		"NOME_MUNICIPIO": "FELIPE GUERRA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403756",
		"NOME_MUNICIPIO": "FERNANDO PEDROZA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403806",
		"NOME_MUNICIPIO": "FLORANIA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2403905",
		"NOME_MUNICIPIO": "FRANCISCO DANTAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404002",
		"NOME_MUNICIPIO": "FRUTUOSO GOMES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404101",
		"NOME_MUNICIPIO": "GALINHOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404200",
		"NOME_MUNICIPIO": "GOIANINHA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404309",
		"NOME_MUNICIPIO": "GOVERNADOR DIX-SEPT ROSADO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404408",
		"NOME_MUNICIPIO": "GROSSOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404507",
		"NOME_MUNICIPIO": "GUAMARE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404606",
		"NOME_MUNICIPIO": "IELMO MARINHO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404705",
		"NOME_MUNICIPIO": "IPANGUAÇU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404804",
		"NOME_MUNICIPIO": "IPUEIRA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404853",
		"NOME_MUNICIPIO": "ITAJA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2404903",
		"NOME_MUNICIPIO": "ITAU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405009",
		"NOME_MUNICIPIO": "JAÇANA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405108",
		"NOME_MUNICIPIO": "JANDAIRA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405207",
		"NOME_MUNICIPIO": "JANDUIS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405306",
		"NOME_MUNICIPIO": "JANUARIO CICCO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405405",
		"NOME_MUNICIPIO": "JAPI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405504",
		"NOME_MUNICIPIO": "JARDIM DE ANGICOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405603",
		"NOME_MUNICIPIO": "JARDIM DE PIRANHAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405702",
		"NOME_MUNICIPIO": "JARDIM DO SERIDO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405801",
		"NOME_MUNICIPIO": "JOAO CAMARA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2405900",
		"NOME_MUNICIPIO": "JOAO DIAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406007",
		"NOME_MUNICIPIO": "JOSE DA PENHA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406106",
		"NOME_MUNICIPIO": "JUCURUTU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406155",
		"NOME_MUNICIPIO": "JUNDIA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406205",
		"NOME_MUNICIPIO": "LAGOA DANTA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406304",
		"NOME_MUNICIPIO": "LAGOA DE PEDRAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406403",
		"NOME_MUNICIPIO": "LAGOA DE VELHOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406502",
		"NOME_MUNICIPIO": "LAGOA NOVA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406601",
		"NOME_MUNICIPIO": "LAGOA SALGADA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406700",
		"NOME_MUNICIPIO": "LAJES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406809",
		"NOME_MUNICIPIO": "LAJES PINTADAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2406908",
		"NOME_MUNICIPIO": "LUCRECIA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407005",
		"NOME_MUNICIPIO": "LUIS GOMES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407104",
		"NOME_MUNICIPIO": "MACAIBA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407203",
		"NOME_MUNICIPIO": "MACAU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407252",
		"NOME_MUNICIPIO": "MAJOR SALES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407302",
		"NOME_MUNICIPIO": "MARCELINO VIEIRA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407401",
		"NOME_MUNICIPIO": "MARTINS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407500",
		"NOME_MUNICIPIO": "MAXARANGUAPE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407609",
		"NOME_MUNICIPIO": "MESSIAS TARGINO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407708",
		"NOME_MUNICIPIO": "MONTANHAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407807",
		"NOME_MUNICIPIO": "MONTE ALEGRE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2407906",
		"NOME_MUNICIPIO": "MONTE DAS GAMELEIRAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408003",
		"NOME_MUNICIPIO": "MOSSORO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408102",
		"NOME_MUNICIPIO": "NATAL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408201",
		"NOME_MUNICIPIO": "NISIA FLORESTA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408300",
		"NOME_MUNICIPIO": "NOVA CRUZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408409",
		"NOME_MUNICIPIO": "OLHO DAGUA DO BORGES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408508",
		"NOME_MUNICIPIO": "OURO BRANCO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408607",
		"NOME_MUNICIPIO": "PARANA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408706",
		"NOME_MUNICIPIO": "PARAU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408805",
		"NOME_MUNICIPIO": "PARAZINHO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408904",
		"NOME_MUNICIPIO": "PARELHAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2408953",
		"NOME_MUNICIPIO": "RIO DO FOGO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409100",
		"NOME_MUNICIPIO": "PASSA E FICA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409209",
		"NOME_MUNICIPIO": "PASSAGEM",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409308",
		"NOME_MUNICIPIO": "PATU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409332",
		"NOME_MUNICIPIO": "SANTA MARIA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409407",
		"NOME_MUNICIPIO": "PAU DOS FERROS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409506",
		"NOME_MUNICIPIO": "PEDRA GRANDE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409605",
		"NOME_MUNICIPIO": "PEDRA PRETA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409704",
		"NOME_MUNICIPIO": "PEDRO AVELINO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409803",
		"NOME_MUNICIPIO": "PEDRO VELHO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2409902",
		"NOME_MUNICIPIO": "PENDÊNCIAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410009",
		"NOME_MUNICIPIO": "PILÕES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410108",
		"NOME_MUNICIPIO": "POÇO BRANCO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410207",
		"NOME_MUNICIPIO": "PORTALEGRE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410256",
		"NOME_MUNICIPIO": "PORTO DO MANGUE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410306",
		"NOME_MUNICIPIO": "SERRA CAIADA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410405",
		"NOME_MUNICIPIO": "PUREZA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410504",
		"NOME_MUNICIPIO": "RAFAEL FERNANDES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410603",
		"NOME_MUNICIPIO": "RAFAEL GODEIRO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410702",
		"NOME_MUNICIPIO": "RIACHO DA CRUZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410801",
		"NOME_MUNICIPIO": "RIACHO DE SANTANA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2410900",
		"NOME_MUNICIPIO": "RIACHUELO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411007",
		"NOME_MUNICIPIO": "RODOLFO FERNANDES",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411056",
		"NOME_MUNICIPIO": "TIBAU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411106",
		"NOME_MUNICIPIO": "RUY BARBOSA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411205",
		"NOME_MUNICIPIO": "SANTA CRUZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411403",
		"NOME_MUNICIPIO": "SANTANA DO MATOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411429",
		"NOME_MUNICIPIO": "SANTANA DO SERIDO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411502",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411601",
		"NOME_MUNICIPIO": "SAO BENTO DO NORTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411700",
		"NOME_MUNICIPIO": "SAO BENTO DO TRAIRI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411809",
		"NOME_MUNICIPIO": "SAO FERNANDO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2411908",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO OESTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412005",
		"NOME_MUNICIPIO": "SAO GONÇALO DO AMARANTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412104",
		"NOME_MUNICIPIO": "SAO JOAO DO SABUGI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412203",
		"NOME_MUNICIPIO": "SAO JOSE DE MIPIBU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412302",
		"NOME_MUNICIPIO": "SAO JOSE DO CAMPESTRE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412401",
		"NOME_MUNICIPIO": "SAO JOSE DO SERIDO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412500",
		"NOME_MUNICIPIO": "SAO MIGUEL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412559",
		"NOME_MUNICIPIO": "SAO MIGUEL DO GOSTOSO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412609",
		"NOME_MUNICIPIO": "SAO PAULO DO POTENGI",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412708",
		"NOME_MUNICIPIO": "SAO PEDRO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412807",
		"NOME_MUNICIPIO": "SAO RAFAEL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2412906",
		"NOME_MUNICIPIO": "SAO TOME",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413003",
		"NOME_MUNICIPIO": "SAO VICENTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413102",
		"NOME_MUNICIPIO": "SENADOR ELOI DE SOUZA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413201",
		"NOME_MUNICIPIO": "SENADOR GEORGINO AVELINO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413300",
		"NOME_MUNICIPIO": "SERRA DE SAO BENTO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413359",
		"NOME_MUNICIPIO": "SERRA DO MEL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413409",
		"NOME_MUNICIPIO": "SERRA NEGRA DO NORTE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413508",
		"NOME_MUNICIPIO": "SERRINHA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413557",
		"NOME_MUNICIPIO": "SERRINHA DOS PINTOS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413607",
		"NOME_MUNICIPIO": "SEVERIANO MELO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413706",
		"NOME_MUNICIPIO": "SITIO NOVO",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413805",
		"NOME_MUNICIPIO": "TABOLEIRO GRANDE",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2413904",
		"NOME_MUNICIPIO": "TAIPU",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414001",
		"NOME_MUNICIPIO": "TANGARA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414100",
		"NOME_MUNICIPIO": "TENENTE ANANIAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414159",
		"NOME_MUNICIPIO": "TENENTE LAURENTINO CRUZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414209",
		"NOME_MUNICIPIO": "TIBAU DO SUL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414308",
		"NOME_MUNICIPIO": "TIMBAUBA DOS BATISTAS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414407",
		"NOME_MUNICIPIO": "TOUROS",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414456",
		"NOME_MUNICIPIO": "TRIUNFO POTIGUAR",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414506",
		"NOME_MUNICIPIO": "UMARIZAL",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414605",
		"NOME_MUNICIPIO": "UPANEMA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414704",
		"NOME_MUNICIPIO": "VARZEA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414753",
		"NOME_MUNICIPIO": "VENHA-VER",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414803",
		"NOME_MUNICIPIO": "VERA CRUZ",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2414902",
		"NOME_MUNICIPIO": "VIÇOSA",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2415008",
		"NOME_MUNICIPIO": "VILA FLOR",
		"COD_UF": "24"
	},
	{
		"COD_MUNICIPIO": "2500106",
		"NOME_MUNICIPIO": "AGUA BRANCA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500205",
		"NOME_MUNICIPIO": "AGUIAR",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500304",
		"NOME_MUNICIPIO": "ALAGOA GRANDE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500403",
		"NOME_MUNICIPIO": "ALAGOA NOVA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500502",
		"NOME_MUNICIPIO": "ALAGOINHA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500536",
		"NOME_MUNICIPIO": "ALCANTIL",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500577",
		"NOME_MUNICIPIO": "ALGODAO DE JANDAIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500601",
		"NOME_MUNICIPIO": "ALHANDRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500700",
		"NOME_MUNICIPIO": "SAO JOAO DO RIO DO PEIXE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500734",
		"NOME_MUNICIPIO": "AMPARO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500775",
		"NOME_MUNICIPIO": "APARECIDA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500809",
		"NOME_MUNICIPIO": "ARAÇAGI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2500908",
		"NOME_MUNICIPIO": "ARARA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501005",
		"NOME_MUNICIPIO": "ARARUNA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501104",
		"NOME_MUNICIPIO": "AREIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501153",
		"NOME_MUNICIPIO": "AREIA DE BARAUNAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501203",
		"NOME_MUNICIPIO": "AREIAL",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501302",
		"NOME_MUNICIPIO": "AROEIRAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501351",
		"NOME_MUNICIPIO": "ASSUNÇAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501401",
		"NOME_MUNICIPIO": "BAIA DA TRAIÇAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501500",
		"NOME_MUNICIPIO": "BANANEIRAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501534",
		"NOME_MUNICIPIO": "BARAUNA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501575",
		"NOME_MUNICIPIO": "BARRA DE SANTANA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501609",
		"NOME_MUNICIPIO": "BARRA DE SANTA ROSA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501708",
		"NOME_MUNICIPIO": "BARRA DE SAO MIGUEL",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501807",
		"NOME_MUNICIPIO": "BAYEUX",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2501906",
		"NOME_MUNICIPIO": "BELEM",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502003",
		"NOME_MUNICIPIO": "BELEM DO BREJO DO CRUZ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502052",
		"NOME_MUNICIPIO": "BERNARDINO BATISTA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502102",
		"NOME_MUNICIPIO": "BOA VENTURA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502151",
		"NOME_MUNICIPIO": "BOA VISTA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502201",
		"NOME_MUNICIPIO": "BOM JESUS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502300",
		"NOME_MUNICIPIO": "BOM SUCESSO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502409",
		"NOME_MUNICIPIO": "BONITO DE SANTA FE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502508",
		"NOME_MUNICIPIO": "BOQUEIRAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502607",
		"NOME_MUNICIPIO": "IGARACY",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502706",
		"NOME_MUNICIPIO": "BORBOREMA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502805",
		"NOME_MUNICIPIO": "BREJO DO CRUZ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2502904",
		"NOME_MUNICIPIO": "BREJO DOS SANTOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503001",
		"NOME_MUNICIPIO": "CAAPORA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503100",
		"NOME_MUNICIPIO": "CABACEIRAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503209",
		"NOME_MUNICIPIO": "CABEDELO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503308",
		"NOME_MUNICIPIO": "CACHOEIRA DOS INDIOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503407",
		"NOME_MUNICIPIO": "CACIMBA DE AREIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503506",
		"NOME_MUNICIPIO": "CACIMBA DE DENTRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503555",
		"NOME_MUNICIPIO": "CACIMBAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503605",
		"NOME_MUNICIPIO": "CAIÇARA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503704",
		"NOME_MUNICIPIO": "CAJAZEIRAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503753",
		"NOME_MUNICIPIO": "CAJAZEIRINHAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503803",
		"NOME_MUNICIPIO": "CALDAS BRANDAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2503902",
		"NOME_MUNICIPIO": "CAMALAU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504009",
		"NOME_MUNICIPIO": "CAMPINA GRANDE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504033",
		"NOME_MUNICIPIO": "CAPIM",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504074",
		"NOME_MUNICIPIO": "CARAUBAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504108",
		"NOME_MUNICIPIO": "CARRAPATEIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504157",
		"NOME_MUNICIPIO": "CASSERENGUE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504207",
		"NOME_MUNICIPIO": "CATINGUEIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504306",
		"NOME_MUNICIPIO": "CATOLE DO ROCHA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504355",
		"NOME_MUNICIPIO": "CATURITE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504405",
		"NOME_MUNICIPIO": "CONCEIÇAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504504",
		"NOME_MUNICIPIO": "CONDADO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504603",
		"NOME_MUNICIPIO": "CONDE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504702",
		"NOME_MUNICIPIO": "CONGO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504801",
		"NOME_MUNICIPIO": "COREMAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504850",
		"NOME_MUNICIPIO": "COXIXOLA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2504900",
		"NOME_MUNICIPIO": "CRUZ DO ESPIRITO SANTO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505006",
		"NOME_MUNICIPIO": "CUBATI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505105",
		"NOME_MUNICIPIO": "CUITE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505204",
		"NOME_MUNICIPIO": "CUITEGI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505238",
		"NOME_MUNICIPIO": "CUITE DE MAMANGUAPE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505279",
		"NOME_MUNICIPIO": "CURRAL DE CIMA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505303",
		"NOME_MUNICIPIO": "CURRAL VELHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505352",
		"NOME_MUNICIPIO": "DAMIAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505402",
		"NOME_MUNICIPIO": "DESTERRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505501",
		"NOME_MUNICIPIO": "VISTA SERRANA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505600",
		"NOME_MUNICIPIO": "DIAMANTE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505709",
		"NOME_MUNICIPIO": "DONA INÊS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505808",
		"NOME_MUNICIPIO": "DUAS ESTRADAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2505907",
		"NOME_MUNICIPIO": "EMAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506004",
		"NOME_MUNICIPIO": "ESPERANÇA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506103",
		"NOME_MUNICIPIO": "FAGUNDES",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506202",
		"NOME_MUNICIPIO": "FREI MARTINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506251",
		"NOME_MUNICIPIO": "GADO BRAVO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506301",
		"NOME_MUNICIPIO": "GUARABIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506400",
		"NOME_MUNICIPIO": "GURINHEM",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506509",
		"NOME_MUNICIPIO": "GURJAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506608",
		"NOME_MUNICIPIO": "IBIARA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506707",
		"NOME_MUNICIPIO": "IMACULADA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506806",
		"NOME_MUNICIPIO": "INGA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2506905",
		"NOME_MUNICIPIO": "ITABAIANA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507002",
		"NOME_MUNICIPIO": "ITAPORANGA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507101",
		"NOME_MUNICIPIO": "ITAPOROROCA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507200",
		"NOME_MUNICIPIO": "ITATUBA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507309",
		"NOME_MUNICIPIO": "JACARAU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507408",
		"NOME_MUNICIPIO": "JERICO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507507",
		"NOME_MUNICIPIO": "JOAO PESSOA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507606",
		"NOME_MUNICIPIO": "JUAREZ TAVORA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507705",
		"NOME_MUNICIPIO": "JUAZEIRINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507804",
		"NOME_MUNICIPIO": "JUNCO DO SERIDO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2507903",
		"NOME_MUNICIPIO": "JURIPIRANGA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508000",
		"NOME_MUNICIPIO": "JURU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508109",
		"NOME_MUNICIPIO": "LAGOA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508208",
		"NOME_MUNICIPIO": "LAGOA DE DENTRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508307",
		"NOME_MUNICIPIO": "LAGOA SECA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508406",
		"NOME_MUNICIPIO": "LASTRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508505",
		"NOME_MUNICIPIO": "LIVRAMENTO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508554",
		"NOME_MUNICIPIO": "LOGRADOURO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508604",
		"NOME_MUNICIPIO": "LUCENA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508703",
		"NOME_MUNICIPIO": "MAE DAGUA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508802",
		"NOME_MUNICIPIO": "MALTA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2508901",
		"NOME_MUNICIPIO": "MAMANGUAPE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509008",
		"NOME_MUNICIPIO": "MANAIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509057",
		"NOME_MUNICIPIO": "MARCAÇAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509107",
		"NOME_MUNICIPIO": "MARI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509156",
		"NOME_MUNICIPIO": "MARIZOPOLIS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509206",
		"NOME_MUNICIPIO": "MASSARANDUBA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509305",
		"NOME_MUNICIPIO": "MATARACA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509339",
		"NOME_MUNICIPIO": "MATINHAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509370",
		"NOME_MUNICIPIO": "MATO GROSSO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509396",
		"NOME_MUNICIPIO": "MATUREIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509404",
		"NOME_MUNICIPIO": "MOGEIRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509503",
		"NOME_MUNICIPIO": "MONTADAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509602",
		"NOME_MUNICIPIO": "MONTE HOREBE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509701",
		"NOME_MUNICIPIO": "MONTEIRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509800",
		"NOME_MUNICIPIO": "MULUNGU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2509909",
		"NOME_MUNICIPIO": "NATUBA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510006",
		"NOME_MUNICIPIO": "NAZAREZINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510105",
		"NOME_MUNICIPIO": "NOVA FLORESTA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510204",
		"NOME_MUNICIPIO": "NOVA OLINDA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510303",
		"NOME_MUNICIPIO": "NOVA PALMEIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510402",
		"NOME_MUNICIPIO": "OLHO DAGUA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510501",
		"NOME_MUNICIPIO": "OLIVEDOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510600",
		"NOME_MUNICIPIO": "OURO VELHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510659",
		"NOME_MUNICIPIO": "PARARI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510709",
		"NOME_MUNICIPIO": "PASSAGEM",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510808",
		"NOME_MUNICIPIO": "PATOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2510907",
		"NOME_MUNICIPIO": "PAULISTA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511004",
		"NOME_MUNICIPIO": "PEDRA BRANCA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511103",
		"NOME_MUNICIPIO": "PEDRA LAVRADA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511202",
		"NOME_MUNICIPIO": "PEDRAS DE FOGO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511301",
		"NOME_MUNICIPIO": "PIANCO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511400",
		"NOME_MUNICIPIO": "PICUI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511509",
		"NOME_MUNICIPIO": "PILAR",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511608",
		"NOME_MUNICIPIO": "PILÕES",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511707",
		"NOME_MUNICIPIO": "PILÕEZINHOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511806",
		"NOME_MUNICIPIO": "PIRPIRITUBA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2511905",
		"NOME_MUNICIPIO": "PITIMBU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512002",
		"NOME_MUNICIPIO": "POCINHOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512036",
		"NOME_MUNICIPIO": "POÇO DANTAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512077",
		"NOME_MUNICIPIO": "POÇO DE JOSE DE MOURA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512101",
		"NOME_MUNICIPIO": "POMBAL",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512200",
		"NOME_MUNICIPIO": "PRATA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512309",
		"NOME_MUNICIPIO": "PRINCESA ISABEL",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512408",
		"NOME_MUNICIPIO": "PUXINANA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512507",
		"NOME_MUNICIPIO": "QUEIMADAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512606",
		"NOME_MUNICIPIO": "QUIXABA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512705",
		"NOME_MUNICIPIO": "REMIGIO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512721",
		"NOME_MUNICIPIO": "PEDRO REGIS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512747",
		"NOME_MUNICIPIO": "RIACHAO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512754",
		"NOME_MUNICIPIO": "RIACHAO DO BACAMARTE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512762",
		"NOME_MUNICIPIO": "RIACHAO DO POÇO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512788",
		"NOME_MUNICIPIO": "RIACHO DE SANTO ANTÔNIO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512804",
		"NOME_MUNICIPIO": "RIACHO DOS CAVALOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2512903",
		"NOME_MUNICIPIO": "RIO TINTO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513000",
		"NOME_MUNICIPIO": "SALGADINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513109",
		"NOME_MUNICIPIO": "SALGADO DE SAO FELIX",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513158",
		"NOME_MUNICIPIO": "SANTA CECILIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513208",
		"NOME_MUNICIPIO": "SANTA CRUZ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513307",
		"NOME_MUNICIPIO": "SANTA HELENA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513356",
		"NOME_MUNICIPIO": "SANTA INÊS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513406",
		"NOME_MUNICIPIO": "SANTA LUZIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513505",
		"NOME_MUNICIPIO": "SANTANA DE MANGUEIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513604",
		"NOME_MUNICIPIO": "SANTANA DOS GARROTES",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513653",
		"NOME_MUNICIPIO": "JOCA CLAUDINO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513703",
		"NOME_MUNICIPIO": "SANTA RITA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513802",
		"NOME_MUNICIPIO": "SANTA TERESINHA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513851",
		"NOME_MUNICIPIO": "SANTO ANDRE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513901",
		"NOME_MUNICIPIO": "SAO BENTO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513927",
		"NOME_MUNICIPIO": "SAO BENTINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513943",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO CARIRI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513968",
		"NOME_MUNICIPIO": "SAO DOMINGOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2513984",
		"NOME_MUNICIPIO": "SAO FRANCISCO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514008",
		"NOME_MUNICIPIO": "SAO JOAO DO CARIRI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514107",
		"NOME_MUNICIPIO": "SAO JOAO DO TIGRE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514206",
		"NOME_MUNICIPIO": "SAO JOSE DA LAGOA TAPADA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514305",
		"NOME_MUNICIPIO": "SAO JOSE DE CAIANA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514404",
		"NOME_MUNICIPIO": "SAO JOSE DE ESPINHARAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514453",
		"NOME_MUNICIPIO": "SAO JOSE DOS RAMOS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514503",
		"NOME_MUNICIPIO": "SAO JOSE DE PIRANHAS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514552",
		"NOME_MUNICIPIO": "SAO JOSE DE PRINCESA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514602",
		"NOME_MUNICIPIO": "SAO JOSE DO BONFIM",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514651",
		"NOME_MUNICIPIO": "SAO JOSE DO BREJO DO CRUZ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514701",
		"NOME_MUNICIPIO": "SAO JOSE DO SABUGI",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514800",
		"NOME_MUNICIPIO": "SAO JOSE DOS CORDEIROS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2514909",
		"NOME_MUNICIPIO": "SAO MAMEDE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515005",
		"NOME_MUNICIPIO": "SAO MIGUEL DE TAIPU",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515104",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DE LAGOA DE ROÇA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515203",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO UMBUZEIRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515302",
		"NOME_MUNICIPIO": "SAPE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515401",
		"NOME_MUNICIPIO": "SAO VICENTE DO SERIDO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515500",
		"NOME_MUNICIPIO": "SERRA BRANCA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515609",
		"NOME_MUNICIPIO": "SERRA DA RAIZ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515708",
		"NOME_MUNICIPIO": "SERRA GRANDE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515807",
		"NOME_MUNICIPIO": "SERRA REDONDA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515906",
		"NOME_MUNICIPIO": "SERRARIA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515930",
		"NOME_MUNICIPIO": "SERTAOZINHO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2515971",
		"NOME_MUNICIPIO": "SOBRADO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516003",
		"NOME_MUNICIPIO": "SOLANEA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516102",
		"NOME_MUNICIPIO": "SOLEDADE",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516151",
		"NOME_MUNICIPIO": "SOSSÊGO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516201",
		"NOME_MUNICIPIO": "SOUSA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516300",
		"NOME_MUNICIPIO": "SUME",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516409",
		"NOME_MUNICIPIO": "TACIMA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516508",
		"NOME_MUNICIPIO": "TAPEROA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516607",
		"NOME_MUNICIPIO": "TAVARES",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516706",
		"NOME_MUNICIPIO": "TEIXEIRA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516755",
		"NOME_MUNICIPIO": "TENORIO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516805",
		"NOME_MUNICIPIO": "TRIUNFO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2516904",
		"NOME_MUNICIPIO": "UIRAUNA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2517001",
		"NOME_MUNICIPIO": "UMBUZEIRO",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2517100",
		"NOME_MUNICIPIO": "VARZEA",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2517209",
		"NOME_MUNICIPIO": "VIEIROPOLIS",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2517407",
		"NOME_MUNICIPIO": "ZABELÊ",
		"COD_UF": "25"
	},
	{
		"COD_MUNICIPIO": "2600054",
		"NOME_MUNICIPIO": "ABREU E LIMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600104",
		"NOME_MUNICIPIO": "AFOGADOS DA INGAZEIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600203",
		"NOME_MUNICIPIO": "AFRANIO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600302",
		"NOME_MUNICIPIO": "AGRESTINA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600401",
		"NOME_MUNICIPIO": "AGUA PRETA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600500",
		"NOME_MUNICIPIO": "AGUAS BELAS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600609",
		"NOME_MUNICIPIO": "ALAGOINHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600708",
		"NOME_MUNICIPIO": "ALIANÇA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600807",
		"NOME_MUNICIPIO": "ALTINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2600906",
		"NOME_MUNICIPIO": "AMARAJI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601003",
		"NOME_MUNICIPIO": "ANGELIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601052",
		"NOME_MUNICIPIO": "ARAÇOIABA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601102",
		"NOME_MUNICIPIO": "ARARIPINA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601201",
		"NOME_MUNICIPIO": "ARCOVERDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601300",
		"NOME_MUNICIPIO": "BARRA DE GUABIRABA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601409",
		"NOME_MUNICIPIO": "BARREIROS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601508",
		"NOME_MUNICIPIO": "BELEM DE MARIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601607",
		"NOME_MUNICIPIO": "BELEM DO SAO FRANCISCO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601706",
		"NOME_MUNICIPIO": "BELO JARDIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601805",
		"NOME_MUNICIPIO": "BETANIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2601904",
		"NOME_MUNICIPIO": "BEZERROS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602001",
		"NOME_MUNICIPIO": "BODOCO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602100",
		"NOME_MUNICIPIO": "BOM CONSELHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602209",
		"NOME_MUNICIPIO": "BOM JARDIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602308",
		"NOME_MUNICIPIO": "BONITO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602407",
		"NOME_MUNICIPIO": "BREJAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602506",
		"NOME_MUNICIPIO": "BREJINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602605",
		"NOME_MUNICIPIO": "BREJO DA MADRE DE DEUS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602704",
		"NOME_MUNICIPIO": "BUENOS AIRES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602803",
		"NOME_MUNICIPIO": "BUIQUE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2602902",
		"NOME_MUNICIPIO": "CABO DE SANTO AGOSTINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603009",
		"NOME_MUNICIPIO": "CABROBO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603108",
		"NOME_MUNICIPIO": "CACHOEIRINHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603207",
		"NOME_MUNICIPIO": "CAETES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603306",
		"NOME_MUNICIPIO": "CALÇADO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603405",
		"NOME_MUNICIPIO": "CALUMBI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603454",
		"NOME_MUNICIPIO": "CAMARAGIBE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603504",
		"NOME_MUNICIPIO": "CAMOCIM DE SAO FELIX",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603603",
		"NOME_MUNICIPIO": "CAMUTANGA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603702",
		"NOME_MUNICIPIO": "CANHOTINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603801",
		"NOME_MUNICIPIO": "CAPOEIRAS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603900",
		"NOME_MUNICIPIO": "CARNAIBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2603926",
		"NOME_MUNICIPIO": "CARNAUBEIRA DA PENHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604007",
		"NOME_MUNICIPIO": "CARPINA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604106",
		"NOME_MUNICIPIO": "CARUARU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604155",
		"NOME_MUNICIPIO": "CASINHAS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604205",
		"NOME_MUNICIPIO": "CATENDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604304",
		"NOME_MUNICIPIO": "CEDRO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604403",
		"NOME_MUNICIPIO": "CHA DE ALEGRIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604502",
		"NOME_MUNICIPIO": "CHA GRANDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604601",
		"NOME_MUNICIPIO": "CONDADO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604700",
		"NOME_MUNICIPIO": "CORRENTES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604809",
		"NOME_MUNICIPIO": "CORTÊS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2604908",
		"NOME_MUNICIPIO": "CUMARU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605004",
		"NOME_MUNICIPIO": "CUPIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605103",
		"NOME_MUNICIPIO": "CUSTODIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605152",
		"NOME_MUNICIPIO": "DORMENTES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605202",
		"NOME_MUNICIPIO": "ESCADA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605301",
		"NOME_MUNICIPIO": "EXU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605400",
		"NOME_MUNICIPIO": "FEIRA NOVA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605459",
		"NOME_MUNICIPIO": "FERNANDO DE NORONHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605509",
		"NOME_MUNICIPIO": "FERREIROS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605608",
		"NOME_MUNICIPIO": "FLORES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605707",
		"NOME_MUNICIPIO": "FLORESTA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605806",
		"NOME_MUNICIPIO": "FREI MIGUELINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2605905",
		"NOME_MUNICIPIO": "GAMELEIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606002",
		"NOME_MUNICIPIO": "GARANHUNS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606101",
		"NOME_MUNICIPIO": "GLORIA DO GOITA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606200",
		"NOME_MUNICIPIO": "GOIANA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606309",
		"NOME_MUNICIPIO": "GRANITO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606408",
		"NOME_MUNICIPIO": "GRAVATA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606507",
		"NOME_MUNICIPIO": "IATI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606606",
		"NOME_MUNICIPIO": "IBIMIRIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606705",
		"NOME_MUNICIPIO": "IBIRAJUBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606804",
		"NOME_MUNICIPIO": "IGARASSU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2606903",
		"NOME_MUNICIPIO": "IGUARACY",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607000",
		"NOME_MUNICIPIO": "INAJA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607109",
		"NOME_MUNICIPIO": "INGAZEIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607208",
		"NOME_MUNICIPIO": "IPOJUCA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607307",
		"NOME_MUNICIPIO": "IPUBI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607406",
		"NOME_MUNICIPIO": "ITACURUBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607505",
		"NOME_MUNICIPIO": "ITAIBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607604",
		"NOME_MUNICIPIO": "ILHA DE ITAMARACA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607653",
		"NOME_MUNICIPIO": "ITAMBE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607703",
		"NOME_MUNICIPIO": "ITAPETIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607752",
		"NOME_MUNICIPIO": "ITAPISSUMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607802",
		"NOME_MUNICIPIO": "ITAQUITINGA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607901",
		"NOME_MUNICIPIO": "JABOATAO DOS GUARARAPES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2607950",
		"NOME_MUNICIPIO": "JAQUEIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608008",
		"NOME_MUNICIPIO": "JATAUBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608057",
		"NOME_MUNICIPIO": "JATOBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608107",
		"NOME_MUNICIPIO": "JOAO ALFREDO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608206",
		"NOME_MUNICIPIO": "JOAQUIM NABUCO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608255",
		"NOME_MUNICIPIO": "JUCATI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608305",
		"NOME_MUNICIPIO": "JUPI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608404",
		"NOME_MUNICIPIO": "JUREMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608453",
		"NOME_MUNICIPIO": "LAGOA DO CARRO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608503",
		"NOME_MUNICIPIO": "LAGOA DE ITAENGA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608602",
		"NOME_MUNICIPIO": "LAGOA DO OURO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608701",
		"NOME_MUNICIPIO": "LAGOA DOS GATOS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608750",
		"NOME_MUNICIPIO": "LAGOA GRANDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608800",
		"NOME_MUNICIPIO": "LAJEDO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2608909",
		"NOME_MUNICIPIO": "LIMOEIRO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609006",
		"NOME_MUNICIPIO": "MACAPARANA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609105",
		"NOME_MUNICIPIO": "MACHADOS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609154",
		"NOME_MUNICIPIO": "MANARI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609204",
		"NOME_MUNICIPIO": "MARAIAL",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609303",
		"NOME_MUNICIPIO": "MIRANDIBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609402",
		"NOME_MUNICIPIO": "MORENO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609501",
		"NOME_MUNICIPIO": "NAZARE DA MATA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609600",
		"NOME_MUNICIPIO": "OLINDA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609709",
		"NOME_MUNICIPIO": "OROBO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609808",
		"NOME_MUNICIPIO": "OROCO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2609907",
		"NOME_MUNICIPIO": "OURICURI",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610004",
		"NOME_MUNICIPIO": "PALMARES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610103",
		"NOME_MUNICIPIO": "PALMEIRINA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610202",
		"NOME_MUNICIPIO": "PANELAS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610301",
		"NOME_MUNICIPIO": "PARANATAMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610400",
		"NOME_MUNICIPIO": "PARNAMIRIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610509",
		"NOME_MUNICIPIO": "PASSIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610608",
		"NOME_MUNICIPIO": "PAUDALHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610707",
		"NOME_MUNICIPIO": "PAULISTA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610806",
		"NOME_MUNICIPIO": "PEDRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2610905",
		"NOME_MUNICIPIO": "PESQUEIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611002",
		"NOME_MUNICIPIO": "PETROLANDIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611101",
		"NOME_MUNICIPIO": "PETROLINA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611200",
		"NOME_MUNICIPIO": "POÇAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611309",
		"NOME_MUNICIPIO": "POMBOS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611408",
		"NOME_MUNICIPIO": "PRIMAVERA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611507",
		"NOME_MUNICIPIO": "QUIPAPA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611533",
		"NOME_MUNICIPIO": "QUIXABA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611606",
		"NOME_MUNICIPIO": "RECIFE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611705",
		"NOME_MUNICIPIO": "RIACHO DAS ALMAS",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611804",
		"NOME_MUNICIPIO": "RIBEIRAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2611903",
		"NOME_MUNICIPIO": "RIO FORMOSO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612000",
		"NOME_MUNICIPIO": "SAIRE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612109",
		"NOME_MUNICIPIO": "SALGADINHO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612208",
		"NOME_MUNICIPIO": "SALGUEIRO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612307",
		"NOME_MUNICIPIO": "SALOA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612406",
		"NOME_MUNICIPIO": "SANHARO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612455",
		"NOME_MUNICIPIO": "SANTA CRUZ",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612471",
		"NOME_MUNICIPIO": "SANTA CRUZ DA BAIXA VERDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612505",
		"NOME_MUNICIPIO": "SANTA CRUZ DO CAPIBARIBE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612554",
		"NOME_MUNICIPIO": "SANTA FILOMENA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612604",
		"NOME_MUNICIPIO": "SANTA MARIA DA BOA VISTA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612703",
		"NOME_MUNICIPIO": "SANTA MARIA DO CAMBUCA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612802",
		"NOME_MUNICIPIO": "SANTA TEREZINHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2612901",
		"NOME_MUNICIPIO": "SAO BENEDITO DO SUL",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613008",
		"NOME_MUNICIPIO": "SAO BENTO DO UNA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613107",
		"NOME_MUNICIPIO": "SAO CAITANO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613206",
		"NOME_MUNICIPIO": "SAO JOAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613305",
		"NOME_MUNICIPIO": "SAO JOAQUIM DO MONTE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613404",
		"NOME_MUNICIPIO": "SAO JOSE DA COROA GRANDE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613503",
		"NOME_MUNICIPIO": "SAO JOSE DO BELMONTE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613602",
		"NOME_MUNICIPIO": "SAO JOSE DO EGITO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613701",
		"NOME_MUNICIPIO": "SAO LOURENÇO DA MATA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613800",
		"NOME_MUNICIPIO": "SAO VICENTE FERRER",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2613909",
		"NOME_MUNICIPIO": "SERRA TALHADA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614006",
		"NOME_MUNICIPIO": "SERRITA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614105",
		"NOME_MUNICIPIO": "SERTANIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614204",
		"NOME_MUNICIPIO": "SIRINHAEM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614303",
		"NOME_MUNICIPIO": "MOREILANDIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614402",
		"NOME_MUNICIPIO": "SOLIDAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614501",
		"NOME_MUNICIPIO": "SURUBIM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614600",
		"NOME_MUNICIPIO": "TABIRA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614709",
		"NOME_MUNICIPIO": "TACAIMBO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614808",
		"NOME_MUNICIPIO": "TACARATU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2614857",
		"NOME_MUNICIPIO": "TAMANDARE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615003",
		"NOME_MUNICIPIO": "TAQUARITINGA DO NORTE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615102",
		"NOME_MUNICIPIO": "TEREZINHA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615201",
		"NOME_MUNICIPIO": "TERRA NOVA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615300",
		"NOME_MUNICIPIO": "TIMBAUBA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615409",
		"NOME_MUNICIPIO": "TORITAMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615508",
		"NOME_MUNICIPIO": "TRACUNHAEM",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615607",
		"NOME_MUNICIPIO": "TRINDADE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615706",
		"NOME_MUNICIPIO": "TRIUNFO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615805",
		"NOME_MUNICIPIO": "TUPANATINGA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2615904",
		"NOME_MUNICIPIO": "TUPARETAMA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616001",
		"NOME_MUNICIPIO": "VENTUROSA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616100",
		"NOME_MUNICIPIO": "VERDEJANTE",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616183",
		"NOME_MUNICIPIO": "VERTENTE DO LERIO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616209",
		"NOME_MUNICIPIO": "VERTENTES",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616308",
		"NOME_MUNICIPIO": "VICÊNCIA",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616407",
		"NOME_MUNICIPIO": "VITORIA DE SANTO ANTAO",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2616506",
		"NOME_MUNICIPIO": "XEXEU",
		"COD_UF": "26"
	},
	{
		"COD_MUNICIPIO": "2700102",
		"NOME_MUNICIPIO": "AGUA BRANCA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700201",
		"NOME_MUNICIPIO": "ANADIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700300",
		"NOME_MUNICIPIO": "ARAPIRACA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700409",
		"NOME_MUNICIPIO": "ATALAIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700508",
		"NOME_MUNICIPIO": "BARRA DE SANTO ANTÔNIO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700607",
		"NOME_MUNICIPIO": "BARRA DE SAO MIGUEL",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700706",
		"NOME_MUNICIPIO": "BATALHA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700805",
		"NOME_MUNICIPIO": "BELEM",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2700904",
		"NOME_MUNICIPIO": "BELO MONTE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701001",
		"NOME_MUNICIPIO": "BOCA DA MATA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701100",
		"NOME_MUNICIPIO": "BRANQUINHA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701209",
		"NOME_MUNICIPIO": "CACIMBINHAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701308",
		"NOME_MUNICIPIO": "CAJUEIRO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701357",
		"NOME_MUNICIPIO": "CAMPESTRE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701407",
		"NOME_MUNICIPIO": "CAMPO ALEGRE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701506",
		"NOME_MUNICIPIO": "CAMPO GRANDE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701605",
		"NOME_MUNICIPIO": "CANAPI",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701704",
		"NOME_MUNICIPIO": "CAPELA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701803",
		"NOME_MUNICIPIO": "CARNEIROS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2701902",
		"NOME_MUNICIPIO": "CHA PRETA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702009",
		"NOME_MUNICIPIO": "COITE DO NOIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702108",
		"NOME_MUNICIPIO": "COLÔNIA LEOPOLDINA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702207",
		"NOME_MUNICIPIO": "COQUEIRO SECO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702306",
		"NOME_MUNICIPIO": "CORURIPE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702355",
		"NOME_MUNICIPIO": "CRAIBAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702405",
		"NOME_MUNICIPIO": "DELMIRO GOUVEIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702504",
		"NOME_MUNICIPIO": "DOIS RIACHOS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702553",
		"NOME_MUNICIPIO": "ESTRELA DE ALAGOAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702603",
		"NOME_MUNICIPIO": "FEIRA GRANDE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702702",
		"NOME_MUNICIPIO": "FELIZ DESERTO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702801",
		"NOME_MUNICIPIO": "FLEXEIRAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2702900",
		"NOME_MUNICIPIO": "GIRAU DO PONCIANO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703007",
		"NOME_MUNICIPIO": "IBATEGUARA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703106",
		"NOME_MUNICIPIO": "IGACI",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703205",
		"NOME_MUNICIPIO": "IGREJA NOVA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703304",
		"NOME_MUNICIPIO": "INHAPI",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703403",
		"NOME_MUNICIPIO": "JACARE DOS HOMENS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703502",
		"NOME_MUNICIPIO": "JACUIPE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703601",
		"NOME_MUNICIPIO": "JAPARATINGA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703700",
		"NOME_MUNICIPIO": "JARAMATAIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703759",
		"NOME_MUNICIPIO": "JEQUIA DA PRAIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703809",
		"NOME_MUNICIPIO": "JOAQUIM GOMES",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2703908",
		"NOME_MUNICIPIO": "JUNDIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704005",
		"NOME_MUNICIPIO": "JUNQUEIRO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704104",
		"NOME_MUNICIPIO": "LAGOA DA CANOA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704203",
		"NOME_MUNICIPIO": "LIMOEIRO DE ANADIA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704302",
		"NOME_MUNICIPIO": "MACEIO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704401",
		"NOME_MUNICIPIO": "MAJOR ISIDORO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704500",
		"NOME_MUNICIPIO": "MARAGOGI",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704609",
		"NOME_MUNICIPIO": "MARAVILHA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704708",
		"NOME_MUNICIPIO": "MARECHAL DEODORO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704807",
		"NOME_MUNICIPIO": "MARIBONDO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2704906",
		"NOME_MUNICIPIO": "MAR VERMELHO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705002",
		"NOME_MUNICIPIO": "MATA GRANDE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705101",
		"NOME_MUNICIPIO": "MATRIZ DE CAMARAGIBE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705200",
		"NOME_MUNICIPIO": "MESSIAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705309",
		"NOME_MUNICIPIO": "MINADOR DO NEGRAO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705408",
		"NOME_MUNICIPIO": "MONTEIROPOLIS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705507",
		"NOME_MUNICIPIO": "MURICI",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705606",
		"NOME_MUNICIPIO": "NOVO LINO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705705",
		"NOME_MUNICIPIO": "OLHO DAGUA DAS FLORES",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705804",
		"NOME_MUNICIPIO": "OLHO DAGUA DO CASADO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2705903",
		"NOME_MUNICIPIO": "OLHO DAGUA GRANDE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706000",
		"NOME_MUNICIPIO": "OLIVENÇA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706109",
		"NOME_MUNICIPIO": "OURO BRANCO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706208",
		"NOME_MUNICIPIO": "PALESTINA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706307",
		"NOME_MUNICIPIO": "PALMEIRA DOS INDIOS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706406",
		"NOME_MUNICIPIO": "PAO DE AÇUCAR",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706422",
		"NOME_MUNICIPIO": "PARICONHA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706448",
		"NOME_MUNICIPIO": "PARIPUEIRA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706505",
		"NOME_MUNICIPIO": "PASSO DE CAMARAGIBE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706604",
		"NOME_MUNICIPIO": "PAULO JACINTO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706703",
		"NOME_MUNICIPIO": "PENEDO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706802",
		"NOME_MUNICIPIO": "PIAÇABUÇU",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2706901",
		"NOME_MUNICIPIO": "PILAR",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707008",
		"NOME_MUNICIPIO": "PINDOBA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707107",
		"NOME_MUNICIPIO": "PIRANHAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707206",
		"NOME_MUNICIPIO": "POÇO DAS TRINCHEIRAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707305",
		"NOME_MUNICIPIO": "PORTO CALVO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707404",
		"NOME_MUNICIPIO": "PORTO DE PEDRAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707503",
		"NOME_MUNICIPIO": "PORTO REAL DO COLEGIO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707602",
		"NOME_MUNICIPIO": "QUEBRANGULO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707701",
		"NOME_MUNICIPIO": "RIO LARGO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707800",
		"NOME_MUNICIPIO": "ROTEIRO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2707909",
		"NOME_MUNICIPIO": "SANTA LUZIA DO NORTE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708006",
		"NOME_MUNICIPIO": "SANTANA DO IPANEMA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708105",
		"NOME_MUNICIPIO": "SANTANA DO MUNDAU",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708204",
		"NOME_MUNICIPIO": "SAO BRAS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708303",
		"NOME_MUNICIPIO": "SAO JOSE DA LAJE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708402",
		"NOME_MUNICIPIO": "SAO JOSE DA TAPERA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708501",
		"NOME_MUNICIPIO": "SAO LUIS DO QUITUNDE",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708600",
		"NOME_MUNICIPIO": "SAO MIGUEL DOS CAMPOS",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708709",
		"NOME_MUNICIPIO": "SAO MIGUEL DOS MILAGRES",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708808",
		"NOME_MUNICIPIO": "SAO SEBASTIAO",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708907",
		"NOME_MUNICIPIO": "SATUBA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2708956",
		"NOME_MUNICIPIO": "SENADOR RUI PALMEIRA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709004",
		"NOME_MUNICIPIO": "TANQUE DARCA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709103",
		"NOME_MUNICIPIO": "TAQUARANA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709152",
		"NOME_MUNICIPIO": "TEOTÔNIO VILELA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709202",
		"NOME_MUNICIPIO": "TRAIPU",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709301",
		"NOME_MUNICIPIO": "UNIAO DOS PALMARES",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2709400",
		"NOME_MUNICIPIO": "VIÇOSA",
		"COD_UF": "27"
	},
	{
		"COD_MUNICIPIO": "2800100",
		"NOME_MUNICIPIO": "AMPARO DE SAO FRANCISCO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800209",
		"NOME_MUNICIPIO": "AQUIDABA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800308",
		"NOME_MUNICIPIO": "ARACAJU",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800407",
		"NOME_MUNICIPIO": "ARAUA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800506",
		"NOME_MUNICIPIO": "AREIA BRANCA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800605",
		"NOME_MUNICIPIO": "BARRA DOS COQUEIROS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800670",
		"NOME_MUNICIPIO": "BOQUIM",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2800704",
		"NOME_MUNICIPIO": "BREJO GRANDE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801009",
		"NOME_MUNICIPIO": "CAMPO DO BRITO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801108",
		"NOME_MUNICIPIO": "CANHOBA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801207",
		"NOME_MUNICIPIO": "CANINDE DE SAO FRANCISCO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801306",
		"NOME_MUNICIPIO": "CAPELA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801405",
		"NOME_MUNICIPIO": "CARIRA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801504",
		"NOME_MUNICIPIO": "CARMOPOLIS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801603",
		"NOME_MUNICIPIO": "CEDRO DE SAO JOAO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801702",
		"NOME_MUNICIPIO": "CRISTINAPOLIS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2801900",
		"NOME_MUNICIPIO": "CUMBE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802007",
		"NOME_MUNICIPIO": "DIVINA PASTORA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802106",
		"NOME_MUNICIPIO": "ESTANCIA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802205",
		"NOME_MUNICIPIO": "FEIRA NOVA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802304",
		"NOME_MUNICIPIO": "FREI PAULO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802403",
		"NOME_MUNICIPIO": "GARARU",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802502",
		"NOME_MUNICIPIO": "GENERAL MAYNARD",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802601",
		"NOME_MUNICIPIO": "GRACHO CARDOSO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802700",
		"NOME_MUNICIPIO": "ILHA DAS FLORES",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802809",
		"NOME_MUNICIPIO": "INDIAROBA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2802908",
		"NOME_MUNICIPIO": "ITABAIANA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803005",
		"NOME_MUNICIPIO": "ITABAIANINHA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803104",
		"NOME_MUNICIPIO": "ITABI",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803203",
		"NOME_MUNICIPIO": "ITAPORANGA DAJUDA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803302",
		"NOME_MUNICIPIO": "JAPARATUBA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803401",
		"NOME_MUNICIPIO": "JAPOATA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803500",
		"NOME_MUNICIPIO": "LAGARTO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803609",
		"NOME_MUNICIPIO": "LARANJEIRAS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803708",
		"NOME_MUNICIPIO": "MACAMBIRA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803807",
		"NOME_MUNICIPIO": "MALHADA DOS BOIS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2803906",
		"NOME_MUNICIPIO": "MALHADOR",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804003",
		"NOME_MUNICIPIO": "MARUIM",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804102",
		"NOME_MUNICIPIO": "MOITA BONITA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804201",
		"NOME_MUNICIPIO": "MONTE ALEGRE DE SERGIPE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804300",
		"NOME_MUNICIPIO": "MURIBECA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804409",
		"NOME_MUNICIPIO": "NEOPOLIS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804458",
		"NOME_MUNICIPIO": "NOSSA SENHORA APARECIDA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804508",
		"NOME_MUNICIPIO": "NOSSA SENHORA DA GLORIA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804607",
		"NOME_MUNICIPIO": "NOSSA SENHORA DAS DORES",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804706",
		"NOME_MUNICIPIO": "NOSSA SENHORA DE LOURDES",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804805",
		"NOME_MUNICIPIO": "NOSSA SENHORA DO SOCORRO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2804904",
		"NOME_MUNICIPIO": "PACATUBA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805000",
		"NOME_MUNICIPIO": "PEDRA MOLE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805109",
		"NOME_MUNICIPIO": "PEDRINHAS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805208",
		"NOME_MUNICIPIO": "PINHAO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805307",
		"NOME_MUNICIPIO": "PIRAMBU",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805406",
		"NOME_MUNICIPIO": "POÇO REDONDO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805505",
		"NOME_MUNICIPIO": "POÇO VERDE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805604",
		"NOME_MUNICIPIO": "PORTO DA FOLHA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805703",
		"NOME_MUNICIPIO": "PROPRIA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805802",
		"NOME_MUNICIPIO": "RIACHAO DO DANTAS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2805901",
		"NOME_MUNICIPIO": "RIACHUELO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806008",
		"NOME_MUNICIPIO": "RIBEIROPOLIS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806107",
		"NOME_MUNICIPIO": "ROSARIO DO CATETE",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806206",
		"NOME_MUNICIPIO": "SALGADO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806305",
		"NOME_MUNICIPIO": "SANTA LUZIA DO ITANHY",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806404",
		"NOME_MUNICIPIO": "SANTANA DO SAO FRANCISCO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806503",
		"NOME_MUNICIPIO": "SANTA ROSA DE LIMA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806602",
		"NOME_MUNICIPIO": "SANTO AMARO DAS BROTAS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806701",
		"NOME_MUNICIPIO": "SAO CRISTOVAO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806800",
		"NOME_MUNICIPIO": "SAO DOMINGOS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2806909",
		"NOME_MUNICIPIO": "SAO FRANCISCO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807006",
		"NOME_MUNICIPIO": "SAO MIGUEL DO ALEIXO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807105",
		"NOME_MUNICIPIO": "SIMAO DIAS",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807204",
		"NOME_MUNICIPIO": "SIRIRI",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807303",
		"NOME_MUNICIPIO": "TELHA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807402",
		"NOME_MUNICIPIO": "TOBIAS BARRETO",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807501",
		"NOME_MUNICIPIO": "TOMAR DO GERU",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2807600",
		"NOME_MUNICIPIO": "UMBAUBA",
		"COD_UF": "28"
	},
	{
		"COD_MUNICIPIO": "2900108",
		"NOME_MUNICIPIO": "ABAIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900207",
		"NOME_MUNICIPIO": "ABARE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900306",
		"NOME_MUNICIPIO": "ACAJUTIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900355",
		"NOME_MUNICIPIO": "ADUSTINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900405",
		"NOME_MUNICIPIO": "AGUA FRIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900504",
		"NOME_MUNICIPIO": "ERICO CARDOSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900603",
		"NOME_MUNICIPIO": "AIQUARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900702",
		"NOME_MUNICIPIO": "ALAGOINHAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900801",
		"NOME_MUNICIPIO": "ALCOBAÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2900900",
		"NOME_MUNICIPIO": "ALMADINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901007",
		"NOME_MUNICIPIO": "AMARGOSA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901106",
		"NOME_MUNICIPIO": "AMELIA RODRIGUES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901155",
		"NOME_MUNICIPIO": "AMERICA DOURADA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901205",
		"NOME_MUNICIPIO": "ANAGE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901304",
		"NOME_MUNICIPIO": "ANDARAI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901353",
		"NOME_MUNICIPIO": "ANDORINHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901403",
		"NOME_MUNICIPIO": "ANGICAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901502",
		"NOME_MUNICIPIO": "ANGUERA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901601",
		"NOME_MUNICIPIO": "ANTAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901700",
		"NOME_MUNICIPIO": "ANTÔNIO CARDOSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901809",
		"NOME_MUNICIPIO": "ANTÔNIO GONÇALVES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901908",
		"NOME_MUNICIPIO": "APORA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2901957",
		"NOME_MUNICIPIO": "APUAREMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902005",
		"NOME_MUNICIPIO": "ARACATU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902054",
		"NOME_MUNICIPIO": "ARAÇAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902104",
		"NOME_MUNICIPIO": "ARACI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902203",
		"NOME_MUNICIPIO": "ARAMARI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902252",
		"NOME_MUNICIPIO": "ARATACA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902302",
		"NOME_MUNICIPIO": "ARATUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902401",
		"NOME_MUNICIPIO": "AURELINO LEAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902500",
		"NOME_MUNICIPIO": "BAIANOPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902609",
		"NOME_MUNICIPIO": "BAIXA GRANDE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902658",
		"NOME_MUNICIPIO": "BANZAÊ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902708",
		"NOME_MUNICIPIO": "BARRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902807",
		"NOME_MUNICIPIO": "BARRA DA ESTIVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2902906",
		"NOME_MUNICIPIO": "BARRA DO CHOÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903003",
		"NOME_MUNICIPIO": "BARRA DO MENDES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903102",
		"NOME_MUNICIPIO": "BARRA DO ROCHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903201",
		"NOME_MUNICIPIO": "BARREIRAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903235",
		"NOME_MUNICIPIO": "BARRO ALTO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903276",
		"NOME_MUNICIPIO": "BARROCAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903300",
		"NOME_MUNICIPIO": "BARRO PRETO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903409",
		"NOME_MUNICIPIO": "BELMONTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903508",
		"NOME_MUNICIPIO": "BELO CAMPO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903607",
		"NOME_MUNICIPIO": "BIRITINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903706",
		"NOME_MUNICIPIO": "BOA NOVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903805",
		"NOME_MUNICIPIO": "BOA VISTA DO TUPIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903904",
		"NOME_MUNICIPIO": "BOM JESUS DA LAPA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2903953",
		"NOME_MUNICIPIO": "BOM JESUS DA SERRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904001",
		"NOME_MUNICIPIO": "BONINAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904050",
		"NOME_MUNICIPIO": "BONITO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904100",
		"NOME_MUNICIPIO": "BOQUIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904209",
		"NOME_MUNICIPIO": "BOTUPORA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904308",
		"NOME_MUNICIPIO": "BREJÕES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904407",
		"NOME_MUNICIPIO": "BREJOLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904506",
		"NOME_MUNICIPIO": "BROTAS DE MACAUBAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904605",
		"NOME_MUNICIPIO": "BRUMADO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904704",
		"NOME_MUNICIPIO": "BUERAREMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904753",
		"NOME_MUNICIPIO": "BURITIRAMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904803",
		"NOME_MUNICIPIO": "CAATIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904852",
		"NOME_MUNICIPIO": "CABACEIRAS DO PARAGUAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2904902",
		"NOME_MUNICIPIO": "CACHOEIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905008",
		"NOME_MUNICIPIO": "CACULE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905107",
		"NOME_MUNICIPIO": "CAEM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905156",
		"NOME_MUNICIPIO": "CAETANOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905206",
		"NOME_MUNICIPIO": "CAETITE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905305",
		"NOME_MUNICIPIO": "CAFARNAUM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905404",
		"NOME_MUNICIPIO": "CAIRU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905503",
		"NOME_MUNICIPIO": "CALDEIRAO GRANDE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905602",
		"NOME_MUNICIPIO": "CAMACAN",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905701",
		"NOME_MUNICIPIO": "CAMAÇARI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905800",
		"NOME_MUNICIPIO": "CAMAMU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2905909",
		"NOME_MUNICIPIO": "CAMPO ALEGRE DE LOURDES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906006",
		"NOME_MUNICIPIO": "CAMPO FORMOSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906105",
		"NOME_MUNICIPIO": "CANAPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906204",
		"NOME_MUNICIPIO": "CANARANA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906303",
		"NOME_MUNICIPIO": "CANAVIEIRAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906402",
		"NOME_MUNICIPIO": "CANDEAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906501",
		"NOME_MUNICIPIO": "CANDEIAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906600",
		"NOME_MUNICIPIO": "CANDIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906709",
		"NOME_MUNICIPIO": "CANDIDO SALES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906808",
		"NOME_MUNICIPIO": "CANSANÇAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906824",
		"NOME_MUNICIPIO": "CANUDOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906857",
		"NOME_MUNICIPIO": "CAPELA DO ALTO ALEGRE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906873",
		"NOME_MUNICIPIO": "CAPIM GROSSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906899",
		"NOME_MUNICIPIO": "CARAIBAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2906907",
		"NOME_MUNICIPIO": "CARAVELAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907004",
		"NOME_MUNICIPIO": "CARDEAL DA SILVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907103",
		"NOME_MUNICIPIO": "CARINHANHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907202",
		"NOME_MUNICIPIO": "CASA NOVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907301",
		"NOME_MUNICIPIO": "CASTRO ALVES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907400",
		"NOME_MUNICIPIO": "CATOLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907509",
		"NOME_MUNICIPIO": "CATU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907558",
		"NOME_MUNICIPIO": "CATURAMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907608",
		"NOME_MUNICIPIO": "CENTRAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907707",
		"NOME_MUNICIPIO": "CHORROCHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907806",
		"NOME_MUNICIPIO": "CICERO DANTAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2907905",
		"NOME_MUNICIPIO": "CIPO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908002",
		"NOME_MUNICIPIO": "COARACI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908101",
		"NOME_MUNICIPIO": "COCOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908200",
		"NOME_MUNICIPIO": "CONCEIÇAO DA FEIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908309",
		"NOME_MUNICIPIO": "CONCEIÇAO DO ALMEIDA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908408",
		"NOME_MUNICIPIO": "CONCEIÇAO DO COITE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908507",
		"NOME_MUNICIPIO": "CONCEIÇAO DO JACUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908606",
		"NOME_MUNICIPIO": "CONDE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908705",
		"NOME_MUNICIPIO": "CONDEUBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908804",
		"NOME_MUNICIPIO": "CONTENDAS DO SINCORA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2908903",
		"NOME_MUNICIPIO": "CORAÇAO DE MARIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909000",
		"NOME_MUNICIPIO": "CORDEIROS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909109",
		"NOME_MUNICIPIO": "CORIBE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909208",
		"NOME_MUNICIPIO": "CORONEL JOAO SA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909307",
		"NOME_MUNICIPIO": "CORRENTINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909406",
		"NOME_MUNICIPIO": "COTEGIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909505",
		"NOME_MUNICIPIO": "CRAVOLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909604",
		"NOME_MUNICIPIO": "CRISOPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909703",
		"NOME_MUNICIPIO": "CRISTOPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909802",
		"NOME_MUNICIPIO": "CRUZ DAS ALMAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2909901",
		"NOME_MUNICIPIO": "CURAÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910008",
		"NOME_MUNICIPIO": "DARIO MEIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910057",
		"NOME_MUNICIPIO": "DIAS DAVILA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910107",
		"NOME_MUNICIPIO": "DOM BASILIO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910206",
		"NOME_MUNICIPIO": "DOM MACEDO COSTA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910305",
		"NOME_MUNICIPIO": "ELISIO MEDRADO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910404",
		"NOME_MUNICIPIO": "ENCRUZILHADA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910503",
		"NOME_MUNICIPIO": "ENTRE RIOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910602",
		"NOME_MUNICIPIO": "ESPLANADA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910701",
		"NOME_MUNICIPIO": "EUCLIDES DA CUNHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910727",
		"NOME_MUNICIPIO": "EUNAPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910750",
		"NOME_MUNICIPIO": "FATIMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910776",
		"NOME_MUNICIPIO": "FEIRA DA MATA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910800",
		"NOME_MUNICIPIO": "FEIRA DE SANTANA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910859",
		"NOME_MUNICIPIO": "FILADELFIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2910909",
		"NOME_MUNICIPIO": "FIRMINO ALVES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911006",
		"NOME_MUNICIPIO": "FLORESTA AZUL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911105",
		"NOME_MUNICIPIO": "FORMOSA DO RIO PRETO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911204",
		"NOME_MUNICIPIO": "GANDU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911253",
		"NOME_MUNICIPIO": "GAVIAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911303",
		"NOME_MUNICIPIO": "GENTIO DO OURO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911402",
		"NOME_MUNICIPIO": "GLORIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911501",
		"NOME_MUNICIPIO": "GONGOGI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911600",
		"NOME_MUNICIPIO": "GOVERNADOR MANGABEIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911659",
		"NOME_MUNICIPIO": "GUAJERU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911709",
		"NOME_MUNICIPIO": "GUANAMBI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911808",
		"NOME_MUNICIPIO": "GUARATINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911857",
		"NOME_MUNICIPIO": "HELIOPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2911907",
		"NOME_MUNICIPIO": "IAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912004",
		"NOME_MUNICIPIO": "IBIASSUCÊ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912103",
		"NOME_MUNICIPIO": "IBICARAI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912202",
		"NOME_MUNICIPIO": "IBICOARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912301",
		"NOME_MUNICIPIO": "IBICUI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912400",
		"NOME_MUNICIPIO": "IBIPEBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912509",
		"NOME_MUNICIPIO": "IBIPITANGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912608",
		"NOME_MUNICIPIO": "IBIQUERA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912707",
		"NOME_MUNICIPIO": "IBIRAPITANGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912806",
		"NOME_MUNICIPIO": "IBIRAPUA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2912905",
		"NOME_MUNICIPIO": "IBIRATAIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913002",
		"NOME_MUNICIPIO": "IBITIARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913101",
		"NOME_MUNICIPIO": "IBITITA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913200",
		"NOME_MUNICIPIO": "IBOTIRAMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913309",
		"NOME_MUNICIPIO": "ICHU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913408",
		"NOME_MUNICIPIO": "IGAPORA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913457",
		"NOME_MUNICIPIO": "IGRAPIUNA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913507",
		"NOME_MUNICIPIO": "IGUAI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913606",
		"NOME_MUNICIPIO": "ILHEUS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913705",
		"NOME_MUNICIPIO": "INHAMBUPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913804",
		"NOME_MUNICIPIO": "IPECAETA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2913903",
		"NOME_MUNICIPIO": "IPIAU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914000",
		"NOME_MUNICIPIO": "IPIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914109",
		"NOME_MUNICIPIO": "IPUPIARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914208",
		"NOME_MUNICIPIO": "IRAJUBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914307",
		"NOME_MUNICIPIO": "IRAMAIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914406",
		"NOME_MUNICIPIO": "IRAQUARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914505",
		"NOME_MUNICIPIO": "IRARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914604",
		"NOME_MUNICIPIO": "IRECÊ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914653",
		"NOME_MUNICIPIO": "ITABELA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914703",
		"NOME_MUNICIPIO": "ITABERABA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914802",
		"NOME_MUNICIPIO": "ITABUNA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2914901",
		"NOME_MUNICIPIO": "ITACARE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915007",
		"NOME_MUNICIPIO": "ITAETE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915106",
		"NOME_MUNICIPIO": "ITAGI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915205",
		"NOME_MUNICIPIO": "ITAGIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915304",
		"NOME_MUNICIPIO": "ITAGIMIRIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915353",
		"NOME_MUNICIPIO": "ITAGUAÇU DA BAHIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915403",
		"NOME_MUNICIPIO": "ITAJU DO COLÔNIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915502",
		"NOME_MUNICIPIO": "ITAJUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915601",
		"NOME_MUNICIPIO": "ITAMARAJU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915700",
		"NOME_MUNICIPIO": "ITAMARI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915809",
		"NOME_MUNICIPIO": "ITAMBE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2915908",
		"NOME_MUNICIPIO": "ITANAGRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916005",
		"NOME_MUNICIPIO": "ITANHEM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916104",
		"NOME_MUNICIPIO": "ITAPARICA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916203",
		"NOME_MUNICIPIO": "ITAPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916302",
		"NOME_MUNICIPIO": "ITAPEBI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916401",
		"NOME_MUNICIPIO": "ITAPETINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916500",
		"NOME_MUNICIPIO": "ITAPICURU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916609",
		"NOME_MUNICIPIO": "ITAPITANGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916708",
		"NOME_MUNICIPIO": "ITAQUARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916807",
		"NOME_MUNICIPIO": "ITARANTIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916856",
		"NOME_MUNICIPIO": "ITATIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2916906",
		"NOME_MUNICIPIO": "ITIRUÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917003",
		"NOME_MUNICIPIO": "ITIUBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917102",
		"NOME_MUNICIPIO": "ITORORO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917201",
		"NOME_MUNICIPIO": "ITUAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917300",
		"NOME_MUNICIPIO": "ITUBERA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917334",
		"NOME_MUNICIPIO": "IUIU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917359",
		"NOME_MUNICIPIO": "JABORANDI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917409",
		"NOME_MUNICIPIO": "JACARACI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917508",
		"NOME_MUNICIPIO": "JACOBINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917607",
		"NOME_MUNICIPIO": "JAGUAQUARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917706",
		"NOME_MUNICIPIO": "JAGUARARI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917805",
		"NOME_MUNICIPIO": "JAGUARIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2917904",
		"NOME_MUNICIPIO": "JANDAIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918001",
		"NOME_MUNICIPIO": "JEQUIE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918100",
		"NOME_MUNICIPIO": "JEREMOABO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918209",
		"NOME_MUNICIPIO": "JIQUIRIÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918308",
		"NOME_MUNICIPIO": "JITAUNA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918357",
		"NOME_MUNICIPIO": "JOAO DOURADO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918407",
		"NOME_MUNICIPIO": "JUAZEIRO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918456",
		"NOME_MUNICIPIO": "JUCURUÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918506",
		"NOME_MUNICIPIO": "JUSSARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918555",
		"NOME_MUNICIPIO": "JUSSARI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918605",
		"NOME_MUNICIPIO": "JUSSIAPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918704",
		"NOME_MUNICIPIO": "LAFAIETE COUTINHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918753",
		"NOME_MUNICIPIO": "LAGOA REAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918803",
		"NOME_MUNICIPIO": "LAJE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2918902",
		"NOME_MUNICIPIO": "LAJEDAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919009",
		"NOME_MUNICIPIO": "LAJEDINHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919058",
		"NOME_MUNICIPIO": "LAJEDO DO TABOCAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919108",
		"NOME_MUNICIPIO": "LAMARAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919157",
		"NOME_MUNICIPIO": "LAPAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919207",
		"NOME_MUNICIPIO": "LAURO DE FREITAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919306",
		"NOME_MUNICIPIO": "LENÇOIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919405",
		"NOME_MUNICIPIO": "LICINIO DE ALMEIDA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919504",
		"NOME_MUNICIPIO": "LIVRAMENTO DE NOSSA SENHORA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919553",
		"NOME_MUNICIPIO": "LUIS EDUARDO MAGALHAES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919603",
		"NOME_MUNICIPIO": "MACAJUBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919702",
		"NOME_MUNICIPIO": "MACARANI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919801",
		"NOME_MUNICIPIO": "MACAUBAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919900",
		"NOME_MUNICIPIO": "MACURURE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919926",
		"NOME_MUNICIPIO": "MADRE DE DEUS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2919959",
		"NOME_MUNICIPIO": "MAETINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920007",
		"NOME_MUNICIPIO": "MAIQUINIQUE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920106",
		"NOME_MUNICIPIO": "MAIRI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920205",
		"NOME_MUNICIPIO": "MALHADA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920304",
		"NOME_MUNICIPIO": "MALHADA DE PEDRAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920403",
		"NOME_MUNICIPIO": "MANOEL VITORINO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920452",
		"NOME_MUNICIPIO": "MANSIDAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920502",
		"NOME_MUNICIPIO": "MARACAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920601",
		"NOME_MUNICIPIO": "MARAGOGIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920700",
		"NOME_MUNICIPIO": "MARAU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920809",
		"NOME_MUNICIPIO": "MARCIONILIO SOUZA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2920908",
		"NOME_MUNICIPIO": "MASCOTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921005",
		"NOME_MUNICIPIO": "MATA DE SAO JOAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921054",
		"NOME_MUNICIPIO": "MATINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921104",
		"NOME_MUNICIPIO": "MEDEIROS NETO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921203",
		"NOME_MUNICIPIO": "MIGUEL CALMON",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921302",
		"NOME_MUNICIPIO": "MILAGRES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921401",
		"NOME_MUNICIPIO": "MIRANGABA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921450",
		"NOME_MUNICIPIO": "MIRANTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921500",
		"NOME_MUNICIPIO": "MONTE SANTO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921609",
		"NOME_MUNICIPIO": "MORPARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921708",
		"NOME_MUNICIPIO": "MORRO DO CHAPEU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921807",
		"NOME_MUNICIPIO": "MORTUGABA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2921906",
		"NOME_MUNICIPIO": "MUCUGÊ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922003",
		"NOME_MUNICIPIO": "MUCURI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922052",
		"NOME_MUNICIPIO": "MULUNGU DO MORRO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922102",
		"NOME_MUNICIPIO": "MUNDO NOVO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922201",
		"NOME_MUNICIPIO": "MUNIZ FERREIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922250",
		"NOME_MUNICIPIO": "MUQUEM DO SAO FRANCISCO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922300",
		"NOME_MUNICIPIO": "MURITIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922409",
		"NOME_MUNICIPIO": "MUTUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922508",
		"NOME_MUNICIPIO": "NAZARE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922607",
		"NOME_MUNICIPIO": "NILO PEÇANHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922656",
		"NOME_MUNICIPIO": "NORDESTINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922706",
		"NOME_MUNICIPIO": "NOVA CANAA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922730",
		"NOME_MUNICIPIO": "NOVA FATIMA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922755",
		"NOME_MUNICIPIO": "NOVA IBIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922805",
		"NOME_MUNICIPIO": "NOVA ITARANA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922854",
		"NOME_MUNICIPIO": "NOVA REDENÇAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2922904",
		"NOME_MUNICIPIO": "NOVA SOURE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923001",
		"NOME_MUNICIPIO": "NOVA VIÇOSA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923035",
		"NOME_MUNICIPIO": "NOVO HORIZONTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923050",
		"NOME_MUNICIPIO": "NOVO TRIUNFO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923100",
		"NOME_MUNICIPIO": "OLINDINA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923209",
		"NOME_MUNICIPIO": "OLIVEIRA DOS BREJINHOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923308",
		"NOME_MUNICIPIO": "OURIÇANGAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923357",
		"NOME_MUNICIPIO": "OUROLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923407",
		"NOME_MUNICIPIO": "PALMAS DE MONTE ALTO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923506",
		"NOME_MUNICIPIO": "PALMEIRAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923605",
		"NOME_MUNICIPIO": "PARAMIRIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923704",
		"NOME_MUNICIPIO": "PARATINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923803",
		"NOME_MUNICIPIO": "PARIPIRANGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2923902",
		"NOME_MUNICIPIO": "PAU BRASIL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924009",
		"NOME_MUNICIPIO": "PAULO AFONSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924058",
		"NOME_MUNICIPIO": "PE DE SERRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924108",
		"NOME_MUNICIPIO": "PEDRAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924207",
		"NOME_MUNICIPIO": "PEDRO ALEXANDRE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924306",
		"NOME_MUNICIPIO": "PIATA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924405",
		"NOME_MUNICIPIO": "PILAO ARCADO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924504",
		"NOME_MUNICIPIO": "PINDAI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924603",
		"NOME_MUNICIPIO": "PINDOBAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924652",
		"NOME_MUNICIPIO": "PINTADAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924678",
		"NOME_MUNICIPIO": "PIRAI DO NORTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924702",
		"NOME_MUNICIPIO": "PIRIPA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924801",
		"NOME_MUNICIPIO": "PIRITIBA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2924900",
		"NOME_MUNICIPIO": "PLANALTINO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925006",
		"NOME_MUNICIPIO": "PLANALTO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925105",
		"NOME_MUNICIPIO": "POÇÕES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925204",
		"NOME_MUNICIPIO": "POJUCA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925253",
		"NOME_MUNICIPIO": "PONTO NOVO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925303",
		"NOME_MUNICIPIO": "PORTO SEGURO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925402",
		"NOME_MUNICIPIO": "POTIRAGUA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925501",
		"NOME_MUNICIPIO": "PRADO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925600",
		"NOME_MUNICIPIO": "PRESIDENTE DUTRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925709",
		"NOME_MUNICIPIO": "PRESIDENTE JANIO QUADROS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925758",
		"NOME_MUNICIPIO": "PRESIDENTE TANCREDO NEVES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925808",
		"NOME_MUNICIPIO": "QUEIMADAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925907",
		"NOME_MUNICIPIO": "QUIJINGUE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925931",
		"NOME_MUNICIPIO": "QUIXABEIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2925956",
		"NOME_MUNICIPIO": "RAFAEL JAMBEIRO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926004",
		"NOME_MUNICIPIO": "REMANSO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926103",
		"NOME_MUNICIPIO": "RETIROLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926202",
		"NOME_MUNICIPIO": "RIACHAO DAS NEVES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926301",
		"NOME_MUNICIPIO": "RIACHAO DO JACUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926400",
		"NOME_MUNICIPIO": "RIACHO DE SANTANA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926509",
		"NOME_MUNICIPIO": "RIBEIRA DO AMPARO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926608",
		"NOME_MUNICIPIO": "RIBEIRA DO POMBAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926657",
		"NOME_MUNICIPIO": "RIBEIRAO DO LARGO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926707",
		"NOME_MUNICIPIO": "RIO DE CONTAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926806",
		"NOME_MUNICIPIO": "RIO DO ANTÔNIO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2926905",
		"NOME_MUNICIPIO": "RIO DO PIRES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927002",
		"NOME_MUNICIPIO": "RIO REAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927101",
		"NOME_MUNICIPIO": "RODELAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927200",
		"NOME_MUNICIPIO": "RUY BARBOSA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927309",
		"NOME_MUNICIPIO": "SALINAS DA MARGARIDA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927408",
		"NOME_MUNICIPIO": "SALVADOR",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927507",
		"NOME_MUNICIPIO": "SANTA BARBARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927606",
		"NOME_MUNICIPIO": "SANTA BRIGIDA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927705",
		"NOME_MUNICIPIO": "SANTA CRUZ CABRALIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927804",
		"NOME_MUNICIPIO": "SANTA CRUZ DA VITORIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2927903",
		"NOME_MUNICIPIO": "SANTA INÊS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928000",
		"NOME_MUNICIPIO": "SANTALUZ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928059",
		"NOME_MUNICIPIO": "SANTA LUZIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928109",
		"NOME_MUNICIPIO": "SANTA MARIA DA VITORIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928208",
		"NOME_MUNICIPIO": "SANTANA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928307",
		"NOME_MUNICIPIO": "SANTANOPOLIS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928406",
		"NOME_MUNICIPIO": "SANTA RITA DE CASSIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928505",
		"NOME_MUNICIPIO": "SANTA TEREZINHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928604",
		"NOME_MUNICIPIO": "SANTO AMARO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928703",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DE JESUS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928802",
		"NOME_MUNICIPIO": "SANTO ESTÊVAO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928901",
		"NOME_MUNICIPIO": "SAO DESIDERIO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2928950",
		"NOME_MUNICIPIO": "SAO DOMINGOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929008",
		"NOME_MUNICIPIO": "SAO FELIX",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929057",
		"NOME_MUNICIPIO": "SAO FELIX DO CORIBE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929107",
		"NOME_MUNICIPIO": "SAO FELIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929206",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO CONDE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929255",
		"NOME_MUNICIPIO": "SAO GABRIEL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929305",
		"NOME_MUNICIPIO": "SAO GONÇALO DOS CAMPOS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929354",
		"NOME_MUNICIPIO": "SAO JOSE DA VITORIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929370",
		"NOME_MUNICIPIO": "SAO JOSE DO JACUIPE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929404",
		"NOME_MUNICIPIO": "SAO MIGUEL DAS MATAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929503",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO PASSE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929602",
		"NOME_MUNICIPIO": "SAPEAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929701",
		"NOME_MUNICIPIO": "SATIRO DIAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929750",
		"NOME_MUNICIPIO": "SAUBARA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929800",
		"NOME_MUNICIPIO": "SAUDE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2929909",
		"NOME_MUNICIPIO": "SEABRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930006",
		"NOME_MUNICIPIO": "SEBASTIAO LARANJEIRAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930105",
		"NOME_MUNICIPIO": "SENHOR DO BONFIM",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930154",
		"NOME_MUNICIPIO": "SERRA DO RAMALHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930204",
		"NOME_MUNICIPIO": "SENTO SE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930303",
		"NOME_MUNICIPIO": "SERRA DOURADA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930402",
		"NOME_MUNICIPIO": "SERRA PRETA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930501",
		"NOME_MUNICIPIO": "SERRINHA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930600",
		"NOME_MUNICIPIO": "SERROLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930709",
		"NOME_MUNICIPIO": "SIMÕES FILHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930758",
		"NOME_MUNICIPIO": "SITIO DO MATO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930766",
		"NOME_MUNICIPIO": "SITIO DO QUINTO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930774",
		"NOME_MUNICIPIO": "SOBRADINHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930808",
		"NOME_MUNICIPIO": "SOUTO SOARES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2930907",
		"NOME_MUNICIPIO": "TABOCAS DO BREJO VELHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931004",
		"NOME_MUNICIPIO": "TANHAÇU",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931053",
		"NOME_MUNICIPIO": "TANQUE NOVO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931103",
		"NOME_MUNICIPIO": "TANQUINHO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931202",
		"NOME_MUNICIPIO": "TAPEROA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931301",
		"NOME_MUNICIPIO": "TAPIRAMUTA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931350",
		"NOME_MUNICIPIO": "TEIXEIRA DE FREITAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931400",
		"NOME_MUNICIPIO": "TEODORO SAMPAIO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931509",
		"NOME_MUNICIPIO": "TEOFILANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931608",
		"NOME_MUNICIPIO": "TEOLANDIA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931707",
		"NOME_MUNICIPIO": "TERRA NOVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931806",
		"NOME_MUNICIPIO": "TREMEDAL",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2931905",
		"NOME_MUNICIPIO": "TUCANO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932002",
		"NOME_MUNICIPIO": "UAUA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932101",
		"NOME_MUNICIPIO": "UBAIRA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932200",
		"NOME_MUNICIPIO": "UBAITABA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932309",
		"NOME_MUNICIPIO": "UBATA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932408",
		"NOME_MUNICIPIO": "UIBAI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932457",
		"NOME_MUNICIPIO": "UMBURANAS",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932507",
		"NOME_MUNICIPIO": "UNA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932606",
		"NOME_MUNICIPIO": "URANDI",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932705",
		"NOME_MUNICIPIO": "URUÇUCA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932804",
		"NOME_MUNICIPIO": "UTINGA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2932903",
		"NOME_MUNICIPIO": "VALENÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933000",
		"NOME_MUNICIPIO": "VALENTE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933059",
		"NOME_MUNICIPIO": "VARZEA DA ROÇA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933109",
		"NOME_MUNICIPIO": "VARZEA DO POÇO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933158",
		"NOME_MUNICIPIO": "VARZEA NOVA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933174",
		"NOME_MUNICIPIO": "VARZEDO",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933208",
		"NOME_MUNICIPIO": "VERA CRUZ",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933257",
		"NOME_MUNICIPIO": "VEREDA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933307",
		"NOME_MUNICIPIO": "VITORIA DA CONQUISTA",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933406",
		"NOME_MUNICIPIO": "WAGNER",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933455",
		"NOME_MUNICIPIO": "WANDERLEY",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933505",
		"NOME_MUNICIPIO": "WENCESLAU GUIMARAES",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "2933604",
		"NOME_MUNICIPIO": "XIQUE-XIQUE",
		"COD_UF": "29"
	},
	{
		"COD_MUNICIPIO": "3100104",
		"NOME_MUNICIPIO": "ABADIA DOS DOURADOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100203",
		"NOME_MUNICIPIO": "ABAETE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100302",
		"NOME_MUNICIPIO": "ABRE CAMPO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100401",
		"NOME_MUNICIPIO": "ACAIACA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100500",
		"NOME_MUNICIPIO": "AÇUCENA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100609",
		"NOME_MUNICIPIO": "AGUA BOA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100708",
		"NOME_MUNICIPIO": "AGUA COMPRIDA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100807",
		"NOME_MUNICIPIO": "AGUANIL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3100906",
		"NOME_MUNICIPIO": "AGUAS FORMOSAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101003",
		"NOME_MUNICIPIO": "AGUAS VERMELHAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101102",
		"NOME_MUNICIPIO": "AIMORES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101201",
		"NOME_MUNICIPIO": "AIURUOCA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101300",
		"NOME_MUNICIPIO": "ALAGOA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101409",
		"NOME_MUNICIPIO": "ALBERTINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101508",
		"NOME_MUNICIPIO": "ALEM PARAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101607",
		"NOME_MUNICIPIO": "ALFENAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101631",
		"NOME_MUNICIPIO": "ALFREDO VASCONCELOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101706",
		"NOME_MUNICIPIO": "ALMENARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101805",
		"NOME_MUNICIPIO": "ALPERCATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3101904",
		"NOME_MUNICIPIO": "ALPINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102001",
		"NOME_MUNICIPIO": "ALTEROSA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102050",
		"NOME_MUNICIPIO": "ALTO CAPARAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102100",
		"NOME_MUNICIPIO": "ALTO RIO DOCE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102209",
		"NOME_MUNICIPIO": "ALVARENGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102308",
		"NOME_MUNICIPIO": "ALVINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102407",
		"NOME_MUNICIPIO": "ALVORADA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102506",
		"NOME_MUNICIPIO": "AMPARO DO SERRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102605",
		"NOME_MUNICIPIO": "ANDRADAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102704",
		"NOME_MUNICIPIO": "CACHOEIRA DE PAJEU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102803",
		"NOME_MUNICIPIO": "ANDRELANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102852",
		"NOME_MUNICIPIO": "ANGELANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3102902",
		"NOME_MUNICIPIO": "ANTÔNIO CARLOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103009",
		"NOME_MUNICIPIO": "ANTÔNIO DIAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103108",
		"NOME_MUNICIPIO": "ANTÔNIO PRADO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103207",
		"NOME_MUNICIPIO": "ARAÇAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103306",
		"NOME_MUNICIPIO": "ARACITABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103405",
		"NOME_MUNICIPIO": "ARAÇUAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103504",
		"NOME_MUNICIPIO": "ARAGUARI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103603",
		"NOME_MUNICIPIO": "ARANTINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103702",
		"NOME_MUNICIPIO": "ARAPONGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103751",
		"NOME_MUNICIPIO": "ARAPORA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103801",
		"NOME_MUNICIPIO": "ARAPUA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3103900",
		"NOME_MUNICIPIO": "ARAUJOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104007",
		"NOME_MUNICIPIO": "ARAXA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104106",
		"NOME_MUNICIPIO": "ARCEBURGO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104205",
		"NOME_MUNICIPIO": "ARCOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104304",
		"NOME_MUNICIPIO": "AREADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104403",
		"NOME_MUNICIPIO": "ARGIRITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104452",
		"NOME_MUNICIPIO": "ARICANDUVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104502",
		"NOME_MUNICIPIO": "ARINOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104601",
		"NOME_MUNICIPIO": "ASTOLFO DUTRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104700",
		"NOME_MUNICIPIO": "ATALEIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104809",
		"NOME_MUNICIPIO": "AUGUSTO DE LIMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3104908",
		"NOME_MUNICIPIO": "BAEPENDI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105004",
		"NOME_MUNICIPIO": "BALDIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105103",
		"NOME_MUNICIPIO": "BAMBUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105202",
		"NOME_MUNICIPIO": "BANDEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105301",
		"NOME_MUNICIPIO": "BANDEIRA DO SUL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105400",
		"NOME_MUNICIPIO": "BARAO DE COCAIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105509",
		"NOME_MUNICIPIO": "BARAO DE MONTE ALTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105608",
		"NOME_MUNICIPIO": "BARBACENA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105707",
		"NOME_MUNICIPIO": "BARRA LONGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3105905",
		"NOME_MUNICIPIO": "BARROSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106002",
		"NOME_MUNICIPIO": "BELA VISTA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106101",
		"NOME_MUNICIPIO": "BELMIRO BRAGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106200",
		"NOME_MUNICIPIO": "BELO HORIZONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106309",
		"NOME_MUNICIPIO": "BELO ORIENTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106408",
		"NOME_MUNICIPIO": "BELO VALE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106507",
		"NOME_MUNICIPIO": "BERILO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106606",
		"NOME_MUNICIPIO": "BERTOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106655",
		"NOME_MUNICIPIO": "BERIZAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106705",
		"NOME_MUNICIPIO": "BETIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106804",
		"NOME_MUNICIPIO": "BIAS FORTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3106903",
		"NOME_MUNICIPIO": "BICAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107000",
		"NOME_MUNICIPIO": "BIQUINHAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107109",
		"NOME_MUNICIPIO": "BOA ESPERANÇA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107208",
		"NOME_MUNICIPIO": "BOCAINA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107307",
		"NOME_MUNICIPIO": "BOCAIUVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107406",
		"NOME_MUNICIPIO": "BOM DESPACHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107505",
		"NOME_MUNICIPIO": "BOM JARDIM DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107604",
		"NOME_MUNICIPIO": "BOM JESUS DA PENHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107703",
		"NOME_MUNICIPIO": "BOM JESUS DO AMPARO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107802",
		"NOME_MUNICIPIO": "BOM JESUS DO GALHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3107901",
		"NOME_MUNICIPIO": "BOM REPOUSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108008",
		"NOME_MUNICIPIO": "BOM SUCESSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108107",
		"NOME_MUNICIPIO": "BONFIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108206",
		"NOME_MUNICIPIO": "BONFINOPOLIS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108255",
		"NOME_MUNICIPIO": "BONITO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108305",
		"NOME_MUNICIPIO": "BORDA DA MATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108404",
		"NOME_MUNICIPIO": "BOTELHOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108503",
		"NOME_MUNICIPIO": "BOTUMIRIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108552",
		"NOME_MUNICIPIO": "BRASILANDIA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108602",
		"NOME_MUNICIPIO": "BRASILIA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108701",
		"NOME_MUNICIPIO": "BRAS PIRES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108800",
		"NOME_MUNICIPIO": "BRAUNAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3108909",
		"NOME_MUNICIPIO": "BRAZOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109006",
		"NOME_MUNICIPIO": "BRUMADINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109105",
		"NOME_MUNICIPIO": "BUENO BRANDAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109204",
		"NOME_MUNICIPIO": "BUENOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109253",
		"NOME_MUNICIPIO": "BUGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109303",
		"NOME_MUNICIPIO": "BURITIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109402",
		"NOME_MUNICIPIO": "BURITIZEIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109451",
		"NOME_MUNICIPIO": "CABECEIRA GRANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109501",
		"NOME_MUNICIPIO": "CABO VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109600",
		"NOME_MUNICIPIO": "CACHOEIRA DA PRATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109709",
		"NOME_MUNICIPIO": "CACHOEIRA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109808",
		"NOME_MUNICIPIO": "CACHOEIRA DOURADA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3109907",
		"NOME_MUNICIPIO": "CAETANOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110004",
		"NOME_MUNICIPIO": "CAETE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110103",
		"NOME_MUNICIPIO": "CAIANA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110202",
		"NOME_MUNICIPIO": "CAJURI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110301",
		"NOME_MUNICIPIO": "CALDAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110400",
		"NOME_MUNICIPIO": "CAMACHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110509",
		"NOME_MUNICIPIO": "CAMANDUCAIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110608",
		"NOME_MUNICIPIO": "CAMBUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110707",
		"NOME_MUNICIPIO": "CAMBUQUIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110806",
		"NOME_MUNICIPIO": "CAMPANARIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3110905",
		"NOME_MUNICIPIO": "CAMPANHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111002",
		"NOME_MUNICIPIO": "CAMPESTRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111101",
		"NOME_MUNICIPIO": "CAMPINA VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111150",
		"NOME_MUNICIPIO": "CAMPO AZUL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111200",
		"NOME_MUNICIPIO": "CAMPO BELO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111309",
		"NOME_MUNICIPIO": "CAMPO DO MEIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111408",
		"NOME_MUNICIPIO": "CAMPO FLORIDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111507",
		"NOME_MUNICIPIO": "CAMPOS ALTOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111606",
		"NOME_MUNICIPIO": "CAMPOS GERAIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111705",
		"NOME_MUNICIPIO": "CANAA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111804",
		"NOME_MUNICIPIO": "CANAPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3111903",
		"NOME_MUNICIPIO": "CANA VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112000",
		"NOME_MUNICIPIO": "CANDEIAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112059",
		"NOME_MUNICIPIO": "CANTAGALO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112109",
		"NOME_MUNICIPIO": "CAPARAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112208",
		"NOME_MUNICIPIO": "CAPELA NOVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112307",
		"NOME_MUNICIPIO": "CAPELINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112406",
		"NOME_MUNICIPIO": "CAPETINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112505",
		"NOME_MUNICIPIO": "CAPIM BRANCO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112604",
		"NOME_MUNICIPIO": "CAPINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112653",
		"NOME_MUNICIPIO": "CAPITAO ANDRADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112703",
		"NOME_MUNICIPIO": "CAPITAO ENEAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112802",
		"NOME_MUNICIPIO": "CAPITOLIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3112901",
		"NOME_MUNICIPIO": "CAPUTIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113008",
		"NOME_MUNICIPIO": "CARAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113107",
		"NOME_MUNICIPIO": "CARANAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113206",
		"NOME_MUNICIPIO": "CARANDAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113305",
		"NOME_MUNICIPIO": "CARANGOLA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113404",
		"NOME_MUNICIPIO": "CARATINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113503",
		"NOME_MUNICIPIO": "CARBONITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113602",
		"NOME_MUNICIPIO": "CAREAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113701",
		"NOME_MUNICIPIO": "CARLOS CHAGAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113800",
		"NOME_MUNICIPIO": "CARMESIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3113909",
		"NOME_MUNICIPIO": "CARMO DA CACHOEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114006",
		"NOME_MUNICIPIO": "CARMO DA MATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114105",
		"NOME_MUNICIPIO": "CARMO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114204",
		"NOME_MUNICIPIO": "CARMO DO CAJURU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114303",
		"NOME_MUNICIPIO": "CARMO DO PARANAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114402",
		"NOME_MUNICIPIO": "CARMO DO RIO CLARO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114501",
		"NOME_MUNICIPIO": "CARMOPOLIS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114550",
		"NOME_MUNICIPIO": "CARNEIRINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114600",
		"NOME_MUNICIPIO": "CARRANCAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114709",
		"NOME_MUNICIPIO": "CARVALHOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114808",
		"NOME_MUNICIPIO": "CARVALHOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3114907",
		"NOME_MUNICIPIO": "CASA GRANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115003",
		"NOME_MUNICIPIO": "CASCALHO RICO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115102",
		"NOME_MUNICIPIO": "CASSIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115201",
		"NOME_MUNICIPIO": "CONCEIÇAO DA BARRA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115300",
		"NOME_MUNICIPIO": "CATAGUASES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115359",
		"NOME_MUNICIPIO": "CATAS ALTAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115409",
		"NOME_MUNICIPIO": "CATAS ALTAS DA NORUEGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115458",
		"NOME_MUNICIPIO": "CATUJI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115474",
		"NOME_MUNICIPIO": "CATUTI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115508",
		"NOME_MUNICIPIO": "CAXAMBU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115607",
		"NOME_MUNICIPIO": "CEDRO DO ABAETE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115706",
		"NOME_MUNICIPIO": "CENTRAL DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115805",
		"NOME_MUNICIPIO": "CENTRALINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3115904",
		"NOME_MUNICIPIO": "CHACARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116001",
		"NOME_MUNICIPIO": "CHALE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116100",
		"NOME_MUNICIPIO": "CHAPADA DO NORTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116159",
		"NOME_MUNICIPIO": "CHAPADA GAUCHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116209",
		"NOME_MUNICIPIO": "CHIADOR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116308",
		"NOME_MUNICIPIO": "CIPOTANEA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116407",
		"NOME_MUNICIPIO": "CLARAVAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116506",
		"NOME_MUNICIPIO": "CLARO DOS POÇÕES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116605",
		"NOME_MUNICIPIO": "CLAUDIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116704",
		"NOME_MUNICIPIO": "COIMBRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116803",
		"NOME_MUNICIPIO": "COLUNA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3116902",
		"NOME_MUNICIPIO": "COMENDADOR GOMES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117009",
		"NOME_MUNICIPIO": "COMERCINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117108",
		"NOME_MUNICIPIO": "CONCEIÇAO DA APARECIDA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117207",
		"NOME_MUNICIPIO": "CONCEIÇAO DAS PEDRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117306",
		"NOME_MUNICIPIO": "CONCEIÇAO DAS ALAGOAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117405",
		"NOME_MUNICIPIO": "CONCEIÇAO DE IPANEMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117504",
		"NOME_MUNICIPIO": "CONCEIÇAO DO MATO DENTRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117603",
		"NOME_MUNICIPIO": "CONCEIÇAO DO PARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117702",
		"NOME_MUNICIPIO": "CONCEIÇAO DO RIO VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117801",
		"NOME_MUNICIPIO": "CONCEIÇAO DOS OUROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117836",
		"NOME_MUNICIPIO": "CÔNEGO MARINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117876",
		"NOME_MUNICIPIO": "CONFINS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3117900",
		"NOME_MUNICIPIO": "CONGONHAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118007",
		"NOME_MUNICIPIO": "CONGONHAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118106",
		"NOME_MUNICIPIO": "CONGONHAS DO NORTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118205",
		"NOME_MUNICIPIO": "CONQUISTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118304",
		"NOME_MUNICIPIO": "CONSELHEIRO LAFAIETE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118403",
		"NOME_MUNICIPIO": "CONSELHEIRO PENA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118502",
		"NOME_MUNICIPIO": "CONSOLAÇAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118601",
		"NOME_MUNICIPIO": "CONTAGEM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118700",
		"NOME_MUNICIPIO": "COQUEIRAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118809",
		"NOME_MUNICIPIO": "CORAÇAO DE JESUS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3118908",
		"NOME_MUNICIPIO": "CORDISBURGO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119005",
		"NOME_MUNICIPIO": "CORDISLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119104",
		"NOME_MUNICIPIO": "CORINTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119203",
		"NOME_MUNICIPIO": "COROACI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119302",
		"NOME_MUNICIPIO": "COROMANDEL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119401",
		"NOME_MUNICIPIO": "CORONEL FABRICIANO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119500",
		"NOME_MUNICIPIO": "CORONEL MURTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119609",
		"NOME_MUNICIPIO": "CORONEL PACHECO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119708",
		"NOME_MUNICIPIO": "CORONEL XAVIER CHAVES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119807",
		"NOME_MUNICIPIO": "CORREGO DANTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119906",
		"NOME_MUNICIPIO": "CORREGO DO BOM JESUS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3119955",
		"NOME_MUNICIPIO": "CORREGO FUNDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120003",
		"NOME_MUNICIPIO": "CORREGO NOVO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120102",
		"NOME_MUNICIPIO": "COUTO DE MAGALHAES DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120151",
		"NOME_MUNICIPIO": "CRISOLITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120201",
		"NOME_MUNICIPIO": "CRISTAIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120300",
		"NOME_MUNICIPIO": "CRISTALIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120409",
		"NOME_MUNICIPIO": "CRISTIANO OTONI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120508",
		"NOME_MUNICIPIO": "CRISTINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120607",
		"NOME_MUNICIPIO": "CRUCILANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120706",
		"NOME_MUNICIPIO": "CRUZEIRO DA FORTALEZA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120805",
		"NOME_MUNICIPIO": "CRUZILIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120839",
		"NOME_MUNICIPIO": "CUPARAQUE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120870",
		"NOME_MUNICIPIO": "CURRAL DE DENTRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3120904",
		"NOME_MUNICIPIO": "CURVELO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121001",
		"NOME_MUNICIPIO": "DATAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121100",
		"NOME_MUNICIPIO": "DELFIM MOREIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121209",
		"NOME_MUNICIPIO": "DELFINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121258",
		"NOME_MUNICIPIO": "DELTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121308",
		"NOME_MUNICIPIO": "DESCOBERTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121407",
		"NOME_MUNICIPIO": "DESTERRO DE ENTRE RIOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121506",
		"NOME_MUNICIPIO": "DESTERRO DO MELO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121605",
		"NOME_MUNICIPIO": "DIAMANTINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121704",
		"NOME_MUNICIPIO": "DIOGO DE VASCONCELOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121803",
		"NOME_MUNICIPIO": "DIONISIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3121902",
		"NOME_MUNICIPIO": "DIVINESIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122009",
		"NOME_MUNICIPIO": "DIVINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122108",
		"NOME_MUNICIPIO": "DIVINO DAS LARANJEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122207",
		"NOME_MUNICIPIO": "DIVINOLANDIA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122306",
		"NOME_MUNICIPIO": "DIVINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122355",
		"NOME_MUNICIPIO": "DIVISA ALEGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122405",
		"NOME_MUNICIPIO": "DIVISA NOVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122454",
		"NOME_MUNICIPIO": "DIVISOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122470",
		"NOME_MUNICIPIO": "DOM BOSCO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122504",
		"NOME_MUNICIPIO": "DOM CAVATI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122603",
		"NOME_MUNICIPIO": "DOM JOAQUIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122702",
		"NOME_MUNICIPIO": "DOM SILVERIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122801",
		"NOME_MUNICIPIO": "DOM VIÇOSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3122900",
		"NOME_MUNICIPIO": "DONA EUSEBIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123007",
		"NOME_MUNICIPIO": "DORES DE CAMPOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123106",
		"NOME_MUNICIPIO": "DORES DE GUANHAES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123205",
		"NOME_MUNICIPIO": "DORES DO INDAIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123304",
		"NOME_MUNICIPIO": "DORES DO TURVO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123403",
		"NOME_MUNICIPIO": "DORESOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123502",
		"NOME_MUNICIPIO": "DOURADOQUARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123528",
		"NOME_MUNICIPIO": "DURANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123601",
		"NOME_MUNICIPIO": "ELOI MENDES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123700",
		"NOME_MUNICIPIO": "ENGENHEIRO CALDAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123809",
		"NOME_MUNICIPIO": "ENGENHEIRO NAVARRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123858",
		"NOME_MUNICIPIO": "ENTRE FOLHAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3123908",
		"NOME_MUNICIPIO": "ENTRE RIOS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124005",
		"NOME_MUNICIPIO": "ERVALIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124104",
		"NOME_MUNICIPIO": "ESMERALDAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124203",
		"NOME_MUNICIPIO": "ESPERA FELIZ",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124302",
		"NOME_MUNICIPIO": "ESPINOSA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124401",
		"NOME_MUNICIPIO": "ESPIRITO SANTO DO DOURADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124500",
		"NOME_MUNICIPIO": "ESTIVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124609",
		"NOME_MUNICIPIO": "ESTRELA DALVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124708",
		"NOME_MUNICIPIO": "ESTRELA DO INDAIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124807",
		"NOME_MUNICIPIO": "ESTRELA DO SUL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3124906",
		"NOME_MUNICIPIO": "EUGENOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125002",
		"NOME_MUNICIPIO": "EWBANK DA CAMARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125101",
		"NOME_MUNICIPIO": "EXTREMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125200",
		"NOME_MUNICIPIO": "FAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125309",
		"NOME_MUNICIPIO": "FARIA LEMOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125408",
		"NOME_MUNICIPIO": "FELICIO DOS SANTOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125507",
		"NOME_MUNICIPIO": "SAO GONÇALO DO RIO PRETO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125606",
		"NOME_MUNICIPIO": "FELISBURGO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125705",
		"NOME_MUNICIPIO": "FELIXLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125804",
		"NOME_MUNICIPIO": "FERNANDES TOURINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125903",
		"NOME_MUNICIPIO": "FERROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3125952",
		"NOME_MUNICIPIO": "FERVEDOURO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126000",
		"NOME_MUNICIPIO": "FLORESTAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126109",
		"NOME_MUNICIPIO": "FORMIGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126208",
		"NOME_MUNICIPIO": "FORMOSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126307",
		"NOME_MUNICIPIO": "FORTALEZA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126406",
		"NOME_MUNICIPIO": "FORTUNA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126505",
		"NOME_MUNICIPIO": "FRANCISCO BADARO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126604",
		"NOME_MUNICIPIO": "FRANCISCO DUMONT",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126703",
		"NOME_MUNICIPIO": "FRANCISCO SA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126752",
		"NOME_MUNICIPIO": "FRANCISCOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126802",
		"NOME_MUNICIPIO": "FREI GASPAR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126901",
		"NOME_MUNICIPIO": "FREI INOCÊNCIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3126950",
		"NOME_MUNICIPIO": "FREI LAGONEGRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127008",
		"NOME_MUNICIPIO": "FRONTEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127057",
		"NOME_MUNICIPIO": "FRONTEIRA DOS VALES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127073",
		"NOME_MUNICIPIO": "FRUTA DE LEITE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127107",
		"NOME_MUNICIPIO": "FRUTAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127206",
		"NOME_MUNICIPIO": "FUNILANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127305",
		"NOME_MUNICIPIO": "GALILEIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127339",
		"NOME_MUNICIPIO": "GAMELEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127354",
		"NOME_MUNICIPIO": "GLAUCILANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127370",
		"NOME_MUNICIPIO": "GOIABEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127388",
		"NOME_MUNICIPIO": "GOIANA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127404",
		"NOME_MUNICIPIO": "GONÇALVES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127503",
		"NOME_MUNICIPIO": "GONZAGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127602",
		"NOME_MUNICIPIO": "GOUVEIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127701",
		"NOME_MUNICIPIO": "GOVERNADOR VALADARES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127800",
		"NOME_MUNICIPIO": "GRAO MOGOL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3127909",
		"NOME_MUNICIPIO": "GRUPIARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128006",
		"NOME_MUNICIPIO": "GUANHAES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128105",
		"NOME_MUNICIPIO": "GUAPE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128204",
		"NOME_MUNICIPIO": "GUARACIABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128253",
		"NOME_MUNICIPIO": "GUARACIAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128303",
		"NOME_MUNICIPIO": "GUARANESIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128402",
		"NOME_MUNICIPIO": "GUARANI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128501",
		"NOME_MUNICIPIO": "GUARARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128600",
		"NOME_MUNICIPIO": "GUARDA-MOR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128709",
		"NOME_MUNICIPIO": "GUAXUPE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128808",
		"NOME_MUNICIPIO": "GUIDOVAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3128907",
		"NOME_MUNICIPIO": "GUIMARANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129004",
		"NOME_MUNICIPIO": "GUIRICEMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129103",
		"NOME_MUNICIPIO": "GURINHATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129202",
		"NOME_MUNICIPIO": "HELIODORA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129301",
		"NOME_MUNICIPIO": "IAPU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129400",
		"NOME_MUNICIPIO": "IBERTIOGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129509",
		"NOME_MUNICIPIO": "IBIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129608",
		"NOME_MUNICIPIO": "IBIAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129657",
		"NOME_MUNICIPIO": "IBIRACATU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129707",
		"NOME_MUNICIPIO": "IBIRACI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129806",
		"NOME_MUNICIPIO": "IBIRITE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3129905",
		"NOME_MUNICIPIO": "IBITIURA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130002",
		"NOME_MUNICIPIO": "IBITURUNA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130051",
		"NOME_MUNICIPIO": "ICARAI DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130101",
		"NOME_MUNICIPIO": "IGARAPE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130200",
		"NOME_MUNICIPIO": "IGARATINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130309",
		"NOME_MUNICIPIO": "IGUATAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130408",
		"NOME_MUNICIPIO": "IJACI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130507",
		"NOME_MUNICIPIO": "ILICINEA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130556",
		"NOME_MUNICIPIO": "IMBE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130606",
		"NOME_MUNICIPIO": "INCONFIDENTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130655",
		"NOME_MUNICIPIO": "INDAIABIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130705",
		"NOME_MUNICIPIO": "INDIANOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130804",
		"NOME_MUNICIPIO": "INGAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3130903",
		"NOME_MUNICIPIO": "INHAPIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131000",
		"NOME_MUNICIPIO": "INHAUMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131109",
		"NOME_MUNICIPIO": "INIMUTABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131158",
		"NOME_MUNICIPIO": "IPABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131208",
		"NOME_MUNICIPIO": "IPANEMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131307",
		"NOME_MUNICIPIO": "IPATINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131406",
		"NOME_MUNICIPIO": "IPIAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131505",
		"NOME_MUNICIPIO": "IPUIUNA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131604",
		"NOME_MUNICIPIO": "IRAI DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131703",
		"NOME_MUNICIPIO": "ITABIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131802",
		"NOME_MUNICIPIO": "ITABIRINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3131901",
		"NOME_MUNICIPIO": "ITABIRITO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132008",
		"NOME_MUNICIPIO": "ITACAMBIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132107",
		"NOME_MUNICIPIO": "ITACARAMBI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132206",
		"NOME_MUNICIPIO": "ITAGUARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132305",
		"NOME_MUNICIPIO": "ITAIPE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132404",
		"NOME_MUNICIPIO": "ITAJUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132503",
		"NOME_MUNICIPIO": "ITAMARANDIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132602",
		"NOME_MUNICIPIO": "ITAMARATI DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132701",
		"NOME_MUNICIPIO": "ITAMBACURI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132800",
		"NOME_MUNICIPIO": "ITAMBE DO MATO DENTRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3132909",
		"NOME_MUNICIPIO": "ITAMOGI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133006",
		"NOME_MUNICIPIO": "ITAMONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133105",
		"NOME_MUNICIPIO": "ITANHANDU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133204",
		"NOME_MUNICIPIO": "ITANHOMI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133303",
		"NOME_MUNICIPIO": "ITAOBIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133402",
		"NOME_MUNICIPIO": "ITAPAGIPE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133501",
		"NOME_MUNICIPIO": "ITAPECERICA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133600",
		"NOME_MUNICIPIO": "ITAPEVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133709",
		"NOME_MUNICIPIO": "ITATIAIUÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133758",
		"NOME_MUNICIPIO": "ITAU DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133808",
		"NOME_MUNICIPIO": "ITAUNA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3133907",
		"NOME_MUNICIPIO": "ITAVERAVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134004",
		"NOME_MUNICIPIO": "ITINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134103",
		"NOME_MUNICIPIO": "ITUETA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134202",
		"NOME_MUNICIPIO": "ITUIUTABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134301",
		"NOME_MUNICIPIO": "ITUMIRIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134400",
		"NOME_MUNICIPIO": "ITURAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134509",
		"NOME_MUNICIPIO": "ITUTINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134608",
		"NOME_MUNICIPIO": "JABOTICATUBAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134707",
		"NOME_MUNICIPIO": "JACINTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134806",
		"NOME_MUNICIPIO": "JACUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3134905",
		"NOME_MUNICIPIO": "JACUTINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135001",
		"NOME_MUNICIPIO": "JAGUARAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135050",
		"NOME_MUNICIPIO": "JAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135076",
		"NOME_MUNICIPIO": "JAMPRUCA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135100",
		"NOME_MUNICIPIO": "JANAUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135209",
		"NOME_MUNICIPIO": "JANUARIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135308",
		"NOME_MUNICIPIO": "JAPARAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135357",
		"NOME_MUNICIPIO": "JAPONVAR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135407",
		"NOME_MUNICIPIO": "JECEABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135456",
		"NOME_MUNICIPIO": "JENIPAPO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135506",
		"NOME_MUNICIPIO": "JEQUERI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135605",
		"NOME_MUNICIPIO": "JEQUITAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135704",
		"NOME_MUNICIPIO": "JEQUITIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135803",
		"NOME_MUNICIPIO": "JEQUITINHONHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3135902",
		"NOME_MUNICIPIO": "JESUANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136009",
		"NOME_MUNICIPIO": "JOAIMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136108",
		"NOME_MUNICIPIO": "JOANESIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136207",
		"NOME_MUNICIPIO": "JOAO MONLEVADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136306",
		"NOME_MUNICIPIO": "JOAO PINHEIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136405",
		"NOME_MUNICIPIO": "JOAQUIM FELICIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136504",
		"NOME_MUNICIPIO": "JORDANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136520",
		"NOME_MUNICIPIO": "JOSE GONÇALVES DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136553",
		"NOME_MUNICIPIO": "JOSE RAYDAN",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136579",
		"NOME_MUNICIPIO": "JOSENOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136603",
		"NOME_MUNICIPIO": "NOVA UNIAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136652",
		"NOME_MUNICIPIO": "JUATUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136702",
		"NOME_MUNICIPIO": "JUIZ DE FORA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136801",
		"NOME_MUNICIPIO": "JURAMENTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136900",
		"NOME_MUNICIPIO": "JURUAIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3136959",
		"NOME_MUNICIPIO": "JUVENILIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137007",
		"NOME_MUNICIPIO": "LADAINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137106",
		"NOME_MUNICIPIO": "LAGAMAR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137205",
		"NOME_MUNICIPIO": "LAGOA DA PRATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137304",
		"NOME_MUNICIPIO": "LAGOA DOS PATOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137403",
		"NOME_MUNICIPIO": "LAGOA DOURADA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137502",
		"NOME_MUNICIPIO": "LAGOA FORMOSA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137536",
		"NOME_MUNICIPIO": "LAGOA GRANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137601",
		"NOME_MUNICIPIO": "LAGOA SANTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137700",
		"NOME_MUNICIPIO": "LAJINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137809",
		"NOME_MUNICIPIO": "LAMBARI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3137908",
		"NOME_MUNICIPIO": "LAMIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138005",
		"NOME_MUNICIPIO": "LARANJAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138104",
		"NOME_MUNICIPIO": "LASSANCE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138203",
		"NOME_MUNICIPIO": "LAVRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138302",
		"NOME_MUNICIPIO": "LEANDRO FERREIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138351",
		"NOME_MUNICIPIO": "LEME DO PRADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138401",
		"NOME_MUNICIPIO": "LEOPOLDINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138500",
		"NOME_MUNICIPIO": "LIBERDADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138609",
		"NOME_MUNICIPIO": "LIMA DUARTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138625",
		"NOME_MUNICIPIO": "LIMEIRA DO OESTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138658",
		"NOME_MUNICIPIO": "LONTRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138674",
		"NOME_MUNICIPIO": "LUISBURGO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138682",
		"NOME_MUNICIPIO": "LUISLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138708",
		"NOME_MUNICIPIO": "LUMINARIAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138807",
		"NOME_MUNICIPIO": "LUZ",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3138906",
		"NOME_MUNICIPIO": "MACHACALIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139003",
		"NOME_MUNICIPIO": "MACHADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139102",
		"NOME_MUNICIPIO": "MADRE DE DEUS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139201",
		"NOME_MUNICIPIO": "MALACACHETA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139250",
		"NOME_MUNICIPIO": "MAMONAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139300",
		"NOME_MUNICIPIO": "MANGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139409",
		"NOME_MUNICIPIO": "MANHUAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139508",
		"NOME_MUNICIPIO": "MANHUMIRIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139607",
		"NOME_MUNICIPIO": "MANTENA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139706",
		"NOME_MUNICIPIO": "MARAVILHAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139805",
		"NOME_MUNICIPIO": "MAR DE ESPANHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3139904",
		"NOME_MUNICIPIO": "MARIA DA FE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140001",
		"NOME_MUNICIPIO": "MARIANA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140100",
		"NOME_MUNICIPIO": "MARILAC",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140159",
		"NOME_MUNICIPIO": "MARIO CAMPOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140209",
		"NOME_MUNICIPIO": "MARIPA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140308",
		"NOME_MUNICIPIO": "MARLIERIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140407",
		"NOME_MUNICIPIO": "MARMELOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140506",
		"NOME_MUNICIPIO": "MARTINHO CAMPOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140530",
		"NOME_MUNICIPIO": "MARTINS SOARES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140555",
		"NOME_MUNICIPIO": "MATA VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140605",
		"NOME_MUNICIPIO": "MATERLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140704",
		"NOME_MUNICIPIO": "MATEUS LEME",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140803",
		"NOME_MUNICIPIO": "MATIAS BARBOSA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140852",
		"NOME_MUNICIPIO": "MATIAS CARDOSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3140902",
		"NOME_MUNICIPIO": "MATIPO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141009",
		"NOME_MUNICIPIO": "MATO VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141108",
		"NOME_MUNICIPIO": "MATOZINHOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141207",
		"NOME_MUNICIPIO": "MATUTINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141306",
		"NOME_MUNICIPIO": "MEDEIROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141405",
		"NOME_MUNICIPIO": "MEDINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141504",
		"NOME_MUNICIPIO": "MENDES PIMENTEL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141603",
		"NOME_MUNICIPIO": "MERCÊS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141702",
		"NOME_MUNICIPIO": "MESQUITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141801",
		"NOME_MUNICIPIO": "MINAS NOVAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3141900",
		"NOME_MUNICIPIO": "MINDURI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142007",
		"NOME_MUNICIPIO": "MIRABELA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142106",
		"NOME_MUNICIPIO": "MIRADOURO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142205",
		"NOME_MUNICIPIO": "MIRAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142254",
		"NOME_MUNICIPIO": "MIRAVANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142304",
		"NOME_MUNICIPIO": "MOEDA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142403",
		"NOME_MUNICIPIO": "MOEMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142502",
		"NOME_MUNICIPIO": "MONJOLOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142601",
		"NOME_MUNICIPIO": "MONSENHOR PAULO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142700",
		"NOME_MUNICIPIO": "MONTALVANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142809",
		"NOME_MUNICIPIO": "MONTE ALEGRE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3142908",
		"NOME_MUNICIPIO": "MONTE AZUL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143005",
		"NOME_MUNICIPIO": "MONTE BELO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143104",
		"NOME_MUNICIPIO": "MONTE CARMELO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143153",
		"NOME_MUNICIPIO": "MONTE FORMOSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143203",
		"NOME_MUNICIPIO": "MONTE SANTO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143302",
		"NOME_MUNICIPIO": "MONTES CLAROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143401",
		"NOME_MUNICIPIO": "MONTE SIAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143450",
		"NOME_MUNICIPIO": "MONTEZUMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143500",
		"NOME_MUNICIPIO": "MORADA NOVA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143609",
		"NOME_MUNICIPIO": "MORRO DA GARÇA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143708",
		"NOME_MUNICIPIO": "MORRO DO PILAR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143807",
		"NOME_MUNICIPIO": "MUNHOZ",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3143906",
		"NOME_MUNICIPIO": "MURIAE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144003",
		"NOME_MUNICIPIO": "MUTUM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144102",
		"NOME_MUNICIPIO": "MUZAMBINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144201",
		"NOME_MUNICIPIO": "NACIP RAYDAN",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144300",
		"NOME_MUNICIPIO": "NANUQUE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144359",
		"NOME_MUNICIPIO": "NAQUE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144375",
		"NOME_MUNICIPIO": "NATALANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144409",
		"NOME_MUNICIPIO": "NATERCIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144508",
		"NOME_MUNICIPIO": "NAZARENO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144607",
		"NOME_MUNICIPIO": "NEPOMUCENO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144656",
		"NOME_MUNICIPIO": "NINHEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144672",
		"NOME_MUNICIPIO": "NOVA BELEM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144706",
		"NOME_MUNICIPIO": "NOVA ERA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144805",
		"NOME_MUNICIPIO": "NOVA LIMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3144904",
		"NOME_MUNICIPIO": "NOVA MODICA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145000",
		"NOME_MUNICIPIO": "NOVA PONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145059",
		"NOME_MUNICIPIO": "NOVA PORTEIRINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145109",
		"NOME_MUNICIPIO": "NOVA RESENDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145208",
		"NOME_MUNICIPIO": "NOVA SERRANA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145307",
		"NOME_MUNICIPIO": "NOVO CRUZEIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145356",
		"NOME_MUNICIPIO": "NOVO ORIENTE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145372",
		"NOME_MUNICIPIO": "NOVORIZONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145406",
		"NOME_MUNICIPIO": "OLARIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145455",
		"NOME_MUNICIPIO": "OLHOS-DAGUA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145505",
		"NOME_MUNICIPIO": "OLIMPIO NORONHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145604",
		"NOME_MUNICIPIO": "OLIVEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145703",
		"NOME_MUNICIPIO": "OLIVEIRA FORTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145802",
		"NOME_MUNICIPIO": "ONÇA DE PITANGUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145851",
		"NOME_MUNICIPIO": "ORATORIOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145877",
		"NOME_MUNICIPIO": "ORIZANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3145901",
		"NOME_MUNICIPIO": "OURO BRANCO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146008",
		"NOME_MUNICIPIO": "OURO FINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146107",
		"NOME_MUNICIPIO": "OURO PRETO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146206",
		"NOME_MUNICIPIO": "OURO VERDE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146255",
		"NOME_MUNICIPIO": "PADRE CARVALHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146305",
		"NOME_MUNICIPIO": "PADRE PARAISO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146404",
		"NOME_MUNICIPIO": "PAINEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146503",
		"NOME_MUNICIPIO": "PAINS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146552",
		"NOME_MUNICIPIO": "PAI PEDRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146602",
		"NOME_MUNICIPIO": "PAIVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146701",
		"NOME_MUNICIPIO": "PALMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146750",
		"NOME_MUNICIPIO": "PALMOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3146909",
		"NOME_MUNICIPIO": "PAPAGAIOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147006",
		"NOME_MUNICIPIO": "PARACATU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147105",
		"NOME_MUNICIPIO": "PARA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147204",
		"NOME_MUNICIPIO": "PARAGUAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147303",
		"NOME_MUNICIPIO": "PARAISOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147402",
		"NOME_MUNICIPIO": "PARAOPEBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147501",
		"NOME_MUNICIPIO": "PASSABEM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147600",
		"NOME_MUNICIPIO": "PASSA QUATRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147709",
		"NOME_MUNICIPIO": "PASSA TEMPO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147808",
		"NOME_MUNICIPIO": "PASSA VINTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147907",
		"NOME_MUNICIPIO": "PASSOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3147956",
		"NOME_MUNICIPIO": "PATIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148004",
		"NOME_MUNICIPIO": "PATOS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148103",
		"NOME_MUNICIPIO": "PATROCINIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148202",
		"NOME_MUNICIPIO": "PATROCINIO DO MURIAE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148301",
		"NOME_MUNICIPIO": "PAULA CANDIDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148400",
		"NOME_MUNICIPIO": "PAULISTAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148509",
		"NOME_MUNICIPIO": "PAVAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148608",
		"NOME_MUNICIPIO": "PEÇANHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148707",
		"NOME_MUNICIPIO": "PEDRA AZUL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148756",
		"NOME_MUNICIPIO": "PEDRA BONITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148806",
		"NOME_MUNICIPIO": "PEDRA DO ANTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3148905",
		"NOME_MUNICIPIO": "PEDRA DO INDAIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149002",
		"NOME_MUNICIPIO": "PEDRA DOURADA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149101",
		"NOME_MUNICIPIO": "PEDRALVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149150",
		"NOME_MUNICIPIO": "PEDRAS DE MARIA DA CRUZ",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149200",
		"NOME_MUNICIPIO": "PEDRINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149309",
		"NOME_MUNICIPIO": "PEDRO LEOPOLDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149408",
		"NOME_MUNICIPIO": "PEDRO TEIXEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149507",
		"NOME_MUNICIPIO": "PEQUERI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149606",
		"NOME_MUNICIPIO": "PEQUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149705",
		"NOME_MUNICIPIO": "PERDIGAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149804",
		"NOME_MUNICIPIO": "PERDIZES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149903",
		"NOME_MUNICIPIO": "PERDÕES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3149952",
		"NOME_MUNICIPIO": "PERIQUITO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150000",
		"NOME_MUNICIPIO": "PESCADOR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150109",
		"NOME_MUNICIPIO": "PIAU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150158",
		"NOME_MUNICIPIO": "PIEDADE DE CARATINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150208",
		"NOME_MUNICIPIO": "PIEDADE DE PONTE NOVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150307",
		"NOME_MUNICIPIO": "PIEDADE DO RIO GRANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150406",
		"NOME_MUNICIPIO": "PIEDADE DOS GERAIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150505",
		"NOME_MUNICIPIO": "PIMENTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150539",
		"NOME_MUNICIPIO": "PINGO DAGUA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150570",
		"NOME_MUNICIPIO": "PINTOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150604",
		"NOME_MUNICIPIO": "PIRACEMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150703",
		"NOME_MUNICIPIO": "PIRAJUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150802",
		"NOME_MUNICIPIO": "PIRANGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3150901",
		"NOME_MUNICIPIO": "PIRANGUÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151008",
		"NOME_MUNICIPIO": "PIRANGUINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151107",
		"NOME_MUNICIPIO": "PIRAPETINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151206",
		"NOME_MUNICIPIO": "PIRAPORA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151305",
		"NOME_MUNICIPIO": "PIRAUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151404",
		"NOME_MUNICIPIO": "PITANGUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151503",
		"NOME_MUNICIPIO": "PIUMHI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151602",
		"NOME_MUNICIPIO": "PLANURA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151701",
		"NOME_MUNICIPIO": "POÇO FUNDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151800",
		"NOME_MUNICIPIO": "POÇOS DE CALDAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3151909",
		"NOME_MUNICIPIO": "POCRANE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152006",
		"NOME_MUNICIPIO": "POMPEU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152105",
		"NOME_MUNICIPIO": "PONTE NOVA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152131",
		"NOME_MUNICIPIO": "PONTO CHIQUE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152170",
		"NOME_MUNICIPIO": "PONTO DOS VOLANTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152204",
		"NOME_MUNICIPIO": "PORTEIRINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152303",
		"NOME_MUNICIPIO": "PORTO FIRME",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152402",
		"NOME_MUNICIPIO": "POTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152501",
		"NOME_MUNICIPIO": "POUSO ALEGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152600",
		"NOME_MUNICIPIO": "POUSO ALTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152709",
		"NOME_MUNICIPIO": "PRADOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152808",
		"NOME_MUNICIPIO": "PRATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3152907",
		"NOME_MUNICIPIO": "PRATAPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153004",
		"NOME_MUNICIPIO": "PRATINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153103",
		"NOME_MUNICIPIO": "PRESIDENTE BERNARDES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153202",
		"NOME_MUNICIPIO": "PRESIDENTE JUSCELINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153301",
		"NOME_MUNICIPIO": "PRESIDENTE KUBITSCHEK",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153400",
		"NOME_MUNICIPIO": "PRESIDENTE OLEGARIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153509",
		"NOME_MUNICIPIO": "ALTO JEQUITIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153608",
		"NOME_MUNICIPIO": "PRUDENTE DE MORAIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153707",
		"NOME_MUNICIPIO": "QUARTEL GERAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153806",
		"NOME_MUNICIPIO": "QUELUZITO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3153905",
		"NOME_MUNICIPIO": "RAPOSOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154002",
		"NOME_MUNICIPIO": "RAUL SOARES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154101",
		"NOME_MUNICIPIO": "RECREIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154150",
		"NOME_MUNICIPIO": "REDUTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154200",
		"NOME_MUNICIPIO": "RESENDE COSTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154309",
		"NOME_MUNICIPIO": "RESPLENDOR",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154408",
		"NOME_MUNICIPIO": "RESSAQUINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154457",
		"NOME_MUNICIPIO": "RIACHINHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154507",
		"NOME_MUNICIPIO": "RIACHO DOS MACHADOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154606",
		"NOME_MUNICIPIO": "RIBEIRAO DAS NEVES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154705",
		"NOME_MUNICIPIO": "RIBEIRAO VERMELHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154804",
		"NOME_MUNICIPIO": "RIO ACIMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3154903",
		"NOME_MUNICIPIO": "RIO CASCA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155009",
		"NOME_MUNICIPIO": "RIO DOCE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155108",
		"NOME_MUNICIPIO": "RIO DO PRADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155207",
		"NOME_MUNICIPIO": "RIO ESPERA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155306",
		"NOME_MUNICIPIO": "RIO MANSO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155405",
		"NOME_MUNICIPIO": "RIO NOVO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155504",
		"NOME_MUNICIPIO": "RIO PARANAIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155603",
		"NOME_MUNICIPIO": "RIO PARDO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155702",
		"NOME_MUNICIPIO": "RIO PIRACICABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155801",
		"NOME_MUNICIPIO": "RIO POMBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3155900",
		"NOME_MUNICIPIO": "RIO PRETO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156007",
		"NOME_MUNICIPIO": "RIO VERMELHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156106",
		"NOME_MUNICIPIO": "RITAPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156205",
		"NOME_MUNICIPIO": "ROCHEDO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156304",
		"NOME_MUNICIPIO": "RODEIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156403",
		"NOME_MUNICIPIO": "ROMARIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156452",
		"NOME_MUNICIPIO": "ROSARIO DA LIMEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156502",
		"NOME_MUNICIPIO": "RUBELITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156601",
		"NOME_MUNICIPIO": "RUBIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156700",
		"NOME_MUNICIPIO": "SABARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156809",
		"NOME_MUNICIPIO": "SABINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3156908",
		"NOME_MUNICIPIO": "SACRAMENTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157005",
		"NOME_MUNICIPIO": "SALINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157104",
		"NOME_MUNICIPIO": "SALTO DA DIVISA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157203",
		"NOME_MUNICIPIO": "SANTA BARBARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157252",
		"NOME_MUNICIPIO": "SANTA BARBARA DO LESTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157278",
		"NOME_MUNICIPIO": "SANTA BARBARA DO MONTE VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157302",
		"NOME_MUNICIPIO": "SANTA BARBARA DO TUGURIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157336",
		"NOME_MUNICIPIO": "SANTA CRUZ DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157377",
		"NOME_MUNICIPIO": "SANTA CRUZ DE SALINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157401",
		"NOME_MUNICIPIO": "SANTA CRUZ DO ESCALVADO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157500",
		"NOME_MUNICIPIO": "SANTA EFIGÊNIA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157609",
		"NOME_MUNICIPIO": "SANTA FE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157658",
		"NOME_MUNICIPIO": "SANTA HELENA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157708",
		"NOME_MUNICIPIO": "SANTA JULIANA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157807",
		"NOME_MUNICIPIO": "SANTA LUZIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3157906",
		"NOME_MUNICIPIO": "SANTA MARGARIDA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158003",
		"NOME_MUNICIPIO": "SANTA MARIA DE ITABIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158102",
		"NOME_MUNICIPIO": "SANTA MARIA DO SALTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158201",
		"NOME_MUNICIPIO": "SANTA MARIA DO SUAÇUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158300",
		"NOME_MUNICIPIO": "SANTANA DA VARGEM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158409",
		"NOME_MUNICIPIO": "SANTANA DE CATAGUASES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158508",
		"NOME_MUNICIPIO": "SANTANA DE PIRAPAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158607",
		"NOME_MUNICIPIO": "SANTANA DO DESERTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158706",
		"NOME_MUNICIPIO": "SANTANA DO GARAMBEU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158805",
		"NOME_MUNICIPIO": "SANTANA DO JACARE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158904",
		"NOME_MUNICIPIO": "SANTANA DO MANHUAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3158953",
		"NOME_MUNICIPIO": "SANTANA DO PARAISO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159001",
		"NOME_MUNICIPIO": "SANTANA DO RIACHO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159100",
		"NOME_MUNICIPIO": "SANTANA DOS MONTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159209",
		"NOME_MUNICIPIO": "SANTA RITA DE CALDAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159308",
		"NOME_MUNICIPIO": "SANTA RITA DE JACUTINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159357",
		"NOME_MUNICIPIO": "SANTA RITA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159407",
		"NOME_MUNICIPIO": "SANTA RITA DE IBITIPOCA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159506",
		"NOME_MUNICIPIO": "SANTA RITA DO ITUETO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159605",
		"NOME_MUNICIPIO": "SANTA RITA DO SAPUCAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159704",
		"NOME_MUNICIPIO": "SANTA ROSA DA SERRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159803",
		"NOME_MUNICIPIO": "SANTA VITORIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3159902",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO AMPARO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160009",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO AVENTUREIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160108",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO GRAMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160207",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO ITAMBE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160306",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO JACINTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160405",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO MONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160454",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO RETIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160504",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO RIO ABAIXO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160603",
		"NOME_MUNICIPIO": "SANTO HIPOLITO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160702",
		"NOME_MUNICIPIO": "SANTOS DUMONT",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160801",
		"NOME_MUNICIPIO": "SAO BENTO ABADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160900",
		"NOME_MUNICIPIO": "SAO BRAS DO SUAÇUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3160959",
		"NOME_MUNICIPIO": "SAO DOMINGOS DAS DORES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161007",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO PRATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161056",
		"NOME_MUNICIPIO": "SAO FELIX DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161106",
		"NOME_MUNICIPIO": "SAO FRANCISCO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161205",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE PAULA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161304",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE SALES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161403",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO GLORIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161502",
		"NOME_MUNICIPIO": "SAO GERALDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161601",
		"NOME_MUNICIPIO": "SAO GERALDO DA PIEDADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161650",
		"NOME_MUNICIPIO": "SAO GERALDO DO BAIXIO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161700",
		"NOME_MUNICIPIO": "SAO GONÇALO DO ABAETE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161809",
		"NOME_MUNICIPIO": "SAO GONÇALO DO PARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3161908",
		"NOME_MUNICIPIO": "SAO GONÇALO DO RIO ABAIXO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162005",
		"NOME_MUNICIPIO": "SAO GONÇALO DO SAPUCAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162104",
		"NOME_MUNICIPIO": "SAO GOTARDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162203",
		"NOME_MUNICIPIO": "SAO JOAO BATISTA DO GLORIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162252",
		"NOME_MUNICIPIO": "SAO JOAO DA LAGOA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162302",
		"NOME_MUNICIPIO": "SAO JOAO DA MATA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162401",
		"NOME_MUNICIPIO": "SAO JOAO DA PONTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162450",
		"NOME_MUNICIPIO": "SAO JOAO DAS MISSÕES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162500",
		"NOME_MUNICIPIO": "SAO JOAO DEL REI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162559",
		"NOME_MUNICIPIO": "SAO JOAO DO MANHUAÇU",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162575",
		"NOME_MUNICIPIO": "SAO JOAO DO MANTENINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162609",
		"NOME_MUNICIPIO": "SAO JOAO DO ORIENTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162658",
		"NOME_MUNICIPIO": "SAO JOAO DO PACUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162708",
		"NOME_MUNICIPIO": "SAO JOAO DO PARAISO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162807",
		"NOME_MUNICIPIO": "SAO JOAO EVANGELISTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162906",
		"NOME_MUNICIPIO": "SAO JOAO NEPOMUCENO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162922",
		"NOME_MUNICIPIO": "SAO JOAQUIM DE BICAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162948",
		"NOME_MUNICIPIO": "SAO JOSE DA BARRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3162955",
		"NOME_MUNICIPIO": "SAO JOSE DA LAPA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163003",
		"NOME_MUNICIPIO": "SAO JOSE DA SAFIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163102",
		"NOME_MUNICIPIO": "SAO JOSE DA VARGINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163201",
		"NOME_MUNICIPIO": "SAO JOSE DO ALEGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163300",
		"NOME_MUNICIPIO": "SAO JOSE DO DIVINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163409",
		"NOME_MUNICIPIO": "SAO JOSE DO GOIABAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163508",
		"NOME_MUNICIPIO": "SAO JOSE DO JACURI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163607",
		"NOME_MUNICIPIO": "SAO JOSE DO MANTIMENTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163706",
		"NOME_MUNICIPIO": "SAO LOURENÇO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163805",
		"NOME_MUNICIPIO": "SAO MIGUEL DO ANTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3163904",
		"NOME_MUNICIPIO": "SAO PEDRO DA UNIAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164001",
		"NOME_MUNICIPIO": "SAO PEDRO DOS FERROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164100",
		"NOME_MUNICIPIO": "SAO PEDRO DO SUAÇUI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164209",
		"NOME_MUNICIPIO": "SAO ROMAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164308",
		"NOME_MUNICIPIO": "SAO ROQUE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164407",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DA BELA VISTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164431",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DA VARGEM ALEGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164472",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO ANTA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164506",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO MARANHAO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164605",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO OESTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164704",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO PARAISO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164803",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO RIO PRETO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3164902",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO RIO VERDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165008",
		"NOME_MUNICIPIO": "SAO TIAGO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165107",
		"NOME_MUNICIPIO": "SAO TOMAS DE AQUINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165206",
		"NOME_MUNICIPIO": "SAO THOME DAS LETRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165305",
		"NOME_MUNICIPIO": "SAO VICENTE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165404",
		"NOME_MUNICIPIO": "SAPUCAI-MIRIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165503",
		"NOME_MUNICIPIO": "SARDOA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165537",
		"NOME_MUNICIPIO": "SARZEDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165552",
		"NOME_MUNICIPIO": "SETUBINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165560",
		"NOME_MUNICIPIO": "SEM-PEIXE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165578",
		"NOME_MUNICIPIO": "SENADOR AMARAL",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165602",
		"NOME_MUNICIPIO": "SENADOR CORTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165701",
		"NOME_MUNICIPIO": "SENADOR FIRMINO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165800",
		"NOME_MUNICIPIO": "SENADOR JOSE BENTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3165909",
		"NOME_MUNICIPIO": "SENADOR MODESTINO GONÇALVES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166006",
		"NOME_MUNICIPIO": "SENHORA DE OLIVEIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166105",
		"NOME_MUNICIPIO": "SENHORA DO PORTO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166204",
		"NOME_MUNICIPIO": "SENHORA DOS REMEDIOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166303",
		"NOME_MUNICIPIO": "SERICITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166402",
		"NOME_MUNICIPIO": "SERITINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166501",
		"NOME_MUNICIPIO": "SERRA AZUL DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166600",
		"NOME_MUNICIPIO": "SERRA DA SAUDADE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166709",
		"NOME_MUNICIPIO": "SERRA DOS AIMORES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166808",
		"NOME_MUNICIPIO": "SERRA DO SALITRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166907",
		"NOME_MUNICIPIO": "SERRANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3166956",
		"NOME_MUNICIPIO": "SERRANOPOLIS DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167004",
		"NOME_MUNICIPIO": "SERRANOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167103",
		"NOME_MUNICIPIO": "SERRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167202",
		"NOME_MUNICIPIO": "SETE LAGOAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167301",
		"NOME_MUNICIPIO": "SILVEIRANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167400",
		"NOME_MUNICIPIO": "SILVIANOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167509",
		"NOME_MUNICIPIO": "SIMAO PEREIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167608",
		"NOME_MUNICIPIO": "SIMONESIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167707",
		"NOME_MUNICIPIO": "SOBRALIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167806",
		"NOME_MUNICIPIO": "SOLEDADE DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3167905",
		"NOME_MUNICIPIO": "TABULEIRO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168002",
		"NOME_MUNICIPIO": "TAIOBEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168051",
		"NOME_MUNICIPIO": "TAPARUBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168101",
		"NOME_MUNICIPIO": "TAPIRA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168200",
		"NOME_MUNICIPIO": "TAPIRAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168309",
		"NOME_MUNICIPIO": "TAQUARAÇU DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168408",
		"NOME_MUNICIPIO": "TARUMIRIM",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168507",
		"NOME_MUNICIPIO": "TEIXEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168606",
		"NOME_MUNICIPIO": "TEOFILO OTONI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168705",
		"NOME_MUNICIPIO": "TIMOTEO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168804",
		"NOME_MUNICIPIO": "TIRADENTES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3168903",
		"NOME_MUNICIPIO": "TIROS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169000",
		"NOME_MUNICIPIO": "TOCANTINS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169059",
		"NOME_MUNICIPIO": "TOCOS DO MOJI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169109",
		"NOME_MUNICIPIO": "TOLEDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169208",
		"NOME_MUNICIPIO": "TOMBOS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169307",
		"NOME_MUNICIPIO": "TRÊS CORAÇÕES",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169356",
		"NOME_MUNICIPIO": "TRÊS MARIAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169406",
		"NOME_MUNICIPIO": "TRÊS PONTAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169505",
		"NOME_MUNICIPIO": "TUMIRITINGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169604",
		"NOME_MUNICIPIO": "TUPACIGUARA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169703",
		"NOME_MUNICIPIO": "TURMALINA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169802",
		"NOME_MUNICIPIO": "TURVOLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3169901",
		"NOME_MUNICIPIO": "UBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170008",
		"NOME_MUNICIPIO": "UBAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170057",
		"NOME_MUNICIPIO": "UBAPORANGA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170107",
		"NOME_MUNICIPIO": "UBERABA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170206",
		"NOME_MUNICIPIO": "UBERLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170305",
		"NOME_MUNICIPIO": "UMBURATIBA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170404",
		"NOME_MUNICIPIO": "UNAI",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170438",
		"NOME_MUNICIPIO": "UNIAO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170479",
		"NOME_MUNICIPIO": "URUANA DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170503",
		"NOME_MUNICIPIO": "URUCANIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170529",
		"NOME_MUNICIPIO": "URUCUIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170578",
		"NOME_MUNICIPIO": "VARGEM ALEGRE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170602",
		"NOME_MUNICIPIO": "VARGEM BONITA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170651",
		"NOME_MUNICIPIO": "VARGEM GRANDE DO RIO PARDO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170701",
		"NOME_MUNICIPIO": "VARGINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170750",
		"NOME_MUNICIPIO": "VARJAO DE MINAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170800",
		"NOME_MUNICIPIO": "VARZEA DA PALMA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3170909",
		"NOME_MUNICIPIO": "VARZELANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171006",
		"NOME_MUNICIPIO": "VAZANTE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171030",
		"NOME_MUNICIPIO": "VERDELANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171071",
		"NOME_MUNICIPIO": "VEREDINHA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171105",
		"NOME_MUNICIPIO": "VERISSIMO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171154",
		"NOME_MUNICIPIO": "VERMELHO NOVO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171204",
		"NOME_MUNICIPIO": "VESPASIANO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171303",
		"NOME_MUNICIPIO": "VIÇOSA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171402",
		"NOME_MUNICIPIO": "VIEIRAS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171501",
		"NOME_MUNICIPIO": "MATHIAS LOBATO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171600",
		"NOME_MUNICIPIO": "VIRGEM DA LAPA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171709",
		"NOME_MUNICIPIO": "VIRGINIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171808",
		"NOME_MUNICIPIO": "VIRGINOPOLIS",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3171907",
		"NOME_MUNICIPIO": "VIRGOLANDIA",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3172004",
		"NOME_MUNICIPIO": "VISCONDE DO RIO BRANCO",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3172103",
		"NOME_MUNICIPIO": "VOLTA GRANDE",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3172202",
		"NOME_MUNICIPIO": "WENCESLAU BRAZ",
		"COD_UF": "31"
	},
	{
		"COD_MUNICIPIO": "3200102",
		"NOME_MUNICIPIO": "AFONSO CLAUDIO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200136",
		"NOME_MUNICIPIO": "AGUIA BRANCA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200169",
		"NOME_MUNICIPIO": "AGUA DOCE DO NORTE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200201",
		"NOME_MUNICIPIO": "ALEGRE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200300",
		"NOME_MUNICIPIO": "ALFREDO CHAVES",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200359",
		"NOME_MUNICIPIO": "ALTO RIO NOVO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200409",
		"NOME_MUNICIPIO": "ANCHIETA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200508",
		"NOME_MUNICIPIO": "APIACA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200607",
		"NOME_MUNICIPIO": "ARACRUZ",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200706",
		"NOME_MUNICIPIO": "ATILIO VIVACQUA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200805",
		"NOME_MUNICIPIO": "BAIXO GUANDU",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3200904",
		"NOME_MUNICIPIO": "BARRA DE SAO FRANCISCO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201001",
		"NOME_MUNICIPIO": "BOA ESPERANÇA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201100",
		"NOME_MUNICIPIO": "BOM JESUS DO NORTE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201159",
		"NOME_MUNICIPIO": "BREJETUBA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201209",
		"NOME_MUNICIPIO": "CACHOEIRO DE ITAPEMIRIM",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201308",
		"NOME_MUNICIPIO": "CARIACICA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201407",
		"NOME_MUNICIPIO": "CASTELO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201506",
		"NOME_MUNICIPIO": "COLATINA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201605",
		"NOME_MUNICIPIO": "CONCEIÇAO DA BARRA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201704",
		"NOME_MUNICIPIO": "CONCEIÇAO DO CASTELO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201803",
		"NOME_MUNICIPIO": "DIVINO DE SAO LOURENÇO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3201902",
		"NOME_MUNICIPIO": "DOMINGOS MARTINS",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202009",
		"NOME_MUNICIPIO": "DORES DO RIO PRETO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202108",
		"NOME_MUNICIPIO": "ECOPORANGA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202207",
		"NOME_MUNICIPIO": "FUNDAO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202256",
		"NOME_MUNICIPIO": "GOVERNADOR LINDENBERG",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202306",
		"NOME_MUNICIPIO": "GUAÇUI",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202405",
		"NOME_MUNICIPIO": "GUARAPARI",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202454",
		"NOME_MUNICIPIO": "IBATIBA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202504",
		"NOME_MUNICIPIO": "IBIRAÇU",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202553",
		"NOME_MUNICIPIO": "IBITIRAMA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202603",
		"NOME_MUNICIPIO": "ICONHA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202652",
		"NOME_MUNICIPIO": "IRUPI",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202702",
		"NOME_MUNICIPIO": "ITAGUAÇU",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202801",
		"NOME_MUNICIPIO": "ITAPEMIRIM",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3202900",
		"NOME_MUNICIPIO": "ITARANA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203007",
		"NOME_MUNICIPIO": "IUNA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203056",
		"NOME_MUNICIPIO": "JAGUARE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203106",
		"NOME_MUNICIPIO": "JERÔNIMO MONTEIRO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203130",
		"NOME_MUNICIPIO": "JOAO NEIVA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203163",
		"NOME_MUNICIPIO": "LARANJA DA TERRA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203205",
		"NOME_MUNICIPIO": "LINHARES",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203304",
		"NOME_MUNICIPIO": "MANTENOPOLIS",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203320",
		"NOME_MUNICIPIO": "MARATAIZES",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203346",
		"NOME_MUNICIPIO": "MARECHAL FLORIANO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203353",
		"NOME_MUNICIPIO": "MARILANDIA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203403",
		"NOME_MUNICIPIO": "MIMOSO DO SUL",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203502",
		"NOME_MUNICIPIO": "MONTANHA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203601",
		"NOME_MUNICIPIO": "MUCURICI",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203700",
		"NOME_MUNICIPIO": "MUNIZ FREIRE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203809",
		"NOME_MUNICIPIO": "MUQUI",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3203908",
		"NOME_MUNICIPIO": "NOVA VENECIA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204005",
		"NOME_MUNICIPIO": "PANCAS",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204054",
		"NOME_MUNICIPIO": "PEDRO CANARIO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204104",
		"NOME_MUNICIPIO": "PINHEIROS",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204203",
		"NOME_MUNICIPIO": "PIUMA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204252",
		"NOME_MUNICIPIO": "PONTO BELO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204302",
		"NOME_MUNICIPIO": "PRESIDENTE KENNEDY",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204351",
		"NOME_MUNICIPIO": "RIO BANANAL",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204401",
		"NOME_MUNICIPIO": "RIO NOVO DO SUL",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204500",
		"NOME_MUNICIPIO": "SANTA LEOPOLDINA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204559",
		"NOME_MUNICIPIO": "SANTA MARIA DE JETIBA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204609",
		"NOME_MUNICIPIO": "SANTA TERESA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204658",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO NORTE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204708",
		"NOME_MUNICIPIO": "SAO GABRIEL DA PALHA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204807",
		"NOME_MUNICIPIO": "SAO JOSE DO CALÇADO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204906",
		"NOME_MUNICIPIO": "SAO MATEUS",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3204955",
		"NOME_MUNICIPIO": "SAO ROQUE DO CANAA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205002",
		"NOME_MUNICIPIO": "SERRA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205010",
		"NOME_MUNICIPIO": "SOORETAMA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205036",
		"NOME_MUNICIPIO": "VARGEM ALTA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205069",
		"NOME_MUNICIPIO": "VENDA NOVA DO IMIGRANTE",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205101",
		"NOME_MUNICIPIO": "VIANA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205150",
		"NOME_MUNICIPIO": "VILA PAVAO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205176",
		"NOME_MUNICIPIO": "VILA VALERIO",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205200",
		"NOME_MUNICIPIO": "VILA VELHA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3205309",
		"NOME_MUNICIPIO": "VITORIA",
		"COD_UF": "32"
	},
	{
		"COD_MUNICIPIO": "3300100",
		"NOME_MUNICIPIO": "ANGRA DOS REIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300159",
		"NOME_MUNICIPIO": "APERIBE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300209",
		"NOME_MUNICIPIO": "ARARUAMA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300225",
		"NOME_MUNICIPIO": "AREAL",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300233",
		"NOME_MUNICIPIO": "ARMAÇAO DOS BUZIOS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300258",
		"NOME_MUNICIPIO": "ARRAIAL DO CABO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300308",
		"NOME_MUNICIPIO": "BARRA DO PIRAI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300407",
		"NOME_MUNICIPIO": "BARRA MANSA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300456",
		"NOME_MUNICIPIO": "BELFORD ROXO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300506",
		"NOME_MUNICIPIO": "BOM JARDIM",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300605",
		"NOME_MUNICIPIO": "BOM JESUS DO ITABAPOANA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300704",
		"NOME_MUNICIPIO": "CABO FRIO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300803",
		"NOME_MUNICIPIO": "CACHOEIRAS DE MACACU",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300902",
		"NOME_MUNICIPIO": "CAMBUCI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300936",
		"NOME_MUNICIPIO": "CARAPEBUS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3300951",
		"NOME_MUNICIPIO": "COMENDADOR LEVY GASPARIAN",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301009",
		"NOME_MUNICIPIO": "CAMPOS DOS GOYTACAZES",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301108",
		"NOME_MUNICIPIO": "CANTAGALO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301157",
		"NOME_MUNICIPIO": "CARDOSO MOREIRA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301207",
		"NOME_MUNICIPIO": "CARMO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301306",
		"NOME_MUNICIPIO": "CASIMIRO DE ABREU",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301405",
		"NOME_MUNICIPIO": "CONCEIÇAO DE MACABU",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301504",
		"NOME_MUNICIPIO": "CORDEIRO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301603",
		"NOME_MUNICIPIO": "DUAS BARRAS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301702",
		"NOME_MUNICIPIO": "DUQUE DE CAXIAS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301801",
		"NOME_MUNICIPIO": "ENGENHEIRO PAULO DE FRONTIN",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301850",
		"NOME_MUNICIPIO": "GUAPIMIRIM",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301876",
		"NOME_MUNICIPIO": "IGUABA GRANDE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3301900",
		"NOME_MUNICIPIO": "ITABORAI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302007",
		"NOME_MUNICIPIO": "ITAGUAI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302056",
		"NOME_MUNICIPIO": "ITALVA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302106",
		"NOME_MUNICIPIO": "ITAOCARA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302205",
		"NOME_MUNICIPIO": "ITAPERUNA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302254",
		"NOME_MUNICIPIO": "ITATIAIA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302270",
		"NOME_MUNICIPIO": "JAPERI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302304",
		"NOME_MUNICIPIO": "LAJE DO MURIAE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302403",
		"NOME_MUNICIPIO": "MACAE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302452",
		"NOME_MUNICIPIO": "MACUCO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302502",
		"NOME_MUNICIPIO": "MAGE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302601",
		"NOME_MUNICIPIO": "MANGARATIBA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302700",
		"NOME_MUNICIPIO": "MARICA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302809",
		"NOME_MUNICIPIO": "MENDES",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302858",
		"NOME_MUNICIPIO": "MESQUITA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3302908",
		"NOME_MUNICIPIO": "MIGUEL PEREIRA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303005",
		"NOME_MUNICIPIO": "MIRACEMA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303104",
		"NOME_MUNICIPIO": "NATIVIDADE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303203",
		"NOME_MUNICIPIO": "NILOPOLIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303302",
		"NOME_MUNICIPIO": "NITEROI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303401",
		"NOME_MUNICIPIO": "NOVA FRIBURGO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303500",
		"NOME_MUNICIPIO": "NOVA IGUAÇU",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303609",
		"NOME_MUNICIPIO": "PARACAMBI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303708",
		"NOME_MUNICIPIO": "PARAIBA DO SUL",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303807",
		"NOME_MUNICIPIO": "PARATY",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303856",
		"NOME_MUNICIPIO": "PATY DO ALFERES",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303906",
		"NOME_MUNICIPIO": "PETROPOLIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3303955",
		"NOME_MUNICIPIO": "PINHEIRAL",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304003",
		"NOME_MUNICIPIO": "PIRAI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304102",
		"NOME_MUNICIPIO": "PORCIUNCULA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304110",
		"NOME_MUNICIPIO": "PORTO REAL",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304128",
		"NOME_MUNICIPIO": "QUATIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304144",
		"NOME_MUNICIPIO": "QUEIMADOS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304151",
		"NOME_MUNICIPIO": "QUISSAMA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304201",
		"NOME_MUNICIPIO": "RESENDE",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304300",
		"NOME_MUNICIPIO": "RIO BONITO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304409",
		"NOME_MUNICIPIO": "RIO CLARO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304508",
		"NOME_MUNICIPIO": "RIO DAS FLORES",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304524",
		"NOME_MUNICIPIO": "RIO DAS OSTRAS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304557",
		"NOME_MUNICIPIO": "RIO DE JANEIRO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304607",
		"NOME_MUNICIPIO": "SANTA MARIA MADALENA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304706",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DE PADUA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304755",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE ITABAPOANA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304805",
		"NOME_MUNICIPIO": "SAO FIDELIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3304904",
		"NOME_MUNICIPIO": "SAO GONÇALO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305000",
		"NOME_MUNICIPIO": "SAO JOAO DA BARRA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305109",
		"NOME_MUNICIPIO": "SAO JOAO DE MERITI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305133",
		"NOME_MUNICIPIO": "SAO JOSE DE UBA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305158",
		"NOME_MUNICIPIO": "SAO JOSE DO VALE DO RIO PRETO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305208",
		"NOME_MUNICIPIO": "SAO PEDRO DA ALDEIA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305307",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO ALTO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305406",
		"NOME_MUNICIPIO": "SAPUCAIA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305505",
		"NOME_MUNICIPIO": "SAQUAREMA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305554",
		"NOME_MUNICIPIO": "SEROPEDICA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305604",
		"NOME_MUNICIPIO": "SILVA JARDIM",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305703",
		"NOME_MUNICIPIO": "SUMIDOURO",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305752",
		"NOME_MUNICIPIO": "TANGUA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305802",
		"NOME_MUNICIPIO": "TERESOPOLIS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3305901",
		"NOME_MUNICIPIO": "TRAJANO DE MORAES",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3306008",
		"NOME_MUNICIPIO": "TRÊS RIOS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3306107",
		"NOME_MUNICIPIO": "VALENÇA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3306156",
		"NOME_MUNICIPIO": "VARRE-SAI",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3306206",
		"NOME_MUNICIPIO": "VASSOURAS",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3306305",
		"NOME_MUNICIPIO": "VOLTA REDONDA",
		"COD_UF": "33"
	},
	{
		"COD_MUNICIPIO": "3500105",
		"NOME_MUNICIPIO": "ADAMANTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500204",
		"NOME_MUNICIPIO": "ADOLFO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500303",
		"NOME_MUNICIPIO": "AGUAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500402",
		"NOME_MUNICIPIO": "AGUAS DA PRATA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500501",
		"NOME_MUNICIPIO": "AGUAS DE LINDOIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500550",
		"NOME_MUNICIPIO": "AGUAS DE SANTA BARBARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500600",
		"NOME_MUNICIPIO": "AGUAS DE SAO PEDRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500709",
		"NOME_MUNICIPIO": "AGUDOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500758",
		"NOME_MUNICIPIO": "ALAMBARI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500808",
		"NOME_MUNICIPIO": "ALFREDO MARCONDES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3500907",
		"NOME_MUNICIPIO": "ALTAIR",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501004",
		"NOME_MUNICIPIO": "ALTINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501103",
		"NOME_MUNICIPIO": "ALTO ALEGRE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501152",
		"NOME_MUNICIPIO": "ALUMINIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501202",
		"NOME_MUNICIPIO": "ALVARES FLORENCE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501301",
		"NOME_MUNICIPIO": "ALVARES MACHADO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501400",
		"NOME_MUNICIPIO": "ALVARO DE CARVALHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501509",
		"NOME_MUNICIPIO": "ALVINLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501608",
		"NOME_MUNICIPIO": "AMERICANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501707",
		"NOME_MUNICIPIO": "AMERICO BRASILIENSE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501806",
		"NOME_MUNICIPIO": "AMERICO DE CAMPOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3501905",
		"NOME_MUNICIPIO": "AMPARO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502002",
		"NOME_MUNICIPIO": "ANALANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502101",
		"NOME_MUNICIPIO": "ANDRADINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502200",
		"NOME_MUNICIPIO": "ANGATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502309",
		"NOME_MUNICIPIO": "ANHEMBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502408",
		"NOME_MUNICIPIO": "ANHUMAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502507",
		"NOME_MUNICIPIO": "APARECIDA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502606",
		"NOME_MUNICIPIO": "APARECIDA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502705",
		"NOME_MUNICIPIO": "APIAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502754",
		"NOME_MUNICIPIO": "ARAÇARIGUAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502804",
		"NOME_MUNICIPIO": "ARAÇATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3502903",
		"NOME_MUNICIPIO": "ARAÇOIABA DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503000",
		"NOME_MUNICIPIO": "ARAMINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503109",
		"NOME_MUNICIPIO": "ARANDU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503158",
		"NOME_MUNICIPIO": "ARAPEI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503208",
		"NOME_MUNICIPIO": "ARARAQUARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503307",
		"NOME_MUNICIPIO": "ARARAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503356",
		"NOME_MUNICIPIO": "ARCO-IRIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503406",
		"NOME_MUNICIPIO": "AREALVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503505",
		"NOME_MUNICIPIO": "AREIAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503604",
		"NOME_MUNICIPIO": "AREIOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503703",
		"NOME_MUNICIPIO": "ARIRANHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503802",
		"NOME_MUNICIPIO": "ARTUR NOGUEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503901",
		"NOME_MUNICIPIO": "ARUJA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3503950",
		"NOME_MUNICIPIO": "ASPASIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504008",
		"NOME_MUNICIPIO": "ASSIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504107",
		"NOME_MUNICIPIO": "ATIBAIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504206",
		"NOME_MUNICIPIO": "AURIFLAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504305",
		"NOME_MUNICIPIO": "AVAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504404",
		"NOME_MUNICIPIO": "AVANHANDAVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504503",
		"NOME_MUNICIPIO": "AVARE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504602",
		"NOME_MUNICIPIO": "BADY BASSITT",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504701",
		"NOME_MUNICIPIO": "BALBINOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504800",
		"NOME_MUNICIPIO": "BALSAMO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3504909",
		"NOME_MUNICIPIO": "BANANAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505005",
		"NOME_MUNICIPIO": "BARAO DE ANTONINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505104",
		"NOME_MUNICIPIO": "BARBOSA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505203",
		"NOME_MUNICIPIO": "BARIRI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505302",
		"NOME_MUNICIPIO": "BARRA BONITA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505351",
		"NOME_MUNICIPIO": "BARRA DO CHAPEU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505401",
		"NOME_MUNICIPIO": "BARRA DO TURVO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505500",
		"NOME_MUNICIPIO": "BARRETOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505609",
		"NOME_MUNICIPIO": "BARRINHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505708",
		"NOME_MUNICIPIO": "BARUERI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505807",
		"NOME_MUNICIPIO": "BASTOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3505906",
		"NOME_MUNICIPIO": "BATATAIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506003",
		"NOME_MUNICIPIO": "BAURU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506102",
		"NOME_MUNICIPIO": "BEBEDOURO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506201",
		"NOME_MUNICIPIO": "BENTO DE ABREU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506300",
		"NOME_MUNICIPIO": "BERNARDINO DE CAMPOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506359",
		"NOME_MUNICIPIO": "BERTIOGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506409",
		"NOME_MUNICIPIO": "BILAC",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506508",
		"NOME_MUNICIPIO": "BIRIGUI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506607",
		"NOME_MUNICIPIO": "BIRITIBA MIRIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506706",
		"NOME_MUNICIPIO": "BOA ESPERANÇA DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506805",
		"NOME_MUNICIPIO": "BOCAINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3506904",
		"NOME_MUNICIPIO": "BOFETE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507001",
		"NOME_MUNICIPIO": "BOITUVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507100",
		"NOME_MUNICIPIO": "BOM JESUS DOS PERDÕES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507159",
		"NOME_MUNICIPIO": "BOM SUCESSO DE ITARARE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507209",
		"NOME_MUNICIPIO": "BORA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507308",
		"NOME_MUNICIPIO": "BORACEIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507407",
		"NOME_MUNICIPIO": "BORBOREMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507456",
		"NOME_MUNICIPIO": "BOREBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507506",
		"NOME_MUNICIPIO": "BOTUCATU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507605",
		"NOME_MUNICIPIO": "BRAGANÇA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507704",
		"NOME_MUNICIPIO": "BRAUNA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507753",
		"NOME_MUNICIPIO": "BREJO ALEGRE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507803",
		"NOME_MUNICIPIO": "BRODOWSKI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3507902",
		"NOME_MUNICIPIO": "BROTAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508009",
		"NOME_MUNICIPIO": "BURI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508108",
		"NOME_MUNICIPIO": "BURITAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508207",
		"NOME_MUNICIPIO": "BURITIZAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508306",
		"NOME_MUNICIPIO": "CABRALIA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508405",
		"NOME_MUNICIPIO": "CABREUVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508504",
		"NOME_MUNICIPIO": "CAÇAPAVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508603",
		"NOME_MUNICIPIO": "CACHOEIRA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508702",
		"NOME_MUNICIPIO": "CACONDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508801",
		"NOME_MUNICIPIO": "CAFELANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3508900",
		"NOME_MUNICIPIO": "CAIABU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509007",
		"NOME_MUNICIPIO": "CAIEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509106",
		"NOME_MUNICIPIO": "CAIUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509205",
		"NOME_MUNICIPIO": "CAJAMAR",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509254",
		"NOME_MUNICIPIO": "CAJATI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509304",
		"NOME_MUNICIPIO": "CAJOBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509403",
		"NOME_MUNICIPIO": "CAJURU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509452",
		"NOME_MUNICIPIO": "CAMPINA DO MONTE ALEGRE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509502",
		"NOME_MUNICIPIO": "CAMPINAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509601",
		"NOME_MUNICIPIO": "CAMPO LIMPO PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509700",
		"NOME_MUNICIPIO": "CAMPOS DO JORDAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509809",
		"NOME_MUNICIPIO": "CAMPOS NOVOS PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509908",
		"NOME_MUNICIPIO": "CANANEIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3509957",
		"NOME_MUNICIPIO": "CANAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510005",
		"NOME_MUNICIPIO": "CANDIDO MOTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510104",
		"NOME_MUNICIPIO": "CANDIDO RODRIGUES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510153",
		"NOME_MUNICIPIO": "CANITAR",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510203",
		"NOME_MUNICIPIO": "CAPAO BONITO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510302",
		"NOME_MUNICIPIO": "CAPELA DO ALTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510401",
		"NOME_MUNICIPIO": "CAPIVARI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510500",
		"NOME_MUNICIPIO": "CARAGUATATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510609",
		"NOME_MUNICIPIO": "CARAPICUIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510708",
		"NOME_MUNICIPIO": "CARDOSO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510807",
		"NOME_MUNICIPIO": "CASA BRANCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3510906",
		"NOME_MUNICIPIO": "CASSIA DOS COQUEIROS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511003",
		"NOME_MUNICIPIO": "CASTILHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511102",
		"NOME_MUNICIPIO": "CATANDUVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511201",
		"NOME_MUNICIPIO": "CATIGUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511300",
		"NOME_MUNICIPIO": "CEDRAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511409",
		"NOME_MUNICIPIO": "CERQUEIRA CESAR",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511508",
		"NOME_MUNICIPIO": "CERQUILHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511607",
		"NOME_MUNICIPIO": "CESARIO LANGE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511706",
		"NOME_MUNICIPIO": "CHARQUEADA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3511904",
		"NOME_MUNICIPIO": "CLEMENTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512001",
		"NOME_MUNICIPIO": "COLINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512100",
		"NOME_MUNICIPIO": "COLÔMBIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512209",
		"NOME_MUNICIPIO": "CONCHAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512308",
		"NOME_MUNICIPIO": "CONCHAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512407",
		"NOME_MUNICIPIO": "CORDEIROPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512506",
		"NOME_MUNICIPIO": "COROADOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512605",
		"NOME_MUNICIPIO": "CORONEL MACEDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512704",
		"NOME_MUNICIPIO": "CORUMBATAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512803",
		"NOME_MUNICIPIO": "COSMOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3512902",
		"NOME_MUNICIPIO": "COSMORAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513009",
		"NOME_MUNICIPIO": "COTIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513108",
		"NOME_MUNICIPIO": "CRAVINHOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513207",
		"NOME_MUNICIPIO": "CRISTAIS PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513306",
		"NOME_MUNICIPIO": "CRUZALIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513405",
		"NOME_MUNICIPIO": "CRUZEIRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513504",
		"NOME_MUNICIPIO": "CUBATAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513603",
		"NOME_MUNICIPIO": "CUNHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513702",
		"NOME_MUNICIPIO": "DESCALVADO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513801",
		"NOME_MUNICIPIO": "DIADEMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513850",
		"NOME_MUNICIPIO": "DIRCE REIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3513900",
		"NOME_MUNICIPIO": "DIVINOLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514007",
		"NOME_MUNICIPIO": "DOBRADA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514106",
		"NOME_MUNICIPIO": "DOIS CORREGOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514205",
		"NOME_MUNICIPIO": "DOLCINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514304",
		"NOME_MUNICIPIO": "DOURADO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514403",
		"NOME_MUNICIPIO": "DRACENA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514502",
		"NOME_MUNICIPIO": "DUARTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514601",
		"NOME_MUNICIPIO": "DUMONT",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514700",
		"NOME_MUNICIPIO": "ECHAPORA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514809",
		"NOME_MUNICIPIO": "ELDORADO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514908",
		"NOME_MUNICIPIO": "ELIAS FAUSTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514924",
		"NOME_MUNICIPIO": "ELISIARIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3514957",
		"NOME_MUNICIPIO": "EMBAUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515004",
		"NOME_MUNICIPIO": "EMBU DAS ARTES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515103",
		"NOME_MUNICIPIO": "EMBU-GUAÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515129",
		"NOME_MUNICIPIO": "EMILIANOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515152",
		"NOME_MUNICIPIO": "ENGENHEIRO COELHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515186",
		"NOME_MUNICIPIO": "ESPIRITO SANTO DO PINHAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515194",
		"NOME_MUNICIPIO": "ESPIRITO SANTO DO TURVO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515202",
		"NOME_MUNICIPIO": "ESTRELA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515301",
		"NOME_MUNICIPIO": "ESTRELA DO NORTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515350",
		"NOME_MUNICIPIO": "EUCLIDES DA CUNHA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515400",
		"NOME_MUNICIPIO": "FARTURA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515509",
		"NOME_MUNICIPIO": "FERNANDOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515608",
		"NOME_MUNICIPIO": "FERNANDO PRESTES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515657",
		"NOME_MUNICIPIO": "FERNAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515707",
		"NOME_MUNICIPIO": "FERRAZ DE VASCONCELOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515806",
		"NOME_MUNICIPIO": "FLORA RICA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3515905",
		"NOME_MUNICIPIO": "FLOREAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516002",
		"NOME_MUNICIPIO": "FLORIDA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516101",
		"NOME_MUNICIPIO": "FLORINEA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516200",
		"NOME_MUNICIPIO": "FRANCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516309",
		"NOME_MUNICIPIO": "FRANCISCO MORATO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516408",
		"NOME_MUNICIPIO": "FRANCO DA ROCHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516507",
		"NOME_MUNICIPIO": "GABRIEL MONTEIRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516606",
		"NOME_MUNICIPIO": "GALIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516705",
		"NOME_MUNICIPIO": "GARÇA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516804",
		"NOME_MUNICIPIO": "GASTAO VIDIGAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516853",
		"NOME_MUNICIPIO": "GAVIAO PEIXOTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3516903",
		"NOME_MUNICIPIO": "GENERAL SALGADO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517000",
		"NOME_MUNICIPIO": "GETULINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517109",
		"NOME_MUNICIPIO": "GLICERIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517208",
		"NOME_MUNICIPIO": "GUAIÇARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517307",
		"NOME_MUNICIPIO": "GUAIMBÊ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517406",
		"NOME_MUNICIPIO": "GUAIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517505",
		"NOME_MUNICIPIO": "GUAPIAÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517604",
		"NOME_MUNICIPIO": "GUAPIARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517703",
		"NOME_MUNICIPIO": "GUARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517802",
		"NOME_MUNICIPIO": "GUARAÇAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3517901",
		"NOME_MUNICIPIO": "GUARACI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518008",
		"NOME_MUNICIPIO": "GUARANI DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518107",
		"NOME_MUNICIPIO": "GUARANTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518206",
		"NOME_MUNICIPIO": "GUARARAPES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518305",
		"NOME_MUNICIPIO": "GUARAREMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518404",
		"NOME_MUNICIPIO": "GUARATINGUETA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518503",
		"NOME_MUNICIPIO": "GUAREI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518602",
		"NOME_MUNICIPIO": "GUARIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518701",
		"NOME_MUNICIPIO": "GUARUJA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518800",
		"NOME_MUNICIPIO": "GUARULHOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518859",
		"NOME_MUNICIPIO": "GUATAPARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3518909",
		"NOME_MUNICIPIO": "GUZOLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519006",
		"NOME_MUNICIPIO": "HERCULANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519055",
		"NOME_MUNICIPIO": "HOLAMBRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519071",
		"NOME_MUNICIPIO": "HORTOLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519105",
		"NOME_MUNICIPIO": "IACANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519204",
		"NOME_MUNICIPIO": "IACRI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519253",
		"NOME_MUNICIPIO": "IARAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519303",
		"NOME_MUNICIPIO": "IBATE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519402",
		"NOME_MUNICIPIO": "IBIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519501",
		"NOME_MUNICIPIO": "IBIRAREMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519600",
		"NOME_MUNICIPIO": "IBITINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519709",
		"NOME_MUNICIPIO": "IBIUNA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519808",
		"NOME_MUNICIPIO": "ICEM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3519907",
		"NOME_MUNICIPIO": "IEPÊ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520004",
		"NOME_MUNICIPIO": "IGARAÇU DO TIETÊ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520103",
		"NOME_MUNICIPIO": "IGARAPAVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520202",
		"NOME_MUNICIPIO": "IGARATA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520301",
		"NOME_MUNICIPIO": "IGUAPE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520400",
		"NOME_MUNICIPIO": "ILHABELA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520426",
		"NOME_MUNICIPIO": "ILHA COMPRIDA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520442",
		"NOME_MUNICIPIO": "ILHA SOLTEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520509",
		"NOME_MUNICIPIO": "INDAIATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520608",
		"NOME_MUNICIPIO": "INDIANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520707",
		"NOME_MUNICIPIO": "INDIAPORA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520806",
		"NOME_MUNICIPIO": "INUBIA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3520905",
		"NOME_MUNICIPIO": "IPAUSSU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521002",
		"NOME_MUNICIPIO": "IPERO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521101",
		"NOME_MUNICIPIO": "IPEUNA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521150",
		"NOME_MUNICIPIO": "IPIGUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521200",
		"NOME_MUNICIPIO": "IPORANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521309",
		"NOME_MUNICIPIO": "IPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521408",
		"NOME_MUNICIPIO": "IRACEMAPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521507",
		"NOME_MUNICIPIO": "IRAPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521606",
		"NOME_MUNICIPIO": "IRAPURU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521705",
		"NOME_MUNICIPIO": "ITABERA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521804",
		"NOME_MUNICIPIO": "ITAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3521903",
		"NOME_MUNICIPIO": "ITAJOBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522000",
		"NOME_MUNICIPIO": "ITAJU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522109",
		"NOME_MUNICIPIO": "ITANHAEM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522158",
		"NOME_MUNICIPIO": "ITAOCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522208",
		"NOME_MUNICIPIO": "ITAPECERICA DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522307",
		"NOME_MUNICIPIO": "ITAPETININGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522406",
		"NOME_MUNICIPIO": "ITAPEVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522505",
		"NOME_MUNICIPIO": "ITAPEVI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522604",
		"NOME_MUNICIPIO": "ITAPIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522653",
		"NOME_MUNICIPIO": "ITAPIRAPUA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522703",
		"NOME_MUNICIPIO": "ITAPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522802",
		"NOME_MUNICIPIO": "ITAPORANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3522901",
		"NOME_MUNICIPIO": "ITAPUI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523008",
		"NOME_MUNICIPIO": "ITAPURA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523107",
		"NOME_MUNICIPIO": "ITAQUAQUECETUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523206",
		"NOME_MUNICIPIO": "ITARARE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523305",
		"NOME_MUNICIPIO": "ITARIRI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523404",
		"NOME_MUNICIPIO": "ITATIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523503",
		"NOME_MUNICIPIO": "ITATINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523602",
		"NOME_MUNICIPIO": "ITIRAPINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523701",
		"NOME_MUNICIPIO": "ITIRAPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523800",
		"NOME_MUNICIPIO": "ITOBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3523909",
		"NOME_MUNICIPIO": "ITU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524006",
		"NOME_MUNICIPIO": "ITUPEVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524105",
		"NOME_MUNICIPIO": "ITUVERAVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524204",
		"NOME_MUNICIPIO": "JABORANDI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524303",
		"NOME_MUNICIPIO": "JABOTICABAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524402",
		"NOME_MUNICIPIO": "JACAREI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524501",
		"NOME_MUNICIPIO": "JACI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524600",
		"NOME_MUNICIPIO": "JACUPIRANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524709",
		"NOME_MUNICIPIO": "JAGUARIUNA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524808",
		"NOME_MUNICIPIO": "JALES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3524907",
		"NOME_MUNICIPIO": "JAMBEIRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525003",
		"NOME_MUNICIPIO": "JANDIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525102",
		"NOME_MUNICIPIO": "JARDINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525201",
		"NOME_MUNICIPIO": "JARINU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525300",
		"NOME_MUNICIPIO": "JAU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525409",
		"NOME_MUNICIPIO": "JERIQUARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525508",
		"NOME_MUNICIPIO": "JOANOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525607",
		"NOME_MUNICIPIO": "JOAO RAMALHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525706",
		"NOME_MUNICIPIO": "JOSE BONIFACIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525805",
		"NOME_MUNICIPIO": "JULIO MESQUITA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525854",
		"NOME_MUNICIPIO": "JUMIRIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3525904",
		"NOME_MUNICIPIO": "JUNDIAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526001",
		"NOME_MUNICIPIO": "JUNQUEIROPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526100",
		"NOME_MUNICIPIO": "JUQUIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526209",
		"NOME_MUNICIPIO": "JUQUITIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526308",
		"NOME_MUNICIPIO": "LAGOINHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526407",
		"NOME_MUNICIPIO": "LARANJAL PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526506",
		"NOME_MUNICIPIO": "LAVINIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526605",
		"NOME_MUNICIPIO": "LAVRINHAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526704",
		"NOME_MUNICIPIO": "LEME",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526803",
		"NOME_MUNICIPIO": "LENÇOIS PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3526902",
		"NOME_MUNICIPIO": "LIMEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527009",
		"NOME_MUNICIPIO": "LINDOIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527108",
		"NOME_MUNICIPIO": "LINS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527207",
		"NOME_MUNICIPIO": "LORENA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527256",
		"NOME_MUNICIPIO": "LOURDES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527306",
		"NOME_MUNICIPIO": "LOUVEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527405",
		"NOME_MUNICIPIO": "LUCELIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527504",
		"NOME_MUNICIPIO": "LUCIANOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527603",
		"NOME_MUNICIPIO": "LUIS ANTÔNIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527702",
		"NOME_MUNICIPIO": "LUIZIANIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527801",
		"NOME_MUNICIPIO": "LUPERCIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3527900",
		"NOME_MUNICIPIO": "LUTECIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528007",
		"NOME_MUNICIPIO": "MACATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528106",
		"NOME_MUNICIPIO": "MACAUBAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528205",
		"NOME_MUNICIPIO": "MACEDÔNIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528304",
		"NOME_MUNICIPIO": "MAGDA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528403",
		"NOME_MUNICIPIO": "MAIRINQUE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528502",
		"NOME_MUNICIPIO": "MAIRIPORA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528601",
		"NOME_MUNICIPIO": "MANDURI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528700",
		"NOME_MUNICIPIO": "MARABA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528809",
		"NOME_MUNICIPIO": "MARACAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528858",
		"NOME_MUNICIPIO": "MARAPOAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3528908",
		"NOME_MUNICIPIO": "MARIAPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529005",
		"NOME_MUNICIPIO": "MARILIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529104",
		"NOME_MUNICIPIO": "MARINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529203",
		"NOME_MUNICIPIO": "MARTINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529302",
		"NOME_MUNICIPIO": "MATAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529401",
		"NOME_MUNICIPIO": "MAUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529500",
		"NOME_MUNICIPIO": "MENDONÇA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529609",
		"NOME_MUNICIPIO": "MERIDIANO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529658",
		"NOME_MUNICIPIO": "MESOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529708",
		"NOME_MUNICIPIO": "MIGUELOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529807",
		"NOME_MUNICIPIO": "MINEIROS DO TIETÊ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3529906",
		"NOME_MUNICIPIO": "MIRACATU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530003",
		"NOME_MUNICIPIO": "MIRA ESTRELA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530102",
		"NOME_MUNICIPIO": "MIRANDOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530201",
		"NOME_MUNICIPIO": "MIRANTE DO PARANAPANEMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530300",
		"NOME_MUNICIPIO": "MIRASSOL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530409",
		"NOME_MUNICIPIO": "MIRASSOLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530508",
		"NOME_MUNICIPIO": "MOCOCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530607",
		"NOME_MUNICIPIO": "MOGI DAS CRUZES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530706",
		"NOME_MUNICIPIO": "MOGI GUAÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530805",
		"NOME_MUNICIPIO": "MOGI MIRIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3530904",
		"NOME_MUNICIPIO": "MOMBUCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531001",
		"NOME_MUNICIPIO": "MONÇÕES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531100",
		"NOME_MUNICIPIO": "MONGAGUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531209",
		"NOME_MUNICIPIO": "MONTE ALEGRE DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531308",
		"NOME_MUNICIPIO": "MONTE ALTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531407",
		"NOME_MUNICIPIO": "MONTE APRAZIVEL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531506",
		"NOME_MUNICIPIO": "MONTE AZUL PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531605",
		"NOME_MUNICIPIO": "MONTE CASTELO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531704",
		"NOME_MUNICIPIO": "MONTEIRO LOBATO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531803",
		"NOME_MUNICIPIO": "MONTE MOR",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3531902",
		"NOME_MUNICIPIO": "MORRO AGUDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532009",
		"NOME_MUNICIPIO": "MORUNGABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532058",
		"NOME_MUNICIPIO": "MOTUCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532108",
		"NOME_MUNICIPIO": "MURUTINGA DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532157",
		"NOME_MUNICIPIO": "NANTES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532207",
		"NOME_MUNICIPIO": "NARANDIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532306",
		"NOME_MUNICIPIO": "NATIVIDADE DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532405",
		"NOME_MUNICIPIO": "NAZARE PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532504",
		"NOME_MUNICIPIO": "NEVES PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532603",
		"NOME_MUNICIPIO": "NHANDEARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532702",
		"NOME_MUNICIPIO": "NIPOA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532801",
		"NOME_MUNICIPIO": "NOVA ALIANÇA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532827",
		"NOME_MUNICIPIO": "NOVA CAMPINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532843",
		"NOME_MUNICIPIO": "NOVA CANAA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532868",
		"NOME_MUNICIPIO": "NOVA CASTILHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3532900",
		"NOME_MUNICIPIO": "NOVA EUROPA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533007",
		"NOME_MUNICIPIO": "NOVA GRANADA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533106",
		"NOME_MUNICIPIO": "NOVA GUATAPORANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533205",
		"NOME_MUNICIPIO": "NOVA INDEPENDÊNCIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533254",
		"NOME_MUNICIPIO": "NOVAIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533304",
		"NOME_MUNICIPIO": "NOVA LUZITANIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533403",
		"NOME_MUNICIPIO": "NOVA ODESSA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533502",
		"NOME_MUNICIPIO": "NOVO HORIZONTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533601",
		"NOME_MUNICIPIO": "NUPORANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533700",
		"NOME_MUNICIPIO": "OCAUÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533809",
		"NOME_MUNICIPIO": "OLEO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3533908",
		"NOME_MUNICIPIO": "OLIMPIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534005",
		"NOME_MUNICIPIO": "ONDA VERDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534104",
		"NOME_MUNICIPIO": "ORIENTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534203",
		"NOME_MUNICIPIO": "ORINDIUVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534302",
		"NOME_MUNICIPIO": "ORLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534401",
		"NOME_MUNICIPIO": "OSASCO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534500",
		"NOME_MUNICIPIO": "OSCAR BRESSANE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534609",
		"NOME_MUNICIPIO": "OSVALDO CRUZ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534708",
		"NOME_MUNICIPIO": "OURINHOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534757",
		"NOME_MUNICIPIO": "OUROESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534807",
		"NOME_MUNICIPIO": "OURO VERDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3534906",
		"NOME_MUNICIPIO": "PACAEMBU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535002",
		"NOME_MUNICIPIO": "PALESTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535101",
		"NOME_MUNICIPIO": "PALMARES PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535200",
		"NOME_MUNICIPIO": "PALMEIRA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535309",
		"NOME_MUNICIPIO": "PALMITAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535408",
		"NOME_MUNICIPIO": "PANORAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535507",
		"NOME_MUNICIPIO": "PARAGUAÇU PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535606",
		"NOME_MUNICIPIO": "PARAIBUNA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535705",
		"NOME_MUNICIPIO": "PARAISO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535804",
		"NOME_MUNICIPIO": "PARANAPANEMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3535903",
		"NOME_MUNICIPIO": "PARANAPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536000",
		"NOME_MUNICIPIO": "PARAPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536109",
		"NOME_MUNICIPIO": "PARDINHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536208",
		"NOME_MUNICIPIO": "PARIQUERA-AÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536257",
		"NOME_MUNICIPIO": "PARISI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536307",
		"NOME_MUNICIPIO": "PATROCINIO PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536406",
		"NOME_MUNICIPIO": "PAULICEIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536505",
		"NOME_MUNICIPIO": "PAULINIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536570",
		"NOME_MUNICIPIO": "PAULISTANIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536604",
		"NOME_MUNICIPIO": "PAULO DE FARIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536703",
		"NOME_MUNICIPIO": "PEDERNEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536802",
		"NOME_MUNICIPIO": "PEDRA BELA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3536901",
		"NOME_MUNICIPIO": "PEDRANOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537008",
		"NOME_MUNICIPIO": "PEDREGULHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537107",
		"NOME_MUNICIPIO": "PEDREIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537156",
		"NOME_MUNICIPIO": "PEDRINHAS PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537206",
		"NOME_MUNICIPIO": "PEDRO DE TOLEDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537305",
		"NOME_MUNICIPIO": "PENAPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537404",
		"NOME_MUNICIPIO": "PEREIRA BARRETO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537503",
		"NOME_MUNICIPIO": "PEREIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537602",
		"NOME_MUNICIPIO": "PERUIBE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537701",
		"NOME_MUNICIPIO": "PIACATU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537800",
		"NOME_MUNICIPIO": "PIEDADE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3537909",
		"NOME_MUNICIPIO": "PILAR DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538006",
		"NOME_MUNICIPIO": "PINDAMONHANGABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538105",
		"NOME_MUNICIPIO": "PINDORAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538204",
		"NOME_MUNICIPIO": "PINHALZINHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538303",
		"NOME_MUNICIPIO": "PIQUEROBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538501",
		"NOME_MUNICIPIO": "PIQUETE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538600",
		"NOME_MUNICIPIO": "PIRACAIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538709",
		"NOME_MUNICIPIO": "PIRACICABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538808",
		"NOME_MUNICIPIO": "PIRAJU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3538907",
		"NOME_MUNICIPIO": "PIRAJUI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539004",
		"NOME_MUNICIPIO": "PIRANGI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539103",
		"NOME_MUNICIPIO": "PIRAPORA DO BOM JESUS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539202",
		"NOME_MUNICIPIO": "PIRAPOZINHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539301",
		"NOME_MUNICIPIO": "PIRASSUNUNGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539400",
		"NOME_MUNICIPIO": "PIRATININGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539509",
		"NOME_MUNICIPIO": "PITANGUEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539608",
		"NOME_MUNICIPIO": "PLANALTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539707",
		"NOME_MUNICIPIO": "PLATINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539806",
		"NOME_MUNICIPIO": "POA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3539905",
		"NOME_MUNICIPIO": "POLONI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540002",
		"NOME_MUNICIPIO": "POMPEIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540101",
		"NOME_MUNICIPIO": "PONGAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540200",
		"NOME_MUNICIPIO": "PONTAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540259",
		"NOME_MUNICIPIO": "PONTALINDA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540309",
		"NOME_MUNICIPIO": "PONTES GESTAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540408",
		"NOME_MUNICIPIO": "POPULINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540507",
		"NOME_MUNICIPIO": "PORANGABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540606",
		"NOME_MUNICIPIO": "PORTO FELIZ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540705",
		"NOME_MUNICIPIO": "PORTO FERREIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540754",
		"NOME_MUNICIPIO": "POTIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540804",
		"NOME_MUNICIPIO": "POTIRENDABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540853",
		"NOME_MUNICIPIO": "PRACINHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3540903",
		"NOME_MUNICIPIO": "PRADOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541000",
		"NOME_MUNICIPIO": "PRAIA GRANDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541059",
		"NOME_MUNICIPIO": "PRATANIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541109",
		"NOME_MUNICIPIO": "PRESIDENTE ALVES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541208",
		"NOME_MUNICIPIO": "PRESIDENTE BERNARDES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541307",
		"NOME_MUNICIPIO": "PRESIDENTE EPITACIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541406",
		"NOME_MUNICIPIO": "PRESIDENTE PRUDENTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541505",
		"NOME_MUNICIPIO": "PRESIDENTE VENCESLAU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541604",
		"NOME_MUNICIPIO": "PROMISSAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541653",
		"NOME_MUNICIPIO": "QUADRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541703",
		"NOME_MUNICIPIO": "QUATA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541802",
		"NOME_MUNICIPIO": "QUEIROZ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3541901",
		"NOME_MUNICIPIO": "QUELUZ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542008",
		"NOME_MUNICIPIO": "QUINTANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542107",
		"NOME_MUNICIPIO": "RAFARD",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542206",
		"NOME_MUNICIPIO": "RANCHARIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542305",
		"NOME_MUNICIPIO": "REDENÇAO DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542404",
		"NOME_MUNICIPIO": "REGENTE FEIJO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542503",
		"NOME_MUNICIPIO": "REGINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542602",
		"NOME_MUNICIPIO": "REGISTRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542701",
		"NOME_MUNICIPIO": "RESTINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542800",
		"NOME_MUNICIPIO": "RIBEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3542909",
		"NOME_MUNICIPIO": "RIBEIRAO BONITO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543006",
		"NOME_MUNICIPIO": "RIBEIRAO BRANCO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543105",
		"NOME_MUNICIPIO": "RIBEIRAO CORRENTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543204",
		"NOME_MUNICIPIO": "RIBEIRAO DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543238",
		"NOME_MUNICIPIO": "RIBEIRAO DOS INDIOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543253",
		"NOME_MUNICIPIO": "RIBEIRAO GRANDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543303",
		"NOME_MUNICIPIO": "RIBEIRAO PIRES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543402",
		"NOME_MUNICIPIO": "RIBEIRAO PRETO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543501",
		"NOME_MUNICIPIO": "RIVERSUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543600",
		"NOME_MUNICIPIO": "RIFAINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543709",
		"NOME_MUNICIPIO": "RINCAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543808",
		"NOME_MUNICIPIO": "RINOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3543907",
		"NOME_MUNICIPIO": "RIO CLARO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544004",
		"NOME_MUNICIPIO": "RIO DAS PEDRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544103",
		"NOME_MUNICIPIO": "RIO GRANDE DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544202",
		"NOME_MUNICIPIO": "RIOLANDIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544251",
		"NOME_MUNICIPIO": "ROSANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544301",
		"NOME_MUNICIPIO": "ROSEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544400",
		"NOME_MUNICIPIO": "RUBIACEA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544509",
		"NOME_MUNICIPIO": "RUBINEIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544608",
		"NOME_MUNICIPIO": "SABINO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544707",
		"NOME_MUNICIPIO": "SAGRES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544806",
		"NOME_MUNICIPIO": "SALES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3544905",
		"NOME_MUNICIPIO": "SALES OLIVEIRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545001",
		"NOME_MUNICIPIO": "SALESOPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545100",
		"NOME_MUNICIPIO": "SALMOURAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545159",
		"NOME_MUNICIPIO": "SALTINHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545209",
		"NOME_MUNICIPIO": "SALTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545308",
		"NOME_MUNICIPIO": "SALTO DE PIRAPORA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545407",
		"NOME_MUNICIPIO": "SALTO GRANDE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545506",
		"NOME_MUNICIPIO": "SANDOVALINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545605",
		"NOME_MUNICIPIO": "SANTA ADELIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545704",
		"NOME_MUNICIPIO": "SANTA ALBERTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3545803",
		"NOME_MUNICIPIO": "SANTA BARBARA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546009",
		"NOME_MUNICIPIO": "SANTA BRANCA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546108",
		"NOME_MUNICIPIO": "SANTA CLARA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546207",
		"NOME_MUNICIPIO": "SANTA CRUZ DA CONCEIÇAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546256",
		"NOME_MUNICIPIO": "SANTA CRUZ DA ESPERANÇA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546306",
		"NOME_MUNICIPIO": "SANTA CRUZ DAS PALMEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546405",
		"NOME_MUNICIPIO": "SANTA CRUZ DO RIO PARDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546504",
		"NOME_MUNICIPIO": "SANTA ERNESTINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546603",
		"NOME_MUNICIPIO": "SANTA FE DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546702",
		"NOME_MUNICIPIO": "SANTA GERTRUDES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546801",
		"NOME_MUNICIPIO": "SANTA ISABEL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3546900",
		"NOME_MUNICIPIO": "SANTA LUCIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547007",
		"NOME_MUNICIPIO": "SANTA MARIA DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547106",
		"NOME_MUNICIPIO": "SANTA MERCEDES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547205",
		"NOME_MUNICIPIO": "SANTANA DA PONTE PENSA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547304",
		"NOME_MUNICIPIO": "SANTANA DE PARNAIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547403",
		"NOME_MUNICIPIO": "SANTA RITA DOESTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547502",
		"NOME_MUNICIPIO": "SANTA RITA DO PASSA QUATRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547601",
		"NOME_MUNICIPIO": "SANTA ROSA DE VITERBO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547650",
		"NOME_MUNICIPIO": "SANTA SALETE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547700",
		"NOME_MUNICIPIO": "SANTO ANASTACIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547809",
		"NOME_MUNICIPIO": "SANTO ANDRE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3547908",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DA ALEGRIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548005",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DE POSSE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548054",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO ARACANGUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548104",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO JARDIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548203",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO PINHAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548302",
		"NOME_MUNICIPIO": "SANTO EXPEDITO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548401",
		"NOME_MUNICIPIO": "SANTOPOLIS DO AGUAPEI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548500",
		"NOME_MUNICIPIO": "SANTOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548609",
		"NOME_MUNICIPIO": "SAO BENTO DO SAPUCAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548708",
		"NOME_MUNICIPIO": "SAO BERNARDO DO CAMPO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548807",
		"NOME_MUNICIPIO": "SAO CAETANO DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3548906",
		"NOME_MUNICIPIO": "SAO CARLOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549003",
		"NOME_MUNICIPIO": "SAO FRANCISCO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549102",
		"NOME_MUNICIPIO": "SAO JOAO DA BOA VISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549201",
		"NOME_MUNICIPIO": "SAO JOAO DAS DUAS PONTES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549250",
		"NOME_MUNICIPIO": "SAO JOAO DE IRACEMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549300",
		"NOME_MUNICIPIO": "SAO JOAO DO PAU DALHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549409",
		"NOME_MUNICIPIO": "SAO JOAQUIM DA BARRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549508",
		"NOME_MUNICIPIO": "SAO JOSE DA BELA VISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549607",
		"NOME_MUNICIPIO": "SAO JOSE DO BARREIRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549706",
		"NOME_MUNICIPIO": "SAO JOSE DO RIO PARDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549805",
		"NOME_MUNICIPIO": "SAO JOSE DO RIO PRETO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549904",
		"NOME_MUNICIPIO": "SAO JOSE DOS CAMPOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3549953",
		"NOME_MUNICIPIO": "SAO LOURENÇO DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550001",
		"NOME_MUNICIPIO": "SAO LUIZ DO PARAITINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550100",
		"NOME_MUNICIPIO": "SAO MANUEL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550209",
		"NOME_MUNICIPIO": "SAO MIGUEL ARCANJO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550308",
		"NOME_MUNICIPIO": "SAO PAULO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550407",
		"NOME_MUNICIPIO": "SAO PEDRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550506",
		"NOME_MUNICIPIO": "SAO PEDRO DO TURVO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550605",
		"NOME_MUNICIPIO": "SAO ROQUE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550704",
		"NOME_MUNICIPIO": "SAO SEBASTIAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550803",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DA GRAMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3550902",
		"NOME_MUNICIPIO": "SAO SIMAO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551009",
		"NOME_MUNICIPIO": "SAO VICENTE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551108",
		"NOME_MUNICIPIO": "SARAPUI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551207",
		"NOME_MUNICIPIO": "SARUTAIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551306",
		"NOME_MUNICIPIO": "SEBASTIANOPOLIS DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551405",
		"NOME_MUNICIPIO": "SERRA AZUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551504",
		"NOME_MUNICIPIO": "SERRANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551603",
		"NOME_MUNICIPIO": "SERRA NEGRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551702",
		"NOME_MUNICIPIO": "SERTAOZINHO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551801",
		"NOME_MUNICIPIO": "SETE BARRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3551900",
		"NOME_MUNICIPIO": "SEVERINIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552007",
		"NOME_MUNICIPIO": "SILVEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552106",
		"NOME_MUNICIPIO": "SOCORRO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552205",
		"NOME_MUNICIPIO": "SOROCABA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552304",
		"NOME_MUNICIPIO": "SUD MENNUCCI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552403",
		"NOME_MUNICIPIO": "SUMARE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552502",
		"NOME_MUNICIPIO": "SUZANO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552551",
		"NOME_MUNICIPIO": "SUZANAPOLIS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552601",
		"NOME_MUNICIPIO": "TABAPUA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552700",
		"NOME_MUNICIPIO": "TABATINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552809",
		"NOME_MUNICIPIO": "TABOAO DA SERRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3552908",
		"NOME_MUNICIPIO": "TACIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553005",
		"NOME_MUNICIPIO": "TAGUAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553104",
		"NOME_MUNICIPIO": "TAIAÇU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553203",
		"NOME_MUNICIPIO": "TAIUVA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553302",
		"NOME_MUNICIPIO": "TAMBAU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553401",
		"NOME_MUNICIPIO": "TANABI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553500",
		"NOME_MUNICIPIO": "TAPIRAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553609",
		"NOME_MUNICIPIO": "TAPIRATIBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553658",
		"NOME_MUNICIPIO": "TAQUARAL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553708",
		"NOME_MUNICIPIO": "TAQUARITINGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553807",
		"NOME_MUNICIPIO": "TAQUARITUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553856",
		"NOME_MUNICIPIO": "TAQUARIVAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553906",
		"NOME_MUNICIPIO": "TARABAI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3553955",
		"NOME_MUNICIPIO": "TARUMA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554003",
		"NOME_MUNICIPIO": "TATUI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554102",
		"NOME_MUNICIPIO": "TAUBATE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554201",
		"NOME_MUNICIPIO": "TEJUPA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554300",
		"NOME_MUNICIPIO": "TEODORO SAMPAIO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554409",
		"NOME_MUNICIPIO": "TERRA ROXA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554508",
		"NOME_MUNICIPIO": "TIETÊ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554607",
		"NOME_MUNICIPIO": "TIMBURI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554656",
		"NOME_MUNICIPIO": "TORRE DE PEDRA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554706",
		"NOME_MUNICIPIO": "TORRINHA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554755",
		"NOME_MUNICIPIO": "TRABIJU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554805",
		"NOME_MUNICIPIO": "TREMEMBE",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554904",
		"NOME_MUNICIPIO": "TRÊS FRONTEIRAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3554953",
		"NOME_MUNICIPIO": "TUIUTI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555000",
		"NOME_MUNICIPIO": "TUPA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555109",
		"NOME_MUNICIPIO": "TUPI PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555208",
		"NOME_MUNICIPIO": "TURIUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555307",
		"NOME_MUNICIPIO": "TURMALINA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555356",
		"NOME_MUNICIPIO": "UBARANA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555406",
		"NOME_MUNICIPIO": "UBATUBA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555505",
		"NOME_MUNICIPIO": "UBIRAJARA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555604",
		"NOME_MUNICIPIO": "UCHOA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555703",
		"NOME_MUNICIPIO": "UNIAO PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555802",
		"NOME_MUNICIPIO": "URANIA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3555901",
		"NOME_MUNICIPIO": "URU",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556008",
		"NOME_MUNICIPIO": "URUPÊS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556107",
		"NOME_MUNICIPIO": "VALENTIM GENTIL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556206",
		"NOME_MUNICIPIO": "VALINHOS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556305",
		"NOME_MUNICIPIO": "VALPARAISO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556354",
		"NOME_MUNICIPIO": "VARGEM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556404",
		"NOME_MUNICIPIO": "VARGEM GRANDE DO SUL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556453",
		"NOME_MUNICIPIO": "VARGEM GRANDE PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556503",
		"NOME_MUNICIPIO": "VARZEA PAULISTA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556602",
		"NOME_MUNICIPIO": "VERA CRUZ",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556701",
		"NOME_MUNICIPIO": "VINHEDO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556800",
		"NOME_MUNICIPIO": "VIRADOURO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556909",
		"NOME_MUNICIPIO": "VISTA ALEGRE DO ALTO",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3556958",
		"NOME_MUNICIPIO": "VITORIA BRASIL",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3557006",
		"NOME_MUNICIPIO": "VOTORANTIM",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3557105",
		"NOME_MUNICIPIO": "VOTUPORANGA",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3557154",
		"NOME_MUNICIPIO": "ZACARIAS",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3557204",
		"NOME_MUNICIPIO": "CHAVANTES",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "3557303",
		"NOME_MUNICIPIO": "ESTIVA GERBI",
		"COD_UF": "35"
	},
	{
		"COD_MUNICIPIO": "4100103",
		"NOME_MUNICIPIO": "ABATIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100202",
		"NOME_MUNICIPIO": "ADRIANOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100301",
		"NOME_MUNICIPIO": "AGUDOS DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100400",
		"NOME_MUNICIPIO": "ALMIRANTE TAMANDARE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100459",
		"NOME_MUNICIPIO": "ALTAMIRA DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100509",
		"NOME_MUNICIPIO": "ALTÔNIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100608",
		"NOME_MUNICIPIO": "ALTO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100707",
		"NOME_MUNICIPIO": "ALTO PIQUIRI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100806",
		"NOME_MUNICIPIO": "ALVORADA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4100905",
		"NOME_MUNICIPIO": "AMAPORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101002",
		"NOME_MUNICIPIO": "AMPERE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101051",
		"NOME_MUNICIPIO": "ANAHY",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101101",
		"NOME_MUNICIPIO": "ANDIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101150",
		"NOME_MUNICIPIO": "ANGULO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101200",
		"NOME_MUNICIPIO": "ANTONINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101309",
		"NOME_MUNICIPIO": "ANTÔNIO OLINTO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101408",
		"NOME_MUNICIPIO": "APUCARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101507",
		"NOME_MUNICIPIO": "ARAPONGAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101606",
		"NOME_MUNICIPIO": "ARAPOTI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101655",
		"NOME_MUNICIPIO": "ARAPUA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101705",
		"NOME_MUNICIPIO": "ARARUNA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101804",
		"NOME_MUNICIPIO": "ARAUCARIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101853",
		"NOME_MUNICIPIO": "ARIRANHA DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4101903",
		"NOME_MUNICIPIO": "ASSAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102000",
		"NOME_MUNICIPIO": "ASSIS CHATEAUBRIAND",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102109",
		"NOME_MUNICIPIO": "ASTORGA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102208",
		"NOME_MUNICIPIO": "ATALAIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102307",
		"NOME_MUNICIPIO": "BALSA NOVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102406",
		"NOME_MUNICIPIO": "BANDEIRANTES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102505",
		"NOME_MUNICIPIO": "BARBOSA FERRAZ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102604",
		"NOME_MUNICIPIO": "BARRACAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102703",
		"NOME_MUNICIPIO": "BARRA DO JACARE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102752",
		"NOME_MUNICIPIO": "BELA VISTA DA CAROBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102802",
		"NOME_MUNICIPIO": "BELA VISTA DO PARAISO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4102901",
		"NOME_MUNICIPIO": "BITURUNA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103008",
		"NOME_MUNICIPIO": "BOA ESPERANÇA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103024",
		"NOME_MUNICIPIO": "BOA ESPERANÇA DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103040",
		"NOME_MUNICIPIO": "BOA VENTURA DE SAO ROQUE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103057",
		"NOME_MUNICIPIO": "BOA VISTA DA APARECIDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103107",
		"NOME_MUNICIPIO": "BOCAIUVA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103156",
		"NOME_MUNICIPIO": "BOM JESUS DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103206",
		"NOME_MUNICIPIO": "BOM SUCESSO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103222",
		"NOME_MUNICIPIO": "BOM SUCESSO DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103305",
		"NOME_MUNICIPIO": "BORRAZOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103354",
		"NOME_MUNICIPIO": "BRAGANEY",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103370",
		"NOME_MUNICIPIO": "BRASILANDIA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103404",
		"NOME_MUNICIPIO": "CAFEARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103453",
		"NOME_MUNICIPIO": "CAFELANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103479",
		"NOME_MUNICIPIO": "CAFEZAL DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103503",
		"NOME_MUNICIPIO": "CALIFORNIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103602",
		"NOME_MUNICIPIO": "CAMBARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103701",
		"NOME_MUNICIPIO": "CAMBE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103800",
		"NOME_MUNICIPIO": "CAMBIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103909",
		"NOME_MUNICIPIO": "CAMPINA DA LAGOA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4103958",
		"NOME_MUNICIPIO": "CAMPINA DO SIMAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104006",
		"NOME_MUNICIPIO": "CAMPINA GRANDE DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104055",
		"NOME_MUNICIPIO": "CAMPO BONITO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104105",
		"NOME_MUNICIPIO": "CAMPO DO TENENTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104204",
		"NOME_MUNICIPIO": "CAMPO LARGO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104253",
		"NOME_MUNICIPIO": "CAMPO MAGRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104303",
		"NOME_MUNICIPIO": "CAMPO MOURAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104402",
		"NOME_MUNICIPIO": "CANDIDO DE ABREU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104428",
		"NOME_MUNICIPIO": "CANDOI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104451",
		"NOME_MUNICIPIO": "CANTAGALO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104501",
		"NOME_MUNICIPIO": "CAPANEMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104600",
		"NOME_MUNICIPIO": "CAPITAO LEÔNIDAS MARQUES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104659",
		"NOME_MUNICIPIO": "CARAMBEI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104709",
		"NOME_MUNICIPIO": "CARLOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104808",
		"NOME_MUNICIPIO": "CASCAVEL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4104907",
		"NOME_MUNICIPIO": "CASTRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105003",
		"NOME_MUNICIPIO": "CATANDUVAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105102",
		"NOME_MUNICIPIO": "CENTENARIO DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105201",
		"NOME_MUNICIPIO": "CERRO AZUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105300",
		"NOME_MUNICIPIO": "CEU AZUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105409",
		"NOME_MUNICIPIO": "CHOPINZINHO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105508",
		"NOME_MUNICIPIO": "CIANORTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105607",
		"NOME_MUNICIPIO": "CIDADE GAUCHA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105706",
		"NOME_MUNICIPIO": "CLEVELANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105805",
		"NOME_MUNICIPIO": "COLOMBO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4105904",
		"NOME_MUNICIPIO": "COLORADO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106001",
		"NOME_MUNICIPIO": "CONGONHINHAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106100",
		"NOME_MUNICIPIO": "CONSELHEIRO MAIRINCK",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106209",
		"NOME_MUNICIPIO": "CONTENDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106308",
		"NOME_MUNICIPIO": "CORBELIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106407",
		"NOME_MUNICIPIO": "CORNELIO PROCOPIO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106456",
		"NOME_MUNICIPIO": "CORONEL DOMINGOS SOARES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106506",
		"NOME_MUNICIPIO": "CORONEL VIVIDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106555",
		"NOME_MUNICIPIO": "CORUMBATAI DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106571",
		"NOME_MUNICIPIO": "CRUZEIRO DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106605",
		"NOME_MUNICIPIO": "CRUZEIRO DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106704",
		"NOME_MUNICIPIO": "CRUZEIRO DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106803",
		"NOME_MUNICIPIO": "CRUZ MACHADO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106852",
		"NOME_MUNICIPIO": "CRUZMALTINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4106902",
		"NOME_MUNICIPIO": "CURITIBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107009",
		"NOME_MUNICIPIO": "CURIUVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107108",
		"NOME_MUNICIPIO": "DIAMANTE DO NORTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107124",
		"NOME_MUNICIPIO": "DIAMANTE DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107157",
		"NOME_MUNICIPIO": "DIAMANTE DOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107207",
		"NOME_MUNICIPIO": "DOIS VIZINHOS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107256",
		"NOME_MUNICIPIO": "DOURADINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107306",
		"NOME_MUNICIPIO": "DOUTOR CAMARGO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107405",
		"NOME_MUNICIPIO": "ENEAS MARQUES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107504",
		"NOME_MUNICIPIO": "ENGENHEIRO BELTRAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107520",
		"NOME_MUNICIPIO": "ESPERANÇA NOVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107538",
		"NOME_MUNICIPIO": "ENTRE RIOS DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107546",
		"NOME_MUNICIPIO": "ESPIGAO ALTO DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107553",
		"NOME_MUNICIPIO": "FAROL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107603",
		"NOME_MUNICIPIO": "FAXINAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107652",
		"NOME_MUNICIPIO": "FAZENDA RIO GRANDE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107702",
		"NOME_MUNICIPIO": "FÊNIX",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107736",
		"NOME_MUNICIPIO": "FERNANDES PINHEIRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107751",
		"NOME_MUNICIPIO": "FIGUEIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107801",
		"NOME_MUNICIPIO": "FLORAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107850",
		"NOME_MUNICIPIO": "FLOR DA SERRA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4107900",
		"NOME_MUNICIPIO": "FLORESTA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108007",
		"NOME_MUNICIPIO": "FLORESTOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108106",
		"NOME_MUNICIPIO": "FLORIDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108205",
		"NOME_MUNICIPIO": "FORMOSA DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108304",
		"NOME_MUNICIPIO": "FOZ DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108320",
		"NOME_MUNICIPIO": "FRANCISCO ALVES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108403",
		"NOME_MUNICIPIO": "FRANCISCO BELTRAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108452",
		"NOME_MUNICIPIO": "FOZ DO JORDAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108502",
		"NOME_MUNICIPIO": "GENERAL CARNEIRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108551",
		"NOME_MUNICIPIO": "GODOY MOREIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108601",
		"NOME_MUNICIPIO": "GOIOERÊ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108650",
		"NOME_MUNICIPIO": "GOIOXIM",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108700",
		"NOME_MUNICIPIO": "GRANDES RIOS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108809",
		"NOME_MUNICIPIO": "GUAIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108908",
		"NOME_MUNICIPIO": "GUAIRAÇA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4108957",
		"NOME_MUNICIPIO": "GUAMIRANGA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109005",
		"NOME_MUNICIPIO": "GUAPIRAMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109104",
		"NOME_MUNICIPIO": "GUAPOREMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109203",
		"NOME_MUNICIPIO": "GUARACI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109302",
		"NOME_MUNICIPIO": "GUARANIAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109401",
		"NOME_MUNICIPIO": "GUARAPUAVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109500",
		"NOME_MUNICIPIO": "GUARAQUEÇABA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109609",
		"NOME_MUNICIPIO": "GUARATUBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109658",
		"NOME_MUNICIPIO": "HONORIO SERPA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109708",
		"NOME_MUNICIPIO": "IBAITI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109757",
		"NOME_MUNICIPIO": "IBEMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109807",
		"NOME_MUNICIPIO": "IBIPORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4109906",
		"NOME_MUNICIPIO": "ICARAIMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110003",
		"NOME_MUNICIPIO": "IGUARAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110052",
		"NOME_MUNICIPIO": "IGUATU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110078",
		"NOME_MUNICIPIO": "IMBAU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110102",
		"NOME_MUNICIPIO": "IMBITUVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110201",
		"NOME_MUNICIPIO": "INACIO MARTINS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110300",
		"NOME_MUNICIPIO": "INAJA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110409",
		"NOME_MUNICIPIO": "INDIANOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110508",
		"NOME_MUNICIPIO": "IPIRANGA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110607",
		"NOME_MUNICIPIO": "IPORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110656",
		"NOME_MUNICIPIO": "IRACEMA DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110706",
		"NOME_MUNICIPIO": "IRATI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110805",
		"NOME_MUNICIPIO": "IRETAMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110904",
		"NOME_MUNICIPIO": "ITAGUAJE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4110953",
		"NOME_MUNICIPIO": "ITAIPULANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111001",
		"NOME_MUNICIPIO": "ITAMBARACA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111100",
		"NOME_MUNICIPIO": "ITAMBE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111209",
		"NOME_MUNICIPIO": "ITAPEJARA DOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111258",
		"NOME_MUNICIPIO": "ITAPERUÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111308",
		"NOME_MUNICIPIO": "ITAUNA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111407",
		"NOME_MUNICIPIO": "IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111506",
		"NOME_MUNICIPIO": "IVAIPORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111555",
		"NOME_MUNICIPIO": "IVATE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111605",
		"NOME_MUNICIPIO": "IVATUBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111704",
		"NOME_MUNICIPIO": "JABOTI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111803",
		"NOME_MUNICIPIO": "JACAREZINHO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4111902",
		"NOME_MUNICIPIO": "JAGUAPITA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112009",
		"NOME_MUNICIPIO": "JAGUARIAIVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112108",
		"NOME_MUNICIPIO": "JANDAIA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112207",
		"NOME_MUNICIPIO": "JANIOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112306",
		"NOME_MUNICIPIO": "JAPIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112405",
		"NOME_MUNICIPIO": "JAPURA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112504",
		"NOME_MUNICIPIO": "JARDIM ALEGRE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112603",
		"NOME_MUNICIPIO": "JARDIM OLINDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112702",
		"NOME_MUNICIPIO": "JATAIZINHO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112751",
		"NOME_MUNICIPIO": "JESUITAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112801",
		"NOME_MUNICIPIO": "JOAQUIM TAVORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112900",
		"NOME_MUNICIPIO": "JUNDIAI DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4112959",
		"NOME_MUNICIPIO": "JURANDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113007",
		"NOME_MUNICIPIO": "JUSSARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113106",
		"NOME_MUNICIPIO": "KALORE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113205",
		"NOME_MUNICIPIO": "LAPA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113254",
		"NOME_MUNICIPIO": "LARANJAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113304",
		"NOME_MUNICIPIO": "LARANJEIRAS DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113403",
		"NOME_MUNICIPIO": "LEOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113429",
		"NOME_MUNICIPIO": "LIDIANOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113452",
		"NOME_MUNICIPIO": "LINDOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113502",
		"NOME_MUNICIPIO": "LOANDA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113601",
		"NOME_MUNICIPIO": "LOBATO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113700",
		"NOME_MUNICIPIO": "LONDRINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113734",
		"NOME_MUNICIPIO": "LUIZIANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113759",
		"NOME_MUNICIPIO": "LUNARDELLI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113809",
		"NOME_MUNICIPIO": "LUPIONOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4113908",
		"NOME_MUNICIPIO": "MALLET",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114005",
		"NOME_MUNICIPIO": "MAMBORÊ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114104",
		"NOME_MUNICIPIO": "MANDAGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114203",
		"NOME_MUNICIPIO": "MANDAGUARI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114302",
		"NOME_MUNICIPIO": "MANDIRITUBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114351",
		"NOME_MUNICIPIO": "MANFRINOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114401",
		"NOME_MUNICIPIO": "MANGUEIRINHA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114500",
		"NOME_MUNICIPIO": "MANOEL RIBAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114609",
		"NOME_MUNICIPIO": "MARECHAL CANDIDO RONDON",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114708",
		"NOME_MUNICIPIO": "MARIA HELENA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114807",
		"NOME_MUNICIPIO": "MARIALVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4114906",
		"NOME_MUNICIPIO": "MARILANDIA DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115002",
		"NOME_MUNICIPIO": "MARILENA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115101",
		"NOME_MUNICIPIO": "MARILUZ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115200",
		"NOME_MUNICIPIO": "MARINGA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115309",
		"NOME_MUNICIPIO": "MARIOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115358",
		"NOME_MUNICIPIO": "MARIPA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115408",
		"NOME_MUNICIPIO": "MARMELEIRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115457",
		"NOME_MUNICIPIO": "MARQUINHO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115507",
		"NOME_MUNICIPIO": "MARUMBI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115606",
		"NOME_MUNICIPIO": "MATELANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115705",
		"NOME_MUNICIPIO": "MATINHOS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115739",
		"NOME_MUNICIPIO": "MATO RICO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115754",
		"NOME_MUNICIPIO": "MAUA DA SERRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115804",
		"NOME_MUNICIPIO": "MEDIANEIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115853",
		"NOME_MUNICIPIO": "MERCEDES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4115903",
		"NOME_MUNICIPIO": "MIRADOR",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116000",
		"NOME_MUNICIPIO": "MIRASELVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116059",
		"NOME_MUNICIPIO": "MISSAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116109",
		"NOME_MUNICIPIO": "MOREIRA SALES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116208",
		"NOME_MUNICIPIO": "MORRETES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116307",
		"NOME_MUNICIPIO": "MUNHOZ DE MELO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116406",
		"NOME_MUNICIPIO": "NOSSA SENHORA DAS GRAÇAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116505",
		"NOME_MUNICIPIO": "NOVA ALIANÇA DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116604",
		"NOME_MUNICIPIO": "NOVA AMERICA DA COLINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116703",
		"NOME_MUNICIPIO": "NOVA AURORA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116802",
		"NOME_MUNICIPIO": "NOVA CANTU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116901",
		"NOME_MUNICIPIO": "NOVA ESPERANÇA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4116950",
		"NOME_MUNICIPIO": "NOVA ESPERANÇA DO SUDOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117008",
		"NOME_MUNICIPIO": "NOVA FATIMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117057",
		"NOME_MUNICIPIO": "NOVA LARANJEIRAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117107",
		"NOME_MUNICIPIO": "NOVA LONDRINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117206",
		"NOME_MUNICIPIO": "NOVA OLIMPIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117214",
		"NOME_MUNICIPIO": "NOVA SANTA BARBARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117222",
		"NOME_MUNICIPIO": "NOVA SANTA ROSA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117255",
		"NOME_MUNICIPIO": "NOVA PRATA DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117271",
		"NOME_MUNICIPIO": "NOVA TEBAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117297",
		"NOME_MUNICIPIO": "NOVO ITACOLOMI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117305",
		"NOME_MUNICIPIO": "ORTIGUEIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117404",
		"NOME_MUNICIPIO": "OURIZONA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117453",
		"NOME_MUNICIPIO": "OURO VERDE DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117503",
		"NOME_MUNICIPIO": "PAIÇANDU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117602",
		"NOME_MUNICIPIO": "PALMAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117701",
		"NOME_MUNICIPIO": "PALMEIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117800",
		"NOME_MUNICIPIO": "PALMITAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4117909",
		"NOME_MUNICIPIO": "PALOTINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118006",
		"NOME_MUNICIPIO": "PARAISO DO NORTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118105",
		"NOME_MUNICIPIO": "PARANACITY",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118204",
		"NOME_MUNICIPIO": "PARANAGUA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118303",
		"NOME_MUNICIPIO": "PARANAPOEMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118402",
		"NOME_MUNICIPIO": "PARANAVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118451",
		"NOME_MUNICIPIO": "PATO BRAGADO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118501",
		"NOME_MUNICIPIO": "PATO BRANCO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118600",
		"NOME_MUNICIPIO": "PAULA FREITAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118709",
		"NOME_MUNICIPIO": "PAULO FRONTIN",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118808",
		"NOME_MUNICIPIO": "PEABIRU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118857",
		"NOME_MUNICIPIO": "PEROBAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4118907",
		"NOME_MUNICIPIO": "PEROLA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119004",
		"NOME_MUNICIPIO": "PEROLA DOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119103",
		"NOME_MUNICIPIO": "PIÊN",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119152",
		"NOME_MUNICIPIO": "PINHAIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119202",
		"NOME_MUNICIPIO": "PINHALAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119251",
		"NOME_MUNICIPIO": "PINHAL DE SAO BENTO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119301",
		"NOME_MUNICIPIO": "PINHAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119400",
		"NOME_MUNICIPIO": "PIRAI DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119509",
		"NOME_MUNICIPIO": "PIRAQUARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119608",
		"NOME_MUNICIPIO": "PITANGA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119657",
		"NOME_MUNICIPIO": "PITANGUEIRAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119707",
		"NOME_MUNICIPIO": "PLANALTINA DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119806",
		"NOME_MUNICIPIO": "PLANALTO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119905",
		"NOME_MUNICIPIO": "PONTA GROSSA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4119954",
		"NOME_MUNICIPIO": "PONTAL DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120002",
		"NOME_MUNICIPIO": "PORECATU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120101",
		"NOME_MUNICIPIO": "PORTO AMAZONAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120150",
		"NOME_MUNICIPIO": "PORTO BARREIRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120200",
		"NOME_MUNICIPIO": "PORTO RICO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120309",
		"NOME_MUNICIPIO": "PORTO VITORIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120333",
		"NOME_MUNICIPIO": "PRADO FERREIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120358",
		"NOME_MUNICIPIO": "PRANCHITA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120408",
		"NOME_MUNICIPIO": "PRESIDENTE CASTELO BRANCO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120507",
		"NOME_MUNICIPIO": "PRIMEIRO DE MAIO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120606",
		"NOME_MUNICIPIO": "PRUDENTOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120655",
		"NOME_MUNICIPIO": "QUARTO CENTENARIO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120705",
		"NOME_MUNICIPIO": "QUATIGUA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120804",
		"NOME_MUNICIPIO": "QUATRO BARRAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120853",
		"NOME_MUNICIPIO": "QUATRO PONTES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4120903",
		"NOME_MUNICIPIO": "QUEDAS DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121000",
		"NOME_MUNICIPIO": "QUERÊNCIA DO NORTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121109",
		"NOME_MUNICIPIO": "QUINTA DO SOL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121208",
		"NOME_MUNICIPIO": "QUITANDINHA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121257",
		"NOME_MUNICIPIO": "RAMILANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121307",
		"NOME_MUNICIPIO": "RANCHO ALEGRE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121356",
		"NOME_MUNICIPIO": "RANCHO ALEGRE DOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121406",
		"NOME_MUNICIPIO": "REALEZA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121505",
		"NOME_MUNICIPIO": "REBOUÇAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121604",
		"NOME_MUNICIPIO": "RENASCENÇA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121703",
		"NOME_MUNICIPIO": "RESERVA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121752",
		"NOME_MUNICIPIO": "RESERVA DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121802",
		"NOME_MUNICIPIO": "RIBEIRAO CLARO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4121901",
		"NOME_MUNICIPIO": "RIBEIRAO DO PINHAL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122008",
		"NOME_MUNICIPIO": "RIO AZUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122107",
		"NOME_MUNICIPIO": "RIO BOM",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122156",
		"NOME_MUNICIPIO": "RIO BONITO DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122172",
		"NOME_MUNICIPIO": "RIO BRANCO DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122206",
		"NOME_MUNICIPIO": "RIO BRANCO DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122305",
		"NOME_MUNICIPIO": "RIO NEGRO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122404",
		"NOME_MUNICIPIO": "ROLANDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122503",
		"NOME_MUNICIPIO": "RONCADOR",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122602",
		"NOME_MUNICIPIO": "RONDON",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122651",
		"NOME_MUNICIPIO": "ROSARIO DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122701",
		"NOME_MUNICIPIO": "SABAUDIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122800",
		"NOME_MUNICIPIO": "SALGADO FILHO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4122909",
		"NOME_MUNICIPIO": "SALTO DO ITARARE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123006",
		"NOME_MUNICIPIO": "SALTO DO LONTRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123105",
		"NOME_MUNICIPIO": "SANTA AMELIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123204",
		"NOME_MUNICIPIO": "SANTA CECILIA DO PAVAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123303",
		"NOME_MUNICIPIO": "SANTA CRUZ DE MONTE CASTELO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123402",
		"NOME_MUNICIPIO": "SANTA FE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123501",
		"NOME_MUNICIPIO": "SANTA HELENA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123600",
		"NOME_MUNICIPIO": "SANTA INÊS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123709",
		"NOME_MUNICIPIO": "SANTA ISABEL DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123808",
		"NOME_MUNICIPIO": "SANTA IZABEL DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123824",
		"NOME_MUNICIPIO": "SANTA LUCIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123857",
		"NOME_MUNICIPIO": "SANTA MARIA DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123907",
		"NOME_MUNICIPIO": "SANTA MARIANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4123956",
		"NOME_MUNICIPIO": "SANTA MÔNICA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124004",
		"NOME_MUNICIPIO": "SANTANA DO ITARARE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124020",
		"NOME_MUNICIPIO": "SANTA TEREZA DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124053",
		"NOME_MUNICIPIO": "SANTA TEREZINHA DE ITAIPU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124103",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DA PLATINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124202",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO CAIUA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124301",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO PARAISO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124400",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO SUDOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124509",
		"NOME_MUNICIPIO": "SANTO INACIO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124608",
		"NOME_MUNICIPIO": "SAO CARLOS DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124707",
		"NOME_MUNICIPIO": "SAO JERÔNIMO DA SERRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124806",
		"NOME_MUNICIPIO": "SAO JOAO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4124905",
		"NOME_MUNICIPIO": "SAO JOAO DO CAIUA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125001",
		"NOME_MUNICIPIO": "SAO JOAO DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125100",
		"NOME_MUNICIPIO": "SAO JOAO DO TRIUNFO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125209",
		"NOME_MUNICIPIO": "SAO JORGE DOESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125308",
		"NOME_MUNICIPIO": "SAO JORGE DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125357",
		"NOME_MUNICIPIO": "SAO JORGE DO PATROCINIO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125407",
		"NOME_MUNICIPIO": "SAO JOSE DA BOA VISTA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125456",
		"NOME_MUNICIPIO": "SAO JOSE DAS PALMEIRAS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125506",
		"NOME_MUNICIPIO": "SAO JOSE DOS PINHAIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125555",
		"NOME_MUNICIPIO": "SAO MANOEL DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125605",
		"NOME_MUNICIPIO": "SAO MATEUS DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125704",
		"NOME_MUNICIPIO": "SAO MIGUEL DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125753",
		"NOME_MUNICIPIO": "SAO PEDRO DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125803",
		"NOME_MUNICIPIO": "SAO PEDRO DO IVAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4125902",
		"NOME_MUNICIPIO": "SAO PEDRO DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126009",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DA AMOREIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126108",
		"NOME_MUNICIPIO": "SAO TOME",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126207",
		"NOME_MUNICIPIO": "SAPOPEMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126256",
		"NOME_MUNICIPIO": "SARANDI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126272",
		"NOME_MUNICIPIO": "SAUDADE DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126306",
		"NOME_MUNICIPIO": "SENGES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126355",
		"NOME_MUNICIPIO": "SERRANOPOLIS DO IGUAÇU",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126405",
		"NOME_MUNICIPIO": "SERTANEJA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126504",
		"NOME_MUNICIPIO": "SERTANOPOLIS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126603",
		"NOME_MUNICIPIO": "SIQUEIRA CAMPOS",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126652",
		"NOME_MUNICIPIO": "SULINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126678",
		"NOME_MUNICIPIO": "TAMARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126702",
		"NOME_MUNICIPIO": "TAMBOARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126801",
		"NOME_MUNICIPIO": "TAPEJARA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4126900",
		"NOME_MUNICIPIO": "TAPIRA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127007",
		"NOME_MUNICIPIO": "TEIXEIRA SOARES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127106",
		"NOME_MUNICIPIO": "TELÊMACO BORBA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127205",
		"NOME_MUNICIPIO": "TERRA BOA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127304",
		"NOME_MUNICIPIO": "TERRA RICA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127403",
		"NOME_MUNICIPIO": "TERRA ROXA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127502",
		"NOME_MUNICIPIO": "TIBAGI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127601",
		"NOME_MUNICIPIO": "TIJUCAS DO SUL",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127700",
		"NOME_MUNICIPIO": "TOLEDO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127809",
		"NOME_MUNICIPIO": "TOMAZINA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127858",
		"NOME_MUNICIPIO": "TRÊS BARRAS DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127882",
		"NOME_MUNICIPIO": "TUNAS DO PARANA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127908",
		"NOME_MUNICIPIO": "TUNEIRAS DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127957",
		"NOME_MUNICIPIO": "TUPASSI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4127965",
		"NOME_MUNICIPIO": "TURVO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128005",
		"NOME_MUNICIPIO": "UBIRATA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128104",
		"NOME_MUNICIPIO": "UMUARAMA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128203",
		"NOME_MUNICIPIO": "UNIAO DA VITORIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128302",
		"NOME_MUNICIPIO": "UNIFLOR",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128401",
		"NOME_MUNICIPIO": "URAI",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128500",
		"NOME_MUNICIPIO": "WENCESLAU BRAZ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128534",
		"NOME_MUNICIPIO": "VENTANIA",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128559",
		"NOME_MUNICIPIO": "VERA CRUZ DO OESTE",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128609",
		"NOME_MUNICIPIO": "VERÊ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128625",
		"NOME_MUNICIPIO": "ALTO PARAISO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128633",
		"NOME_MUNICIPIO": "DOUTOR ULYSSES",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128658",
		"NOME_MUNICIPIO": "VIRMOND",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128708",
		"NOME_MUNICIPIO": "VITORINO",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4128807",
		"NOME_MUNICIPIO": "XAMBRÊ",
		"COD_UF": "41"
	},
	{
		"COD_MUNICIPIO": "4200051",
		"NOME_MUNICIPIO": "ABDON BATISTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200101",
		"NOME_MUNICIPIO": "ABELARDO LUZ",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200200",
		"NOME_MUNICIPIO": "AGROLANDIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200309",
		"NOME_MUNICIPIO": "AGRONÔMICA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200408",
		"NOME_MUNICIPIO": "AGUA DOCE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200507",
		"NOME_MUNICIPIO": "AGUAS DE CHAPECO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200556",
		"NOME_MUNICIPIO": "AGUAS FRIAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200606",
		"NOME_MUNICIPIO": "AGUAS MORNAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200705",
		"NOME_MUNICIPIO": "ALFREDO WAGNER",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200754",
		"NOME_MUNICIPIO": "ALTO BELA VISTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200804",
		"NOME_MUNICIPIO": "ANCHIETA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4200903",
		"NOME_MUNICIPIO": "ANGELINA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201000",
		"NOME_MUNICIPIO": "ANITA GARIBALDI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201109",
		"NOME_MUNICIPIO": "ANITAPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201208",
		"NOME_MUNICIPIO": "ANTÔNIO CARLOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201257",
		"NOME_MUNICIPIO": "APIUNA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201273",
		"NOME_MUNICIPIO": "ARABUTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201307",
		"NOME_MUNICIPIO": "ARAQUARI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201406",
		"NOME_MUNICIPIO": "ARARANGUA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201505",
		"NOME_MUNICIPIO": "ARMAZEM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201604",
		"NOME_MUNICIPIO": "ARROIO TRINTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201653",
		"NOME_MUNICIPIO": "ARVOREDO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201703",
		"NOME_MUNICIPIO": "ASCURRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201802",
		"NOME_MUNICIPIO": "ATALANTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201901",
		"NOME_MUNICIPIO": "AURORA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4201950",
		"NOME_MUNICIPIO": "BALNEARIO ARROIO DO SILVA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202008",
		"NOME_MUNICIPIO": "BALNEARIO CAMBORIU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202057",
		"NOME_MUNICIPIO": "BALNEARIO BARRA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202073",
		"NOME_MUNICIPIO": "BALNEARIO GAIVOTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202081",
		"NOME_MUNICIPIO": "BANDEIRANTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202099",
		"NOME_MUNICIPIO": "BARRA BONITA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202107",
		"NOME_MUNICIPIO": "BARRA VELHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202131",
		"NOME_MUNICIPIO": "BELA VISTA DO TOLDO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202156",
		"NOME_MUNICIPIO": "BELMONTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202206",
		"NOME_MUNICIPIO": "BENEDITO NOVO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202305",
		"NOME_MUNICIPIO": "BIGUAÇU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202404",
		"NOME_MUNICIPIO": "BLUMENAU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202438",
		"NOME_MUNICIPIO": "BOCAINA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202453",
		"NOME_MUNICIPIO": "BOMBINHAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202503",
		"NOME_MUNICIPIO": "BOM JARDIM DA SERRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202537",
		"NOME_MUNICIPIO": "BOM JESUS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202578",
		"NOME_MUNICIPIO": "BOM JESUS DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202602",
		"NOME_MUNICIPIO": "BOM RETIRO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202701",
		"NOME_MUNICIPIO": "BOTUVERA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202800",
		"NOME_MUNICIPIO": "BRAÇO DO NORTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202859",
		"NOME_MUNICIPIO": "BRAÇO DO TROMBUDO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202875",
		"NOME_MUNICIPIO": "BRUNOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4202909",
		"NOME_MUNICIPIO": "BRUSQUE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203006",
		"NOME_MUNICIPIO": "CAÇADOR",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203105",
		"NOME_MUNICIPIO": "CAIBI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203154",
		"NOME_MUNICIPIO": "CALMON",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203204",
		"NOME_MUNICIPIO": "CAMBORIU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203253",
		"NOME_MUNICIPIO": "CAPAO ALTO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203303",
		"NOME_MUNICIPIO": "CAMPO ALEGRE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203402",
		"NOME_MUNICIPIO": "CAMPO BELO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203501",
		"NOME_MUNICIPIO": "CAMPO ERÊ",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203600",
		"NOME_MUNICIPIO": "CAMPOS NOVOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203709",
		"NOME_MUNICIPIO": "CANELINHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203808",
		"NOME_MUNICIPIO": "CANOINHAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203907",
		"NOME_MUNICIPIO": "CAPINZAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4203956",
		"NOME_MUNICIPIO": "CAPIVARI DE BAIXO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204004",
		"NOME_MUNICIPIO": "CATANDUVAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204103",
		"NOME_MUNICIPIO": "CAXAMBU DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204152",
		"NOME_MUNICIPIO": "CELSO RAMOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204178",
		"NOME_MUNICIPIO": "CERRO NEGRO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204194",
		"NOME_MUNICIPIO": "CHAPADAO DO LAGEADO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204202",
		"NOME_MUNICIPIO": "CHAPECO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204251",
		"NOME_MUNICIPIO": "COCAL DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204301",
		"NOME_MUNICIPIO": "CONCORDIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204350",
		"NOME_MUNICIPIO": "CORDILHEIRA ALTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204400",
		"NOME_MUNICIPIO": "CORONEL FREITAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204459",
		"NOME_MUNICIPIO": "CORONEL MARTINS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204509",
		"NOME_MUNICIPIO": "CORUPA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204558",
		"NOME_MUNICIPIO": "CORREIA PINTO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204608",
		"NOME_MUNICIPIO": "CRICIUMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204707",
		"NOME_MUNICIPIO": "CUNHA PORA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204756",
		"NOME_MUNICIPIO": "CUNHATAI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204806",
		"NOME_MUNICIPIO": "CURITIBANOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4204905",
		"NOME_MUNICIPIO": "DESCANSO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205001",
		"NOME_MUNICIPIO": "DIONISIO CERQUEIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205100",
		"NOME_MUNICIPIO": "DONA EMMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205159",
		"NOME_MUNICIPIO": "DOUTOR PEDRINHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205175",
		"NOME_MUNICIPIO": "ENTRE RIOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205191",
		"NOME_MUNICIPIO": "ERMO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205209",
		"NOME_MUNICIPIO": "ERVAL VELHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205308",
		"NOME_MUNICIPIO": "FAXINAL DOS GUEDES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205357",
		"NOME_MUNICIPIO": "FLOR DO SERTAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205407",
		"NOME_MUNICIPIO": "FLORIANOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205431",
		"NOME_MUNICIPIO": "FORMOSA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205456",
		"NOME_MUNICIPIO": "FORQUILHINHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205506",
		"NOME_MUNICIPIO": "FRAIBURGO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205555",
		"NOME_MUNICIPIO": "FREI ROGERIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205605",
		"NOME_MUNICIPIO": "GALVAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205704",
		"NOME_MUNICIPIO": "GAROPABA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205803",
		"NOME_MUNICIPIO": "GARUVA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4205902",
		"NOME_MUNICIPIO": "GASPAR",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206009",
		"NOME_MUNICIPIO": "GOVERNADOR CELSO RAMOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206108",
		"NOME_MUNICIPIO": "GRAO PARA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206207",
		"NOME_MUNICIPIO": "GRAVATAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206306",
		"NOME_MUNICIPIO": "GUABIRUBA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206405",
		"NOME_MUNICIPIO": "GUARACIABA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206504",
		"NOME_MUNICIPIO": "GUARAMIRIM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206603",
		"NOME_MUNICIPIO": "GUARUJA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206652",
		"NOME_MUNICIPIO": "GUATAMBU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206702",
		"NOME_MUNICIPIO": "HERVAL DOESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206751",
		"NOME_MUNICIPIO": "IBIAM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206801",
		"NOME_MUNICIPIO": "IBICARE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4206900",
		"NOME_MUNICIPIO": "IBIRAMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207007",
		"NOME_MUNICIPIO": "IÇARA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207106",
		"NOME_MUNICIPIO": "ILHOTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207205",
		"NOME_MUNICIPIO": "IMARUI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207304",
		"NOME_MUNICIPIO": "IMBITUBA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207403",
		"NOME_MUNICIPIO": "IMBUIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207502",
		"NOME_MUNICIPIO": "INDAIAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207577",
		"NOME_MUNICIPIO": "IOMERÊ",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207601",
		"NOME_MUNICIPIO": "IPIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207650",
		"NOME_MUNICIPIO": "IPORA DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207684",
		"NOME_MUNICIPIO": "IPUAÇU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207700",
		"NOME_MUNICIPIO": "IPUMIRIM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207759",
		"NOME_MUNICIPIO": "IRACEMINHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207809",
		"NOME_MUNICIPIO": "IRANI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207858",
		"NOME_MUNICIPIO": "IRATI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4207908",
		"NOME_MUNICIPIO": "IRINEOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208005",
		"NOME_MUNICIPIO": "ITA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208104",
		"NOME_MUNICIPIO": "ITAIOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208203",
		"NOME_MUNICIPIO": "ITAJAI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208302",
		"NOME_MUNICIPIO": "ITAPEMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208401",
		"NOME_MUNICIPIO": "ITAPIRANGA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208450",
		"NOME_MUNICIPIO": "ITAPOA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208500",
		"NOME_MUNICIPIO": "ITUPORANGA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208609",
		"NOME_MUNICIPIO": "JABORA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208708",
		"NOME_MUNICIPIO": "JACINTO MACHADO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208807",
		"NOME_MUNICIPIO": "JAGUARUNA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208906",
		"NOME_MUNICIPIO": "JARAGUA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4208955",
		"NOME_MUNICIPIO": "JARDINOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209003",
		"NOME_MUNICIPIO": "JOAÇABA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209102",
		"NOME_MUNICIPIO": "JOINVILLE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209151",
		"NOME_MUNICIPIO": "JOSE BOITEUX",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209177",
		"NOME_MUNICIPIO": "JUPIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209201",
		"NOME_MUNICIPIO": "LACERDOPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209300",
		"NOME_MUNICIPIO": "LAGES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209409",
		"NOME_MUNICIPIO": "LAGUNA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209458",
		"NOME_MUNICIPIO": "LAJEADO GRANDE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209508",
		"NOME_MUNICIPIO": "LAURENTINO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209607",
		"NOME_MUNICIPIO": "LAURO MÜLLER",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209706",
		"NOME_MUNICIPIO": "LEBON REGIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209805",
		"NOME_MUNICIPIO": "LEOBERTO LEAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209854",
		"NOME_MUNICIPIO": "LINDOIA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4209904",
		"NOME_MUNICIPIO": "LONTRAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210001",
		"NOME_MUNICIPIO": "LUIZ ALVES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210035",
		"NOME_MUNICIPIO": "LUZERNA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210050",
		"NOME_MUNICIPIO": "MACIEIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210100",
		"NOME_MUNICIPIO": "MAFRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210209",
		"NOME_MUNICIPIO": "MAJOR GERCINO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210308",
		"NOME_MUNICIPIO": "MAJOR VIEIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210407",
		"NOME_MUNICIPIO": "MARACAJA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210506",
		"NOME_MUNICIPIO": "MARAVILHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210555",
		"NOME_MUNICIPIO": "MAREMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210605",
		"NOME_MUNICIPIO": "MASSARANDUBA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210704",
		"NOME_MUNICIPIO": "MATOS COSTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210803",
		"NOME_MUNICIPIO": "MELEIRO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210852",
		"NOME_MUNICIPIO": "MIRIM DOCE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4210902",
		"NOME_MUNICIPIO": "MODELO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211009",
		"NOME_MUNICIPIO": "MONDAI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211058",
		"NOME_MUNICIPIO": "MONTE CARLO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211108",
		"NOME_MUNICIPIO": "MONTE CASTELO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211207",
		"NOME_MUNICIPIO": "MORRO DA FUMAÇA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211256",
		"NOME_MUNICIPIO": "MORRO GRANDE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211306",
		"NOME_MUNICIPIO": "NAVEGANTES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211405",
		"NOME_MUNICIPIO": "NOVA ERECHIM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211454",
		"NOME_MUNICIPIO": "NOVA ITABERABA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211504",
		"NOME_MUNICIPIO": "NOVA TRENTO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211603",
		"NOME_MUNICIPIO": "NOVA VENEZA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211652",
		"NOME_MUNICIPIO": "NOVO HORIZONTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211702",
		"NOME_MUNICIPIO": "ORLEANS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211751",
		"NOME_MUNICIPIO": "OTACILIO COSTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211801",
		"NOME_MUNICIPIO": "OURO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211850",
		"NOME_MUNICIPIO": "OURO VERDE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211876",
		"NOME_MUNICIPIO": "PAIAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211892",
		"NOME_MUNICIPIO": "PAINEL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4211900",
		"NOME_MUNICIPIO": "PALHOÇA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212007",
		"NOME_MUNICIPIO": "PALMA SOLA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212056",
		"NOME_MUNICIPIO": "PALMEIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212106",
		"NOME_MUNICIPIO": "PALMITOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212205",
		"NOME_MUNICIPIO": "PAPANDUVA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212239",
		"NOME_MUNICIPIO": "PARAISO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212254",
		"NOME_MUNICIPIO": "PASSO DE TORRES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212270",
		"NOME_MUNICIPIO": "PASSOS MAIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212304",
		"NOME_MUNICIPIO": "PAULO LOPES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212403",
		"NOME_MUNICIPIO": "PEDRAS GRANDES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212502",
		"NOME_MUNICIPIO": "PENHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212601",
		"NOME_MUNICIPIO": "PERITIBA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212650",
		"NOME_MUNICIPIO": "PESCARIA BRAVA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212700",
		"NOME_MUNICIPIO": "PETROLANDIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212809",
		"NOME_MUNICIPIO": "BALNEARIO PIÇARRAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4212908",
		"NOME_MUNICIPIO": "PINHALZINHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213005",
		"NOME_MUNICIPIO": "PINHEIRO PRETO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213104",
		"NOME_MUNICIPIO": "PIRATUBA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213153",
		"NOME_MUNICIPIO": "PLANALTO ALEGRE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213203",
		"NOME_MUNICIPIO": "POMERODE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213302",
		"NOME_MUNICIPIO": "PONTE ALTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213351",
		"NOME_MUNICIPIO": "PONTE ALTA DO NORTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213401",
		"NOME_MUNICIPIO": "PONTE SERRADA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213500",
		"NOME_MUNICIPIO": "PORTO BELO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213609",
		"NOME_MUNICIPIO": "PORTO UNIAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213708",
		"NOME_MUNICIPIO": "POUSO REDONDO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213807",
		"NOME_MUNICIPIO": "PRAIA GRANDE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4213906",
		"NOME_MUNICIPIO": "PRESIDENTE CASTELLO BRANCO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214003",
		"NOME_MUNICIPIO": "PRESIDENTE GETULIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214102",
		"NOME_MUNICIPIO": "PRESIDENTE NEREU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214151",
		"NOME_MUNICIPIO": "PRINCESA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214201",
		"NOME_MUNICIPIO": "QUILOMBO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214300",
		"NOME_MUNICIPIO": "RANCHO QUEIMADO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214409",
		"NOME_MUNICIPIO": "RIO DAS ANTAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214508",
		"NOME_MUNICIPIO": "RIO DO CAMPO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214607",
		"NOME_MUNICIPIO": "RIO DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214706",
		"NOME_MUNICIPIO": "RIO DOS CEDROS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214805",
		"NOME_MUNICIPIO": "RIO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4214904",
		"NOME_MUNICIPIO": "RIO FORTUNA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215000",
		"NOME_MUNICIPIO": "RIO NEGRINHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215059",
		"NOME_MUNICIPIO": "RIO RUFINO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215075",
		"NOME_MUNICIPIO": "RIQUEZA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215109",
		"NOME_MUNICIPIO": "RODEIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215208",
		"NOME_MUNICIPIO": "ROMELANDIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215307",
		"NOME_MUNICIPIO": "SALETE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215356",
		"NOME_MUNICIPIO": "SALTINHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215406",
		"NOME_MUNICIPIO": "SALTO VELOSO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215455",
		"NOME_MUNICIPIO": "SANGAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215505",
		"NOME_MUNICIPIO": "SANTA CECILIA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215554",
		"NOME_MUNICIPIO": "SANTA HELENA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215604",
		"NOME_MUNICIPIO": "SANTA ROSA DE LIMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215653",
		"NOME_MUNICIPIO": "SANTA ROSA DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215679",
		"NOME_MUNICIPIO": "SANTA TEREZINHA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215687",
		"NOME_MUNICIPIO": "SANTA TEREZINHA DO PROGRESSO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215695",
		"NOME_MUNICIPIO": "SANTIAGO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215703",
		"NOME_MUNICIPIO": "SANTO AMARO DA IMPERATRIZ",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215752",
		"NOME_MUNICIPIO": "SAO BERNARDINO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215802",
		"NOME_MUNICIPIO": "SAO BENTO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4215901",
		"NOME_MUNICIPIO": "SAO BONIFACIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216008",
		"NOME_MUNICIPIO": "SAO CARLOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216057",
		"NOME_MUNICIPIO": "SAO CRISTOVAO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216107",
		"NOME_MUNICIPIO": "SAO DOMINGOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216206",
		"NOME_MUNICIPIO": "SAO FRANCISCO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216255",
		"NOME_MUNICIPIO": "SAO JOAO DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216305",
		"NOME_MUNICIPIO": "SAO JOAO BATISTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216354",
		"NOME_MUNICIPIO": "SAO JOAO DO ITAPERIU",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216404",
		"NOME_MUNICIPIO": "SAO JOAO DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216503",
		"NOME_MUNICIPIO": "SAO JOAQUIM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216602",
		"NOME_MUNICIPIO": "SAO JOSE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216701",
		"NOME_MUNICIPIO": "SAO JOSE DO CEDRO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216800",
		"NOME_MUNICIPIO": "SAO JOSE DO CERRITO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4216909",
		"NOME_MUNICIPIO": "SAO LOURENÇO DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217006",
		"NOME_MUNICIPIO": "SAO LUDGERO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217105",
		"NOME_MUNICIPIO": "SAO MARTINHO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217154",
		"NOME_MUNICIPIO": "SAO MIGUEL DA BOA VISTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217204",
		"NOME_MUNICIPIO": "SAO MIGUEL DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217253",
		"NOME_MUNICIPIO": "SAO PEDRO DE ALCANTARA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217303",
		"NOME_MUNICIPIO": "SAUDADES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217402",
		"NOME_MUNICIPIO": "SCHROEDER",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217501",
		"NOME_MUNICIPIO": "SEARA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217550",
		"NOME_MUNICIPIO": "SERRA ALTA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217600",
		"NOME_MUNICIPIO": "SIDEROPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217709",
		"NOME_MUNICIPIO": "SOMBRIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217758",
		"NOME_MUNICIPIO": "SUL BRASIL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217808",
		"NOME_MUNICIPIO": "TAIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217907",
		"NOME_MUNICIPIO": "TANGARA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4217956",
		"NOME_MUNICIPIO": "TIGRINHOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218004",
		"NOME_MUNICIPIO": "TIJUCAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218103",
		"NOME_MUNICIPIO": "TIMBE DO SUL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218202",
		"NOME_MUNICIPIO": "TIMBO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218251",
		"NOME_MUNICIPIO": "TIMBO GRANDE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218301",
		"NOME_MUNICIPIO": "TRÊS BARRAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218350",
		"NOME_MUNICIPIO": "TREVISO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218400",
		"NOME_MUNICIPIO": "TREZE DE MAIO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218509",
		"NOME_MUNICIPIO": "TREZE TILIAS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218608",
		"NOME_MUNICIPIO": "TROMBUDO CENTRAL",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218707",
		"NOME_MUNICIPIO": "TUBARAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218756",
		"NOME_MUNICIPIO": "TUNAPOLIS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218806",
		"NOME_MUNICIPIO": "TURVO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218855",
		"NOME_MUNICIPIO": "UNIAO DO OESTE",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218905",
		"NOME_MUNICIPIO": "URUBICI",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4218954",
		"NOME_MUNICIPIO": "URUPEMA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219002",
		"NOME_MUNICIPIO": "URUSSANGA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219101",
		"NOME_MUNICIPIO": "VARGEAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219150",
		"NOME_MUNICIPIO": "VARGEM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219176",
		"NOME_MUNICIPIO": "VARGEM BONITA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219200",
		"NOME_MUNICIPIO": "VIDAL RAMOS",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219309",
		"NOME_MUNICIPIO": "VIDEIRA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219358",
		"NOME_MUNICIPIO": "VITOR MEIRELES",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219408",
		"NOME_MUNICIPIO": "WITMARSUM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219507",
		"NOME_MUNICIPIO": "XANXERÊ",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219606",
		"NOME_MUNICIPIO": "XAVANTINA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219705",
		"NOME_MUNICIPIO": "XAXIM",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4219853",
		"NOME_MUNICIPIO": "ZORTEA",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4220000",
		"NOME_MUNICIPIO": "BALNEARIO RINCAO",
		"COD_UF": "42"
	},
	{
		"COD_MUNICIPIO": "4300034",
		"NOME_MUNICIPIO": "ACEGUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300059",
		"NOME_MUNICIPIO": "AGUA SANTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300109",
		"NOME_MUNICIPIO": "AGUDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300208",
		"NOME_MUNICIPIO": "AJURICABA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300307",
		"NOME_MUNICIPIO": "ALECRIM",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300406",
		"NOME_MUNICIPIO": "ALEGRETE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300455",
		"NOME_MUNICIPIO": "ALEGRIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300471",
		"NOME_MUNICIPIO": "ALMIRANTE TAMANDARE DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300505",
		"NOME_MUNICIPIO": "ALPESTRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300554",
		"NOME_MUNICIPIO": "ALTO ALEGRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300570",
		"NOME_MUNICIPIO": "ALTO FELIZ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300604",
		"NOME_MUNICIPIO": "ALVORADA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300638",
		"NOME_MUNICIPIO": "AMARAL FERRADOR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300646",
		"NOME_MUNICIPIO": "AMETISTA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300661",
		"NOME_MUNICIPIO": "ANDRE DA ROCHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300703",
		"NOME_MUNICIPIO": "ANTA GORDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300802",
		"NOME_MUNICIPIO": "ANTÔNIO PRADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300851",
		"NOME_MUNICIPIO": "ARAMBARE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300877",
		"NOME_MUNICIPIO": "ARARICA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4300901",
		"NOME_MUNICIPIO": "ARATIBA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301008",
		"NOME_MUNICIPIO": "ARROIO DO MEIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301057",
		"NOME_MUNICIPIO": "ARROIO DO SAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301073",
		"NOME_MUNICIPIO": "ARROIO DO PADRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301107",
		"NOME_MUNICIPIO": "ARROIO DOS RATOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301206",
		"NOME_MUNICIPIO": "ARROIO DO TIGRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301305",
		"NOME_MUNICIPIO": "ARROIO GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301404",
		"NOME_MUNICIPIO": "ARVOREZINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301503",
		"NOME_MUNICIPIO": "AUGUSTO PESTANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301552",
		"NOME_MUNICIPIO": "AUREA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301602",
		"NOME_MUNICIPIO": "BAGE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301636",
		"NOME_MUNICIPIO": "BALNEARIO PINHAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301651",
		"NOME_MUNICIPIO": "BARAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301701",
		"NOME_MUNICIPIO": "BARAO DE COTEGIPE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301750",
		"NOME_MUNICIPIO": "BARAO DO TRIUNFO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301800",
		"NOME_MUNICIPIO": "BARRACAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301859",
		"NOME_MUNICIPIO": "BARRA DO GUARITA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301875",
		"NOME_MUNICIPIO": "BARRA DO QUARAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301909",
		"NOME_MUNICIPIO": "BARRA DO RIBEIRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301925",
		"NOME_MUNICIPIO": "BARRA DO RIO AZUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4301958",
		"NOME_MUNICIPIO": "BARRA FUNDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302006",
		"NOME_MUNICIPIO": "BARROS CASSAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302055",
		"NOME_MUNICIPIO": "BENJAMIN CONSTANT DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302105",
		"NOME_MUNICIPIO": "BENTO GONÇALVES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302154",
		"NOME_MUNICIPIO": "BOA VISTA DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302204",
		"NOME_MUNICIPIO": "BOA VISTA DO BURICA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302220",
		"NOME_MUNICIPIO": "BOA VISTA DO CADEADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302238",
		"NOME_MUNICIPIO": "BOA VISTA DO INCRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302253",
		"NOME_MUNICIPIO": "BOA VISTA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302303",
		"NOME_MUNICIPIO": "BOM JESUS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302352",
		"NOME_MUNICIPIO": "BOM PRINCIPIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302378",
		"NOME_MUNICIPIO": "BOM PROGRESSO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302402",
		"NOME_MUNICIPIO": "BOM RETIRO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302451",
		"NOME_MUNICIPIO": "BOQUEIRAO DO LEAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302501",
		"NOME_MUNICIPIO": "BOSSOROCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302584",
		"NOME_MUNICIPIO": "BOZANO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302600",
		"NOME_MUNICIPIO": "BRAGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302659",
		"NOME_MUNICIPIO": "BROCHIER",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302709",
		"NOME_MUNICIPIO": "BUTIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302808",
		"NOME_MUNICIPIO": "CAÇAPAVA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4302907",
		"NOME_MUNICIPIO": "CACEQUI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303004",
		"NOME_MUNICIPIO": "CACHOEIRA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303103",
		"NOME_MUNICIPIO": "CACHOEIRINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303202",
		"NOME_MUNICIPIO": "CACIQUE DOBLE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303301",
		"NOME_MUNICIPIO": "CAIBATE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303400",
		"NOME_MUNICIPIO": "CAIÇARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303509",
		"NOME_MUNICIPIO": "CAMAQUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303558",
		"NOME_MUNICIPIO": "CAMARGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303608",
		"NOME_MUNICIPIO": "CAMBARA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303673",
		"NOME_MUNICIPIO": "CAMPESTRE DA SERRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303707",
		"NOME_MUNICIPIO": "CAMPINA DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303806",
		"NOME_MUNICIPIO": "CAMPINAS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4303905",
		"NOME_MUNICIPIO": "CAMPO BOM",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304002",
		"NOME_MUNICIPIO": "CAMPO NOVO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304101",
		"NOME_MUNICIPIO": "CAMPOS BORGES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304200",
		"NOME_MUNICIPIO": "CANDELARIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304309",
		"NOME_MUNICIPIO": "CANDIDO GODOI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304358",
		"NOME_MUNICIPIO": "CANDIOTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304408",
		"NOME_MUNICIPIO": "CANELA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304507",
		"NOME_MUNICIPIO": "CANGUÇU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304606",
		"NOME_MUNICIPIO": "CANOAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304614",
		"NOME_MUNICIPIO": "CANUDOS DO VALE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304622",
		"NOME_MUNICIPIO": "CAPAO BONITO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304630",
		"NOME_MUNICIPIO": "CAPAO DA CANOA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304655",
		"NOME_MUNICIPIO": "CAPAO DO CIPO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304663",
		"NOME_MUNICIPIO": "CAPAO DO LEAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304671",
		"NOME_MUNICIPIO": "CAPIVARI DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304689",
		"NOME_MUNICIPIO": "CAPELA DE SANTANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304697",
		"NOME_MUNICIPIO": "CAPITAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304705",
		"NOME_MUNICIPIO": "CARAZINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304713",
		"NOME_MUNICIPIO": "CARAA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304804",
		"NOME_MUNICIPIO": "CARLOS BARBOSA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304853",
		"NOME_MUNICIPIO": "CARLOS GOMES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304903",
		"NOME_MUNICIPIO": "CASCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4304952",
		"NOME_MUNICIPIO": "CASEIROS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305009",
		"NOME_MUNICIPIO": "CATUIPE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305108",
		"NOME_MUNICIPIO": "CAXIAS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305116",
		"NOME_MUNICIPIO": "CENTENARIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305124",
		"NOME_MUNICIPIO": "CERRITO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305132",
		"NOME_MUNICIPIO": "CERRO BRANCO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305157",
		"NOME_MUNICIPIO": "CERRO GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305173",
		"NOME_MUNICIPIO": "CERRO GRANDE DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305207",
		"NOME_MUNICIPIO": "CERRO LARGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305306",
		"NOME_MUNICIPIO": "CHAPADA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305355",
		"NOME_MUNICIPIO": "CHARQUEADAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305371",
		"NOME_MUNICIPIO": "CHARRUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305405",
		"NOME_MUNICIPIO": "CHIAPETTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305439",
		"NOME_MUNICIPIO": "CHUI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305447",
		"NOME_MUNICIPIO": "CHUVISCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305454",
		"NOME_MUNICIPIO": "CIDREIRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305504",
		"NOME_MUNICIPIO": "CIRIACO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305587",
		"NOME_MUNICIPIO": "COLINAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305603",
		"NOME_MUNICIPIO": "COLORADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305702",
		"NOME_MUNICIPIO": "CONDOR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305801",
		"NOME_MUNICIPIO": "CONSTANTINA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305835",
		"NOME_MUNICIPIO": "COQUEIRO BAIXO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305850",
		"NOME_MUNICIPIO": "COQUEIROS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305871",
		"NOME_MUNICIPIO": "CORONEL BARROS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305900",
		"NOME_MUNICIPIO": "CORONEL BICACO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305934",
		"NOME_MUNICIPIO": "CORONEL PILAR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305959",
		"NOME_MUNICIPIO": "COTIPORA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4305975",
		"NOME_MUNICIPIO": "COXILHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306007",
		"NOME_MUNICIPIO": "CRISSIUMAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306056",
		"NOME_MUNICIPIO": "CRISTAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306072",
		"NOME_MUNICIPIO": "CRISTAL DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306106",
		"NOME_MUNICIPIO": "CRUZ ALTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306130",
		"NOME_MUNICIPIO": "CRUZALTENSE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306205",
		"NOME_MUNICIPIO": "CRUZEIRO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306304",
		"NOME_MUNICIPIO": "DAVID CANABARRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306320",
		"NOME_MUNICIPIO": "DERRUBADAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306353",
		"NOME_MUNICIPIO": "DEZESSEIS DE NOVEMBRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306379",
		"NOME_MUNICIPIO": "DILERMANDO DE AGUIAR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306403",
		"NOME_MUNICIPIO": "DOIS IRMAOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306429",
		"NOME_MUNICIPIO": "DOIS IRMAOS DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306452",
		"NOME_MUNICIPIO": "DOIS LAJEADOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306502",
		"NOME_MUNICIPIO": "DOM FELICIANO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306551",
		"NOME_MUNICIPIO": "DOM PEDRO DE ALCANTARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306601",
		"NOME_MUNICIPIO": "DOM PEDRITO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306700",
		"NOME_MUNICIPIO": "DONA FRANCISCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306734",
		"NOME_MUNICIPIO": "DOUTOR MAURICIO CARDOSO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306759",
		"NOME_MUNICIPIO": "DOUTOR RICARDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306767",
		"NOME_MUNICIPIO": "ELDORADO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306809",
		"NOME_MUNICIPIO": "ENCANTADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306908",
		"NOME_MUNICIPIO": "ENCRUZILHADA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306924",
		"NOME_MUNICIPIO": "ENGENHO VELHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306932",
		"NOME_MUNICIPIO": "ENTRE-IJUIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306957",
		"NOME_MUNICIPIO": "ENTRE RIOS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4306973",
		"NOME_MUNICIPIO": "EREBANGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307005",
		"NOME_MUNICIPIO": "ERECHIM",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307054",
		"NOME_MUNICIPIO": "ERNESTINA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307104",
		"NOME_MUNICIPIO": "HERVAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307203",
		"NOME_MUNICIPIO": "ERVAL GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307302",
		"NOME_MUNICIPIO": "ERVAL SECO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307401",
		"NOME_MUNICIPIO": "ESMERALDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307450",
		"NOME_MUNICIPIO": "ESPERANÇA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307500",
		"NOME_MUNICIPIO": "ESPUMOSO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307559",
		"NOME_MUNICIPIO": "ESTAÇAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307609",
		"NOME_MUNICIPIO": "ESTANCIA VELHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307708",
		"NOME_MUNICIPIO": "ESTEIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307807",
		"NOME_MUNICIPIO": "ESTRELA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307815",
		"NOME_MUNICIPIO": "ESTRELA VELHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307831",
		"NOME_MUNICIPIO": "EUGÊNIO DE CASTRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307864",
		"NOME_MUNICIPIO": "FAGUNDES VARELA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4307906",
		"NOME_MUNICIPIO": "FARROUPILHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308003",
		"NOME_MUNICIPIO": "FAXINAL DO SOTURNO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308052",
		"NOME_MUNICIPIO": "FAXINALZINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308078",
		"NOME_MUNICIPIO": "FAZENDA VILANOVA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308102",
		"NOME_MUNICIPIO": "FELIZ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308201",
		"NOME_MUNICIPIO": "FLORES DA CUNHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308250",
		"NOME_MUNICIPIO": "FLORIANO PEIXOTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308300",
		"NOME_MUNICIPIO": "FONTOURA XAVIER",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308409",
		"NOME_MUNICIPIO": "FORMIGUEIRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308433",
		"NOME_MUNICIPIO": "FORQUETINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308458",
		"NOME_MUNICIPIO": "FORTALEZA DOS VALOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308508",
		"NOME_MUNICIPIO": "FREDERICO WESTPHALEN",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308607",
		"NOME_MUNICIPIO": "GARIBALDI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308656",
		"NOME_MUNICIPIO": "GARRUCHOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308706",
		"NOME_MUNICIPIO": "GAURAMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308805",
		"NOME_MUNICIPIO": "GENERAL CAMARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308854",
		"NOME_MUNICIPIO": "GENTIL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4308904",
		"NOME_MUNICIPIO": "GETULIO VARGAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309001",
		"NOME_MUNICIPIO": "GIRUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309050",
		"NOME_MUNICIPIO": "GLORINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309100",
		"NOME_MUNICIPIO": "GRAMADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309126",
		"NOME_MUNICIPIO": "GRAMADO DOS LOUREIROS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309159",
		"NOME_MUNICIPIO": "GRAMADO XAVIER",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309209",
		"NOME_MUNICIPIO": "GRAVATAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309258",
		"NOME_MUNICIPIO": "GUABIJU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309308",
		"NOME_MUNICIPIO": "GUAIBA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309407",
		"NOME_MUNICIPIO": "GUAPORE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309506",
		"NOME_MUNICIPIO": "GUARANI DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309555",
		"NOME_MUNICIPIO": "HARMONIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309571",
		"NOME_MUNICIPIO": "HERVEIRAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309605",
		"NOME_MUNICIPIO": "HORIZONTINA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309654",
		"NOME_MUNICIPIO": "HULHA NEGRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309704",
		"NOME_MUNICIPIO": "HUMAITA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309753",
		"NOME_MUNICIPIO": "IBARAMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309803",
		"NOME_MUNICIPIO": "IBIAÇA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309902",
		"NOME_MUNICIPIO": "IBIRAIARAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4309951",
		"NOME_MUNICIPIO": "IBIRAPUITA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310009",
		"NOME_MUNICIPIO": "IBIRUBA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310108",
		"NOME_MUNICIPIO": "IGREJINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310207",
		"NOME_MUNICIPIO": "IJUI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310306",
		"NOME_MUNICIPIO": "ILOPOLIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310330",
		"NOME_MUNICIPIO": "IMBE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310363",
		"NOME_MUNICIPIO": "IMIGRANTE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310405",
		"NOME_MUNICIPIO": "INDEPENDÊNCIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310413",
		"NOME_MUNICIPIO": "INHACORA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310439",
		"NOME_MUNICIPIO": "IPÊ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310462",
		"NOME_MUNICIPIO": "IPIRANGA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310504",
		"NOME_MUNICIPIO": "IRAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310538",
		"NOME_MUNICIPIO": "ITAARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310553",
		"NOME_MUNICIPIO": "ITACURUBI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310579",
		"NOME_MUNICIPIO": "ITAPUCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310603",
		"NOME_MUNICIPIO": "ITAQUI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310652",
		"NOME_MUNICIPIO": "ITATI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310702",
		"NOME_MUNICIPIO": "ITATIBA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310751",
		"NOME_MUNICIPIO": "IVORA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310801",
		"NOME_MUNICIPIO": "IVOTI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310850",
		"NOME_MUNICIPIO": "JABOTICABA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310876",
		"NOME_MUNICIPIO": "JACUIZINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4310900",
		"NOME_MUNICIPIO": "JACUTINGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311007",
		"NOME_MUNICIPIO": "JAGUARAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311106",
		"NOME_MUNICIPIO": "JAGUARI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311122",
		"NOME_MUNICIPIO": "JAQUIRANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311130",
		"NOME_MUNICIPIO": "JARI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311155",
		"NOME_MUNICIPIO": "JOIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311205",
		"NOME_MUNICIPIO": "JULIO DE CASTILHOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311239",
		"NOME_MUNICIPIO": "LAGOA BONITA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311254",
		"NOME_MUNICIPIO": "LAGOAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311270",
		"NOME_MUNICIPIO": "LAGOA DOS TRÊS CANTOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311304",
		"NOME_MUNICIPIO": "LAGOA VERMELHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311403",
		"NOME_MUNICIPIO": "LAJEADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311429",
		"NOME_MUNICIPIO": "LAJEADO DO BUGRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311502",
		"NOME_MUNICIPIO": "LAVRAS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311601",
		"NOME_MUNICIPIO": "LIBERATO SALZANO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311627",
		"NOME_MUNICIPIO": "LINDOLFO COLLOR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311643",
		"NOME_MUNICIPIO": "LINHA NOVA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311700",
		"NOME_MUNICIPIO": "MACHADINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311718",
		"NOME_MUNICIPIO": "MAÇAMBARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311734",
		"NOME_MUNICIPIO": "MAMPITUBA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311759",
		"NOME_MUNICIPIO": "MANOEL VIANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311775",
		"NOME_MUNICIPIO": "MAQUINE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311791",
		"NOME_MUNICIPIO": "MARATA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311809",
		"NOME_MUNICIPIO": "MARAU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311908",
		"NOME_MUNICIPIO": "MARCELINO RAMOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4311981",
		"NOME_MUNICIPIO": "MARIANA PIMENTEL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312005",
		"NOME_MUNICIPIO": "MARIANO MORO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312054",
		"NOME_MUNICIPIO": "MARQUES DE SOUZA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312104",
		"NOME_MUNICIPIO": "MATA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312138",
		"NOME_MUNICIPIO": "MATO CASTELHANO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312153",
		"NOME_MUNICIPIO": "MATO LEITAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312179",
		"NOME_MUNICIPIO": "MATO QUEIMADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312203",
		"NOME_MUNICIPIO": "MAXIMILIANO DE ALMEIDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312252",
		"NOME_MUNICIPIO": "MINAS DO LEAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312302",
		"NOME_MUNICIPIO": "MIRAGUAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312351",
		"NOME_MUNICIPIO": "MONTAURI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312377",
		"NOME_MUNICIPIO": "MONTE ALEGRE DOS CAMPOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312385",
		"NOME_MUNICIPIO": "MONTE BELO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312401",
		"NOME_MUNICIPIO": "MONTENEGRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312427",
		"NOME_MUNICIPIO": "MORMAÇO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312443",
		"NOME_MUNICIPIO": "MORRINHOS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312450",
		"NOME_MUNICIPIO": "MORRO REDONDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312476",
		"NOME_MUNICIPIO": "MORRO REUTER",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312500",
		"NOME_MUNICIPIO": "MOSTARDAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312609",
		"NOME_MUNICIPIO": "MUÇUM",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312617",
		"NOME_MUNICIPIO": "MUITOS CAPÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312625",
		"NOME_MUNICIPIO": "MULITERNO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312658",
		"NOME_MUNICIPIO": "NAO-ME-TOQUE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312674",
		"NOME_MUNICIPIO": "NICOLAU VERGUEIRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312708",
		"NOME_MUNICIPIO": "NONOAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312757",
		"NOME_MUNICIPIO": "NOVA ALVORADA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312807",
		"NOME_MUNICIPIO": "NOVA ARAÇA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312906",
		"NOME_MUNICIPIO": "NOVA BASSANO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4312955",
		"NOME_MUNICIPIO": "NOVA BOA VISTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313003",
		"NOME_MUNICIPIO": "NOVA BRESCIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313011",
		"NOME_MUNICIPIO": "NOVA CANDELARIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313037",
		"NOME_MUNICIPIO": "NOVA ESPERANÇA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313060",
		"NOME_MUNICIPIO": "NOVA HARTZ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313086",
		"NOME_MUNICIPIO": "NOVA PADUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313102",
		"NOME_MUNICIPIO": "NOVA PALMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313201",
		"NOME_MUNICIPIO": "NOVA PETROPOLIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313300",
		"NOME_MUNICIPIO": "NOVA PRATA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313334",
		"NOME_MUNICIPIO": "NOVA RAMADA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313359",
		"NOME_MUNICIPIO": "NOVA ROMA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313375",
		"NOME_MUNICIPIO": "NOVA SANTA RITA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313391",
		"NOME_MUNICIPIO": "NOVO CABRAIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313409",
		"NOME_MUNICIPIO": "NOVO HAMBURGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313425",
		"NOME_MUNICIPIO": "NOVO MACHADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313441",
		"NOME_MUNICIPIO": "NOVO TIRADENTES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313466",
		"NOME_MUNICIPIO": "NOVO XINGU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313490",
		"NOME_MUNICIPIO": "NOVO BARREIRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313508",
		"NOME_MUNICIPIO": "OSORIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313607",
		"NOME_MUNICIPIO": "PAIM FILHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313656",
		"NOME_MUNICIPIO": "PALMARES DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313706",
		"NOME_MUNICIPIO": "PALMEIRA DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313805",
		"NOME_MUNICIPIO": "PALMITINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313904",
		"NOME_MUNICIPIO": "PANAMBI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4313953",
		"NOME_MUNICIPIO": "PANTANO GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314001",
		"NOME_MUNICIPIO": "PARAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314027",
		"NOME_MUNICIPIO": "PARAISO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314035",
		"NOME_MUNICIPIO": "PARECI NOVO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314050",
		"NOME_MUNICIPIO": "PAROBE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314068",
		"NOME_MUNICIPIO": "PASSA SETE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314076",
		"NOME_MUNICIPIO": "PASSO DO SOBRADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314100",
		"NOME_MUNICIPIO": "PASSO FUNDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314134",
		"NOME_MUNICIPIO": "PAULO BENTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314159",
		"NOME_MUNICIPIO": "PAVERAMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314175",
		"NOME_MUNICIPIO": "PEDRAS ALTAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314209",
		"NOME_MUNICIPIO": "PEDRO OSORIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314308",
		"NOME_MUNICIPIO": "PEJUÇARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314407",
		"NOME_MUNICIPIO": "PELOTAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314423",
		"NOME_MUNICIPIO": "PICADA CAFE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314456",
		"NOME_MUNICIPIO": "PINHAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314464",
		"NOME_MUNICIPIO": "PINHAL DA SERRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314472",
		"NOME_MUNICIPIO": "PINHAL GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314498",
		"NOME_MUNICIPIO": "PINHEIRINHO DO VALE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314506",
		"NOME_MUNICIPIO": "PINHEIRO MACHADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314548",
		"NOME_MUNICIPIO": "PINTO BANDEIRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314555",
		"NOME_MUNICIPIO": "PIRAPO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314605",
		"NOME_MUNICIPIO": "PIRATINI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314704",
		"NOME_MUNICIPIO": "PLANALTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314753",
		"NOME_MUNICIPIO": "POÇO DAS ANTAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314779",
		"NOME_MUNICIPIO": "PONTAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314787",
		"NOME_MUNICIPIO": "PONTE PRETA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314803",
		"NOME_MUNICIPIO": "PORTAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4314902",
		"NOME_MUNICIPIO": "PORTO ALEGRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315008",
		"NOME_MUNICIPIO": "PORTO LUCENA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315057",
		"NOME_MUNICIPIO": "PORTO MAUA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315073",
		"NOME_MUNICIPIO": "PORTO VERA CRUZ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315107",
		"NOME_MUNICIPIO": "PORTO XAVIER",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315131",
		"NOME_MUNICIPIO": "POUSO NOVO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315149",
		"NOME_MUNICIPIO": "PRESIDENTE LUCENA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315156",
		"NOME_MUNICIPIO": "PROGRESSO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315172",
		"NOME_MUNICIPIO": "PROTASIO ALVES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315206",
		"NOME_MUNICIPIO": "PUTINGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315305",
		"NOME_MUNICIPIO": "QUARAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315313",
		"NOME_MUNICIPIO": "QUATRO IRMAOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315321",
		"NOME_MUNICIPIO": "QUEVEDOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315354",
		"NOME_MUNICIPIO": "QUINZE DE NOVEMBRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315404",
		"NOME_MUNICIPIO": "REDENTORA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315453",
		"NOME_MUNICIPIO": "RELVADO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315503",
		"NOME_MUNICIPIO": "RESTINGA SÊCA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315552",
		"NOME_MUNICIPIO": "RIO DOS INDIOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315602",
		"NOME_MUNICIPIO": "RIO GRANDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315701",
		"NOME_MUNICIPIO": "RIO PARDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315750",
		"NOME_MUNICIPIO": "RIOZINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315800",
		"NOME_MUNICIPIO": "ROCA SALES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315909",
		"NOME_MUNICIPIO": "RODEIO BONITO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4315958",
		"NOME_MUNICIPIO": "ROLADOR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316006",
		"NOME_MUNICIPIO": "ROLANTE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316105",
		"NOME_MUNICIPIO": "RONDA ALTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316204",
		"NOME_MUNICIPIO": "RONDINHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316303",
		"NOME_MUNICIPIO": "ROQUE GONZALES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316402",
		"NOME_MUNICIPIO": "ROSARIO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316428",
		"NOME_MUNICIPIO": "SAGRADA FAMILIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316436",
		"NOME_MUNICIPIO": "SALDANHA MARINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316451",
		"NOME_MUNICIPIO": "SALTO DO JACUI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316477",
		"NOME_MUNICIPIO": "SALVADOR DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316501",
		"NOME_MUNICIPIO": "SALVADOR DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316600",
		"NOME_MUNICIPIO": "SANANDUVA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316709",
		"NOME_MUNICIPIO": "SANTA BARBARA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316733",
		"NOME_MUNICIPIO": "SANTA CECILIA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316758",
		"NOME_MUNICIPIO": "SANTA CLARA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316808",
		"NOME_MUNICIPIO": "SANTA CRUZ DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316907",
		"NOME_MUNICIPIO": "SANTA MARIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316956",
		"NOME_MUNICIPIO": "SANTA MARIA DO HERVAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4316972",
		"NOME_MUNICIPIO": "SANTA MARGARIDA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317004",
		"NOME_MUNICIPIO": "SANTANA DA BOA VISTA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317103",
		"NOME_MUNICIPIO": "SANTANA DO LIVRAMENTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317202",
		"NOME_MUNICIPIO": "SANTA ROSA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317251",
		"NOME_MUNICIPIO": "SANTA TEREZA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317301",
		"NOME_MUNICIPIO": "SANTA VITORIA DO PALMAR",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317400",
		"NOME_MUNICIPIO": "SANTIAGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317509",
		"NOME_MUNICIPIO": "SANTO ANGELO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317558",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO PALMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317608",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DA PATRULHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317707",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317756",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO PLANALTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317806",
		"NOME_MUNICIPIO": "SANTO AUGUSTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317905",
		"NOME_MUNICIPIO": "SANTO CRISTO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4317954",
		"NOME_MUNICIPIO": "SANTO EXPEDITO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318002",
		"NOME_MUNICIPIO": "SAO BORJA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318051",
		"NOME_MUNICIPIO": "SAO DOMINGOS DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318101",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE ASSIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318200",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE PAULA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318309",
		"NOME_MUNICIPIO": "SAO GABRIEL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318408",
		"NOME_MUNICIPIO": "SAO JERÔNIMO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318424",
		"NOME_MUNICIPIO": "SAO JOAO DA URTIGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318432",
		"NOME_MUNICIPIO": "SAO JOAO DO POLÊSINE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318440",
		"NOME_MUNICIPIO": "SAO JORGE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318457",
		"NOME_MUNICIPIO": "SAO JOSE DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318465",
		"NOME_MUNICIPIO": "SAO JOSE DO HERVAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318481",
		"NOME_MUNICIPIO": "SAO JOSE DO HORTÊNCIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318499",
		"NOME_MUNICIPIO": "SAO JOSE DO INHACORA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318507",
		"NOME_MUNICIPIO": "SAO JOSE DO NORTE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318606",
		"NOME_MUNICIPIO": "SAO JOSE DO OURO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318614",
		"NOME_MUNICIPIO": "SAO JOSE DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318622",
		"NOME_MUNICIPIO": "SAO JOSE DOS AUSENTES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318705",
		"NOME_MUNICIPIO": "SAO LEOPOLDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318804",
		"NOME_MUNICIPIO": "SAO LOURENÇO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4318903",
		"NOME_MUNICIPIO": "SAO LUIZ GONZAGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319000",
		"NOME_MUNICIPIO": "SAO MARCOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319109",
		"NOME_MUNICIPIO": "SAO MARTINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319125",
		"NOME_MUNICIPIO": "SAO MARTINHO DA SERRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319158",
		"NOME_MUNICIPIO": "SAO MIGUEL DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319208",
		"NOME_MUNICIPIO": "SAO NICOLAU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319307",
		"NOME_MUNICIPIO": "SAO PAULO DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319356",
		"NOME_MUNICIPIO": "SAO PEDRO DA SERRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319364",
		"NOME_MUNICIPIO": "SAO PEDRO DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319372",
		"NOME_MUNICIPIO": "SAO PEDRO DO BUTIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319406",
		"NOME_MUNICIPIO": "SAO PEDRO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319505",
		"NOME_MUNICIPIO": "SAO SEBASTIAO DO CAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319604",
		"NOME_MUNICIPIO": "SAO SEPE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319703",
		"NOME_MUNICIPIO": "SAO VALENTIM",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319711",
		"NOME_MUNICIPIO": "SAO VALENTIM DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319737",
		"NOME_MUNICIPIO": "SAO VALERIO DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319752",
		"NOME_MUNICIPIO": "SAO VENDELINO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319802",
		"NOME_MUNICIPIO": "SAO VICENTE DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4319901",
		"NOME_MUNICIPIO": "SAPIRANGA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320008",
		"NOME_MUNICIPIO": "SAPUCAIA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320107",
		"NOME_MUNICIPIO": "SARANDI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320206",
		"NOME_MUNICIPIO": "SEBERI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320230",
		"NOME_MUNICIPIO": "SEDE NOVA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320263",
		"NOME_MUNICIPIO": "SEGREDO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320305",
		"NOME_MUNICIPIO": "SELBACH",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320321",
		"NOME_MUNICIPIO": "SENADOR SALGADO FILHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320354",
		"NOME_MUNICIPIO": "SENTINELA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320404",
		"NOME_MUNICIPIO": "SERAFINA CORRÊA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320453",
		"NOME_MUNICIPIO": "SERIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320503",
		"NOME_MUNICIPIO": "SERTAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320552",
		"NOME_MUNICIPIO": "SERTAO SANTANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320578",
		"NOME_MUNICIPIO": "SETE DE SETEMBRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320602",
		"NOME_MUNICIPIO": "SEVERIANO DE ALMEIDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320651",
		"NOME_MUNICIPIO": "SILVEIRA MARTINS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320677",
		"NOME_MUNICIPIO": "SINIMBU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320701",
		"NOME_MUNICIPIO": "SOBRADINHO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320800",
		"NOME_MUNICIPIO": "SOLEDADE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320859",
		"NOME_MUNICIPIO": "TABAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4320909",
		"NOME_MUNICIPIO": "TAPEJARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321006",
		"NOME_MUNICIPIO": "TAPERA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321105",
		"NOME_MUNICIPIO": "TAPES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321204",
		"NOME_MUNICIPIO": "TAQUARA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321303",
		"NOME_MUNICIPIO": "TAQUARI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321329",
		"NOME_MUNICIPIO": "TAQUARUÇU DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321352",
		"NOME_MUNICIPIO": "TAVARES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321402",
		"NOME_MUNICIPIO": "TENENTE PORTELA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321436",
		"NOME_MUNICIPIO": "TERRA DE AREIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321451",
		"NOME_MUNICIPIO": "TEUTÔNIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321469",
		"NOME_MUNICIPIO": "TIO HUGO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321477",
		"NOME_MUNICIPIO": "TIRADENTES DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321493",
		"NOME_MUNICIPIO": "TOROPI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321501",
		"NOME_MUNICIPIO": "TORRES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321600",
		"NOME_MUNICIPIO": "TRAMANDAI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321626",
		"NOME_MUNICIPIO": "TRAVESSEIRO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321634",
		"NOME_MUNICIPIO": "TRÊS ARROIOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321667",
		"NOME_MUNICIPIO": "TRÊS CACHOEIRAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321709",
		"NOME_MUNICIPIO": "TRÊS COROAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321808",
		"NOME_MUNICIPIO": "TRÊS DE MAIO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321832",
		"NOME_MUNICIPIO": "TRÊS FORQUILHAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321857",
		"NOME_MUNICIPIO": "TRÊS PALMEIRAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321907",
		"NOME_MUNICIPIO": "TRÊS PASSOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4321956",
		"NOME_MUNICIPIO": "TRINDADE DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322004",
		"NOME_MUNICIPIO": "TRIUNFO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322103",
		"NOME_MUNICIPIO": "TUCUNDUVA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322152",
		"NOME_MUNICIPIO": "TUNAS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322186",
		"NOME_MUNICIPIO": "TUPANCI DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322202",
		"NOME_MUNICIPIO": "TUPANCIRETA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322251",
		"NOME_MUNICIPIO": "TUPANDI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322301",
		"NOME_MUNICIPIO": "TUPARENDI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322327",
		"NOME_MUNICIPIO": "TURUÇU",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322343",
		"NOME_MUNICIPIO": "UBIRETAMA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322350",
		"NOME_MUNICIPIO": "UNIAO DA SERRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322376",
		"NOME_MUNICIPIO": "UNISTALDA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322400",
		"NOME_MUNICIPIO": "URUGUAIANA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322509",
		"NOME_MUNICIPIO": "VACARIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322525",
		"NOME_MUNICIPIO": "VALE VERDE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322533",
		"NOME_MUNICIPIO": "VALE DO SOL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322541",
		"NOME_MUNICIPIO": "VALE REAL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322558",
		"NOME_MUNICIPIO": "VANINI",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322608",
		"NOME_MUNICIPIO": "VENANCIO AIRES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322707",
		"NOME_MUNICIPIO": "VERA CRUZ",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322806",
		"NOME_MUNICIPIO": "VERANOPOLIS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322855",
		"NOME_MUNICIPIO": "VESPASIANO CORRÊA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4322905",
		"NOME_MUNICIPIO": "VIADUTOS",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323002",
		"NOME_MUNICIPIO": "VIAMAO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323101",
		"NOME_MUNICIPIO": "VICENTE DUTRA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323200",
		"NOME_MUNICIPIO": "VICTOR GRAEFF",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323309",
		"NOME_MUNICIPIO": "VILA FLORES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323358",
		"NOME_MUNICIPIO": "VILA LANGARO",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323408",
		"NOME_MUNICIPIO": "VILA MARIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323457",
		"NOME_MUNICIPIO": "VILA NOVA DO SUL",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323507",
		"NOME_MUNICIPIO": "VISTA ALEGRE",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323606",
		"NOME_MUNICIPIO": "VISTA ALEGRE DO PRATA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323705",
		"NOME_MUNICIPIO": "VISTA GAUCHA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323754",
		"NOME_MUNICIPIO": "VITORIA DAS MISSÕES",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323770",
		"NOME_MUNICIPIO": "WESTFALIA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "4323804",
		"NOME_MUNICIPIO": "XANGRI-LA",
		"COD_UF": "43"
	},
	{
		"COD_MUNICIPIO": "5000203",
		"NOME_MUNICIPIO": "AGUA CLARA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000252",
		"NOME_MUNICIPIO": "ALCINOPOLIS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000609",
		"NOME_MUNICIPIO": "AMAMBAI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000708",
		"NOME_MUNICIPIO": "ANASTACIO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000807",
		"NOME_MUNICIPIO": "ANAURILANDIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000856",
		"NOME_MUNICIPIO": "ANGELICA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5000906",
		"NOME_MUNICIPIO": "ANTÔNIO JOAO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5001003",
		"NOME_MUNICIPIO": "APARECIDA DO TABOADO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5001102",
		"NOME_MUNICIPIO": "AQUIDAUANA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5001243",
		"NOME_MUNICIPIO": "ARAL MOREIRA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5001508",
		"NOME_MUNICIPIO": "BANDEIRANTES",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5001904",
		"NOME_MUNICIPIO": "BATAGUASSU",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002001",
		"NOME_MUNICIPIO": "BATAYPORA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002100",
		"NOME_MUNICIPIO": "BELA VISTA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002159",
		"NOME_MUNICIPIO": "BODOQUENA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002209",
		"NOME_MUNICIPIO": "BONITO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002308",
		"NOME_MUNICIPIO": "BRASILANDIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002407",
		"NOME_MUNICIPIO": "CAARAPO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002605",
		"NOME_MUNICIPIO": "CAMAPUA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002704",
		"NOME_MUNICIPIO": "CAMPO GRANDE",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002803",
		"NOME_MUNICIPIO": "CARACOL",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002902",
		"NOME_MUNICIPIO": "CASSILANDIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5002951",
		"NOME_MUNICIPIO": "CHAPADAO DO SUL",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003108",
		"NOME_MUNICIPIO": "CORGUINHO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003157",
		"NOME_MUNICIPIO": "CORONEL SAPUCAIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003207",
		"NOME_MUNICIPIO": "CORUMBA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003256",
		"NOME_MUNICIPIO": "COSTA RICA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003306",
		"NOME_MUNICIPIO": "COXIM",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003454",
		"NOME_MUNICIPIO": "DEODAPOLIS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003488",
		"NOME_MUNICIPIO": "DOIS IRMAOS DO BURITI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003504",
		"NOME_MUNICIPIO": "DOURADINA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003702",
		"NOME_MUNICIPIO": "DOURADOS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003751",
		"NOME_MUNICIPIO": "ELDORADO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003801",
		"NOME_MUNICIPIO": "FATIMA DO SUL",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5003900",
		"NOME_MUNICIPIO": "FIGUEIRAO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004007",
		"NOME_MUNICIPIO": "GLORIA DE DOURADOS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004106",
		"NOME_MUNICIPIO": "GUIA LOPES DA LAGUNA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004304",
		"NOME_MUNICIPIO": "IGUATEMI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004403",
		"NOME_MUNICIPIO": "INOCÊNCIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004502",
		"NOME_MUNICIPIO": "ITAPORA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004601",
		"NOME_MUNICIPIO": "ITAQUIRAI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004700",
		"NOME_MUNICIPIO": "IVINHEMA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004809",
		"NOME_MUNICIPIO": "JAPORA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5004908",
		"NOME_MUNICIPIO": "JARAGUARI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005004",
		"NOME_MUNICIPIO": "JARDIM",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005103",
		"NOME_MUNICIPIO": "JATEI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005152",
		"NOME_MUNICIPIO": "JUTI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005202",
		"NOME_MUNICIPIO": "LADARIO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005251",
		"NOME_MUNICIPIO": "LAGUNA CARAPA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005400",
		"NOME_MUNICIPIO": "MARACAJU",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005608",
		"NOME_MUNICIPIO": "MIRANDA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005681",
		"NOME_MUNICIPIO": "MUNDO NOVO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005707",
		"NOME_MUNICIPIO": "NAVIRAI",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5005806",
		"NOME_MUNICIPIO": "NIOAQUE",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006002",
		"NOME_MUNICIPIO": "NOVA ALVORADA DO SUL",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006200",
		"NOME_MUNICIPIO": "NOVA ANDRADINA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006259",
		"NOME_MUNICIPIO": "NOVO HORIZONTE DO SUL",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006275",
		"NOME_MUNICIPIO": "PARAISO DAS AGUAS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006309",
		"NOME_MUNICIPIO": "PARANAIBA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006358",
		"NOME_MUNICIPIO": "PARANHOS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006408",
		"NOME_MUNICIPIO": "PEDRO GOMES",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006606",
		"NOME_MUNICIPIO": "PONTA PORA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5006903",
		"NOME_MUNICIPIO": "PORTO MURTINHO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007109",
		"NOME_MUNICIPIO": "RIBAS DO RIO PARDO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007208",
		"NOME_MUNICIPIO": "RIO BRILHANTE",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007307",
		"NOME_MUNICIPIO": "RIO NEGRO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007406",
		"NOME_MUNICIPIO": "RIO VERDE DE MATO GROSSO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007505",
		"NOME_MUNICIPIO": "ROCHEDO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007554",
		"NOME_MUNICIPIO": "SANTA RITA DO PARDO",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007695",
		"NOME_MUNICIPIO": "SAO GABRIEL DO OESTE",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007703",
		"NOME_MUNICIPIO": "SETE QUEDAS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007802",
		"NOME_MUNICIPIO": "SELVIRIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007901",
		"NOME_MUNICIPIO": "SIDROLANDIA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007935",
		"NOME_MUNICIPIO": "SONORA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007950",
		"NOME_MUNICIPIO": "TACURU",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5007976",
		"NOME_MUNICIPIO": "TAQUARUSSU",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5008008",
		"NOME_MUNICIPIO": "TERENOS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5008305",
		"NOME_MUNICIPIO": "TRÊS LAGOAS",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5008404",
		"NOME_MUNICIPIO": "VICENTINA",
		"COD_UF": "50"
	},
	{
		"COD_MUNICIPIO": "5100102",
		"NOME_MUNICIPIO": "ACORIZAL",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100201",
		"NOME_MUNICIPIO": "AGUA BOA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100250",
		"NOME_MUNICIPIO": "ALTA FLORESTA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100300",
		"NOME_MUNICIPIO": "ALTO ARAGUAIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100359",
		"NOME_MUNICIPIO": "ALTO BOA VISTA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100409",
		"NOME_MUNICIPIO": "ALTO GARÇAS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100508",
		"NOME_MUNICIPIO": "ALTO PARAGUAI",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100607",
		"NOME_MUNICIPIO": "ALTO TAQUARI",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5100805",
		"NOME_MUNICIPIO": "APIACAS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101001",
		"NOME_MUNICIPIO": "ARAGUAIANA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101209",
		"NOME_MUNICIPIO": "ARAGUAINHA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101258",
		"NOME_MUNICIPIO": "ARAPUTANGA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101308",
		"NOME_MUNICIPIO": "ARENAPOLIS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101407",
		"NOME_MUNICIPIO": "ARIPUANA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101605",
		"NOME_MUNICIPIO": "BARAO DE MELGAÇO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101704",
		"NOME_MUNICIPIO": "BARRA DO BUGRES",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101803",
		"NOME_MUNICIPIO": "BARRA DO GARÇAS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101852",
		"NOME_MUNICIPIO": "BOM JESUS DO ARAGUAIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5101902",
		"NOME_MUNICIPIO": "BRASNORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102504",
		"NOME_MUNICIPIO": "CACERES",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102603",
		"NOME_MUNICIPIO": "CAMPINAPOLIS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102637",
		"NOME_MUNICIPIO": "CAMPO NOVO DO PARECIS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102678",
		"NOME_MUNICIPIO": "CAMPO VERDE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102686",
		"NOME_MUNICIPIO": "CAMPOS DE JULIO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102694",
		"NOME_MUNICIPIO": "CANABRAVA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102702",
		"NOME_MUNICIPIO": "CANARANA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102793",
		"NOME_MUNICIPIO": "CARLINDA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5102850",
		"NOME_MUNICIPIO": "CASTANHEIRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103007",
		"NOME_MUNICIPIO": "CHAPADA DOS GUIMARAES",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103056",
		"NOME_MUNICIPIO": "CLAUDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103106",
		"NOME_MUNICIPIO": "COCALINHO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103205",
		"NOME_MUNICIPIO": "COLIDER",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103254",
		"NOME_MUNICIPIO": "COLNIZA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103304",
		"NOME_MUNICIPIO": "COMODORO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103353",
		"NOME_MUNICIPIO": "CONFRESA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103361",
		"NOME_MUNICIPIO": "CONQUISTA DOESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103379",
		"NOME_MUNICIPIO": "COTRIGUAÇU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103403",
		"NOME_MUNICIPIO": "CUIABA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103437",
		"NOME_MUNICIPIO": "CURVELANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103452",
		"NOME_MUNICIPIO": "DENISE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103502",
		"NOME_MUNICIPIO": "DIAMANTINO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103601",
		"NOME_MUNICIPIO": "DOM AQUINO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103700",
		"NOME_MUNICIPIO": "FELIZ NATAL",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103809",
		"NOME_MUNICIPIO": "FIGUEIROPOLIS DOESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103858",
		"NOME_MUNICIPIO": "GAUCHA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103908",
		"NOME_MUNICIPIO": "GENERAL CARNEIRO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5103957",
		"NOME_MUNICIPIO": "GLORIA DOESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104104",
		"NOME_MUNICIPIO": "GUARANTA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104203",
		"NOME_MUNICIPIO": "GUIRATINGA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104500",
		"NOME_MUNICIPIO": "INDIAVAI",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104526",
		"NOME_MUNICIPIO": "IPIRANGA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104542",
		"NOME_MUNICIPIO": "ITANHANGA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104559",
		"NOME_MUNICIPIO": "ITAUBA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104609",
		"NOME_MUNICIPIO": "ITIQUIRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104807",
		"NOME_MUNICIPIO": "JACIARA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5104906",
		"NOME_MUNICIPIO": "JANGADA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105002",
		"NOME_MUNICIPIO": "JAURU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105101",
		"NOME_MUNICIPIO": "JUARA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105150",
		"NOME_MUNICIPIO": "JUINA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105176",
		"NOME_MUNICIPIO": "JURUENA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105200",
		"NOME_MUNICIPIO": "JUSCIMEIRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105234",
		"NOME_MUNICIPIO": "LAMBARI DOESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105259",
		"NOME_MUNICIPIO": "LUCAS DO RIO VERDE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105309",
		"NOME_MUNICIPIO": "LUCIARA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105507",
		"NOME_MUNICIPIO": "VILA BELA DA SANTISSIMA TRINDADE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105580",
		"NOME_MUNICIPIO": "MARCELANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105606",
		"NOME_MUNICIPIO": "MATUPA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105622",
		"NOME_MUNICIPIO": "MIRASSOL DOESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5105903",
		"NOME_MUNICIPIO": "NOBRES",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106000",
		"NOME_MUNICIPIO": "NORTELANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106109",
		"NOME_MUNICIPIO": "NOSSA SENHORA DO LIVRAMENTO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106158",
		"NOME_MUNICIPIO": "NOVA BANDEIRANTES",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106174",
		"NOME_MUNICIPIO": "NOVA NAZARE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106182",
		"NOME_MUNICIPIO": "NOVA LACERDA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106190",
		"NOME_MUNICIPIO": "NOVA SANTA HELENA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106208",
		"NOME_MUNICIPIO": "NOVA BRASILANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106216",
		"NOME_MUNICIPIO": "NOVA CANAA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106224",
		"NOME_MUNICIPIO": "NOVA MUTUM",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106232",
		"NOME_MUNICIPIO": "NOVA OLIMPIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106240",
		"NOME_MUNICIPIO": "NOVA UBIRATA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106257",
		"NOME_MUNICIPIO": "NOVA XAVANTINA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106265",
		"NOME_MUNICIPIO": "NOVO MUNDO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106273",
		"NOME_MUNICIPIO": "NOVO HORIZONTE DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106281",
		"NOME_MUNICIPIO": "NOVO SAO JOAQUIM",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106299",
		"NOME_MUNICIPIO": "PARANAITA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106307",
		"NOME_MUNICIPIO": "PARANATINGA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106315",
		"NOME_MUNICIPIO": "NOVO SANTO ANTÔNIO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106372",
		"NOME_MUNICIPIO": "PEDRA PRETA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106422",
		"NOME_MUNICIPIO": "PEIXOTO DE AZEVEDO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106455",
		"NOME_MUNICIPIO": "PLANALTO DA SERRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106505",
		"NOME_MUNICIPIO": "POCONE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106653",
		"NOME_MUNICIPIO": "PONTAL DO ARAGUAIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106703",
		"NOME_MUNICIPIO": "PONTE BRANCA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106752",
		"NOME_MUNICIPIO": "PONTES E LACERDA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106778",
		"NOME_MUNICIPIO": "PORTO ALEGRE DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106802",
		"NOME_MUNICIPIO": "PORTO DOS GAUCHOS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106828",
		"NOME_MUNICIPIO": "PORTO ESPERIDIAO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5106851",
		"NOME_MUNICIPIO": "PORTO ESTRELA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107008",
		"NOME_MUNICIPIO": "POXOREU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107040",
		"NOME_MUNICIPIO": "PRIMAVERA DO LESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107065",
		"NOME_MUNICIPIO": "QUERÊNCIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107107",
		"NOME_MUNICIPIO": "SAO JOSE DOS QUATRO MARCOS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107156",
		"NOME_MUNICIPIO": "RESERVA DO CABAÇAL",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107180",
		"NOME_MUNICIPIO": "RIBEIRAO CASCALHEIRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107198",
		"NOME_MUNICIPIO": "RIBEIRAOZINHO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107206",
		"NOME_MUNICIPIO": "RIO BRANCO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107248",
		"NOME_MUNICIPIO": "SANTA CARMEM",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107263",
		"NOME_MUNICIPIO": "SANTO AFONSO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107297",
		"NOME_MUNICIPIO": "SAO JOSE DO POVO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107305",
		"NOME_MUNICIPIO": "SAO JOSE DO RIO CLARO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107354",
		"NOME_MUNICIPIO": "SAO JOSE DO XINGU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107404",
		"NOME_MUNICIPIO": "SAO PEDRO DA CIPA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107578",
		"NOME_MUNICIPIO": "RONDOLANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107602",
		"NOME_MUNICIPIO": "RONDONOPOLIS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107701",
		"NOME_MUNICIPIO": "ROSARIO OESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107743",
		"NOME_MUNICIPIO": "SANTA CRUZ DO XINGU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107750",
		"NOME_MUNICIPIO": "SALTO DO CEU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107768",
		"NOME_MUNICIPIO": "SANTA RITA DO TRIVELATO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107776",
		"NOME_MUNICIPIO": "SANTA TEREZINHA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107792",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO LESTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107800",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO LEVERGER",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107859",
		"NOME_MUNICIPIO": "SAO FELIX DO ARAGUAIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107875",
		"NOME_MUNICIPIO": "SAPEZAL",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107883",
		"NOME_MUNICIPIO": "SERRA NOVA DOURADA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107909",
		"NOME_MUNICIPIO": "SINOP",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107925",
		"NOME_MUNICIPIO": "SORRISO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107941",
		"NOME_MUNICIPIO": "TABAPORA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5107958",
		"NOME_MUNICIPIO": "TANGARA DA SERRA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108006",
		"NOME_MUNICIPIO": "TAPURAH",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108055",
		"NOME_MUNICIPIO": "TERRA NOVA DO NORTE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108105",
		"NOME_MUNICIPIO": "TESOURO",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108204",
		"NOME_MUNICIPIO": "TORIXOREU",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108303",
		"NOME_MUNICIPIO": "UNIAO DO SUL",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108352",
		"NOME_MUNICIPIO": "VALE DE SAO DOMINGOS",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108402",
		"NOME_MUNICIPIO": "VARZEA GRANDE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108501",
		"NOME_MUNICIPIO": "VERA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108600",
		"NOME_MUNICIPIO": "VILA RICA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108808",
		"NOME_MUNICIPIO": "NOVA GUARITA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108857",
		"NOME_MUNICIPIO": "NOVA MARILANDIA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108907",
		"NOME_MUNICIPIO": "NOVA MARINGA",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5108956",
		"NOME_MUNICIPIO": "NOVA MONTE VERDE",
		"COD_UF": "51"
	},
	{
		"COD_MUNICIPIO": "5200050",
		"NOME_MUNICIPIO": "ABADIA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200100",
		"NOME_MUNICIPIO": "ABADIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200134",
		"NOME_MUNICIPIO": "ACREUNA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200159",
		"NOME_MUNICIPIO": "ADELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200175",
		"NOME_MUNICIPIO": "AGUA FRIA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200209",
		"NOME_MUNICIPIO": "AGUA LIMPA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200258",
		"NOME_MUNICIPIO": "AGUAS LINDAS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200308",
		"NOME_MUNICIPIO": "ALEXANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200506",
		"NOME_MUNICIPIO": "ALOANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200555",
		"NOME_MUNICIPIO": "ALTO HORIZONTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200605",
		"NOME_MUNICIPIO": "ALTO PARAISO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200803",
		"NOME_MUNICIPIO": "ALVORADA DO NORTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200829",
		"NOME_MUNICIPIO": "AMARALINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200852",
		"NOME_MUNICIPIO": "AMERICANO DO BRASIL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5200902",
		"NOME_MUNICIPIO": "AMORINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201108",
		"NOME_MUNICIPIO": "ANAPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201207",
		"NOME_MUNICIPIO": "ANHANGUERA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201306",
		"NOME_MUNICIPIO": "ANICUNS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201405",
		"NOME_MUNICIPIO": "APARECIDA DE GOIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201454",
		"NOME_MUNICIPIO": "APARECIDA DO RIO DOCE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201504",
		"NOME_MUNICIPIO": "APORE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201603",
		"NOME_MUNICIPIO": "ARAÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201702",
		"NOME_MUNICIPIO": "ARAGARÇAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5201801",
		"NOME_MUNICIPIO": "ARAGOIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5202155",
		"NOME_MUNICIPIO": "ARAGUAPAZ",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5202353",
		"NOME_MUNICIPIO": "ARENOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5202502",
		"NOME_MUNICIPIO": "ARUANA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5202601",
		"NOME_MUNICIPIO": "AURILANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5202809",
		"NOME_MUNICIPIO": "AVELINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203104",
		"NOME_MUNICIPIO": "BALIZA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203203",
		"NOME_MUNICIPIO": "BARRO ALTO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203302",
		"NOME_MUNICIPIO": "BELA VISTA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203401",
		"NOME_MUNICIPIO": "BOM JARDIM DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203500",
		"NOME_MUNICIPIO": "BOM JESUS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203559",
		"NOME_MUNICIPIO": "BONFINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203575",
		"NOME_MUNICIPIO": "BONOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203609",
		"NOME_MUNICIPIO": "BRAZABRANTES",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203807",
		"NOME_MUNICIPIO": "BRITANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203906",
		"NOME_MUNICIPIO": "BURITI ALEGRE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203939",
		"NOME_MUNICIPIO": "BURITI DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5203962",
		"NOME_MUNICIPIO": "BURITINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204003",
		"NOME_MUNICIPIO": "CABECEIRAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204102",
		"NOME_MUNICIPIO": "CACHOEIRA ALTA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204201",
		"NOME_MUNICIPIO": "CACHOEIRA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204250",
		"NOME_MUNICIPIO": "CACHOEIRA DOURADA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204300",
		"NOME_MUNICIPIO": "CAÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204409",
		"NOME_MUNICIPIO": "CAIAPÔNIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204508",
		"NOME_MUNICIPIO": "CALDAS NOVAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204557",
		"NOME_MUNICIPIO": "CALDAZINHA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204607",
		"NOME_MUNICIPIO": "CAMPESTRE DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204656",
		"NOME_MUNICIPIO": "CAMPINAÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204706",
		"NOME_MUNICIPIO": "CAMPINORTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204805",
		"NOME_MUNICIPIO": "CAMPO ALEGRE DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204854",
		"NOME_MUNICIPIO": "CAMPO LIMPO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204904",
		"NOME_MUNICIPIO": "CAMPOS BELOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5204953",
		"NOME_MUNICIPIO": "CAMPOS VERDES",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205000",
		"NOME_MUNICIPIO": "CARMO DO RIO VERDE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205059",
		"NOME_MUNICIPIO": "CASTELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205109",
		"NOME_MUNICIPIO": "CATALAO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205208",
		"NOME_MUNICIPIO": "CATURAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205307",
		"NOME_MUNICIPIO": "CAVALCANTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205406",
		"NOME_MUNICIPIO": "CERES",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205455",
		"NOME_MUNICIPIO": "CEZARINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205471",
		"NOME_MUNICIPIO": "CHAPADAO DO CEU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205497",
		"NOME_MUNICIPIO": "CIDADE OCIDENTAL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205513",
		"NOME_MUNICIPIO": "COCALZINHO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205521",
		"NOME_MUNICIPIO": "COLINAS DO SUL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205703",
		"NOME_MUNICIPIO": "CORREGO DO OURO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205802",
		"NOME_MUNICIPIO": "CORUMBA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5205901",
		"NOME_MUNICIPIO": "CORUMBAIBA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206206",
		"NOME_MUNICIPIO": "CRISTALINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206305",
		"NOME_MUNICIPIO": "CRISTIANOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206404",
		"NOME_MUNICIPIO": "CRIXAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206503",
		"NOME_MUNICIPIO": "CROMINIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206602",
		"NOME_MUNICIPIO": "CUMARI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206701",
		"NOME_MUNICIPIO": "DAMIANOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206800",
		"NOME_MUNICIPIO": "DAMOLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5206909",
		"NOME_MUNICIPIO": "DAVINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207105",
		"NOME_MUNICIPIO": "DIORAMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207253",
		"NOME_MUNICIPIO": "DOVERLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207352",
		"NOME_MUNICIPIO": "EDEALINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207402",
		"NOME_MUNICIPIO": "EDEIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207501",
		"NOME_MUNICIPIO": "ESTRELA DO NORTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207535",
		"NOME_MUNICIPIO": "FAINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207600",
		"NOME_MUNICIPIO": "FAZENDA NOVA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207808",
		"NOME_MUNICIPIO": "FIRMINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5207907",
		"NOME_MUNICIPIO": "FLORES DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208004",
		"NOME_MUNICIPIO": "FORMOSA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208103",
		"NOME_MUNICIPIO": "FORMOSO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208152",
		"NOME_MUNICIPIO": "GAMELEIRA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208301",
		"NOME_MUNICIPIO": "DIVINOPOLIS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208400",
		"NOME_MUNICIPIO": "GOIANAPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208509",
		"NOME_MUNICIPIO": "GOIANDIRA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208608",
		"NOME_MUNICIPIO": "GOIANESIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208707",
		"NOME_MUNICIPIO": "GOIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208806",
		"NOME_MUNICIPIO": "GOIANIRA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5208905",
		"NOME_MUNICIPIO": "GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209101",
		"NOME_MUNICIPIO": "GOIATUBA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209150",
		"NOME_MUNICIPIO": "GOUVELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209200",
		"NOME_MUNICIPIO": "GUAPO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209291",
		"NOME_MUNICIPIO": "GUARAITA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209408",
		"NOME_MUNICIPIO": "GUARANI DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209457",
		"NOME_MUNICIPIO": "GUARINOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209606",
		"NOME_MUNICIPIO": "HEITORAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209705",
		"NOME_MUNICIPIO": "HIDROLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209804",
		"NOME_MUNICIPIO": "HIDROLINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209903",
		"NOME_MUNICIPIO": "IACIARA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209937",
		"NOME_MUNICIPIO": "INACIOLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5209952",
		"NOME_MUNICIPIO": "INDIARA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210000",
		"NOME_MUNICIPIO": "INHUMAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210109",
		"NOME_MUNICIPIO": "IPAMERI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210158",
		"NOME_MUNICIPIO": "IPIRANGA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210208",
		"NOME_MUNICIPIO": "IPORA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210307",
		"NOME_MUNICIPIO": "ISRAELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210406",
		"NOME_MUNICIPIO": "ITABERAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210562",
		"NOME_MUNICIPIO": "ITAGUARI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210604",
		"NOME_MUNICIPIO": "ITAGUARU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210802",
		"NOME_MUNICIPIO": "ITAJA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5210901",
		"NOME_MUNICIPIO": "ITAPACI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211008",
		"NOME_MUNICIPIO": "ITAPIRAPUA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211206",
		"NOME_MUNICIPIO": "ITAPURANGA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211305",
		"NOME_MUNICIPIO": "ITARUMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211404",
		"NOME_MUNICIPIO": "ITAUÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211503",
		"NOME_MUNICIPIO": "ITUMBIARA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211602",
		"NOME_MUNICIPIO": "IVOLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211701",
		"NOME_MUNICIPIO": "JANDAIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211800",
		"NOME_MUNICIPIO": "JARAGUA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5211909",
		"NOME_MUNICIPIO": "JATAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212006",
		"NOME_MUNICIPIO": "JAUPACI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212055",
		"NOME_MUNICIPIO": "JESUPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212105",
		"NOME_MUNICIPIO": "JOVIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212204",
		"NOME_MUNICIPIO": "JUSSARA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212253",
		"NOME_MUNICIPIO": "LAGOA SANTA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212303",
		"NOME_MUNICIPIO": "LEOPOLDO DE BULHÕES",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212501",
		"NOME_MUNICIPIO": "LUZIANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212600",
		"NOME_MUNICIPIO": "MAIRIPOTABA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212709",
		"NOME_MUNICIPIO": "MAMBAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212808",
		"NOME_MUNICIPIO": "MARA ROSA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212907",
		"NOME_MUNICIPIO": "MARZAGAO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5212956",
		"NOME_MUNICIPIO": "MATRINCHA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213004",
		"NOME_MUNICIPIO": "MAURILANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213053",
		"NOME_MUNICIPIO": "MIMOSO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213087",
		"NOME_MUNICIPIO": "MINAÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213103",
		"NOME_MUNICIPIO": "MINEIROS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213400",
		"NOME_MUNICIPIO": "MOIPORA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213509",
		"NOME_MUNICIPIO": "MONTE ALEGRE DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213707",
		"NOME_MUNICIPIO": "MONTES CLAROS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213756",
		"NOME_MUNICIPIO": "MONTIVIDIU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213772",
		"NOME_MUNICIPIO": "MONTIVIDIU DO NORTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213806",
		"NOME_MUNICIPIO": "MORRINHOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213855",
		"NOME_MUNICIPIO": "MORRO AGUDO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5213905",
		"NOME_MUNICIPIO": "MOSSAMEDES",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214002",
		"NOME_MUNICIPIO": "MOZARLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214051",
		"NOME_MUNICIPIO": "MUNDO NOVO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214101",
		"NOME_MUNICIPIO": "MUTUNOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214408",
		"NOME_MUNICIPIO": "NAZARIO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214507",
		"NOME_MUNICIPIO": "NEROPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214606",
		"NOME_MUNICIPIO": "NIQUELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214705",
		"NOME_MUNICIPIO": "NOVA AMERICA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214804",
		"NOME_MUNICIPIO": "NOVA AURORA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214838",
		"NOME_MUNICIPIO": "NOVA CRIXAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214861",
		"NOME_MUNICIPIO": "NOVA GLORIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214879",
		"NOME_MUNICIPIO": "NOVA IGUAÇU DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5214903",
		"NOME_MUNICIPIO": "NOVA ROMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215009",
		"NOME_MUNICIPIO": "NOVA VENEZA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215207",
		"NOME_MUNICIPIO": "NOVO BRASIL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215231",
		"NOME_MUNICIPIO": "NOVO GAMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215256",
		"NOME_MUNICIPIO": "NOVO PLANALTO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215306",
		"NOME_MUNICIPIO": "ORIZONA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215405",
		"NOME_MUNICIPIO": "OURO VERDE DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215504",
		"NOME_MUNICIPIO": "OUVIDOR",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215603",
		"NOME_MUNICIPIO": "PADRE BERNARDO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215652",
		"NOME_MUNICIPIO": "PALESTINA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215702",
		"NOME_MUNICIPIO": "PALMEIRAS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215801",
		"NOME_MUNICIPIO": "PALMELO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5215900",
		"NOME_MUNICIPIO": "PALMINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216007",
		"NOME_MUNICIPIO": "PANAMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216304",
		"NOME_MUNICIPIO": "PARANAIGUARA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216403",
		"NOME_MUNICIPIO": "PARAUNA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216452",
		"NOME_MUNICIPIO": "PEROLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216809",
		"NOME_MUNICIPIO": "PETROLINA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5216908",
		"NOME_MUNICIPIO": "PILAR DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217104",
		"NOME_MUNICIPIO": "PIRACANJUBA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217203",
		"NOME_MUNICIPIO": "PIRANHAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217302",
		"NOME_MUNICIPIO": "PIRENOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217401",
		"NOME_MUNICIPIO": "PIRES DO RIO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217609",
		"NOME_MUNICIPIO": "PLANALTINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5217708",
		"NOME_MUNICIPIO": "PONTALINA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218003",
		"NOME_MUNICIPIO": "PORANGATU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218052",
		"NOME_MUNICIPIO": "PORTEIRAO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218102",
		"NOME_MUNICIPIO": "PORTELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218300",
		"NOME_MUNICIPIO": "POSSE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218391",
		"NOME_MUNICIPIO": "PROFESSOR JAMIL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218508",
		"NOME_MUNICIPIO": "QUIRINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218607",
		"NOME_MUNICIPIO": "RIALMA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218706",
		"NOME_MUNICIPIO": "RIANAPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218789",
		"NOME_MUNICIPIO": "RIO QUENTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218805",
		"NOME_MUNICIPIO": "RIO VERDE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5218904",
		"NOME_MUNICIPIO": "RUBIATABA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219001",
		"NOME_MUNICIPIO": "SANCLERLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219100",
		"NOME_MUNICIPIO": "SANTA BARBARA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219209",
		"NOME_MUNICIPIO": "SANTA CRUZ DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219258",
		"NOME_MUNICIPIO": "SANTA FE DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219308",
		"NOME_MUNICIPIO": "SANTA HELENA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219357",
		"NOME_MUNICIPIO": "SANTA ISABEL",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219407",
		"NOME_MUNICIPIO": "SANTA RITA DO ARAGUAIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219456",
		"NOME_MUNICIPIO": "SANTA RITA DO NOVO DESTINO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219506",
		"NOME_MUNICIPIO": "SANTA ROSA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219605",
		"NOME_MUNICIPIO": "SANTA TEREZA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219704",
		"NOME_MUNICIPIO": "SANTA TEREZINHA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219712",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DA BARRA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219738",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219753",
		"NOME_MUNICIPIO": "SANTO ANTÔNIO DO DESCOBERTO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219803",
		"NOME_MUNICIPIO": "SAO DOMINGOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5219902",
		"NOME_MUNICIPIO": "SAO FRANCISCO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220009",
		"NOME_MUNICIPIO": "SAO JOAO DALIANÇA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220058",
		"NOME_MUNICIPIO": "SAO JOAO DA PARAUNA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220108",
		"NOME_MUNICIPIO": "SAO LUIS DE MONTES BELOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220157",
		"NOME_MUNICIPIO": "SAO LUIZ DO NORTE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220207",
		"NOME_MUNICIPIO": "SAO MIGUEL DO ARAGUAIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220264",
		"NOME_MUNICIPIO": "SAO MIGUEL DO PASSA QUATRO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220280",
		"NOME_MUNICIPIO": "SAO PATRICIO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220405",
		"NOME_MUNICIPIO": "SAO SIMAO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220454",
		"NOME_MUNICIPIO": "SENADOR CANEDO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220504",
		"NOME_MUNICIPIO": "SERRANOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220603",
		"NOME_MUNICIPIO": "SILVANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220686",
		"NOME_MUNICIPIO": "SIMOLANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5220702",
		"NOME_MUNICIPIO": "SITIO DABADIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221007",
		"NOME_MUNICIPIO": "TAQUARAL DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221080",
		"NOME_MUNICIPIO": "TERESINA DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221197",
		"NOME_MUNICIPIO": "TEREZOPOLIS DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221304",
		"NOME_MUNICIPIO": "TRÊS RANCHOS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221403",
		"NOME_MUNICIPIO": "TRINDADE",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221452",
		"NOME_MUNICIPIO": "TROMBAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221502",
		"NOME_MUNICIPIO": "TURVANIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221551",
		"NOME_MUNICIPIO": "TURVELANDIA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221577",
		"NOME_MUNICIPIO": "UIRAPURU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221601",
		"NOME_MUNICIPIO": "URUAÇU",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221700",
		"NOME_MUNICIPIO": "URUANA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221809",
		"NOME_MUNICIPIO": "URUTAI",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221858",
		"NOME_MUNICIPIO": "VALPARAISO DE GOIAS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5221908",
		"NOME_MUNICIPIO": "VARJAO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5222005",
		"NOME_MUNICIPIO": "VIANOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5222054",
		"NOME_MUNICIPIO": "VICENTINOPOLIS",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5222203",
		"NOME_MUNICIPIO": "VILA BOA",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5222302",
		"NOME_MUNICIPIO": "VILA PROPICIO",
		"COD_UF": "52"
	},
	{
		"COD_MUNICIPIO": "5300108",
		"NOME_MUNICIPIO": "BRASILIA",
		"COD_UF": "53"
	}
]
